var Mp = Object.defineProperty;
var qp = (e, t, r) => t in e ? Mp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var so = (e, t, r) => qp(e, typeof t != "symbol" ? t + "" : t, r);
import { isRef as _a, defineComponent as Pe, withAsyncContext as Ep, createElementBlock as S, createCommentVNode as B, unref as g, openBlock as m, normalizeStyle as we, normalizeClass as pe, useCssVars as zt, computed as C, createBlock as J, resolveDynamicComponent as Yo, resolveComponent as oe, Teleport as Xt, toValue as Ht, h as wi, createVNode as K, toRefs as nr, ref as z, watch as Le, onMounted as St, withKeys as Jt, createElementVNode as W, renderSlot as at, Transition as bt, withCtx as ie, withDirectives as Kt, vShow as _r, TransitionGroup as Sr, Fragment as qe, renderList as We, inject as mr, provide as ar, onBeforeUnmount as jr, withModifiers as Bl, vModelCheckbox as Vp, reactive as Gt, nextTick as ut, toDisplayString as je, onUnmounted as Uo, normalizeProps as An, mergeProps as rn, toRef as dr, watchEffect as an, guardReactiveProps as jl, createTextVNode as pt, resolveDirective as Lp, toHandlers as Bp, vModelDynamic as jp, useSlots as fc, vModelText as Hp, onBeforeMount as ts, createSlots as Ca } from "vue";
import { aQ as Rt, cS as zr, cX as Rp, an as fa, cQ as Fp, cU as Dt, cR as Np, aj as Ka, c as vc, C as zo, U as rs, V as Ao, bd as pc, aL as Yp, ap as La, cY as Wo, M as wr, N as nn, W as as, bv as Po, a_ as mc, bh as Up, bg as hc, bi as zp, F as ns, aa as Wp, D as yc, ao as kt, d2 as os, d0 as bc, b4 as xr, aJ as gc, bo as Ia, bl as Kp, aZ as ls, ae as _c, aK as Ft, aw as Gp, v as $n, ag as Zp, o as Xp, cZ as Ar, b8 as Jp, aq as wc, bj as Qp, Y as em, w as tm, p as In, bp as kc, bf as rm, be as ki, aM as ss, aR as is, K as am, L as nm, aV as Ko, g as om, b3 as lm, G as sm, aN as im, cT as $c, B as um, bn as cm, bm as dm } from "./value-extraction-C_fDiBaZ.js";
import { u as us, a as Cc } from "./svg-D2_vqQWe.js";
import { a as fm, b as vm, P as pm, C as mm, U as Sc } from "./symbols-CVSaLsTy.js";
import { P as pr, d as hm, b as ym, e as bm, c as pl, R as $i, $ as ml, j as gm } from "./person-D_kW40Oo.js";
import { l as Wt, i as xc, h as _m, P as hr } from "./product-CdujHKtW.js";
import { N as qr, O as _o, a as Ke, b as Ge, c as Ze, n as cs, m as ds, o as fs, z as vs, H as Go, t as wm, g as Kr, P as km, y as $m, u as Cm, v as Bn, w as jn, G as Hn, F as Sm, E as Dc, r as Ac, x as xm, d as Pc, e as Oc, i as Dm } from "./data-store-DcC2aSru.js";
import "vue-router";
import { storeToRefs as Am } from "pinia";
const Hl = [
  {
    country: "af",
    label: "Afghanistan"
  },
  {
    country: "al",
    label: "Albania"
  },
  {
    country: "dz",
    label: "Algerie"
  },
  {
    country: "ad",
    label: "Andorra"
  },
  {
    country: "ao",
    label: "Angola"
  },
  {
    country: "ag",
    label: "Antigua og Barbuda"
  },
  {
    country: "ar",
    label: "Argentina"
  },
  {
    country: "am",
    label: "Armenia"
  },
  {
    country: "az",
    label: "Aserbajdsjan"
  },
  {
    country: "au",
    label: "Australia"
  },
  {
    country: "bs",
    label: "Bahamas"
  },
  {
    country: "bh",
    label: "Bahrain"
  },
  {
    country: "bd",
    label: "Bangladesh"
  },
  {
    country: "bb",
    label: "Barbados"
  },
  {
    country: "be",
    label: "Belgia"
  },
  {
    country: "bz",
    label: "Belize"
  },
  {
    country: "bj",
    label: "Benin"
  },
  {
    country: "bt",
    label: "Bhutan"
  },
  {
    country: "bo",
    label: "Bolivia"
  },
  {
    country: "ba",
    label: "Bosnia-Hercegovina"
  },
  {
    country: "bw",
    label: "Botswana"
  },
  {
    country: "br",
    label: "Brasil"
  },
  {
    country: "bn",
    label: "Brunei"
  },
  {
    country: "bg",
    label: "Bulgaria"
  },
  {
    country: "bf",
    label: "Burkina Faso"
  },
  {
    country: "bi",
    label: "Burundi"
  },
  {
    country: "ca",
    label: "Canada"
  },
  {
    country: "cl",
    label: "Chile"
  },
  {
    country: "co",
    label: "Colombia"
  },
  {
    country: "cr",
    label: "Costa Rica"
  },
  {
    country: "cu",
    label: "Cuba"
  },
  {
    country: "dk",
    label: "Danmark"
  },
  {
    country: "ae",
    label: "De forente arabiske emirater"
  },
  {
    country: "do",
    label: "Den dominikanske republikk"
  },
  {
    country: "cf",
    label: "Den sentralafrikanske republikk"
  },
  {
    country: "dj",
    label: "Djibouti"
  },
  {
    country: "dm",
    label: "Dominica"
  },
  {
    country: "ec",
    label: "Ecuador"
  },
  {
    country: "eg",
    label: "Egypt"
  },
  {
    country: "gq",
    label: "Ekvatorial-Guinea"
  },
  {
    country: "ci",
    label: "Elfenbenskysten"
  },
  {
    country: "sv",
    label: "El Salvador"
  },
  {
    country: "er",
    label: "Eritrea"
  },
  {
    country: "ee",
    label: "Estland"
  },
  {
    country: "et",
    label: "Etiopia"
  },
  {
    country: "fj",
    label: "Fiji"
  },
  {
    country: "ph",
    label: "Filippinene"
  },
  {
    country: "fi",
    label: "Finland"
  },
  {
    country: "fr",
    label: "Frankrike"
  },
  {
    country: "ga",
    label: "Gabon"
  },
  {
    country: "gm",
    label: "Gambia"
  },
  {
    country: "ge",
    label: "Georgia"
  },
  {
    country: "gh",
    label: "Ghana"
  },
  {
    country: "gd",
    label: "Grenada"
  },
  {
    country: "gt",
    label: "Guatemala"
  },
  {
    country: "gn",
    label: "Guinea"
  },
  {
    country: "gw",
    label: "Guinea-Bissau"
  },
  {
    country: "gy",
    label: "Guyana"
  },
  {
    country: "ht",
    label: "Haiti"
  },
  {
    country: "gr",
    label: "Hellas"
  },
  {
    country: "hn",
    label: "Honduras"
  },
  {
    country: "by",
    label: "Hviterussland"
  },
  {
    country: "in",
    label: "India"
  },
  {
    country: "id",
    label: "Indonesia"
  },
  {
    country: "iq",
    label: "Irak"
  },
  {
    country: "ir",
    label: "Iran"
  },
  {
    country: "ie",
    label: "Irland"
  },
  {
    country: "is",
    label: "Island"
  },
  {
    country: "il",
    label: "Israel"
  },
  {
    country: "it",
    label: "Italia"
  },
  {
    country: "jm",
    label: "Jamaica"
  },
  {
    country: "jp",
    label: "Japan"
  },
  {
    country: "ye",
    label: "Jemen"
  },
  {
    country: "jo",
    label: "Jordan"
  },
  {
    country: "kh",
    label: "Kambodsja"
  },
  {
    country: "cm",
    label: "Kamerun"
  },
  {
    country: "cv",
    label: "Kapp Verde"
  },
  {
    country: "kz",
    label: "Kasakhstan"
  },
  {
    country: "ke",
    label: "Kenya"
  },
  {
    country: "cn",
    label: "Kina"
  },
  {
    country: "kg",
    label: "Kirgisistan"
  },
  {
    country: "ki",
    label: "Kiribati"
  },
  {
    country: "km",
    label: "Komorene"
  },
  {
    country: "cd",
    label: "Kongo, Den demokratiske republikken"
  },
  {
    country: "cg",
    label: "Kongo, Republikken"
  },
  {
    country: "xk",
    label: "Kosovo"
  },
  {
    country: "hr",
    label: "Kroatia"
  },
  {
    country: "kw",
    label: "Kuwait"
  },
  {
    country: "cy",
    label: "Kypros"
  },
  {
    country: "la",
    label: "Laos"
  },
  {
    country: "lv",
    label: "Latvia"
  },
  {
    country: "ls",
    label: "Lesotho"
  },
  {
    country: "lb",
    label: "Libanon"
  },
  {
    country: "lr",
    label: "Liberia"
  },
  {
    country: "ly",
    label: "Libya"
  },
  {
    country: "li",
    label: "Liechtenstein"
  },
  {
    country: "lt",
    label: "Litauen"
  },
  {
    country: "lu",
    label: "Luxembourg"
  },
  {
    country: "mg",
    label: "Madagaskar"
  },
  {
    country: "mk",
    label: "Makedonia, Republikken"
  },
  {
    country: "mw",
    label: "Malawi"
  },
  {
    country: "my",
    label: "Malaysia"
  },
  {
    country: "mv",
    label: "Maldivene"
  },
  {
    country: "ml",
    label: "Mali"
  },
  {
    country: "mt",
    label: "Malta"
  },
  {
    country: "ma",
    label: "Marokko"
  },
  {
    country: "mh",
    label: "Marshalløyene"
  },
  {
    country: "mr",
    label: "Mauritania"
  },
  {
    country: "mu",
    label: "Mauritius"
  },
  {
    country: "mx",
    label: "Mexico"
  },
  {
    country: "fm",
    label: "Mikronesiaføderasjonen"
  },
  {
    country: "md",
    label: "Moldova"
  },
  {
    country: "mc",
    label: "Monaco"
  },
  {
    country: "mn",
    label: "Mongolia"
  },
  {
    country: "me",
    label: "Montenegro"
  },
  {
    country: "mz",
    label: "Mosambik"
  },
  {
    country: "mm",
    label: "Myanmar"
  },
  {
    country: "na",
    label: "Namibia"
  },
  {
    country: "nr",
    label: "Nauru"
  },
  {
    country: "np",
    label: "Nepal"
  },
  {
    country: "nl",
    label: "Nederland"
  },
  {
    country: "nz",
    label: "New Zealand"
  },
  {
    country: "ni",
    label: "Nicaragua"
  },
  {
    country: "ne",
    label: "Niger"
  },
  {
    country: "ng",
    label: "Nigeria"
  },
  {
    country: "kp",
    label: "Nord-Korea"
  },
  {
    country: "no",
    label: "Norge"
  },
  {
    country: "om",
    label: "Oman"
  },
  {
    country: "pk",
    label: "Pakistan"
  },
  {
    country: "pw",
    label: "Palau"
  },
  {
    country: "ps",
    label: "Palestina"
  },
  {
    country: "pa",
    label: "Panama"
  },
  {
    country: "pg",
    label: "Papua Ny-Guinea"
  },
  {
    country: "py",
    label: "Paraguay"
  },
  {
    country: "pe",
    label: "Peru"
  },
  {
    country: "pl",
    label: "Polen"
  },
  {
    country: "pt",
    label: "Portugal"
  },
  {
    country: "qa",
    label: "Qatar"
  },
  {
    country: "ro",
    label: "Romania"
  },
  {
    country: "ru",
    label: "Russland"
  },
  {
    country: "rw",
    label: "Rwanda"
  },
  {
    country: "kn",
    label: "Saint Kitts og Nevis"
  },
  {
    country: "lc",
    label: "Saint Lucia"
  },
  {
    country: "vc",
    label: "Saint Vincent og Grenadinene"
  },
  {
    country: "sb",
    label: "Salomonøyene"
  },
  {
    country: "ws",
    label: "Samoa"
  },
  {
    country: "sm",
    label: "San Marino"
  },
  {
    country: "st",
    label: "São Tomé og Príncipe"
  },
  {
    country: "sa",
    label: "Saudi-Arabia"
  },
  {
    country: "sn",
    label: "Senegal"
  },
  {
    country: "rs",
    label: "Serbia"
  },
  {
    country: "sc",
    label: "Seychellene"
  },
  {
    country: "sl",
    label: "Sierra Leone"
  },
  {
    country: "sg",
    label: "Singapore"
  },
  {
    country: "sk",
    label: "Slovakia"
  },
  {
    country: "si",
    label: "Slovenia"
  },
  {
    country: "so",
    label: "Somalia"
  },
  {
    country: "es",
    label: "Spania"
  },
  {
    country: "lk",
    label: "Sri Lanka"
  },
  {
    country: "gb",
    label: "Storbritannia"
  },
  {
    country: "sd",
    label: "Sudan"
  },
  {
    country: "sr",
    label: "Surinam"
  },
  {
    country: "ch",
    label: "Sveits"
  },
  {
    country: "se",
    label: "Sverige"
  },
  {
    country: "sz",
    label: "Eswatini"
  },
  {
    country: "sy",
    label: "Syria"
  },
  {
    country: "za",
    label: "Sør-Afrika"
  },
  {
    country: "kr",
    label: "Sør-Korea"
  },
  {
    country: "ss",
    label: "Sør-Sudan"
  },
  {
    country: "tw",
    label: "Taiwan"
  },
  {
    country: "tj",
    label: "Tadsjikistan"
  },
  {
    country: "tz",
    label: "Tanzania"
  },
  {
    country: "th",
    label: "Thailand"
  },
  {
    country: "tg",
    label: "Togo"
  },
  {
    country: "to",
    label: "Tonga"
  },
  {
    country: "tt",
    label: "Trinidad og Tobago"
  },
  {
    country: "td",
    label: "Tsjad"
  },
  {
    country: "cz",
    label: "Tsjekkia"
  },
  {
    country: "tn",
    label: "Tunisia"
  },
  {
    country: "tm",
    label: "Turkmenistan"
  },
  {
    country: "tv",
    label: "Tuvalu"
  },
  {
    country: "tr",
    label: "Tyrkia"
  },
  {
    country: "de",
    label: "Tyskland"
  },
  {
    country: "ug",
    label: "Uganda"
  },
  {
    country: "ua",
    label: "Ukraina"
  },
  {
    country: "hu",
    label: "Ungarn"
  },
  {
    country: "uy",
    label: "Uruguay"
  },
  {
    country: "us",
    label: "USA"
  },
  {
    country: "uz",
    label: "Usbekistan"
  },
  {
    country: "vu",
    label: "Vanuatu"
  },
  {
    country: "ve",
    label: "Venezuela"
  },
  {
    country: "vn",
    label: "Vietnam"
  },
  {
    country: "zm",
    label: "Zambia"
  },
  {
    country: "zw",
    label: "Zimbabwe"
  },
  {
    country: "at",
    label: "Østerrike"
  },
  {
    country: "tl",
    label: "Øst-Timor"
  }
];
function Pm() {
  return Tc().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Tc() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Om = typeof Proxy == "function", Tm = "devtools-plugin:setup", Im = "plugin:settings:set";
let Ma, Rl;
function Mm() {
  var e;
  return Ma !== void 0 || (typeof window < "u" && window.performance ? (Ma = !0, Rl = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Ma = !0, Rl = globalThis.perf_hooks.performance) : Ma = !1), Ma;
}
function qm() {
  return Mm() ? Rl.now() : Date.now();
}
class Em {
  constructor(t, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = r;
    const a = {};
    if (t.settings)
      for (const l in t.settings) {
        const s = t.settings[l];
        a[l] = s.defaultValue;
      }
    const n = `__vue-devtools-plugin-settings__${t.id}`;
    let o = Object.assign({}, a);
    try {
      const l = localStorage.getItem(n), s = JSON.parse(l);
      Object.assign(o, s);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return o;
      },
      setSettings(l) {
        try {
          localStorage.setItem(n, JSON.stringify(l));
        } catch {
        }
        o = l;
      },
      now() {
        return qm();
      }
    }, r && r.on(Im, (l, s) => {
      l === this.plugin.id && this.fallbacks.setSettings(s);
    }), this.proxiedOn = new Proxy({}, {
      get: (l, s) => this.target ? this.target.on[s] : (...u) => {
        this.onQueue.push({
          method: s,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (l, s) => this.target ? this.target[s] : s === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(s) ? (...u) => (this.targetQueue.push({
        method: s,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[s](...u)) : (...u) => new Promise((i) => {
        this.targetQueue.push({
          method: s,
          args: u,
          resolve: i
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function Vm(e, t) {
  const r = e, a = Tc(), n = Pm(), o = Om && r.enableEarlyProxy;
  if (n && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !o))
    n.emit(Tm, e, t);
  else {
    const l = o ? new Em(r, n) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: t,
      proxy: l
    }), l && t(l.proxiedTarget);
  }
}
const Lm = "Acquisit: Component Props", Bm = "Acquisit: Component Data", Ci = "Acquisit: Component Color", ia = {
  events: {
    id: "acquisit-events",
    color: 65280,
    label: "Acquisit: Events"
  },
  guards: {
    id: "acquisit-guards",
    color: 1144746,
    label: "Acquisit: Guards"
  }
};
let Vt = null, jm = 0;
const Ha = (e = !1) => {
  e && !Vt && console.warn("Vue Devtools are not installed. Get them here:", "https://devtools.vuejs.org/");
  const t = (a, n, o) => {
    const l = "track-" + jm++;
    return Vt == null || Vt.addTimelineEvent({
      layerId: a.id,
      event: {
        time: Vt.now(),
        title: n,
        data: o,
        groupId: l
      }
    }), l;
  }, r = (a, n, o) => {
    Vt == null || Vt.addTimelineEvent({
      layerId: a.id,
      event: {
        time: Vt.now(),
        data: {
          done: !0
        },
        title: o,
        groupId: n
      }
    });
  };
  return {
    startTrackingEvent: (a, n) => {
      const o = t(ia.events, a, n);
      return () => {
        r(ia.events, o, a);
      };
    },
    startTrackingGuard: (a, n, o, l) => {
      const s = t(ia.guards, a + ": " + n, {
        action: o,
        arguments: l,
        uid: a
      });
      return () => {
        r(ia.guards, s, n);
      };
    },
    addEvent: (a, n) => {
      Vt == null || Vt.addTimelineEvent({
        layerId: ia.events.id,
        event: {
          time: Vt.now(),
          data: n,
          title: a
        }
      });
    },
    trackGuardSource: (a, n) => {
      Vt == null || Vt.addTimelineEvent({
        layerId: ia.guards.id,
        event: {
          time: Vt.now(),
          data: {
            component: a,
            type: n
          },
          title: "Source: " + a.properties.uid + ":" + n
        }
      });
    },
    trackGuardTarget: (a) => {
      Vt == null || Vt.addTimelineEvent({
        layerId: ia.guards.id,
        event: {
          time: Vt.now(),
          data: a,
          title: "Target; " + a.uid + ":" + a.action
        }
      });
    }
  };
}, VL = {
  install(e) {
    process.env.NODE_ENV == "development" && Vm({
      id: "acquisit.ui.devtools",
      label: "AcquisitUI DevTools",
      packageName: "acquisit-ui",
      homepage: "https://meglerfront.no",
      componentStateTypes: [Bm, Lm],
      enableEarlyProxy: !0,
      app: e
    }, (t) => {
      Rt(ia, (r) => {
        t.addTimelineLayer({
          id: r.id,
          color: r.color,
          label: r.label
        });
      }), t.on.visitComponentTree((r, a) => {
        var l;
        const n = r.treeNode, o = r.componentInstance;
        (l = o.props) != null && l.uid && n.tags.push({
          label: "uid: " + o.props.uid,
          textColor: 6788808,
          backgroundColor: 1845560
        });
      }), t.on.inspectComponent((r, a) => {
        const n = r.componentInstance, o = (l) => ({
          hex: l.cssHex,
          hsla: l.cssHSLA
        });
        if (n.setupState.color) {
          const l = n.setupState.color;
          r.instanceData.state.push({
            type: Ci,
            key: "branding",
            value: l.branding
          }), Rt(l, (s, u) => {
            _a(s) && (s.value instanceof zr || s.value == null) && r.instanceData.state.push({
              type: Ci,
              key: u,
              value: s.value ? o(s.value) : null
            });
          });
        }
      }), Vt = t;
    });
  }
}, Hm = "image:uploaded", Rm = "image:deleted", Fm = "image:metadata-changed", LL = "router:route-changed", io = (e) => Array.isArray(e) ? e : [e];
class Nm {
  constructor() {
    so(this, "eventListeners", /* @__PURE__ */ new Map());
  }
  /**
   * @param {EventName|EventName[]} eventNames
   * @param {Function} callback
   * @param {boolean} [once]
   * @private
   */
  registerEventListener(t, r, a = !1) {
    for (let n of io(t)) {
      this.eventListeners.has(n) || this.eventListeners.set(n, []);
      const o = this.eventListeners.get(n);
      o == null || o.push({ callback: r, once: a });
    }
    return this;
  }
  /**
   * Does this bus have a specific listener for a specific event?
   *
   * @param {EventName|EventName[]} eventNames
   * @param {EventHandler} callback
   *
   * @returns {boolean}
   */
  hasListener(t, r) {
    for (let a of io(t))
      if (this.eventListeners.has(a)) {
        for (const n of this.eventListeners.get(a))
          if (n.callback == r)
            return !0;
      }
    return !1;
  }
  /**
   * Does this bus have any listener for a specific event?
   *
   * @param {EventName|EventName[]} eventNames
   *
   * @returns {boolean}
   */
  hasAnyListener(t) {
    for (let r of io(t))
      if (this.eventListeners.has(r) && this.eventListeners.get(r).length > -1)
        return !0;
    return !1;
  }
  /**
   * See: https://v2.vuejs.org/v2/api/#vm-on
   *
   * @param {EventName|EventName[]} eventNames
   * @param {Function} callback
   */
  $on(t, r) {
    return this.registerEventListener(t, r);
  }
  /**
   * See: https://v2.vuejs.org/v2/api/#vm-once
   *
   * @param {EventName} eventNames
   * @param {Function} callback
   */
  $once(t, r) {
    return this.registerEventListener(t, r, !0);
  }
  /**
   * Removes all event listeners for the given event name or names.
   *
   * When provided with a callback function, removes only event listeners matching the provided function.
   *
   * See: https://v2.vuejs.org/v2/api/#vm-off
   *
   * @param {EventName|EventName[]} eventNames
   * @param {Function} [callback]
   */
  $off(t, r) {
    for (const a of io(t)) {
      const n = this.eventListeners.get(a);
      if (n !== void 0)
        if (typeof r == "function")
          for (let o = n.length - 1; o >= 0; o--)
            n[o].callback === r && n.splice(o, 1);
        else
          this.eventListeners.delete(a);
    }
    return this;
  }
  /**
   * See: https://v2.vuejs.org/v2/api/#vm-emit
   *
   * @param {EventName} eventName
   * @param {any} args
   */
  $emit(t, ...r) {
    if (Ha().addEvent("$emit: " + t, {
      event: t,
      args: r
    }), !this.eventListeners.has(t))
      return this;
    const a = this.eventListeners.get(t), n = [];
    for (const [o, l] of (a == null ? void 0 : a.entries()) ?? [])
      l.callback(...r), l.once && n.push(o);
    for (let o = n.length - 1; o >= 0; o--)
      a == null || a.splice(n[o], 1);
    return this;
  }
}
const Ra = new Nm(), Ic = (e, t, r, a) => {
  const n = Rp();
  if (!n.backend)
    throw new Error("Backend dependency missing");
  const o = n.backend;
  let l = [];
  for (let s of a)
    if (s.deleted) {
      let u = o.deleteImageCollection(s.hash_id).then(() => {
        if (t) {
          if (t.image_collections) {
            for (let i = 0; i < t.image_collections.length; i++)
              if (t.image_collections[i].id == s.id) {
                t.image_collections.splice(i, 1);
                break;
              }
          }
        } else if (Array.isArray(e.properties.modelValue)) {
          for (let i = 0; i < e.properties.modelValue.length; i++)
            if (e.properties.modelValue[i].id == s.id) {
              e.properties.modelValue.splice(i, 1);
              break;
            }
        }
      });
      l.push(u);
    } else if (!s.hash_id && s.images.length) {
      const u = Array.isArray(e.properties.semantic) ? e.properties.semantic[0] : e.properties.semantic;
      let i = o.addImageCollection(s, r, u).then((c) => new Promise((d, p) => {
        s.hash_id = c.hash_id;
        let h = s.images.filter((y) => y.base64).map((y) => o.addImage(s.hash_id, y).then((_) => (y.hash_id = _.hash_id, y.url = _.url, y.base64 = null, y)));
        return Promise.all(h).then(d).catch(p);
      }));
      l.push(i);
    } else {
      s.images.length;
      for (let u of s.images)
        if (u.deleted) {
          let i = o.deleteImage(s.hash_id, u.hash_id).then(() => {
            for (let c = 0; c < s.images.length; c++)
              if (s.images[c].id == u.id) {
                s.images.splice(c, 1);
                break;
              }
          });
          l.push(i);
        } else if (!u.hash_id) {
          let i = o.addImage(s.hash_id, u).then((c) => (u.hash_id = c.hash_id, u.url = c.url, u.base64 = null, u));
          l.push(i);
        }
    }
  return l;
};
class Ym {
  constructor(t = 1, r, a) {
    so(this, "queue", []);
    so(this, "runningPromises", 0);
    this.concurrencyLimit = t, this.onPromiseQueued = r, this.onPromiseResolved = a;
  }
  isFull() {
    return this.runningPromises >= this.concurrencyLimit;
  }
  getConcurrencyLimit() {
    return this.concurrencyLimit;
  }
  getRunningPromises() {
    return this.runningPromises;
  }
  push(t, ...r) {
    return new Promise((a) => {
      this.enqueue(t, a, r), this.runningPromises < 0 && this.run();
    });
  }
  enqueue(t, r, a) {
    this.queue.push(this.runPromise.bind(this, t, r, a)), this.onPromiseQueued && this.onPromiseQueued(this.concurrencyLimit, this.runningPromises + 1), (async () => (await Promise.resolve(), this.runningPromises < this.concurrencyLimit && this.queue.length && this.queue.shift()()))();
  }
  next() {
    this.runningPromises--, this.onPromiseResolved && this.onPromiseResolved(this.concurrencyLimit, this.runningPromises), this.queue.length && this.queue.shift()();
  }
  async runPromise(t, r, a) {
    this.runningPromises++;
    const n = (async () => t(...a))();
    r(n);
    try {
      await n;
    } catch {
    }
    this.next();
  }
  run() {
    return Promise.all(this.queue);
  }
}
class ze {
  /**
   * Create a ValidationError
   * The reference should point to the object (e.g. component) that the validation failed against.
   * The key should contain the name of the property in the reference that failed the validation
   * The owner should contain an object describing who owns the validation error, e.g. a component that creates its own components
   * If the error should actively interrupt the user with a modal, set isUserInterrupting to true. The message should contain
   * a human-friendly message.
   */
  constructor(t, r, a = void 0, n = void 0, o = !1, l = !1) {
    this.message = t, this.reference = r, this.key = a, this.owner = n, this.isUserVisible = o, this.isUserInterrupting = l;
  }
  /**
   * Shallow clone
   * Does not clone reference or owner
   *
   * @return {ValidationError}
   */
  clone() {
    return new ze(this.message, this.reference, this.key, this.owner);
  }
}
var ps = /* @__PURE__ */ ((e) => (e.OR = "OR", e.AND = "AND", e))(ps || {}), Um = /* @__PURE__ */ ((e) => (e.UNIQUE = "unique", e))(Um || {});
const zm = (e) => !!(e && typeof e == "object" && fa(e.type) && Array.isArray(e.selectors) && e.operator && fa(e.error_label)), Mc = (e) => !!(zm(e) && e.type == "unique"), qc = (e) => !e || typeof e != "object" || Object.keys(e).length !== 1 ? !1 : e.uid !== void 0, Ec = (e) => !!(typeof e == "object" && e && (e.dataType || e.value !== void 0) && e.uid), BL = (e) => Ec(e) && e.dataType !== void 0, jL = (e) => Ec(e) && e.value !== void 0, HL = (e) => qc(e), RL = (e) => qc(e);
var Lt = /* @__PURE__ */ ((e) => (e.BOOLEAN = "boolean", e.STRING = "string", e.NUMBER = "number", e.INTEGER = "integer", e.FLOAT = "float", e.DATE = "date", e.DATETIME = "datetime", e.COMPLEX = "complex", e))(Lt || {});
const Wm = ["innerHTML"], Km = /* @__PURE__ */ Pe({
  __name: "VSvgSsr",
  props: {
    ...Fp(),
    ...us()
  },
  async setup(e) {
    let t, r;
    const a = e, n = Cc(a), { svg: o, style: l } = n;
    return o.value = ([t, r] = Ep(() => n.get(a.file)), t = await t, r(), t), (s, u) => g(o) ? (m(), S("span", {
      key: 0,
      class: pe(["svg", { colored: !s.multiColor, stroke: s.stroke, fill: s.fill }]),
      innerHTML: g(o),
      style: we(g(l))
    }, null, 14, Wm)) : B("", !0);
  }
}), Gm = ["innerHTML"], Zm = /* @__PURE__ */ Pe({
  __name: "VSvgBrowser",
  props: {
    ...us()
  },
  setup(e) {
    const t = e;
    Dt("components/VSvgBrowser", Dt.COLOR_COMPONENT);
    const r = Cc(t), { svg: a, style: n } = r;
    return (o, l) => g(a) ? (m(), S("span", {
      key: 0,
      class: pe(["svg", { colored: !o.multiColor, stroke: o.stroke, fill: o.fill }]),
      innerHTML: g(a),
      style: we(g(n))
    }, null, 14, Gm)) : B("", !0);
  }
}), Xm = /* @__PURE__ */ Pe({
  __name: "VSvg",
  props: {
    ...us()
  },
  setup(e) {
    zt((s) => ({
      "341d4908": n.value.cssHSLA,
      "7ea1dd92": o.value.cssHSLA,
      fcc6c6f8: l.value.cssHSLA
    }));
    const t = e, r = Np(t), a = C(() => typeof window > "u" ? Km : Zm), n = C(() => r.baseVisuallySafe.value), o = C(() => {
      const s = r.baseVisuallySafe.value.darken(36);
      return s.perceivedBrightness < 40 ? s.lighten(12) : s;
    }), l = C(() => n.value.lighten(16));
    return (s, u) => (m(), J(Yo(a.value), {
      file: s.file,
      color: t.color,
      "multi-color": s.multiColor,
      stroke: s.stroke,
      fill: s.fill
    }, null, 8, ["file", "color", "multi-color", "stroke", "fill"]));
  }
}), Jm = async ({
  component: e,
  value: t,
  componentsByTag: r,
  enableValueUpdates: a,
  disableValueUpdates: n,
  setProperties: o,
  invalidateAll: l,
  parent: s
}) => {
  if ((s == null ? void 0 : s.tag_normalized) == "checkbox-group")
    return;
  let u = e;
  l();
  let i = r.checkbox ?? [], c = {}, d = r["checkbox-group"] ?? [], p = {};
  for (let y of d)
    for (let _ of y.children.default)
      p[_.properties.uid] = _;
  for (let y of i)
    p[y.properties.uid] || (c[y.properties.uid] = y);
  const h = Vc({
    checkboxes: c,
    clickedCheckbox: u,
    modelValue: t
  });
  n([
    "checkbox"
  ]);
  for (let y in h)
    if (h.hasOwnProperty(y)) {
      let _ = c[y], $ = h[y];
      $.modelValue;
      let w = {
        modelValue: $.modelValue,
        disabled: $.disabled
      };
      $.errors === null && (w.errors = null), o(_, w);
    }
  await Ka(50), a([
    "checkbox"
  ]);
}, Qm = (e) => {
  let t = {};
  for (let r in e)
    e.hasOwnProperty(r) && (t[r] = {
      modelValue: e[r].properties.modelValue,
      disabled: e[r].properties.disabled
    });
  return t;
}, eh = (e) => {
  let t = {};
  for (let r in e)
    e.hasOwnProperty(r) && (t[r] = {
      out: e[r].linked || [],
      in: []
    });
  for (let r in e)
    if (e.hasOwnProperty(r)) {
      for (let a in t)
        if (t.hasOwnProperty(a)) {
          let n = t[a];
          n && n.out.indexOf(r) > -1 && (t[r] || (t[r] = {
            out: [],
            in: []
          }), t[r].in.push(a));
        }
    }
  return t;
}, Vc = ({ checkboxes: e, clickedCheckbox: t, modelValue: r }) => {
  let a = t.properties.uid, n = Qm(e), o = n[a], l = eh(e), s = {}, u = {};
  for (let i in e)
    if (e.hasOwnProperty(i)) {
      let c = e[i];
      i == a || (c.linked || []).indexOf(a) > -1 ? s[i] = n[i] : u[i] = n[i];
    }
  for (let i in s)
    if (s.hasOwnProperty(i) && n.hasOwnProperty(i)) {
      let c = n[i];
      c.disabled = !1, i == t.properties.uid && (c.modelValue = r, c.errors = null);
    }
  for (let i of t.linked || [])
    n[i] !== void 0 && (o.modelValue && (n[i].modelValue = !1), n[i].disabled = o.modelValue, n[i].errors = null);
  for (let i in u)
    if (u.hasOwnProperty(i)) {
      let c = e[i];
      if (c.properties.modelValue)
        for (let d of c.linked || [])
          n[d] !== void 0 && (n[d].modelValue = !1, n[d].disabled = !0);
      if (c.properties.disabled && l[c.properties.uid]) {
        let d = !1;
        for (let p of l[c.properties.uid].in)
          n[p].modelValue && (d = !0);
        d || (n[c.properties.uid].disabled = !1);
      }
    }
  return n;
}, Si = async ({
  component: e,
  value: t,
  setProperties: r,
  invalidateAll: a
}) => {
  a(), vc(e.properties.modelValue, t) || r(e, {
    modelValue: t,
    declined: !1
  });
}, th = ({ component: e, componentsByUID: t, componentsByTag: r, owner: a, setProperties: n, pagesByUID: o, productsByUID: l, personsByID: s }) => new Promise((u, i) => {
  if (e.required && !e.properties.disabled && !e.properties.modelValue) {
    if (e.validation_linked || e.linked) {
      let d = [].concat(e.validation_linked || []).concat(e.linked || []), p = {};
      for (let h of d) {
        if (h == e.properties.uid || p[h]) continue;
        let y = t[h];
        if (y && !y.properties.disabled && y.properties.modelValue) {
          u(!0);
          return;
        }
        p[h] = !0;
      }
    }
    i([new ze("value missing", e, "value", a)]);
    return;
  }
  e.children && !e.properties.disabled && (e.properties.childrenInverted ? !e.properties.modelValue : e.properties.modelValue) ? Gr({
    components: zo(e.children),
    componentsByUID: t,
    componentsByTag: r,
    pagesByUID: o,
    productsByUID: l,
    personsByID: s,
    owner: a,
    setProperties: n
    //}).then(resolve).catch(_ => void(0))
  }).then(u).catch(i) : u(!0);
}), rh = ({ component: e }) => new Promise((t, r) => {
  if (e.properties.modelValue == "error") {
    r([
      new ze('value was "error"', e, "value")
    ]);
    return;
  }
  t(!0);
}), ah = ({ component: e, componentsByUID: t, owner: r }) => new Promise(async (a, n) => {
  var l, s, u, i, c, d, p, h, y, _, $, w, L, R;
  const o = (q, E = !1, Y = "modelValue") => new ze(
    q,
    e,
    Y,
    r,
    E
  );
  try {
    let q = [];
    const E = e.properties.modelValue;
    let Y = !!E, V = !!e.required && !e.properties.disabled;
    if (e.properties.type == "number" && e.properties.allow_zero && (Y = Y || E === 0 || E === "0"), V && !Y && q.push(o(
      Wt((l = e.validation_error_labels) == null ? void 0 : l.required, void 0, "value missing"),
      !!((s = e.validation_error_labels) != null && s.required)
    )), Y) {
      if (e.properties.format && e.properties.format != "number") {
        let T = rs(e.properties.format).replace(/\+$/, ""), A = Ao(E, e.properties.format);
        T.length > A.length && q.push(o(
          Wt((u = e.validation_error_labels) == null ? void 0 : u.too_short, void 0, "Value too short"),
          !!((i = e.validation_error_labels) != null && i.too_short)
        ));
      }
      e.properties.min_length && String(E || "").length < e.properties.min_length ? q.push(o(
        Wt((c = e.validation_error_labels) == null ? void 0 : c.too_short, void 0, "Value too short"),
        !!((d = e.validation_error_labels) != null && d.too_short)
      )) : e.properties.max_length && String(E || "").length > e.properties.max_length && q.push(o(
        Wt((p = e.validation_error_labels) == null ? void 0 : p.too_long, void 0, "Value too long"),
        !!((h = e.validation_error_labels) != null && h.too_long)
      )), e.properties.type == "email" && !pc(E) && q.push(o(
        Wt((y = e.validation_error_labels) == null ? void 0 : y.invalid_email_address, void 0, "Invalid email address"),
        !!((_ = e.validation_error_labels) != null && _.invalid_email_address)
      )), e.properties.regex && (new RegExp(e.properties.regex).test(String(E)) || q.push(o(
        Wt(($ = e.validation_error_labels) == null ? void 0 : $.regex_mismatch, void 0, "Value does not match regex"),
        !!((w = e.validation_error_labels) != null && w.regex_mismatch)
      )));
    }
    if (Array.isArray(e.linked) && e.linked.length)
      for (let T of e.linked) {
        let A = t[T];
        if (!A) {
          console.warn('Could not find linked component "' + T + '" in "' + e.properties.uid + '"');
          continue;
        }
        switch (A.tag_normalized) {
          case "input":
            String(A.properties.modelValue).trim() != String(E).trim() && q.push(o(
              Wt((L = e.validation_error_labels) == null ? void 0 : L.value_mismatch, void 0, "Value mismatch"),
              !!((R = e.validation_error_labels) != null && R.value_mismatch)
            ));
            break;
        }
      }
    q.length ? n(q) : a(!0);
  } catch (q) {
    n(q);
  }
}), nh = ({ component: e, owner: t }) => new Promise((r, a) => {
  e.required && !e.properties.disabled && (!Array.isArray(e.properties.modelValue) || !e.properties.modelValue.length) ? a([new ze("value missing", e, "value", t)]) : r(!0);
}), oh = ({ component: e, owner: t, personsByID: r, pagesByUID: a, productsByUID: n }) => new Promise(async (o, l) => {
  var $, w, L, R, q, E, Y, V, T, A, P, b;
  const s = e.properties.types || {}, u = Yp(Array.isArray(e.properties.modelValue) ? e.properties.modelValue : []), i = Object.values(r).filter((x) => e.properties.modelValue ? u[x.id] && s[x.type] : s[x.type]), c = e.properties.edit_person_modal, d = e.properties.max_persons || null, p = e.properties.required_types || null, h = {
    name_missing: Wt(($ = e.validation_error_labels) == null ? void 0 : $.name_missing, void 0, "Name missing"),
    commercial_name_missing: Wt((w = e.validation_error_labels) == null ? void 0 : w.commercial_name_missing, void 0, "Commercial name missing"),
    contact_missing: Wt((L = e.validation_error_labels) == null ? void 0 : L.contact_missing, void 0, "Contact missing"),
    birthdate_in_future: Wt((R = e.validation_error_labels) == null ? void 0 : R.birthdate_in_future, void 0, "Birthdate cannot be in the future"),
    birthdate_missing: Wt((q = e.validation_error_labels) == null ? void 0 : q.birthdate_missing, void 0, "Birthdate missing")
  };
  let y = [];
  const _ = {};
  Rt(s, (x, D) => {
    _[D] = 0;
  });
  for (let x of i) {
    if (_[x.type] === void 0 && (_[x.type] = 0), _[x.type] += 1, c) {
      let D = !La(x.org_number);
      if (La(x.name)) {
        const M = D ? h.commercial_name_missing : h.name_missing;
        y.push(new ze(M, e, "name", {
          owner: t,
          person: x,
          component_uid: e.properties.uid
        }, !!((E = e.validation_error_labels) != null && E.name_missing)));
      }
      x.type == "buyer" && c.phone_input_label && (!x.contact || !x.contact.email && !x.contact.phone.national) && y.push(new ze(h.contact_missing, e, "contact", {
        owner: t,
        person: x,
        component_uid: e.properties.uid
      }, !!((Y = e.validation_error_labels) != null && Y.contact_missing))), D || (c.birthdate_input_label && ((V = x.birthdate) != null && V.timestamp) && x.birthdate.timestamp > Wo.now().getTimestamp() && y.push(new ze(h.birthdate_in_future, e, "birthdate", {
        owner: t,
        person: x,
        component_uid: e.properties.uid
      }, !!((T = e.validation_error_labels) != null && T.birthdate_in_future))), x.type == "buyer" && c.birthdate_input_label && c.birthdate_required && !((A = x.birthdate) != null && A.timestamp) && !x.person_number && !x.org_number && y.push(new ze(h.birthdate_missing, e, "birthdate", {
        owner: t,
        person: x,
        component_uid: e.properties.uid
      }, !!((P = e.validation_error_labels) != null && P.birthdate_missing))));
    }
    if ((b = x.additional_components) != null && b.length) {
      let D = x.additional_components, N = wr(D), M = nn(D);
      try {
        await Gr({
          owner: {
            owner: t,
            person: x,
            component_uid: e.properties.uid,
            key: "additional_components",
            path: [
              ...t.path ?? [],
              {
                component_uid: e.properties.uid,
                person: x
              }
            ]
          },
          setProperties: as,
          components: x.additional_components,
          componentsByUID: N,
          componentsByTag: M,
          pagesByUID: a,
          productsByUID: n,
          personsByID: r
        });
      } catch (H) {
        if (Array.isArray(H))
          y = y.concat(H);
        else
          throw H;
      }
    }
  }
  (p || d) && Rt(_, (x, D) => {
    p != null && p[D] && x < p[D] && y.push(new ze('Too few persons of type "' + D + '", ' + p[D] + " required", e, "required_types", {
      owner: t,
      type: D
    })), d && x > d && y.push(new ze('Too many persons of type "' + D + '"', e, "max_persons", {
      owner: t,
      type: D
    }));
  }), y.length ? l(y) : o(!0);
}), hl = (e, t, r) => ({
  component_uid: e.properties.uid,
  path: ((r == null ? void 0 : r.path) || []).concat([{ component_uid: e.properties.uid, person_id: t }]),
  person_id: t
}), lh = ({ component: e, owner: t, pagesByUID: r, productsByUID: a, personsByID: n, componentsByUID: o }) => new Promise((l, s) => {
  if (e.properties.modelValue && typeof e.properties.modelValue != "object")
    throw new Error("Value of persons-layout must be an object, " + typeof e.properties.modelValue + " received");
  const u = !!(e.properties.modelValue && Object.keys(e.properties.modelValue).length), i = e.properties.constraints ?? [];
  if (u) {
    let c = [], d = [], p = (h, y) => {
      for (let _ in y)
        y.hasOwnProperty(_) && (h.properties[_] = y[_]);
    };
    for (let h in e.properties.modelValue)
      if (e.properties.modelValue.hasOwnProperty(h)) {
        let y = e.properties.modelValue[h].components, _ = wr(y), $ = nn(y);
        for (let w of y)
          c.push(ms({
            owner: hl(e, h, t),
            setProperties: p,
            component: w,
            componentsByUID: _,
            componentsByTag: $,
            pagesByUID: r,
            productsByUID: a,
            personsByID: n
          }));
      }
    if (i != null && i.length) {
      for (let h of i)
        if (Mc(h)) {
          const y = {};
          for (let $ in e.properties.modelValue)
            if (e.properties.modelValue.hasOwnProperty($)) {
              if (h.condition && !Po(h.condition, {
                componentsByUID: o,
                pagesByUID: r,
                productsByUID: a,
                personsByID: n,
                scope: {
                  person: n[$]
                }
              }))
                continue;
              let w = e.properties.modelValue[$].components, L = wr(w);
              for (let R of h.selectors) {
                const q = L[R.uid];
                if (q) {
                  const E = mc(q.properties, R.property), Y = R.uid + "+" + R.property + "+" + JSON.stringify(E);
                  y[Y] || (y[Y] = []), y[Y].push({
                    personID: $,
                    component: q,
                    property: R.property,
                    value: E
                  });
                }
              }
            }
          let _ = !0;
          if (h.operator == ps.AND) {
            let $ = 0;
            Rt(y, (w) => {
              w.length > 1 && $++;
            }), $ >= h.selectors.length && Rt(y, (w) => {
              let L = !0;
              if (w.length > 1)
                for (let R of w) {
                  if (L) {
                    L = !1;
                    continue;
                  }
                  d.push(new ze(
                    Wt(h.error_label, void 0),
                    R.component,
                    R.property,
                    hl(e, R.personID, t),
                    _
                  )), _ = !1;
                }
            });
          } else
            Rt(y, ($) => {
              if ($.length > 1)
                for (let w of $)
                  d.push(new ze(
                    Wt(h.error_label, void 0),
                    w.component,
                    w.property,
                    hl(e, w.personID, t),
                    _
                  )), _ = !1;
            });
        }
    }
    Promise.allSettled(c).then((h) => {
      for (let y of h)
        y.status == "rejected" && (d = d.concat(y.reason));
      d.length ? s(d) : l(!0);
    });
  } else
    l(!0);
}), yl = (e, t, r) => ({
  component_uid: e.properties.uid,
  path: ((r == null ? void 0 : r.path) || []).concat([{ component_uid: e.properties.uid, item: t }]),
  item: t
}), xi = ({ component: e, owner: t, setProperties: r, componentsByUID: a, componentsByTag: n, pagesByUID: o, productsByUID: l, personsByID: s }, u = null) => new Promise((i, c) => {
  let d = e.properties.no_items_checkbox, p = d && d.value;
  const h = u ?? e.properties.modelValue ?? [];
  let y = () => new Promise((L, R) => {
    e.required && !p && (!e.properties.modelValue || !e.properties.modelValue.length) && R([new ze("Value missing", e, "value", t)]), L(!0);
  }), _ = () => new Promise((L, R) => {
    let q = [], E = [];
    if (!d || !p)
      for (let Y of h) {
        let V = wr(Y.components), T = nn(Y.components);
        for (let A of Y.components)
          q.push(ms({
            component: A,
            componentsByUID: V,
            componentsByTag: T,
            pagesByUID: o,
            productsByUID: l,
            personsByID: s,
            owner: yl(e, Y, t),
            setProperties: r
          }));
      }
    Promise.allSettled(q).then((Y) => {
      for (let V of Y)
        V.status == "rejected" && (E = E.concat(V.reason));
      E.length ? R(E) : L(!0);
    });
  }), $ = () => new Promise((L, R) => {
    if (e.properties.modelValue && e.properties.modelValue.length) {
      const q = qr();
      let E = [];
      for (let Y of h)
        E = E.concat(Ic(
          e,
          Y,
          {
            component: e.properties.uid
          },
          Y.image_collections || []
        ));
      E.length && q.setLoader(!0), Promise.all(E).then(() => {
        L(!0);
      }).catch((Y) => {
        R(Y);
      }).finally(() => {
        q.setLoader(!1);
      });
    } else
      L(!0);
  }), w = () => new Promise((L, R) => {
    if (Array.isArray(e.properties.constraints)) {
      const q = e.properties.constraints;
      let E = [];
      for (let Y of q)
        if (Mc(Y)) {
          const V = {};
          for (let A of h) {
            if (Y.condition && !Po(Y.condition, {
              componentsByUID: a,
              pagesByUID: o,
              productsByUID: l,
              personsByID: s,
              scope: {
                item: A
              }
            }))
              continue;
            let P = wr(A.components);
            for (let b of Y.selectors) {
              const x = P[b.uid];
              if (x) {
                const D = mc(x.properties, b.property), N = b.uid + "+" + b.property + "+" + JSON.stringify(D);
                V[N] || (V[N] = []), V[N].push({
                  item: A,
                  component: x,
                  property: b.property,
                  value: D
                });
              }
            }
          }
          let T = !0;
          if (Y.operator == ps.AND) {
            let A = 0;
            Rt(V, (P) => {
              P.length > 1 && A++;
            }), A >= Y.selectors.length && Rt(V, (P) => {
              let b = !0;
              if (P.length > 1)
                for (let x of P) {
                  if (b) {
                    b = !1;
                    continue;
                  }
                  E.push(new ze(
                    Wt(Y.error_label, void 0),
                    x.component,
                    x.property,
                    yl(e, x.item, t),
                    T
                  )), T = !1;
                }
            });
          } else
            Rt(V, (A) => {
              if (A.length > 1)
                for (let P of A)
                  E.push(new ze(
                    Wt(Y.error_label, void 0),
                    P.component,
                    P.property,
                    yl(e, P.item, t),
                    T
                  )), T = !1;
            });
        }
      E.length ? R(E) : L(!0);
    } else
      L(!0);
  });
  Promise.allSettled([
    y(),
    _(),
    $(),
    w()
  ]).then((L) => {
    let R = [];
    for (let q of L)
      q.status == "rejected" && (R = R.concat(q.reason));
    R.length ? c(R) : i(!0);
  });
}), sh = ({ component: e, owner: t }) => new Promise((r, a) => {
  let n = Number(e.properties.modelValue);
  if (e.required && n <= 0) {
    a([new ze("value missing or lower than 0", e, "value", t)]);
    return;
  }
  let o = [];
  fa(n) && (e.properties.min && n < e.properties.min && o.push(new ze("value is lower than min", e, "value", t)), e.properties.max && n > e.properties.max && o.push(new ze("value is higher than max", e, "value", t))), o.length ? a(o) : r(!0);
}), ih = ({ component: e, owner: t }) => new Promise((r, a) => {
  var s, u;
  let n = e.properties.modelValue;
  if (!n)
    if (e.required) {
      let i = [new ze("Value missing", e, "value", t)];
      a(i);
      return;
    } else {
      r(!0);
      return;
    }
  let o = [], l = {
    address: hc,
    city: Up,
    postcode: (i) => {
      let c = rs(e.properties.postcode_format || "DDDD+").replace(/\+$/, ""), d = Ao(i, e.properties.postcode_format);
      return c.length <= d.length && d.length <= 6;
    }
  };
  for (let i of n) {
    let c = i.address.undefined_address || ((s = i.address.temporary) == null ? void 0 : s.enabled), d = e.required || !!i.address.address || !!i.address.postcode || !!i.address.city;
    for (let p in i.address) {
      let h = p == "address" || p == "postcode" || p == "city" || p == "date";
      i.address.hasOwnProperty(p) && h && !c && (i.address[p] ? p in l && !l[p](i.address[p]) && o.push(new ze(p + " invalid", e, p, {
        owner: t,
        change: i
      })) : d && o.push(new ze(p + " missing", e, p, {
        owner: t,
        change: i
      })));
    }
    if (e.properties.temporary_address_label && ((u = i.address.temporary) != null && u.enabled)) {
      let p = ["address", "postcode", "city"];
      for (let h of p)
        i.address.temporary[h] ? h in l && !l[h](i.address.temporary[h]) && o.push(new ze("temporary_" + h + " invalid", e, "temporary_" + h, {
          owner: t,
          change: i
        })) : e.required && o.push(new ze("temporary_" + h + " missing", e, "temporary_" + h, {
          owner: t,
          change: i
        }));
    }
  }
  o.length ? a(o) : r(!0);
}), uh = Dt("validators/single-product-chooser", Dt.COLOR_VALIDATOR), Di = ({
  component: e,
  componentsByUID: t,
  componentsByTag: r,
  productsByUID: a,
  personsByID: n,
  pagesByUID: o,
  owner: l,
  setProperties: s
}) => new Promise((u, i) => {
  var y, _, $;
  let c = [], d = !1;
  for (let w of e.properties.modelValue || []) {
    const L = a[w];
    if (!L) {
      uh.always.warn("Trying to validate a product that could not be found:", w);
      continue;
    }
    if (L.selected && (d = !0, (y = L.terms) != null && y.checkbox_label && !L.terms_agreed && c.push(new ze("Terms not agreed", e, "terms_agreed", {
      owner: l,
      product: L
    })), L.checkboxes))
      for (let R of L.checkboxes)
        R.required && !((_ = L.checkboxes_values) != null && _[R.uid]) && c.push(new ze("Checkbox not checked", e, R.uid, {
          owner: l,
          product: L
        }));
  }
  let p = e.properties.already_ordered, h = !d && !p;
  c.length ? i(c) : (s(e, {
    declined: h
  }), Array.isArray(($ = e.children) == null ? void 0 : $.default) ? Gr({
    components: e.children.default,
    componentsByUID: t,
    componentsByTag: r,
    productsByUID: a,
    personsByID: n,
    pagesByUID: o,
    owner: l,
    setProperties: s
  }).then(u).catch(i) : u(!0));
});
let ch = (e, t, r, a) => {
  let n = (u) => [
    e.properties.use_person_address_label && u.address.address,
    e.properties.use_estate_address_label
  ].filter((i) => !!i).length > 0, o = [], l = n(t), s = {
    owner: a,
    person: t
  };
  return l && !(r.use_person_address || r.use_estate_address || r.use_custom_address) ? (o.push(new ze("Billing Address option not chosen", e, "billing_address", s)), o) : (e.properties.billing_address_label && (!l || r.use_custom_address !== !1) && (r ? (r.address ? hc(r.address ?? "") || o.push(new ze("Billing Address invalid", e, "billing_address.address", s)) : o.push(new ze("Billing Address missing", e, "billing_address.address", s)), r.postcode ? zp(r.postcode) || o.push(new ze("Billing Postcode invalid", e, "billing_address.postcode", s)) : o.push(new ze("Billing Postcode missing", e, "billing_address.postcode", s)), r.city || o.push(new ze("Billing City missing", e, "billing_address.city", s))) : (o.push(new ze("Billing Address missing completely", e, "billing_address.address", s)), o.push(new ze("Billing Address missing completely", e, "billing_address.postcode", s)), o.push(new ze("Billing Address missing completely", e, "billing_address.city", s)))), o);
};
const dh = ({ component: e, owner: t, personsByID: r }) => new Promise((a, n) => {
  let o = [], l = e.properties.modelValue;
  const s = Object.values(r), u = s.filter((d) => d.role == pr.SELLER) ?? [], i = s.filter((d) => d.role == pr.BUYER) ?? [];
  let c = {
    [String(pr.SELLER)]: "selected_seller_id",
    [String(pr.BUYER)]: "selected_buyer_id"
  };
  (!e.properties.role_seller_label || !u.length) && delete c[String(pr.SELLER)], (!e.properties.role_buyer_label || !i.length) && delete c[String(pr.BUYER)];
  for (let d in c)
    if (c.hasOwnProperty(d)) {
      let p = c[d], h = l[p];
      if (!h)
        o.push(new ze("Marking missing", e, p, {
          owner: t,
          role: d
        }));
      else {
        const y = r[h];
        y ? l.billing_addresses && (o = o.concat(ch(e, y, l.billing_addresses[y.id], t))) : o.push(new ze("Person missing", e, "selected_seller_id", {
          owner: t,
          personID: h
        }));
      }
    }
  o.length ? n(o) : a(!0);
}), fh = ({ component: e, componentsByUID: t, componentsByTag: r, owner: a, setProperties: n, pagesByUID: o, productsByUID: l, personsByID: s }) => new Promise(async (u, i) => {
  const c = [], d = [];
  for (let h of e.children.default ?? [])
    h.tag_normalized == "checkbox" ? c.push(h) : d.push(h);
  if (e.required || e.properties.require == "one" || e.properties.require == "all") {
    let h = 0;
    for (let $ of c)
      $.properties.modelValue && h++;
    const y = (e.required || e.properties.require == "one") && h >= 1 || e.properties.require == "all" && h == c.length, _ = [];
    if (!y) {
      for (let $ of c)
        if (!$.properties.modelValue) {
          const w = new ze("value missing", $, "modelValue", a);
          _.push(w), n($, {
            errors: [
              w
            ]
          });
        }
      i(_);
      return;
    }
  }
  if (e.properties.allow == "one") {
    let h = 0, y = [];
    for (let _ of c)
      _.properties.modelValue === !0 && (h++, y.push(_));
    if (h > 1) {
      for (let _ of y)
        n(_, {
          errors: [
            new ze("Duplicate value", _, "modelValue", a)
          ]
        });
      i([
        new ze("Only one selection allowed", e, "children", a)
      ]);
      return;
    }
  }
  let p = [];
  for (let h of c)
    if (h.validated = !0, h.properties.modelValue && h.children.default.length)
      try {
        await Gr({
          components: h.children.default,
          componentsByUID: t,
          componentsByTag: r,
          pagesByUID: o,
          productsByUID: l,
          personsByID: s,
          owner: a,
          setProperties: n
        });
      } catch (y) {
        p = p.concat(y);
      }
  if (p.length) {
    i(p);
    return;
  }
  if (d.length)
    try {
      await Gr({
        components: d,
        componentsByUID: t,
        componentsByTag: r,
        pagesByUID: o,
        productsByUID: l,
        personsByID: s,
        owner: a,
        setProperties: n
      });
    } catch (h) {
      i(h);
      return;
    }
  u(!0);
}), vh = ({ component: e, owner: t }) => new Promise((r, a) => {
  var n;
  if (e.required && !(Array.isArray(e.properties.modelValue) && Array.isArray((n = e.properties.modelValue[0]) == null ? void 0 : n.images) && e.properties.modelValue[0].images.filter((l) => !l.deleted).length > 0)) {
    let l = [new ze("Value missing", e, "value", t)];
    a(l);
    return;
  }
  if (e.properties.modelValue.length) {
    const o = qr();
    let l = Ic(
      e,
      null,
      {
        component: e.properties.uid
      },
      e.properties.modelValue
    );
    l.length && o.setLoader(!0), Promise.allSettled(l).then((s) => {
      let u = [];
      for (let i of s)
        i.status == "rejected" && (u = u.concat(i.reason));
      u.length ? a(u) : r(!0);
    }).catch((s) => {
      a(s);
    }).then((s) => {
      o.setLoader(!1);
    });
  } else
    r(!0);
}), ph = ({ component: e, owner: t }) => new Promise(async (r, a) => {
  if (e.required) {
    const n = e.properties.modelValue;
    if (n && typeof n == "object") {
      if (!n.value) {
        a([
          new ze("Value in object missing", e, "modelValue", t)
        ]);
        return;
      }
    } else {
      a([
        new ze("Value missing entirely", e, "modelValue", t)
      ]);
      return;
    }
  }
  r(!0);
}), mh = Dt("validators/multi-product-chooser", Dt.COLOR_VALIDATOR), hh = ({
  component: e,
  productsByUID: t,
  owner: r
}) => new Promise((a, n) => {
  var l;
  let o = [];
  for (let s of e.properties.modelValue || []) {
    const u = t[s];
    if (!u) {
      mh.always.warn("Trying to validate a product that could not be found:", s);
      continue;
    }
    if (u.selected && u.checkboxes)
      for (let i of u.checkboxes)
        i.required && !((l = u.checkboxes_values) != null && l[i.uid]) && o.push(new ze("Checkbox not checked", e, i.uid, {
          owner: r,
          product: u
        }));
  }
  o.length ? n(o) : a(!0);
}), yh = ({ component: e, owner: t }) => new Promise((r, a) => {
  if (e.required && !(Array.isArray(e.properties.modelValue) && e.properties.modelValue.length)) {
    a([
      new ze("Images missing", e, "value", t)
    ]);
    return;
  }
  r(!0);
}), bh = Dt("validators", Dt.COLOR_VALIDATOR), bl = Dt("validators", "lightgreen"), gh = Dt("validators", "pink"), _h = (e) => ({
  componentsByUID: e.componentsByUID,
  pagesByUID: e.pagesByUID,
  productsByUID: e.productsByUID,
  personsByID: e.personsByID,
  scope: {}
}), gl = (e, t) => {
  t(e, {
    errors: null
  }), e.validated = !0;
}, wh = (e, t, r) => {
  t(e, {
    errors: r
  }), e.validated = !1;
}, Oo = (e, t, r, a) => {
  if (e.properties.errors && (r(e, {
    errors: null
  }), t && r(t, {
    errors: null
  })), ns(e, (n) => {
    Oo(n, null, r, a);
  }), a && Array.isArray(e.validation_linked) && e.validation_linked.length)
    for (let n of e.validation_linked) {
      let o = a[n];
      o && o.properties.errors && Oo(o, null, r, a);
    }
}, ms = (e) => {
  let { component: t, componentsByUID: r, componentsByTag: a, owner: n = null, setProperties: o, pagesByUID: l, productsByUID: s, personsByID: u } = e, i = Lc[t.tag_normalized] || kh;
  return uo("beforeValidation", e, void 0), new Promise((c, d) => {
    const p = Ha().startTrackingEvent("validateComponent: " + e.component.tag_normalized, {
      ...e
    });
    let h = Wp(t, _h(e));
    t.hidden || h ? (bl.debugFrom("validateComponent", t.properties.uid, "is hidden or disabled, skipping validation"), gl(t, o), p(), c(!0)) : (bh.debugFrom("validateComponent", t.properties.uid, i), i({
      component: t,
      componentsByUID: r,
      componentsByTag: a,
      pagesByUID: l,
      productsByUID: s,
      personsByID: u,
      owner: n,
      setProperties: o
    }).then(() => {
      bl.debugFrom("validateComponent:then", "Resolve", t.properties.uid), gl(t, o), c(!0), uo("afterValidation", e, []);
    }).catch((y) => {
      let _ = !1, $ = null;
      if (Array.isArray(t.validation_linked) && t.validation_linked.length) {
        for (let w of t.validation_linked)
          if (r[w].validated) {
            _ = !0, $ = w;
            let L = (R, q) => {
              var E;
              for (let Y in R.children)
                if (R.children.hasOwnProperty(Y)) {
                  const V = R.children[Y];
                  for (let T of V)
                    if (T.properties.uid == ((E = q.reference) == null ? void 0 : E.properties.uid) || L(T, q))
                      return !0;
                }
              return !1;
            };
            for (let R of y)
              if (R instanceof ze && L(t, R)) {
                _ = !1, $ = null;
                break;
              }
            if (_)
              break;
          }
      }
      _ ? (bl.debugFrom("validateComponent:catch", "Resolve due to validation link", t.properties.uid, "resolved link", $), gl(t, o), c(!0), uo("afterValidation", e, [])) : (gh.debugFrom("validateComponent:catch", "Reject with errors", t.properties.uid, y), wh(t, o, y), d(y), uo("afterValidation", e, y));
    }).finally(() => {
      p();
    }));
  });
}, Gr = ({ components: e, componentsByUID: t, componentsByTag: r, owner: a, setProperties: n, pagesByUID: o, productsByUID: l, personsByID: s }) => new Promise((u, i) => {
  e.length || u(!0);
  let c = [];
  for (let d of e)
    c.push(ms({
      component: d,
      componentsByUID: t,
      componentsByTag: r,
      pagesByUID: o,
      productsByUID: l,
      personsByID: s,
      owner: a,
      setProperties: n
    }).then(() => n(d, {
      errors: null
    })));
  Promise.allSettled(c).then((d) => {
    let p = [];
    for (let h of d)
      h.status == "rejected" && (p = p.concat(h.reason));
    p.length ? i(p) : u(!0);
  });
}), kh = ({ component: e, componentsByUID: t, componentsByTag: r, owner: a, setProperties: n, pagesByUID: o, productsByUID: l, personsByID: s }) => new Promise((u, i) => {
  e.required && !e.properties.disabled && !e.properties.modelValue ? i([new ze("value missing", e, "value", a)]) : Array.isArray(e.children) && e.children.length ? Gr({
    components: e.children,
    componentsByUID: t,
    componentsByTag: r,
    pagesByUID: o,
    productsByUID: l,
    personsByID: s,
    owner: a,
    setProperties: n
  }).then((c) => u(!0)).catch(i) : u(!0);
}), yn = ({ component: e, componentsByUID: t, componentsByTag: r, owner: a, setProperties: n, pagesByUID: o, productsByUID: l, personsByID: s }) => {
  if (yc(e)) {
    const u = zo(e.children);
    return Gr({
      components: u,
      componentsByUID: t,
      componentsByTag: r,
      pagesByUID: o,
      productsByUID: l,
      personsByID: s,
      owner: a,
      setProperties: n
    });
  }
  return cr();
}, cr = () => new Promise((e) => {
  e(!0);
}), $h = ({ component: e, owner: t }) => new Promise((r, a) => {
  a([
    new ze("component must not validate while visible", e, "value", t)
  ]);
}), Lc = {
  "accordion-item": yn,
  button: cr,
  checklist: cr,
  checkbox: th,
  "checkbox-group": fh,
  "container-layout": yn,
  "context-menu": cr,
  "country-chooser": ph,
  divider: cr,
  header: cr,
  "horizontal-layout": yn,
  icon: cr,
  image: cr,
  "image-button": cr,
  "image-input": vh,
  "info-box": rh,
  input: ah,
  "items-editor": xi,
  "items-input": xi,
  modal: cr,
  "multi-product-chooser": hh,
  pagination: cr,
  "persons-address": ih,
  "persons-chooser": nh,
  "persons-editor": oh,
  "persons-layout": lh,
  "product-person-chooser": dh,
  "single-product-chooser-list": Di,
  "single-product-chooser-carousel": Di,
  tabs: yn,
  tab: yn,
  stepper: sh,
  span: cr,
  spacer: cr,
  spinner: $h,
  "viewfinder-image-input": yh
}, FL = (e, t) => Lc[e] = t, Fa = {
  beforeValidation: [],
  afterValidation: []
}, NL = (e, t) => {
  e in Fa || (Fa[e] = []), Fa[e].push(t);
}, YL = (e, t) => {
  const r = Fa[e].indexOf(t);
  r !== -1 && Fa[e].splice(r, 1);
}, uo = (e, t, r) => {
  for (const a of Fa[e] ?? [])
    a(e, t, r);
}, Ch = async ({
  component: e,
  parent: t,
  setProperties: r,
  invalidateAll: a
}) => {
  a(), ns(e, (n) => {
    Oo(n, t, r);
  });
}, Sh = async (e) => {
  let t = Bc[e.component.tag_normalized] || xh;
  Ai("beforeHandle", e);
  const r = Ha().startTrackingEvent("handleComponentValue: " + e.component.tag_normalized, {
    ...e
  });
  await t(e), e.clearErrorsForComponent(e.component, e.parent, e.setProperties, e.componentsByUID), r(), Ai("afterHandle", e);
}, xh = async ({ component: e, value: t, setProperties: r, invalidateAll: a }) => {
  r(e, {
    modelValue: t
  }), a();
}, Bc = {
  checkbox: Jm,
  "checkbox-group": Ch,
  "single-product-chooser-carousel": Si,
  "single-product-chooser-list": Si
}, UL = (e, t) => Bc[e] = t, Na = {
  beforeHandle: [],
  afterHandle: []
}, zL = (e, t) => {
  e in Na || (Na[e] = []), Na[e].push(t);
}, WL = (e, t) => {
  const r = Na[e].indexOf(t);
  r !== -1 && Na[e].splice(r, 1);
}, Ai = (e, t) => {
  for (const r of Na[e] ?? [])
    r(e, t);
}, jc = Pe({
  name: "ComponentsContainer",
  props: {
    uid: {
      type: String,
      required: !1,
      default() {
        return xr("container-");
      }
    },
    components: {
      type: Array,
      required: !0
    },
    owner: {
      type: Object,
      required: !1,
      default: null
    },
    guards: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    errors: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    hasCurrentErrors: {
      type: Boolean,
      required: !1,
      default: !1
    },
    invalidators: {
      type: Object,
      required: !1,
      default: null
    },
    noInteract: {
      type: Boolean,
      required: !1,
      default: !1
    },
    noChildren: {
      type: Boolean,
      required: !1,
      default: !1
    },
    displayOnly: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    transitions: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hostPage: {
      type: Object,
      required: !1,
      default: null
    },
    ignoreDisplayConditions: {
      type: Boolean,
      required: !1,
      default: !1
    },
    ignoreDisabledConditions: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  inject: {
    injected_uiComponentExists: {
      from: Sc,
      default: () => (e) => !1
    },
    injected_componentsStore: {
      from: mm
    },
    injected_pagesStore: {
      from: pm
    },
    injected_productsStore: {
      from: vm
    },
    injected_personsStore: {
      from: fm
    }
  },
  emits: ["update:modelValue", "component-change"],
  data() {
    return {
      components_mutable: this.components,
      log: Dt("components/ComponentsContainer", Dt.COLOR_COMPONENT)
    };
  },
  mounted() {
    this.evaluateComponentConditions();
  },
  render() {
    return wi("div", {
      class: "acquisit-components-container",
      key: "components-container-" + this.uid
    }, this.createComponents(this.components_mutable, wi));
  },
  computed: {
    /**
     * All components by their UID, including children
     * @returns {ComponentUIDDictionary}
     */
    all_components_by_uid() {
      return Ht(this.injected_componentsStore.byUID);
    },
    /**
     * All components in this container by their UID, including children
     *
     * @return {ComponentUIDDictionary}
     */
    components_by_uid() {
      return wr(this.components_mutable);
    },
    /**
     * All components in this container by their normalized tag, including children
     *
     * @return {ComponentTagDictionary}
     */
    components_by_tag() {
      return nn(this.components_mutable);
    },
    /**
     * All pages by their UID
     *
     * @returns {PageUIDDictionary}
     */
    all_pages_by_uid() {
      return Ht(this.injected_pagesStore.byUID);
    },
    /**
     * All products by their UID
     *
     * @returns {ProductUIDDictionary}
     */
    all_products_by_uid() {
      return Ht(this.injected_productsStore.byUID);
    },
    /**
     * All persons by their UID
     *
     * @returns {Record<string, Person>}
     */
    all_persons_by_uid() {
      return Ht(this.injected_personsStore.byID);
    },
    /**
     * Retrieve the guards in a parsed map
     */
    guards_parsed() {
      return bm(this.guards);
    },
    errors_mapped() {
      var t;
      let e = {};
      for (let r of this.errors || []) {
        if (!((t = r.reference) != null && t.properties))
          continue;
        let a = r.reference.properties.uid;
        a in e || (e[a] = []), e[a].push(r);
      }
      return e;
    }
  },
  methods: {
    emitValue() {
      this.$emit("update:modelValue", this.components_mutable);
    },
    uiComponentExists(e) {
      return this.injected_uiComponentExists(e);
    },
    createComponents(e, t, r = null) {
      var n;
      let a = [];
      for (let o of e) {
        let l = o.tag_normalized;
        if (l == "placeholder") {
          this.log.infoFrom("createComponents", "Skipping placeholder", o.properties.uid);
          continue;
        }
        if (!this.uiComponentExists(o.tag)) {
          bc().send(new Error("Could not find component:" + o.tag), [], { location: "ComponentsContainer.vue:createComponents", data: o }), this.log.always.errorFrom("createComponents", "Could not find component:", o), typeof window < "u" && window.DEBUG && a.push(t("div", {
            class: "render-error"
          }, 'Unknown component "' + l + '"'));
          continue;
        }
        if (o.hidden && !this.ignoreDisplayConditions)
          continue;
        const s = oe(o.tag);
        let u = { ...o.properties };
        u.errors = this.errors_mapped[o.properties.uid] || o.properties.errors, u.hostPage = this.hostPage, u.required = o.required, this.noInteract && (u.noInteract = !0), this.displayOnly && (u.displayOnly = !0), (this.disabled || o.disabled_condition && !this.ignoreDisabledConditions && this.evaluateCondition(o.disabled_condition)) && (u.noInteract = !0, u.disabled = !0), o.tag_normalized || this.log.always.warn("Component", ((n = o.properties) == null ? void 0 : n.uid) ?? o, "is probably not normalized");
        let i = Array.isArray(u.errors) ? u.errors.length : u.errors, c = {
          class: [
            "acquisit-component",
            {
              /*
               This class is only set if mapped errors are used to trigger a change,
               otherwise each component tracks erroring itself
               */
              "acquisit-erroring": i && this.hasCurrentErrors,
              "acquisit-has-errors": i
            }
          ],
          "data-uid": o.properties.uid,
          "data-parent-uid": (r == null ? void 0 : r.properties.uid) ?? void 0,
          ...u,
          key: this.uid + "-" + u.uid,
          ref: u.uid,
          "onUpdate:modelValue": (p) => {
            this.onComponentInput(o, p, r), this.evaluateComponentConditions();
          },
          onGuard: (p) => this.onComponentGuard(o, p.type, p.payload || {}),
          onProperty: (p) => this.onComponentProperty(o, p.property, p.value === void 0 ? null : p.value)
        }, d = {};
        !this.noChildren && "children" in o && Rt(o.children, (p, h) => {
          p.length && (d[h] = () => this.createComponents(p, t, o));
        }), o.tag_normalized == "modal" ? a.push(t(Xt, {
          to: "body"
        }, [
          t(s, c, d)
        ])) : a.push(t(s, c, d));
      }
      return a;
    },
    onComponentInput(e, t, r = null) {
      window.DEBUG && console.log("---------------- [onComponentInput: " + e.tag_normalized + " (" + e.properties.uid + ")] ----------------");
      const a = _o();
      let n = () => Sh({
        component: e,
        value: t,
        parent: r,
        owner: this.owner,
        componentsByUID: this.components_by_uid,
        componentsByTag: this.components_by_tag,
        invalidators: this.invalidators || a.invalidators,
        invalidateAll: () => {
          Rt(this.invalidators || a.invalidators, (o) => {
            o({
              component: e
            });
          });
        },
        enableValueUpdates: (o) => {
          _o().enableValueUpdates(o);
        },
        disableValueUpdates: (o) => {
          _o().disableValueUpdates(o);
        },
        clearErrorsForComponent: Oo,
        setProperties: as
      }).then(() => {
        if (e.validated = !1, this.$emit("component-change", e), Array.isArray(e.validation_linked) && e.validation_linked.length)
          for (let o of e.validation_linked) {
            let l = this.components_by_uid[o];
            l && (l.validated = !1);
          }
      }).catch((o) => {
        console.error("Error handling value", t, "for", e.properties.uid), console.error(o);
      }).then(() => {
        this.evaluateComponentConditions(), this.emitValue();
      });
      if (this.noInteract)
        return null;
      if (Array.isArray(a.value_updates_disabled)) {
        if (a.value_updates_disabled.indexOf(e.tag_normalized) === -1)
          return n();
      } else if (a.value_updates_disabled === !1)
        return n();
      return null;
    },
    onComponentProperty(e, t, r) {
      e.properties[t] = r;
    },
    onComponentGuard(e, t, r = {}) {
      let a = this.guards_parsed, n = e.properties.uid;
      const o = Ha();
      if (o.trackGuardSource(e, t), a[n] && a[n][t]) {
        let l = a[n][t];
        for (let s of l) {
          let u = !0;
          for (let i in s.other_sources)
            if (i != "page" && s.other_sources.hasOwnProperty(i)) {
              let c = s.other_sources[i], d = this.$refs[i];
              for (let p of c)
                d.conformsToGuardType(p) && (u = !1);
            }
          if (u) {
            let i = (c, d) => {
              var p;
              (p = c.$refs[d.uid]) != null && p.triggerAction ? c.$refs[d.uid].triggerAction(d.action, d) : c.$parent ? i(c.$parent, d) : this.log.warnFrom("onComponentGuard:triggerAction", 'Could not trigger guard action "' + d.action + '" on "' + d.uid + '", $ref does not exist. Check for typos in your guards.');
            };
            for (let c of s.targets)
              o.trackGuardTarget(c), i(this, c);
          }
        }
      }
    },
    evaluateCondition(e, t = !0) {
      return e ? Po(e, {
        componentsByUID: this.components_by_uid,
        pagesByUID: this.all_pages_by_uid,
        productsByUID: this.all_products_by_uid,
        personsByID: this.all_persons_by_uid,
        scope: {}
      }) ? !0 : Po(e, {
        componentsByUID: this.all_components_by_uid,
        pagesByUID: this.all_pages_by_uid,
        productsByUID: this.all_products_by_uid,
        personsByID: this.all_persons_by_uid,
        scope: {}
      }) : t;
    },
    evaluateComponentConditions() {
      let e = (t) => {
        for (let r of t) {
          if (r.display_condition) {
            const a = this.evaluateCondition(r.display_condition);
            r.hidden = !a, this.$emit("component-change", r);
          }
          yc(r) && e(zo(r.children));
        }
      };
      e(this.components_mutable);
    },
    extractValues() {
      return os({
        componentsByUID: this.all_components_by_uid,
        productsByUID: this.all_products_by_uid,
        personsByID: this.all_persons_by_uid
      }, !1);
    },
    focusComponent(e, t = null) {
      const r = this;
      if (r.$refs[e]) {
        let a = r.$refs[e];
        if (a != null && a.focus)
          return a.focus(), !0;
      } else if (t != null && t.component_uid) {
        let a = r.$refs[t.component_uid];
        if (a != null && a.focusComponent)
          return a.focusComponent(e, t), !0;
      }
      return !1;
    },
    focusFirstComponent() {
      var t;
      if (!this.components_mutable.length)
        return !1;
      let e = (t = this.components_mutable[0].properties) == null ? void 0 : t.uid;
      return e ? this.focusComponent(e, null) : !1;
    },
    triggerErrorAnimation(e) {
      var n, o;
      let t = (o = (n = e.reference) == null ? void 0 : n.properties) == null ? void 0 : o.uid, r = e.owner, a = this;
      if (!t) {
        this.log.warnFrom("triggerErrorAnimation", "Cannot trigger error animation for error", e);
        return;
      }
      if (a.$refs[t]) {
        let l = a.$refs[t];
        l != null && l.triggerErrorAnimation && l.triggerErrorAnimation();
      } else if (r != null && r.component_uid) {
        let l = r.path ? kt(r.path) : [
          {
            component_uid: r.component_uid
          }
        ], s, u = !1;
        for (; s = l.pop(); ) {
          let i = s.component_uid, c = a.$refs[i];
          c != null && c.triggerErrorAnimationForSubComponent ? (c.triggerErrorAnimationForSubComponent(e), u = !0) : c != null && c.triggerErrorAnimation && (c.triggerErrorAnimation(e), u = !0);
        }
        u || this.log.infoFrom("triggerErrorAnimation:subComponent", "No $ref found for", t, r);
      } else
        this.log.infoFrom("triggerErrorAnimation", "No instructions", t, r);
    },
    triggerGuard(e) {
      var t;
      for (let r of e.targets)
        switch (r.uid) {
          case "_page-help":
            r.action == "open" ? (Ha().trackGuardTarget(r), Ra.$emit("page-help:open")) : this.log.warnFrom("triggerGuard", 'Could not trigger guard action "' + r.action + '" on "' + r.uid + '", action unknown');
            break;
          default:
            (t = this.$refs[r.uid]) != null && t.triggerAction ? (Ha().trackGuardTarget(r), this.$refs[r.uid].triggerAction(r.action, r)) : this.log.warnFrom("triggerGuard", 'Could not trigger guard action "' + r.action + '" on "' + r.uid + '", $ref does not exist');
        }
    },
    parseGuardSource: ym,
    parseGuardTarget: hm
  },
  watch: {
    components: {
      deep: !0,
      handler(e) {
        this.components_mutable = e;
      }
    }
  }
}), Dh = {
  class: "acquisit-component-error",
  role: "presentation"
}, hs = /* @__PURE__ */ Pe({
  __name: "ComponentError",
  props: {
    error: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => {
      const a = oe("v-svg"), n = oe("acquisit-string");
      return m(), S("div", Dh, [
        K(a, {
          class: "icon",
          file: "acq/cross-thick"
        }),
        K(n, {
          source: e.error.message,
          class: "message"
        }, null, 8, ["source"])
      ]);
    };
  }
}), Ah = ["aria-labelledby"], Ph = { class: "title" }, Oh = { class: "accordion-content" }, Th = /* @__PURE__ */ Pe({
  __name: "AccordionItem",
  props: {
    ...Ge(),
    title: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    collapsed: {
      type: Boolean,
      required: !1,
      default: !0
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    auto_expand: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, o = Ze(a, r), { color: l, uid: s } = o, { displayOnly: u, noInteract: i, theme: c } = nr(a), { errors: d } = nr(a), p = z(!a.displayOnly && a.collapsed), h = C(() => a.theme == "dark" ? {
      borderColor: p.value ? l.parse("light-grey-blue").cssHSLA : l.baseVisuallyAndContextSafe.value.cssHSLA
    } : {
      borderColor: p.value ? void 0 : l.baseVisuallyAndContextSafe.value.withAlpha(0.5).cssHSLA,
      boxShadow: p.value ? void 0 : `0px 0px 0px 1px ${l.baseVisuallyAndContextSafe.value.cssHSLA}`
    }), y = C(() => ({
      color: l.baseVisuallyAndContextSafe.value.cssHSLA
    })), _ = () => {
      a.noInteract || a.displayOnly || (p.value = !1);
    }, $ = () => {
      a.noInteract || a.displayOnly || (p.value = !0);
    }, w = () => {
      a.noInteract || a.displayOnly || (p.value = !p.value);
    };
    return Le(d, (L) => {
      L && L.length && _();
    }), Le(p, (L) => {
      o.guards.emit(L ? "collapsed" : "expanded"), o.guards.emit("toggle", { collapsed: L });
    }), o.registerAction("expand", _), o.registerAction("collapse", $), St(() => {
      var L, R;
      if (a.auto_expand) {
        for (let q of o.ui.getChildren())
          if ((R = (L = q.$options) == null ? void 0 : L.props) != null && R.modelValue) {
            _();
            break;
          }
      }
    }), t({
      ...o.expose,
      expand: _,
      collapse: $,
      toggle: w,
      isCollapsed: p,
      conformsToGuardType(L) {
        switch (L) {
          case "expanded":
            return p.value == !1;
          case "collapsed":
            return p.value == !0;
        }
        return !1;
      }
    }), (L, R) => {
      const q = oe("v-svg"), E = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-accordion-item", "theme-" + g(c), { expanded: !p.value, collapsed: p.value, error: p.value && g(o).erroring.value && g(o).hasErrors.value, "display-only": g(u), "no-interact": g(i) }]),
        "aria-labelledby": g(s).id + "-title",
        tabindex: 0,
        onKeyup: Jt(w, ["enter"]),
        style: we(h.value)
      }, [
        W("header", {
          class: "accordion-header",
          tabindex: "-1",
          onClick: w,
          style: we(y.value)
        }, [
          e.icon ? (m(), J(q, {
            key: 0,
            class: "icon",
            file: e.icon
          }, null, 8, ["file"])) : B("", !0),
          W("span", Ph, [
            e.title ? (m(), J(E, {
              key: 0,
              id: g(s).id + "-title",
              source: e.title
            }, null, 8, ["id", "source"])) : B("", !0),
            at(L.$slots, "title")
          ]),
          K(q, {
            class: "trigger-icon",
            file: "chevrons/left"
          })
        ], 4),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            Kt(W("section", Oh, [
              at(L.$slots, "default")
            ], 512), [
              [_r, !p.value]
            ])
          ]),
          _: 3
        }),
        W("div", {
          class: "focus-ring",
          style: we({ borderColor: g(l).focusDark.value.cssHSLA })
        }, null, 4)
      ], 46, Ah);
    };
  }
}), Ih = (e) => ({
  /** {@link HTMLElement.getBoundingClientRect} **/
  getBoundingClientRect: () => {
    var t;
    return (t = e.value) == null ? void 0 : t.getBoundingClientRect();
  }
}), ys = (e) => ({
  ariaLabel: {
    type: [String, Object],
    required: !1,
    default: void 0
  },
  ariaLabelledby: {
    type: String,
    required: !1,
    default(t) {
      if (e)
        return e(t);
    }
  }
}), Mh = ["aria-disabled", "aria-label", "aria-labelledby", "href"], qh = {
  key: 0,
  class: "content-wrapper",
  role: "presentation"
}, Eh = {
  key: 1,
  class: "ripple-container",
  "aria-hidden": "true"
}, Vh = {
  key: 3,
  class: "pulse-wrapper",
  "aria-hidden": "true"
}, Lh = /* @__PURE__ */ Pe({
  __name: "Button",
  props: {
    ...Ge(),
    ...ds(),
    ...ys(),
    label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    modal: {
      type: Object,
      required: !1,
      default: void 0
    },
    size: {
      type: [Number, String],
      required: !1,
      default: 36
    },
    iconSize: {
      type: Number,
      required: !1,
      default: 22
    },
    iconPosition: {
      type: String,
      required: !1,
      default: "left"
    },
    effect: {
      type: String,
      required: !1,
      default: "ripple"
    },
    bordered: {
      type: Boolean,
      required: !1,
      default: !1
    },
    bold: {
      type: Boolean,
      required: !1,
      default: !1
    },
    underlined: {
      type: Boolean,
      required: !1,
      default: !1
    },
    // Options: raised, flat, text, action, icon, pill
    type: {
      type: String,
      required: !1,
      default: "raised"
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    pulse: {
      type: Boolean,
      required: !1,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    ...cs()
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { uid: l, color: s, guards: u } = o, { theme: i, container: c } = s, d = C(() => a.colorContainer ? c.value.isWhite() ? s.base.value : c.value.isSimilarTo(s.base.value, 0.95) ? c.value.isDark() ? s.white : c.value.darken(32) : c.value.isDark() ? s.ensureIdealContrast("dark", c.value, s.base.value) : s.ensureIdealContrast("light", c.value, s.base.value) : s.base.value), p = z(), h = z(), y = fs(a, n), _ = vs(p), $ = (D) => {
      a.noInteract || (y.click(D), u.emit("clicked"), D.type == "click" && !a.disabled && _.click(D), h.value && h.value.openModal());
    }, w = () => {
      var D;
      (D = p.value) == null || D.focus();
    }, L = C(() => [
      "acquisit-button",
      "type-" + a.type,
      "theme-" + i.value,
      {
        "no-interact": a.noInteract,
        bordered: a.bordered,
        bold: a.bold,
        underlined: a.underlined,
        "full-width": a.fullWidth,
        "has-icon": a.icon,
        disabled: a.disabled,
        error: a.errors,
        erroring: o.erroring.value,
        ["size-" + a.size]: typeof a.size == "string"
      }
    ]), R = C(() => o.language.parse(a.ariaLabel)), q = C(() => !!a.color), E = C(() => !((a.type == "icon" || a.type == "action") && a.icon)), Y = C(() => (a.type == "raised" || a.type == "pill" || a.type == "action" && !a.bordered) && d.value.perceivedBrightness < 230 ? s.focusLight.value : s.focusDark.value), V = C(() => s.ensureIdealContrast(i.value, s.container.value, d.value)), T = C(() => {
      let D = c.value.perceivedBrightness > 220 ? 94 : 80;
      return c.value.mixWith(V.value, D);
    }), A = C(() => s.textContrastFor(T.value).mixWith(T.value, 44)), P = C(() => c.value.isWhite() ? s.parse("light-grey-blue") : s.textContrastFor(T.value).mixWith(T.value, 67)), b = C(() => {
      var D;
      return ((D = x.value.wrapper) == null ? void 0 : D.color) || s.baseVisuallySafe;
    }), x = C(() => {
      let D = Math.min(1, Math.max(0, d.value.alpha)), N = {}, M = {}, H = {}, U = {}, G = {}, F;
      switch (c.value.isWhite() || q.value || c.value.contrastTo(s.base.value) > 2.4 ? F = s.base.value : F = V.value, a.type) {
        case "raised":
        case "pill":
        case "action":
          if (a.bordered)
            q.value || (F = s.ensureIdealContrast(s.theme.value, c.value, F, 3.8)), N = {
              borderColor: F.cssHSLA,
              color: F.cssHSLA
            }, M = {
              background: F.withAlpha(0.3).cssHSLA
            }, H = {
              background: N.color
            }, U = {
              borderColor: F.cssHSLA
            }, a.disabled && (N.borderColor = A.value.withAlpha(0.33), N.color = A.value);
          else {
            let O = s.textContrastFor(F);
            N = {
              background: F.cssHSLA,
              color: O.cssHSLA
            }, M = {
              background: O.withAlpha(0.3).cssHSLA
            }, F.perceivedBrightness < 230 && !a.disabled && (N.boxShadow = `0px 2px 4px ${F.withAlpha(0.3 * D).cssHSLA},
										     0px 2px 5px ${F.darken(16).withAlpha(0.2 * D).cssHSLA}`), H = {
              background: O.cssHSLA
            }, U = {
              borderColor: N.background
            }, a.disabled && (N.background = T.value, N.color = A.value), N.borderColor = N.background;
          }
          a.type == "action" && (G = {
            width: a.iconSize + "px",
            height: a.iconSize + "px"
          });
          break;
        case "flat":
          q.value || (F = s.ensureIdealContrast(s.theme.value, c.value, F, 3.8)), a.bordered ? (N = {
            color: F.cssHSLA,
            borderColor: F.withAlpha(0.5).cssHSLA
          }, a.disabled && (N.color = P.value.cssHSLA, N.borderColor = A.value.withAlpha(0.33))) : (N = {
            color: F.cssHSLA
          }, a.disabled && (N.color = P.value.cssHSLA)), M = {
            background: F.withAlpha(0.3).cssHSLA
          }, H = {
            background: F.cssHSLA
          }, U = {
            borderColor: N.color
          };
          break;
        case "icon":
          q.value || (F = s.ensureIdealContrast(s.theme.value, c.value, F, 3.8)), N = {
            color: F.cssHSLA
          }, M = {
            background: F.withAlpha(0.3).cssHSLA
          }, a.bordered && (N.borderColor = F.withAlpha(0.67).cssHSLA), H = {
            background: F.cssHSLA
          }, U = {
            borderColor: N.color
          }, G = {
            width: a.iconSize + "px",
            height: a.iconSize + "px"
          }, a.disabled && (N.color = P.value, a.bordered && (N.borderColor = A.value.withAlpha(0.33)));
          break;
        case "text":
          q.value || (F = s.ensureIdealContrast(s.theme.value, c.value, F, 3.8)), N = {
            color: F.cssHSLA,
            textDecoration: "underline !important"
          }, H = {
            background: F.cssHSLA
          }, U = {
            borderColor: N.color
          }, a.disabled && (N.color = P.value.cssHSLA);
          break;
      }
      return {
        wrapper: N,
        hover: M,
        ripple: H,
        pulse: U,
        icon: G
      };
    });
    return C(() => {
      let D = d.value.alpha || 1, N, M = {}, H = {}, U = {}, G = {}, F = {}, O = s.textContrastFor(d.value);
      switch (a.type) {
        case "raised":
        case "pill":
        case "action":
          let Q = V.value;
          if (c.value.isLight() && s.base.value.isDark() && (Q = s.base.value), N = Q.isLight() ? Q.darken(10) : Q.lighten(10).desaturate(8), M = {
            background: Q.cssHSLA,
            color: O.cssHSLA
          }, Q.isDark() && (M.boxShadow = `0px 2px 4px ${Q.withAlpha(0.3 * D).cssHSLA},
										 0px 2px 5px ${Q.darken(16).withAlpha(0.2 * D).cssHSLA}`), H = {
            background: N.cssHSLA
          }, U = {
            background: M.color
          }, G = {
            borderColor: M.background
          }, a.bordered && (delete M.background, delete M.boxShadow, M.borderColor = Q.cssHSLA, M.color = Q.cssHSLA, H.background = N.withAlpha(0.3).cssHSLA, U.background = M.color), a.disabled) {
            let Ae = T.value;
            M.background = Ae.cssHSLA, M.color = P.value, delete M.boxShadow, a.bordered && (M.borderColor = M.background, delete M.background), a.type == "action" && (delete M.background, M.color = s.container.value.mixWith(Q, 40).desaturate(8).cssHSLA, M.borderColor = M.color);
          }
          a.type == "action" && (F = {
            width: a.iconSize + "px",
            height: a.iconSize + "px"
          });
          break;
        case "flat":
          const ae = V.value;
          M = {
            color: ae.cssHSLA,
            borderColor: ae.withAlpha(0.67).cssHSLA
          }, H = {
            background: i.value == "dark" ? ae.withAlpha(0.2).cssHSLA : ae.withAlpha(0.1).cssHSLA
          }, U = {
            background: ae.cssHSLA
          }, G = {
            borderColor: M.color
          }, a.disabled && (M.color = ae.withAlpha(0.67).cssHSLA, M.borderColor = ae.withAlpha(0.4).cssHSLA);
          break;
        case "icon":
          let Te = V.value;
          c.value.isLight() && s.base.value.isDark() && (Te = s.base.value), N = Te.isLight() ? Te.darken(10) : Te.lighten(10).desaturate(8), M = {
            color: Te.cssHSLA,
            width: a.size + "px",
            height: a.size + "px"
          }, H = {
            background: N
          }, U = {
            background: Te.cssHSLA
          }, G = {
            borderColor: M.color
          }, F = {
            width: a.iconSize + "px",
            height: a.iconSize + "px"
          }, a.bordered && (delete M.background, delete M.boxShadow, M.borderColor = M.color), a.disabled && (delete M.background, M.color = s.container.value.mixWith(Te, 40).desaturate(8).cssHSLA, M.borderColor = M.color);
          break;
        case "text":
          M = {
            color: d.value.cssHSLA,
            textDecoration: "underline !important"
          }, U = {
            background: d.value.cssHSLA
          }, G = {
            borerColor: M.color
          };
          break;
      }
      return {
        wrapper: M,
        hover: H,
        ripple: U,
        pulse: G,
        icon: F
      };
    }), t({
      ...o.expose,
      ...Ih(p),
      focus: w
    }), (D, N) => {
      const M = oe("acquisit-spinner"), H = oe("v-svg"), U = oe("acquisit-string"), G = oe("acquisit-modal");
      return m(), S("a", {
        class: pe(L.value),
        tabindex: 0,
        onKeypress: Jt($, ["enter"]),
        onClick: $,
        role: "button",
        "aria-disabled": e.disabled ? "true" : "false",
        "aria-label": R.value,
        "aria-labelledby": e.label && !D.ariaLabel ? g(l).uid.value + "-label" : D.ariaLabelledby,
        href: D.hrefDisabled ? void 0 : g(y).niceHref.value,
        ref_key: "root",
        ref: p
      }, [
        K(bt, { name: "fade" }, {
          default: ie(() => [
            W("div", {
              style: we(x.value.wrapper),
              class: pe(["wrapper", e.type + "-wrapper", e.iconPosition, { disabled: e.disabled }]),
              tabindex: "-1",
              role: "presentation"
            }, [
              K(bt, {
                name: "fade",
                mode: "out-in"
              }, {
                default: ie(() => [
                  e.loading ? (m(), J(M, {
                    class: "spinner",
                    size: "tiny",
                    color: b.value,
                    key: "spinner"
                  }, null, 8, ["color"])) : e.icon ? (m(), J(H, {
                    style: we(x.value.icon),
                    class: "icon",
                    file: e.icon,
                    "aria-hidden": "true",
                    key: "icon"
                  }, null, 8, ["style", "file"])) : B("", !0)
                ]),
                _: 1
              }),
              E.value ? (m(), S("div", qh, [
                e.label ? (m(), J(U, {
                  key: 0,
                  class: "content",
                  id: g(l).uid.value + "-label",
                  source: e.label
                }, null, 8, ["id", "source"])) : at(D.$slots, "default", {
                  key: 1,
                  class: "content"
                })
              ])) : B("", !0),
              D.noInteract ? B("", !0) : (m(), S("div", Eh, [
                K(Sr, {
                  name: "ripple",
                  onBeforeEnter: g(_).onBeforeEnter,
                  onAfterEnter: g(_).clearLast,
                  appear: ""
                }, {
                  default: ie(() => [
                    (m(!0), S(qe, null, We(g(_).ripples.value, (F) => (m(), S("span", {
                      class: "ripple",
                      key: F,
                      style: we(x.value.ripple)
                    }, null, 4))), 128))
                  ]),
                  _: 1
                }, 8, ["onBeforeEnter", "onAfterEnter"])
              ])),
              e.type == "raised" || e.type == "action" || e.type == "flat" ? (m(), S("div", {
                key: 2,
                class: "hover-background",
                style: we(x.value.hover)
              }, null, 4)) : B("", !0),
              D.errors ? (m(), S("div", Vh, [
                W("div", {
                  class: "pulse",
                  style: we(x.value.pulse)
                }, null, 4)
              ])) : B("", !0),
              W("div", {
                class: "focus-ring",
                style: we({ borderColor: Y.value.cssHSLA }),
                "aria-hidden": "true"
              }, null, 4)
            ], 6)
          ]),
          _: 3
        }),
        (m(), J(Xt, { to: "body" }, [
          e.modal ? (m(), J(G, {
            key: 0,
            ref_key: "$modal",
            ref: h,
            modal: e.modal
          }, null, 8, ["modal"])) : B("", !0)
        ]))
      ], 42, Mh);
    };
  }
}), Bh = ["id"], jh = ["aria-checked", "aria-labelledby", "aria-label", "onKeydown"], Hh = ["id", "name"], Rh = ["for", "id"], Fh = {
  key: 0,
  class: "children",
  role: "presentation",
  "data-tag": "children"
}, Nh = /* @__PURE__ */ Pe({
  __name: "Checkbox",
  props: {
    ...Ge(),
    // Dummies for aria labels so that outside components can override the aria labelled by attribute
    ...ys((e) => e.uid + "-checkbox-label"),
    // So a Checkbox can have a custom ID for custom <label> elements
    id: {
      type: String,
      required: !1,
      default: void 0
    },
    label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    labelPosition: {
      type: String
    },
    childrenInverted: {
      type: Boolean,
      default: !1
    },
    childrenIndented: {
      type: Boolean,
      required: !1,
      default: !0
    },
    childrenHiddenWhenDisabled: {
      type: Boolean,
      required: !1,
      default: !0
    },
    boldWhenChecked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    radio: {
      type: Boolean,
      required: !1,
      default: !1
    },
    triState: {
      type: [String, Boolean],
      required: !1,
      default: !1
    },
    product: {
      type: Object,
      required: !1,
      default: null
    },
    productSelectionInverted: {
      type: Boolean,
      required: !1,
      default: !1
    },
    resettable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    modelValue: {
      type: [Boolean],
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "click",
    "change",
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((E) => ({
      "1cb73db3": u.value.cssHSLA,
      dd8b9416: i.value.cssHSLA
    }));
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s } = o, u = C(() => l.base.value), i = C(() => l.textContrast.value), c = Go(), d = z(
      a.triState ? a.modelValue === void 0 ? null : a.modelValue : !!a.modelValue
    ), p = C(() => a.radio ? "acq/dot" : a.triState && d.value === null ? "acq/minus" : "acq/checkmark"), h = C(() => d.value || d.value === null && a.triState == "checked"), y = C(() => a.childrenHiddenWhenDisabled && a.disabled ? !1 : d.value !== a.childrenInverted), _ = C(() => [
      "acquisit-component",
      "acquisit-checkbox",
      "checkbox-component",
      {
        radio: a.radio,
        disabled: a.disabled,
        erroring: o.erroring.value,
        "acquisit-has-errors": Array.isArray(a.errors) ? a.errors.length : a.errors,
        checked: d.value,
        "has-children": o.hasChildren.value,
        "children-visible": y.value,
        "children-indented": a.childrenIndented
      }
    ]), $ = mr("checkboxGroupEmitChange", null), w = mr("checkboxGroupRegister", null), L = mr("checkboxGroupUnregister", null);
    ar("checkboxGroupEmitChange", null), ar("checkboxGroupRegister", null), ar("checkboxGroupUnregister", null);
    const R = () => {
      if (!a.product)
        return;
      let E, Y;
      a.productSelectionInverted ? d.value ? (E = [], Y = [a.product]) : (E = [a.product], Y = []) : d.value ? (E = [a.product], Y = []) : (E = [], Y = [a.product]), c.bulkSelect(E, Y, a.uid);
    }, q = () => {
      a.noInteract || a.radio && d.value && !a.resettable || (d.value === null ? typeof a.triState == "boolean" ? d.value = !a.triState : a.triState == "checked" ? d.value = !1 : d.value = !0 : d.value = !d.value, R(), n("click"));
    };
    return Le(d, (E) => {
      n("update:modelValue", E), n("change", E), $ && $(a.uid, E), o.guards.emit(E ? "checked" : "unchecked"), R();
    }), Le(() => a.modelValue, (E) => {
      a.triState ? E === void 0 && (E = null) : E = !!E, d.value = E;
    }), t({
      ...o.expose,
      conformsToGuardType(E) {
        return E == "checked" ? d.value : !1;
      }
    }), St(() => {
      R(), w && w(a.uid, {
        get() {
          return d.value;
        },
        set(E) {
          d.value = E, o.emitProperty("modelValue", E);
        }
      }, {
        get() {
          return a.disabled;
        },
        set(E) {
          o.emitProperty("disabled", E);
        }
      });
    }), jr(() => {
      L && L(a.uid);
    }), (E, Y) => {
      const V = oe("v-svg"), T = oe("acquisit-string");
      return m(), S("div", {
        id: g(s).id,
        class: pe(_.value),
        role: "presentation"
      }, [
        W("div", {
          class: pe(["checkbox-wrapper", { "no-interact": E.noInteract }]),
          tabindex: 0,
          role: "checkbox",
          "aria-checked": d.value ? "true" : "false",
          "aria-labelledby": E.ariaLabel ? void 0 : E.ariaLabelledby,
          "aria-label": E.ariaLabel ? g(o).language.parse(E.ariaLabel) : void 0,
          onKeydown: Jt(Bl(q, ["prevent"]), ["space"])
        }, [
          W("div", {
            class: pe(["focus-trick-wrapper", { "label-left": e.labelPosition == "left" }]),
            tabindex: "-1",
            onClick: q,
            role: "presentation"
          }, [
            Kt(W("input", {
              type: "checkbox",
              id: e.id ?? g(s).id + "-checkbox",
              name: g(s).id,
              "onUpdate:modelValue": Y[0] || (Y[0] = (A) => d.value = A),
              class: pe({ checked: d.value }),
              "aria-hidden": "true",
              onChange: Y[1] || (Y[1] = (A) => E.$emit("click"))
            }, null, 42, Hh), [
              [Vp, d.value]
            ]),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(l).focusDark.value.cssHSLA }),
              "aria-hidden": "true"
            }, null, 4),
            W("div", {
              class: pe(["checkbox-box", { standalone: !e.label && !E.$slots.label }]),
              "aria-hidden": "true"
            }, [
              K(bt, { name: "fill" }, {
                default: ie(() => [
                  h.value ? (m(), S("div", {
                    key: 0,
                    class: pe(["checkbox-fill", { disabled: e.disabled }]),
                    "data-tag": "checkbox-fill"
                  }, [
                    K(bt, { name: "icon" }, {
                      default: ie(() => [
                        h.value ? (m(), J(V, {
                          key: 0,
                          class: "checked-icon",
                          file: p.value
                        }, null, 8, ["file"])) : B("", !0)
                      ]),
                      _: 1
                    })
                  ], 2)) : B("", !0)
                ]),
                _: 1
              })
            ], 2),
            e.label || E.$slots.label ? (m(), S("label", {
              key: 0,
              for: e.id ?? g(s).id + "-checkbox",
              onClick: Bl((A) => {
              }, ["prevent"]),
              id: g(s).id + "-checkbox-label",
              class: pe([{ bold: d.value && e.boldWhenChecked }]),
              "data-tag": "label"
            }, [
              K(T, { source: e.label }, null, 8, ["source"]),
              at(E.$slots, "label")
            ], 10, Rh)) : B("", !0)
          ], 2)
        ], 42, jh),
        K(bt, {
          name: "move-fade-top",
          appear: ""
        }, {
          default: ie(() => [
            g(o).hasChildren.value && y.value ? (m(), S("div", Fh, [
              at(E.$slots, "default")
            ])) : B("", !0)
          ]),
          _: 3
        })
      ], 10, Bh);
    };
  }
}), Yh = { class: "acquisit-checklist" }, Uh = /* @__PURE__ */ Pe({
  __name: "Checklist",
  props: {
    ...Ge(),
    items: {
      type: Array,
      required: !0
    },
    icon: {
      type: String,
      required: !1,
      default: "acq/checked-circle-outline"
    },
    iconColor: {
      type: [String, Object],
      required: !1,
      default: "#388E3C"
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const o = Ze(e, r), { color: l } = o;
    return t({
      ...o.expose
    }), (s, u) => {
      const i = oe("v-svg"), c = oe("acquisit-string");
      return m(), S("ul", Yh, [
        (m(!0), S(qe, null, We(e.items, (d) => (m(), S("li", null, [
          K(i, {
            class: "icon",
            file: e.icon,
            color: e.iconColor,
            "aria-hidden": "true"
          }, null, 8, ["file", "color"]),
          K(c, {
            class: "string",
            source: d
          }, null, 8, ["source"])
        ]))), 256))
      ]);
    };
  }
}), zh = { class: "search" }, Wh = {
  key: 0,
  class: "empty"
}, Kh = ["onClick", "onKeyup"], Gh = {
  key: 0,
  class: "divider"
}, Zh = {
  key: 1,
  class: "content-wrapper",
  tabindex: -1
}, Xh = {
  key: 1,
  class: "emoji"
}, Jh = { class: "label" }, Qh = /* @__PURE__ */ Pe({
  __name: "ContextMenu",
  props: {
    ...Ge(),
    items: {
      type: Array,
      required: !0
    },
    anchor: {
      type: String,
      required: !1,
      default: "top-left",
      validator: (e) => ["top-left", "bottom-left", "top-right", "bottom-right", "top-center", "bottom-center"].indexOf(e) > -1
    },
    maxWidth: {
      type: [String, Number],
      required: !1,
      default: "600px"
    },
    searchable: {
      type: [Boolean, Number],
      required: !1,
      default: !1
    },
    searchLabel: {
      type: [String, Object],
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "click"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((P) => ({
      97559758: g(l).baseVisuallyAndContextSafe.value.cssHSLA
    }));
    const a = e, n = r, o = Ze(a, n), { color: l } = o, s = z(!1), u = z(!1), i = Gt({
      x: null,
      y: null
    }), c = C(() => {
      if (E.value) {
        const P = E.value.toLocaleLowerCase();
        return a.items.filter((b) => String(b.label ?? "").toLocaleLowerCase().indexOf(P) > -1);
      }
      return a.items;
    }), d = z(), p = z(null), h = z(), y = async (P, b = { x: null, y: null }) => {
      s.value = !0, E.value = "", d.value = P, await ut(), $(b), u.value = !0, await Ka(100), T();
    }, _ = async (P) => {
      if (!P)
        throw new Error("No trigger supplied");
      const b = P.getBoundingClientRect();
      return await y(
        P,
        {
          x: b.left + b.width / 2,
          y: b.top + b.height / 2
        }
      );
    }, $ = ({ x: P, y: b } = { x: null, y: null }) => {
      if (!h.value || typeof window > "u")
        return;
      P = P ?? 0, b = b ?? 0, p.value = {
        x: P,
        y: b
      };
      let x = h.value.clientWidth, D = h.value.clientHeight;
      const N = window.innerWidth, M = window.innerHeight;
      switch (a.anchor) {
        case "top-left":
          i.x = P, i.y = b;
          break;
        case "top-center":
          i.x = P - x / 2, i.y = b;
          break;
        case "top-right":
          i.x = P - x, i.y = b;
          break;
        case "bottom-left":
          i.x = P, i.y = b - D;
          break;
        case "bottom-center":
          i.x = P - x / 2, i.y = b - D;
          break;
        case "bottom-right":
          i.x = P - x, i.y = b - D;
          break;
      }
      const H = i.x, U = i.y;
      H + x > N ? i.x = H - (H + x - N) : H < 0 && (i.x = 0), U + D > M ? i.y = U - (U + D - M) : U < 0 && (i.y = 0);
    }, w = async () => {
      A(), u.value = !1, await Ka(300), s.value = !1, d.value = null, p.value = null;
    }, L = C(() => {
      let P = a.maxWidth;
      return typeof P == "number" && (P = P + "px"), {
        top: i.y + "px",
        left: i.x + "px",
        maxWidth: P
      };
    }), R = async (P) => a.noInteract || P.divider ? !1 : (n("click", P), await w()), q = C(() => {
      var P;
      return typeof a.searchable == "number" ? (((P = a.items) == null ? void 0 : P.length) ?? 0) >= a.searchable : !!a.searchable;
    }), E = z("");
    Le(E, async () => {
      p.value && (await ut(), $(p.value));
    });
    const Y = (P) => {
      if (!h.value)
        return;
      const b = h.value.contains(P.target), x = d.value ? d.value.$el ? d.value.$el : d.value : null, D = x ? x.contains(P.target) : !1;
      !b && !D && w();
    }, V = (P) => {
      P.code == "Escape" && (P.preventDefault(), w());
    }, T = () => {
      window.addEventListener("click", Y), window.addEventListener("touchend", Y), window.addEventListener("contextmenu", Y), document.addEventListener("keyup", V);
    }, A = () => {
      window.removeEventListener("click", Y), window.removeEventListener("touchend", Y), window.removeEventListener("contextmenu", Y), document.removeEventListener("keyup", V);
    };
    return jr(() => {
      A();
    }), t({
      ...o.expose,
      open: y,
      openRelativeTo: _,
      updatePosition: $,
      close: w,
      isOpen: C(() => s.value)
    }), (P, b) => {
      const x = oe("acquisit-input"), D = oe("acquisit-string"), N = oe("v-svg");
      return s.value ? (m(), S("ul", {
        key: 0,
        class: pe(["acquisit-context-menu", "theme-" + P.theme, "acquisit-no-window-click-close", { hidden: !u.value }]),
        style: we(L.value),
        ref_key: "root",
        ref: h
      }, [
        q.value ? (m(), S(qe, { key: 0 }, [
          W("li", zh, [
            K(x, {
              modelValue: E.value,
              "onUpdate:modelValue": b[0] || (b[0] = (M) => E.value = M),
              label: e.searchLabel,
              "hide-label-on-value": "",
              icon: "acq/search"
            }, null, 8, ["modelValue", "label"])
          ]),
          c.value.length ? B("", !0) : (m(), S("li", Wh, " 😕 "))
        ], 64)) : B("", !0),
        (m(!0), S(qe, null, We(c.value, (M) => (m(), S("li", {
          class: pe([{ selected: M.selected ?? !1, disabled: M.disabled ?? !1, "is-divider": M.divider, "is-header": M.divider && g(o).language.parse(M.label) }]),
          onClick: (H) => R(M),
          onKeyup: Jt((H) => R(M), ["enter"]),
          tabindex: 0,
          key: g(o).language.parse(M.label)
        }, [
          M.divider ? (m(), S("div", Gh, [
            K(D, {
              source: g(o).language.parse(M.label)
            }, null, 8, ["source"])
          ])) : (m(), S("div", Zh, [
            M.icon ? (m(), J(N, {
              key: 0,
              file: M.icon,
              class: "icon",
              style: we({ color: M.color ? M.color : g(l).baseVisuallyAndContextSafe.value.cssHSLA })
            }, null, 8, ["file", "style"])) : B("", !0),
            M.emoji ? (m(), S("span", Xh, je(M.emoji), 1)) : B("", !0),
            W("div", Jh, [
              K(D, {
                source: M.label
              }, null, 8, ["source"]),
              M.description ? (m(), J(D, {
                key: 0,
                class: "description",
                source: M.description
              }, null, 8, ["source"])) : B("", !0)
            ]),
            M.shortcut ? (m(), J(D, {
              key: 2,
              class: "shortcut",
              source: M.shortcut
            }, null, 8, ["source"])) : B("", !0),
            M.selected ?? !1 ? (m(), J(N, {
              key: 3,
              file: "acq/checkmark",
              class: "selected-icon"
            })) : B("", !0),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(l).baseContextSafe.value.cssHSLA })
            }, null, 4)
          ]))
        ], 42, Kh))), 128))
      ], 6)) : B("", !0);
    };
  }
}), ey = /* @__PURE__ */ Pe({
  __name: "Divider",
  props: {
    ...Ge(),
    spacing: {
      type: String,
      required: !1,
      default: "regular",
      validator: (e) => ["regular", "big"].indexOf(e) > -1
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const o = Ze(e, r), { color: l } = o;
    return t({
      ...o.expose
    }), (s, u) => (m(), S("div", {
      class: pe(["acquisit-divider", "spacing-" + e.spacing])
    }, null, 2));
  }
});
var Hc = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, Pi = (e, t, r) => (Hc(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ty = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, ry = (e, t, r, a) => (Hc(e, t, "write to private field"), t.set(e, r), r);
const Rc = [
  ["aztec", "Aztec"],
  ["code_128", "Code128"],
  ["code_39", "Code39"],
  ["code_93", "Code93"],
  ["codabar", "Codabar"],
  ["databar", "DataBar"],
  ["databar_expanded", "DataBarExpanded"],
  ["data_matrix", "DataMatrix"],
  ["dx_film_edge", "DXFilmEdge"],
  ["ean_13", "EAN-13"],
  ["ean_8", "EAN-8"],
  ["itf", "ITF"],
  ["maxi_code", "MaxiCode"],
  ["micro_qr_code", "MicroQRCode"],
  ["pdf417", "PDF417"],
  ["qr_code", "QRCode"],
  ["rm_qr_code", "rMQRCode"],
  ["upc_a", "UPC-A"],
  ["upc_e", "UPC-E"],
  ["linear_codes", "Linear-Codes"],
  ["matrix_codes", "Matrix-Codes"]
], ay = [...Rc, ["unknown"]].map((e) => e[0]), wo = new Map(
  Rc
);
function ny(e) {
  for (const [t, r] of wo)
    if (e === r)
      return t;
  return "unknown";
}
function oy(e) {
  if (Fc(e))
    return {
      width: e.naturalWidth,
      height: e.naturalHeight
    };
  if (Nc(e))
    return {
      width: e.width.baseVal.value,
      height: e.height.baseVal.value
    };
  if (Yc(e))
    return {
      width: e.videoWidth,
      height: e.videoHeight
    };
  if (zc(e))
    return {
      width: e.width,
      height: e.height
    };
  if (Kc(e))
    return {
      width: e.displayWidth,
      height: e.displayHeight
    };
  if (Uc(e))
    return {
      width: e.width,
      height: e.height
    };
  if (Wc(e))
    return {
      width: e.width,
      height: e.height
    };
  throw new TypeError(
    "The provided value is not of type '(Blob or HTMLCanvasElement or HTMLImageElement or HTMLVideoElement or ImageBitmap or ImageData or OffscreenCanvas or SVGImageElement or VideoFrame)'."
  );
}
function Fc(e) {
  try {
    return e instanceof HTMLImageElement;
  } catch {
    return !1;
  }
}
function Nc(e) {
  try {
    return e instanceof SVGImageElement;
  } catch {
    return !1;
  }
}
function Yc(e) {
  try {
    return e instanceof HTMLVideoElement;
  } catch {
    return !1;
  }
}
function Uc(e) {
  try {
    return e instanceof HTMLCanvasElement;
  } catch {
    return !1;
  }
}
function zc(e) {
  try {
    return e instanceof ImageBitmap;
  } catch {
    return !1;
  }
}
function Wc(e) {
  try {
    return e instanceof OffscreenCanvas;
  } catch {
    return !1;
  }
}
function Kc(e) {
  try {
    return e instanceof VideoFrame;
  } catch {
    return !1;
  }
}
function Gc(e) {
  try {
    return e instanceof Blob;
  } catch {
    return !1;
  }
}
function ly(e) {
  try {
    return e instanceof ImageData;
  } catch {
    return !1;
  }
}
function sy(e, t) {
  try {
    const r = new OffscreenCanvas(e, t);
    if (r.getContext("2d") instanceof OffscreenCanvasRenderingContext2D)
      return r;
    throw void 0;
  } catch {
    const a = document.createElement("canvas");
    return a.width = e, a.height = t, a;
  }
}
async function Zc(e) {
  if (Fc(e) && !await dy(e))
    throw new DOMException(
      "Failed to load or decode HTMLImageElement.",
      "InvalidStateError"
    );
  if (Nc(e) && !await fy(e))
    throw new DOMException(
      "Failed to load or decode SVGImageElement.",
      "InvalidStateError"
    );
  if (Kc(e) && vy(e))
    throw new DOMException("VideoFrame is closed.", "InvalidStateError");
  if (Yc(e) && (e.readyState === 0 || e.readyState === 1))
    throw new DOMException("Invalid element or state.", "InvalidStateError");
  if (zc(e) && my(e))
    throw new DOMException(
      "The image source is detached.",
      "InvalidStateError"
    );
  const { width: t, height: r } = oy(e);
  if (t === 0 || r === 0)
    return null;
  const a = sy(t, r).getContext("2d");
  a.drawImage(e, 0, 0);
  try {
    return a.getImageData(0, 0, t, r);
  } catch {
    throw new DOMException("Source would taint origin.", "SecurityError");
  }
}
async function iy(e) {
  let t;
  try {
    if (globalThis.createImageBitmap)
      t = await createImageBitmap(e);
    else if (globalThis.Image) {
      t = new Image();
      let r = "";
      try {
        r = URL.createObjectURL(e), t.src = r, await t.decode();
      } finally {
        URL.revokeObjectURL(r);
      }
    } else
      return e;
  } catch {
    throw new DOMException(
      "Failed to load or decode Blob.",
      "InvalidStateError"
    );
  }
  return await Zc(t);
}
function uy(e) {
  const { width: t, height: r } = e;
  if (t === 0 || r === 0)
    return null;
  const a = e.getContext("2d");
  try {
    return a.getImageData(0, 0, t, r);
  } catch {
    throw new DOMException("Source would taint origin.", "SecurityError");
  }
}
async function cy(e) {
  if (Gc(e))
    return await iy(e);
  if (ly(e)) {
    if (py(e))
      throw new DOMException(
        "The image data has been detached.",
        "InvalidStateError"
      );
    return e;
  }
  return Uc(e) || Wc(e) ? uy(e) : await Zc(e);
}
async function dy(e) {
  try {
    return await e.decode(), !0;
  } catch {
    return !1;
  }
}
async function fy(e) {
  var t;
  try {
    return await ((t = e.decode) == null ? void 0 : t.call(e)), !0;
  } catch {
    return !1;
  }
}
function vy(e) {
  return e.format === null;
}
function py(e) {
  return e.data.buffer.byteLength === 0;
}
function my(e) {
  return e.width === 0 && e.height === 0;
}
function Oi(e, t) {
  return e instanceof DOMException ? new DOMException(`${t}: ${e.message}`, e.name) : e instanceof Error ? new e.constructor(`${t}: ${e.message}`) : new Error(`${t}: ${e}`);
}
const Ti = [
  "Aztec",
  "Codabar",
  "Code128",
  "Code39",
  "Code93",
  "DataBar",
  "DataBarExpanded",
  "DataMatrix",
  "DXFilmEdge",
  "EAN-13",
  "EAN-8",
  "ITF",
  "Linear-Codes",
  "Matrix-Codes",
  "MaxiCode",
  "MicroQRCode",
  "None",
  "PDF417",
  "QRCode",
  "rMQRCode",
  "UPC-A",
  "UPC-E"
];
function hy(e) {
  return e.join("|");
}
function yy(e) {
  const t = Ii(e);
  let r = 0, a = Ti.length - 1;
  for (; r <= a; ) {
    const n = Math.floor((r + a) / 2), o = Ti[n], l = Ii(o);
    if (l === t)
      return o;
    l < t ? r = n + 1 : a = n - 1;
  }
  return "None";
}
function Ii(e) {
  return e.toLowerCase().replace(/_-\[\]/g, "");
}
function by(e, t) {
  return e.Binarizer[t];
}
function gy(e, t) {
  return e.CharacterSet[t];
}
const _y = [
  "Text",
  "Binary",
  "Mixed",
  "GS1",
  "ISO15434",
  "UnknownECI"
];
function wy(e) {
  return _y[e.value];
}
function ky(e, t) {
  return e.EanAddOnSymbol[t];
}
function $y(e, t) {
  return e.TextMode[t];
}
const Ga = {
  formats: [],
  tryHarder: !0,
  tryRotate: !0,
  tryInvert: !0,
  tryDownscale: !0,
  binarizer: "LocalAverage",
  isPure: !1,
  downscaleFactor: 3,
  downscaleThreshold: 500,
  minLineCount: 2,
  maxNumberOfSymbols: 255,
  tryCode39ExtendedMode: !1,
  validateCode39CheckSum: !1,
  validateITFCheckSum: !1,
  returnCodabarStartEnd: !1,
  returnErrors: !1,
  eanAddOnSymbol: "Read",
  textMode: "Plain",
  characterSet: "Unknown"
};
function Xc(e, t) {
  return {
    ...t,
    formats: hy(t.formats),
    binarizer: by(e, t.binarizer),
    eanAddOnSymbol: ky(
      e,
      t.eanAddOnSymbol
    ),
    textMode: $y(e, t.textMode),
    characterSet: gy(
      e,
      t.characterSet
    )
  };
}
function Jc(e) {
  return {
    ...e,
    format: yy(e.format),
    eccLevel: e.eccLevel,
    contentType: wy(e.contentType)
  };
}
const Cy = {
  locateFile: (e, t) => {
    const r = e.match(/_(.+?)\.wasm$/);
    return r ? `https://fastly.jsdelivr.net/npm/zxing-wasm@1.1.3/dist/${r[1]}/${e}` : t + e;
  }
};
let Mi = /* @__PURE__ */ new WeakMap();
function bs(e, t) {
  var r;
  const a = Mi.get(e);
  if (a != null && a.modulePromise && t === void 0)
    return a.modulePromise;
  const n = (r = a == null ? void 0 : a.moduleOverrides) != null ? r : Cy, o = e({
    ...n
  });
  return Mi.set(e, {
    moduleOverrides: n,
    modulePromise: o
  }), o;
}
async function Sy(e, t, r = Ga) {
  const a = {
    ...Ga,
    ...r
  }, n = await bs(e), { size: o } = t, l = new Uint8Array(await t.arrayBuffer()), s = n._malloc(o);
  n.HEAPU8.set(l, s);
  const u = n.readBarcodesFromImage(
    s,
    o,
    Xc(n, a)
  );
  n._free(s);
  const i = [];
  for (let c = 0; c < u.size(); ++c)
    i.push(
      Jc(u.get(c))
    );
  return i;
}
async function xy(e, t, r = Ga) {
  const a = {
    ...Ga,
    ...r
  }, n = await bs(e), {
    data: o,
    width: l,
    height: s,
    data: { byteLength: u }
  } = t, i = n._malloc(u);
  n.HEAPU8.set(o, i);
  const c = n.readBarcodesFromPixmap(
    i,
    l,
    s,
    Xc(n, a)
  );
  n._free(i);
  const d = [];
  for (let p = 0; p < c.size(); ++p)
    d.push(
      Jc(c.get(p))
    );
  return d;
}
({
  ...Ga,
  formats: [...Ga.formats]
});
var gs = (() => {
  var e = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return function(t = {}) {
    var r = t, a, n;
    r.ready = new Promise((f, v) => {
      a = f, n = v;
    });
    var o = Object.assign({}, r), l = "./this.program", s = typeof window == "object", u = typeof importScripts == "function";
    typeof process == "object" && typeof process.versions == "object" && process.versions.node;
    var i = "";
    function c(f) {
      return r.locateFile ? r.locateFile(f, i) : i + f;
    }
    var d;
    (s || u) && (u ? i = self.location.href : typeof document < "u" && document.currentScript && (i = document.currentScript.src), e && (i = e), i.indexOf("blob:") !== 0 ? i = i.substr(0, i.replace(/[?#].*/, "").lastIndexOf("/") + 1) : i = "", u && (d = (f) => {
      var v = new XMLHttpRequest();
      return v.open("GET", f, !1), v.responseType = "arraybuffer", v.send(null), new Uint8Array(v.response);
    })), r.print || console.log.bind(console);
    var p = r.printErr || console.error.bind(console);
    Object.assign(r, o), o = null, r.arguments && r.arguments, r.thisProgram && (l = r.thisProgram), r.quit && r.quit;
    var h;
    r.wasmBinary && (h = r.wasmBinary), typeof WebAssembly != "object" && ae("no native wasm support detected");
    var y, _ = !1, $, w, L, R, q, E, Y, V;
    function T() {
      var f = y.buffer;
      r.HEAP8 = $ = new Int8Array(f), r.HEAP16 = L = new Int16Array(f), r.HEAPU8 = w = new Uint8Array(f), r.HEAPU16 = R = new Uint16Array(f), r.HEAP32 = q = new Int32Array(f), r.HEAPU32 = E = new Uint32Array(f), r.HEAPF32 = Y = new Float32Array(f), r.HEAPF64 = V = new Float64Array(f);
    }
    var A = [], P = [], b = [];
    function x() {
      if (r.preRun)
        for (typeof r.preRun == "function" && (r.preRun = [r.preRun]); r.preRun.length; )
          M(r.preRun.shift());
      Se(A);
    }
    function D() {
      Se(P);
    }
    function N() {
      if (r.postRun)
        for (typeof r.postRun == "function" && (r.postRun = [r.postRun]); r.postRun.length; )
          U(r.postRun.shift());
      Se(b);
    }
    function M(f) {
      A.unshift(f);
    }
    function H(f) {
      P.unshift(f);
    }
    function U(f) {
      b.unshift(f);
    }
    var G = 0, F = null;
    function O(f) {
      var v;
      G++, (v = r.monitorRunDependencies) === null || v === void 0 || v.call(r, G);
    }
    function Q(f) {
      var v;
      if (G--, (v = r.monitorRunDependencies) === null || v === void 0 || v.call(r, G), G == 0 && F) {
        var k = F;
        F = null, k();
      }
    }
    function ae(f) {
      var v;
      (v = r.onAbort) === null || v === void 0 || v.call(r, f), f = "Aborted(" + f + ")", p(f), _ = !0, f += ". Build with -sASSERTIONS for more info.";
      var k = new WebAssembly.RuntimeError(f);
      throw n(k), k;
    }
    var Te = "data:application/octet-stream;base64,", Ae = (f) => f.startsWith(Te), Ye;
    Ye = "zxing_reader.wasm", Ae(Ye) || (Ye = c(Ye));
    function Re(f) {
      if (f == Ye && h)
        return new Uint8Array(h);
      if (d)
        return d(f);
      throw "both async and sync fetching of the wasm failed";
    }
    function it(f) {
      return !h && (s || u) && typeof fetch == "function" ? fetch(f, {
        credentials: "same-origin"
      }).then((v) => {
        if (!v.ok)
          throw "failed to load wasm binary file at '" + f + "'";
        return v.arrayBuffer();
      }).catch(() => Re(f)) : Promise.resolve().then(() => Re(f));
    }
    function he(f, v, k) {
      return it(f).then((I) => WebAssembly.instantiate(I, v)).then((I) => I).then(k, (I) => {
        p(`failed to asynchronously prepare wasm: ${I}`), ae(I);
      });
    }
    function X(f, v, k, I) {
      return !f && typeof WebAssembly.instantiateStreaming == "function" && !Ae(v) && typeof fetch == "function" ? fetch(v, {
        credentials: "same-origin"
      }).then((Z) => {
        var ee = WebAssembly.instantiateStreaming(Z, k);
        return ee.then(I, function(le) {
          return p(`wasm streaming compile failed: ${le}`), p("falling back to ArrayBuffer instantiation"), he(v, k, I);
        });
      }) : he(v, k, I);
    }
    function re() {
      var f = {
        a: dp
      };
      function v(I, Z) {
        return jt = I.exports, y = jt.ia, T(), ei = jt.ma, H(jt.ja), Q(), jt;
      }
      O();
      function k(I) {
        v(I.instance);
      }
      if (r.instantiateWasm)
        try {
          return r.instantiateWasm(f, v);
        } catch (I) {
          p(`Module.instantiateWasm callback failed with error: ${I}`), n(I);
        }
      return X(h, Ye, f, k).catch(n), {};
    }
    var Se = (f) => {
      for (; f.length > 0; )
        f.shift()(r);
    };
    r.noExitRuntime;
    var me = [], fe = 0, Oe = (f) => {
      var v = new Fe(f);
      return v.get_caught() || (v.set_caught(!0), fe--), v.set_rethrown(!1), me.push(v), pi(v.excPtr), v.get_exception_ptr();
    }, Ie = 0, ye = () => {
      At(0, 0);
      var f = me.pop();
      vi(f.excPtr), Ie = 0;
    };
    function Fe(f) {
      this.excPtr = f, this.ptr = f - 24, this.set_type = function(v) {
        E[this.ptr + 4 >> 2] = v;
      }, this.get_type = function() {
        return E[this.ptr + 4 >> 2];
      }, this.set_destructor = function(v) {
        E[this.ptr + 8 >> 2] = v;
      }, this.get_destructor = function() {
        return E[this.ptr + 8 >> 2];
      }, this.set_caught = function(v) {
        v = v ? 1 : 0, $[this.ptr + 12 >> 0] = v;
      }, this.get_caught = function() {
        return $[this.ptr + 12 >> 0] != 0;
      }, this.set_rethrown = function(v) {
        v = v ? 1 : 0, $[this.ptr + 13 >> 0] = v;
      }, this.get_rethrown = function() {
        return $[this.ptr + 13 >> 0] != 0;
      }, this.init = function(v, k) {
        this.set_adjusted_ptr(0), this.set_type(v), this.set_destructor(k);
      }, this.set_adjusted_ptr = function(v) {
        E[this.ptr + 16 >> 2] = v;
      }, this.get_adjusted_ptr = function() {
        return E[this.ptr + 16 >> 2];
      }, this.get_exception_ptr = function() {
        var v = hi(this.get_type());
        if (v)
          return E[this.excPtr >> 2];
        var k = this.get_adjusted_ptr();
        return k !== 0 ? k : this.excPtr;
      };
    }
    var Me = (f) => {
      throw Ie || (Ie = f), Ie;
    }, He = (f) => {
      var v = Ie;
      if (!v)
        return hn(0), 0;
      var k = new Fe(v);
      k.set_adjusted_ptr(v);
      var I = k.get_type();
      if (!I)
        return hn(0), v;
      for (var Z in f) {
        var ee = f[Z];
        if (ee === 0 || ee === I)
          break;
        var le = k.ptr + 16;
        if (mi(ee, I, le))
          return hn(ee), v;
      }
      return hn(I), v;
    }, ce = () => He([]), mt = (f) => He([f]), nt = (f, v) => He([f, v]), ot = () => {
      var f = me.pop();
      f || ae("no exception to throw");
      var v = f.excPtr;
      throw f.get_rethrown() || (me.push(f), f.set_rethrown(!0), f.set_caught(!1), fe++), Ie = v, Ie;
    }, ft = (f, v, k) => {
      var I = new Fe(f);
      throw I.init(v, k), Ie = f, fe++, Ie;
    }, $e = () => fe, Qe = {}, te = (f) => {
      for (; f.length; ) {
        var v = f.pop(), k = f.pop();
        k(v);
      }
    };
    function xe(f) {
      return this.fromWireType(q[f >> 2]);
    }
    var Ee = {}, Ve = {}, Xe = {}, de, ke = (f) => {
      throw new de(f);
    }, lt = (f, v, k) => {
      f.forEach(function(se) {
        Xe[se] = v;
      });
      function I(se) {
        var be = k(se);
        be.length !== f.length && ke("Mismatched type converter count");
        for (var Ce = 0; Ce < f.length; ++Ce)
          gt(f[Ce], be[Ce]);
      }
      var Z = new Array(v.length), ee = [], le = 0;
      v.forEach((se, be) => {
        Ve.hasOwnProperty(se) ? Z[be] = Ve[se] : (ee.push(se), Ee.hasOwnProperty(se) || (Ee[se] = []), Ee[se].push(() => {
          Z[be] = Ve[se], ++le, le === ee.length && I(Z);
        }));
      }), ee.length === 0 && I(Z);
    }, dt = (f) => {
      var v = Qe[f];
      delete Qe[f];
      var k = v.rawConstructor, I = v.rawDestructor, Z = v.fields, ee = Z.map((le) => le.getterReturnType).concat(Z.map((le) => le.setterArgumentType));
      lt([f], ee, (le) => {
        var se = {};
        return Z.forEach((be, Ce) => {
          var Be = be.fieldName, et = le[Ce], tt = be.getter, ct = be.getterContext, Pt = le[Ce + Z.length], qt = be.setter, $t = be.setterContext;
          se[Be] = {
            read: (Ut) => et.fromWireType(tt(ct, Ut)),
            write: (Ut, _e) => {
              var Ne = [];
              qt($t, Ut, Pt.toWireType(Ne, _e)), te(Ne);
            }
          };
        }), [{
          name: v.name,
          fromWireType: (be) => {
            var Ce = {};
            for (var Be in se)
              Ce[Be] = se[Be].read(be);
            return I(be), Ce;
          },
          toWireType: (be, Ce) => {
            for (var Be in se)
              if (!(Be in Ce))
                throw new TypeError(`Missing field: "${Be}"`);
            var et = k();
            for (Be in se)
              se[Be].write(et, Ce[Be]);
            return be !== null && be.push(I, et), et;
          },
          argPackAdvance: _t,
          readValueFromPointer: xe,
          destructorFunction: I
        }];
      });
    }, Je = (f, v, k, I, Z) => {
    }, ue = () => {
      for (var f = new Array(256), v = 0; v < 256; ++v)
        f[v] = String.fromCharCode(v);
      j = f;
    }, j, ne = (f) => {
      for (var v = "", k = f; w[k]; )
        v += j[w[k++]];
      return v;
    }, ge, De = (f) => {
      throw new ge(f);
    };
    function yt(f, v) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var I = v.name;
      if (f || De(`type "${I}" must have a positive integer typeid pointer`), Ve.hasOwnProperty(f)) {
        if (k.ignoreDuplicateRegistrations)
          return;
        De(`Cannot register type '${I}' twice`);
      }
      if (Ve[f] = v, delete Xe[f], Ee.hasOwnProperty(f)) {
        var Z = Ee[f];
        delete Ee[f], Z.forEach((ee) => ee());
      }
    }
    function gt(f, v) {
      let k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (!("argPackAdvance" in v))
        throw new TypeError("registerType registeredInstance requires argPackAdvance");
      return yt(f, v, k);
    }
    var _t = 8, ve = (f, v, k, I) => {
      v = ne(v), gt(f, {
        name: v,
        fromWireType: function(Z) {
          return !!Z;
        },
        toWireType: function(Z, ee) {
          return ee ? k : I;
        },
        argPackAdvance: _t,
        readValueFromPointer: function(Z) {
          return this.fromWireType(w[Z]);
        },
        destructorFunction: null
      });
    }, st = (f) => ({
      count: f.count,
      deleteScheduled: f.deleteScheduled,
      preservePointerOnDelete: f.preservePointerOnDelete,
      ptr: f.ptr,
      ptrType: f.ptrType,
      smartPtr: f.smartPtr,
      smartPtrType: f.smartPtrType
    }), rt = (f) => {
      function v(k) {
        return k.$$.ptrType.registeredClass.name;
      }
      De(v(f) + " instance already deleted");
    }, vt = !1, ta = (f) => {
    }, Tr = (f) => {
      f.smartPtr ? f.smartPtrType.rawDestructor(f.smartPtr) : f.ptrType.registeredClass.rawDestructor(f.ptr);
    }, Yt = (f) => {
      f.count.value -= 1;
      var v = f.count.value === 0;
      v && Tr(f);
    }, Bt = (f, v, k) => {
      if (v === k)
        return f;
      if (k.baseClass === void 0)
        return null;
      var I = Bt(f, v, k.baseClass);
      return I === null ? null : k.downcast(I);
    }, Nr = {}, ur = () => Object.keys(oa).length, ra = () => {
      var f = [];
      for (var v in oa)
        oa.hasOwnProperty(v) && f.push(oa[v]);
      return f;
    }, aa = [], Oa = () => {
      for (; aa.length; ) {
        var f = aa.pop();
        f.$$.deleteScheduled = !1, f.delete();
      }
    }, na, zn = (f) => {
      na = f, aa.length && na && na(Oa);
    }, Wn = () => {
      r.getInheritedInstanceCount = ur, r.getLiveInheritedInstances = ra, r.flushPendingDeletes = Oa, r.setDelayFunction = zn;
    }, oa = {}, Kn = (f, v) => {
      for (v === void 0 && De("ptr should not be undefined"); f.baseClass; )
        v = f.upcast(v), f = f.baseClass;
      return v;
    }, Gn = (f, v) => (v = Kn(f, v), oa[v]), ba = (f, v) => {
      (!v.ptrType || !v.ptr) && ke("makeClassHandle requires ptr and ptrType");
      var k = !!v.smartPtrType, I = !!v.smartPtr;
      return k !== I && ke("Both smartPtrType and smartPtr must be specified"), v.count = {
        value: 1
      }, la(Object.create(f, {
        $$: {
          value: v,
          writable: !0
        }
      }));
    };
    function Zn(f) {
      var v = this.getPointee(f);
      if (!v)
        return this.destructor(f), null;
      var k = Gn(this.registeredClass, v);
      if (k !== void 0) {
        if (k.$$.count.value === 0)
          return k.$$.ptr = v, k.$$.smartPtr = f, k.clone();
        var I = k.clone();
        return this.destructor(f), I;
      }
      function Z() {
        return this.isSmartPointer ? ba(this.registeredClass.instancePrototype, {
          ptrType: this.pointeeType,
          ptr: v,
          smartPtrType: this,
          smartPtr: f
        }) : ba(this.registeredClass.instancePrototype, {
          ptrType: this,
          ptr: f
        });
      }
      var ee = this.registeredClass.getActualType(v), le = Nr[ee];
      if (!le)
        return Z.call(this);
      var se;
      this.isConst ? se = le.constPointerType : se = le.pointerType;
      var be = Bt(v, this.registeredClass, se.registeredClass);
      return be === null ? Z.call(this) : this.isSmartPointer ? ba(se.registeredClass.instancePrototype, {
        ptrType: se,
        ptr: be,
        smartPtrType: this,
        smartPtr: f
      }) : ba(se.registeredClass.instancePrototype, {
        ptrType: se,
        ptr: be
      });
    }
    var la = (f) => typeof FinalizationRegistry > "u" ? (la = (v) => v, f) : (vt = new FinalizationRegistry((v) => {
      Yt(v.$$);
    }), la = (v) => {
      var k = v.$$, I = !!k.smartPtr;
      if (I) {
        var Z = {
          $$: k
        };
        vt.register(v, Z, v);
      }
      return v;
    }, ta = (v) => vt.unregister(v), la(f)), Xn = () => {
      Object.assign(ht.prototype, {
        isAliasOf(f) {
          if (!(this instanceof ht) || !(f instanceof ht))
            return !1;
          var v = this.$$.ptrType.registeredClass, k = this.$$.ptr;
          f.$$ = f.$$;
          for (var I = f.$$.ptrType.registeredClass, Z = f.$$.ptr; v.baseClass; )
            k = v.upcast(k), v = v.baseClass;
          for (; I.baseClass; )
            Z = I.upcast(Z), I = I.baseClass;
          return v === I && k === Z;
        },
        clone() {
          if (this.$$.ptr || rt(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var f = la(Object.create(Object.getPrototypeOf(this), {
            $$: {
              value: st(this.$$)
            }
          }));
          return f.$$.count.value += 1, f.$$.deleteScheduled = !1, f;
        },
        delete() {
          this.$$.ptr || rt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && De("Object already scheduled for deletion"), ta(this), Yt(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        },
        isDeleted() {
          return !this.$$.ptr;
        },
        deleteLater() {
          return this.$$.ptr || rt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && De("Object already scheduled for deletion"), aa.push(this), aa.length === 1 && na && na(Oa), this.$$.deleteScheduled = !0, this;
        }
      });
    };
    function ht() {
    }
    var Ot = (f, v) => Object.defineProperty(v, "name", {
      value: f
    }), pn = (f, v, k) => {
      if (f[v].overloadTable === void 0) {
        var I = f[v];
        f[v] = function() {
          return f[v].overloadTable.hasOwnProperty(arguments.length) || De(`Function '${k}' called with an invalid number of arguments (${arguments.length}) - expects one of (${f[v].overloadTable})!`), f[v].overloadTable[arguments.length].apply(this, arguments);
        }, f[v].overloadTable = [], f[v].overloadTable[I.argCount] = I;
      }
    }, or = (f, v, k) => {
      r.hasOwnProperty(f) ? ((k === void 0 || r[f].overloadTable !== void 0 && r[f].overloadTable[k] !== void 0) && De(`Cannot register public name '${f}' twice`), pn(r, f, f), r.hasOwnProperty(k) && De(`Cannot register multiple overloads of a function with the same number of arguments (${k})!`), r[f].overloadTable[k] = v) : (r[f] = v, k !== void 0 && (r[f].numArguments = k));
    }, Jn = 48, Qn = 57, eo = (f) => {
      if (f === void 0)
        return "_unknown";
      f = f.replace(/[^a-zA-Z0-9_]/g, "$");
      var v = f.charCodeAt(0);
      return v >= Jn && v <= Qn ? `_${f}` : f;
    };
    function Xs(f, v, k, I, Z, ee, le, se) {
      this.name = f, this.constructor = v, this.instancePrototype = k, this.rawDestructor = I, this.baseClass = Z, this.getActualType = ee, this.upcast = le, this.downcast = se, this.pureVirtualFunctions = [];
    }
    var nl = (f, v, k) => {
      for (; v !== k; )
        v.upcast || De(`Expected null or instance of ${k.name}, got an instance of ${v.name}`), f = v.upcast(f), v = v.baseClass;
      return f;
    };
    function Qf(f, v) {
      if (v === null)
        return this.isReference && De(`null is not a valid ${this.name}`), 0;
      v.$$ || De(`Cannot pass "${ul(v)}" as a ${this.name}`), v.$$.ptr || De(`Cannot pass deleted object as a pointer of type ${this.name}`);
      var k = v.$$.ptrType.registeredClass, I = nl(v.$$.ptr, k, this.registeredClass);
      return I;
    }
    function ev(f, v) {
      var k;
      if (v === null)
        return this.isReference && De(`null is not a valid ${this.name}`), this.isSmartPointer ? (k = this.rawConstructor(), f !== null && f.push(this.rawDestructor, k), k) : 0;
      (!v || !v.$$) && De(`Cannot pass "${ul(v)}" as a ${this.name}`), v.$$.ptr || De(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && v.$$.ptrType.isConst && De(`Cannot convert argument of type ${v.$$.smartPtrType ? v.$$.smartPtrType.name : v.$$.ptrType.name} to parameter type ${this.name}`);
      var I = v.$$.ptrType.registeredClass;
      if (k = nl(v.$$.ptr, I, this.registeredClass), this.isSmartPointer)
        switch (v.$$.smartPtr === void 0 && De("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
          case 0:
            v.$$.smartPtrType === this ? k = v.$$.smartPtr : De(`Cannot convert argument of type ${v.$$.smartPtrType ? v.$$.smartPtrType.name : v.$$.ptrType.name} to parameter type ${this.name}`);
            break;
          case 1:
            k = v.$$.smartPtr;
            break;
          case 2:
            if (v.$$.smartPtrType === this)
              k = v.$$.smartPtr;
            else {
              var Z = v.clone();
              k = this.rawShare(k, Yr.toHandle(() => Z.delete())), f !== null && f.push(this.rawDestructor, k);
            }
            break;
          default:
            De("Unsupporting sharing policy");
        }
      return k;
    }
    function tv(f, v) {
      if (v === null)
        return this.isReference && De(`null is not a valid ${this.name}`), 0;
      v.$$ || De(`Cannot pass "${ul(v)}" as a ${this.name}`), v.$$.ptr || De(`Cannot pass deleted object as a pointer of type ${this.name}`), v.$$.ptrType.isConst && De(`Cannot convert argument of type ${v.$$.ptrType.name} to parameter type ${this.name}`);
      var k = v.$$.ptrType.registeredClass, I = nl(v.$$.ptr, k, this.registeredClass);
      return I;
    }
    function Js(f) {
      return this.fromWireType(E[f >> 2]);
    }
    var rv = () => {
      Object.assign(to.prototype, {
        getPointee(f) {
          return this.rawGetPointee && (f = this.rawGetPointee(f)), f;
        },
        destructor(f) {
          var v;
          (v = this.rawDestructor) === null || v === void 0 || v.call(this, f);
        },
        argPackAdvance: _t,
        readValueFromPointer: Js,
        deleteObject(f) {
          f !== null && f.delete();
        },
        fromWireType: Zn
      });
    };
    function to(f, v, k, I, Z, ee, le, se, be, Ce, Be) {
      this.name = f, this.registeredClass = v, this.isReference = k, this.isConst = I, this.isSmartPointer = Z, this.pointeeType = ee, this.sharingPolicy = le, this.rawGetPointee = se, this.rawConstructor = be, this.rawShare = Ce, this.rawDestructor = Be, !Z && v.baseClass === void 0 ? I ? (this.toWireType = Qf, this.destructorFunction = null) : (this.toWireType = tv, this.destructorFunction = null) : this.toWireType = ev;
    }
    var Qs = (f, v, k) => {
      r.hasOwnProperty(f) || ke("Replacing nonexistant public symbol"), r[f].overloadTable !== void 0 && k !== void 0 ? r[f].overloadTable[k] = v : (r[f] = v, r[f].argCount = k);
    }, av = (f, v, k) => {
      var I = r["dynCall_" + f];
      return k && k.length ? I.apply(null, [v].concat(k)) : I.call(null, v);
    }, ro = [], ei, Tt = (f) => {
      var v = ro[f];
      return v || (f >= ro.length && (ro.length = f + 1), ro[f] = v = ei.get(f)), v;
    }, nv = (f, v, k) => {
      if (f.includes("j"))
        return av(f, v, k);
      var I = Tt(v).apply(null, k);
      return I;
    }, ov = (f, v) => {
      var k = [];
      return function() {
        return k.length = 0, Object.assign(k, arguments), nv(f, v, k);
      };
    }, Cr = (f, v) => {
      f = ne(f);
      function k() {
        return f.includes("j") ? ov(f, v) : Tt(v);
      }
      var I = k();
      return typeof I != "function" && De(`unknown function pointer with signature ${f}: ${v}`), I;
    }, lv = (f, v) => {
      var k = Ot(v, function(I) {
        this.name = v, this.message = I;
        var Z = new Error(I).stack;
        Z !== void 0 && (this.stack = this.toString() + `
` + Z.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return k.prototype = Object.create(f.prototype), k.prototype.constructor = k, k.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, k;
    }, ti, ri = (f) => {
      var v = fi(f), k = ne(v);
      return Ur(v), k;
    }, ao = (f, v) => {
      var k = [], I = {};
      function Z(ee) {
        if (!I[ee] && !Ve[ee]) {
          if (Xe[ee]) {
            Xe[ee].forEach(Z);
            return;
          }
          k.push(ee), I[ee] = !0;
        }
      }
      throw v.forEach(Z), new ti(`${f}: ` + k.map(ri).join([", "]));
    }, sv = (f, v, k, I, Z, ee, le, se, be, Ce, Be, et, tt) => {
      Be = ne(Be), ee = Cr(Z, ee), se && (se = Cr(le, se)), Ce && (Ce = Cr(be, Ce)), tt = Cr(et, tt);
      var ct = eo(Be);
      or(ct, function() {
        ao(`Cannot construct ${Be} due to unbound types`, [I]);
      }), lt([f, v, k], I ? [I] : [], function(Pt) {
        Pt = Pt[0];
        var qt, $t;
        I ? (qt = Pt.registeredClass, $t = qt.instancePrototype) : $t = ht.prototype;
        var Ut = Ot(Be, function() {
          if (Object.getPrototypeOf(this) !== _e)
            throw new ge("Use 'new' to construct " + Be);
          if (Ne.constructor_body === void 0)
            throw new ge(Be + " has no accessible constructor");
          var _i = Ne.constructor_body[arguments.length];
          if (_i === void 0)
            throw new ge(`Tried to invoke ctor of ${Be} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(Ne.constructor_body).toString()}) parameters instead!`);
          return _i.apply(this, arguments);
        }), _e = Object.create($t, {
          constructor: {
            value: Ut
          }
        });
        Ut.prototype = _e;
        var Ne = new Xs(Be, Ut, _e, tt, qt, ee, se, Ce);
        if (Ne.baseClass) {
          var Et, Nt;
          (Nt = (Et = Ne.baseClass).__derivedClasses) !== null && Nt !== void 0 || (Et.__derivedClasses = []), Ne.baseClass.__derivedClasses.push(Ne);
        }
        var Ta = new to(Be, Ne, !0, !1, !1), lo = new to(Be + "*", Ne, !1, !1, !1), gi = new to(Be + " const*", Ne, !1, !0, !1);
        return Nr[f] = {
          pointerType: lo,
          constPointerType: gi
        }, Qs(ct, Ut), [Ta, lo, gi];
      });
    }, ol = (f, v) => {
      for (var k = [], I = 0; I < f; I++)
        k.push(E[v + I * 4 >> 2]);
      return k;
    };
    function iv(f) {
      for (var v = 1; v < f.length; ++v)
        if (f[v] !== null && f[v].destructorFunction === void 0)
          return !0;
      return !1;
    }
    function ll(f, v, k, I, Z, ee) {
      var le = v.length;
      le < 2 && De("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var se = v[1] !== null && k !== null, be = iv(v), Ce = v[0].name !== "void", Be = le - 2, et = new Array(Be), tt = [], ct = [], Pt = function() {
        arguments.length !== Be && De(`function ${f} called with ${arguments.length} arguments, expected ${Be}`), ct.length = 0;
        var qt;
        tt.length = se ? 2 : 1, tt[0] = Z, se && (qt = v[1].toWireType(ct, this), tt[1] = qt);
        for (var $t = 0; $t < Be; ++$t)
          et[$t] = v[$t + 2].toWireType(ct, arguments[$t]), tt.push(et[$t]);
        var Ut = I.apply(null, tt);
        function _e(Ne) {
          if (be)
            te(ct);
          else
            for (var Et = se ? 1 : 2; Et < v.length; Et++) {
              var Nt = Et === 1 ? qt : et[Et - 2];
              v[Et].destructorFunction !== null && v[Et].destructorFunction(Nt);
            }
          if (Ce)
            return v[0].fromWireType(Ne);
        }
        return _e(Ut);
      };
      return Ot(f, Pt);
    }
    var uv = (f, v, k, I, Z, ee) => {
      var le = ol(v, k);
      Z = Cr(I, Z), lt([], [f], function(se) {
        se = se[0];
        var be = `constructor ${se.name}`;
        if (se.registeredClass.constructor_body === void 0 && (se.registeredClass.constructor_body = []), se.registeredClass.constructor_body[v - 1] !== void 0)
          throw new ge(`Cannot register multiple constructors with identical number of parameters (${v - 1}) for class '${se.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return se.registeredClass.constructor_body[v - 1] = () => {
          ao(`Cannot construct ${se.name} due to unbound types`, le);
        }, lt([], le, (Ce) => (Ce.splice(1, 0, null), se.registeredClass.constructor_body[v - 1] = ll(be, Ce, null, Z, ee), [])), [];
      });
    }, ai = (f) => {
      f = f.trim();
      const v = f.indexOf("(");
      return v !== -1 ? f.substr(0, v) : f;
    }, cv = (f, v, k, I, Z, ee, le, se, be) => {
      var Ce = ol(k, I);
      v = ne(v), v = ai(v), ee = Cr(Z, ee), lt([], [f], function(Be) {
        Be = Be[0];
        var et = `${Be.name}.${v}`;
        v.startsWith("@@") && (v = Symbol[v.substring(2)]), se && Be.registeredClass.pureVirtualFunctions.push(v);
        function tt() {
          ao(`Cannot call ${et} due to unbound types`, Ce);
        }
        var ct = Be.registeredClass.instancePrototype, Pt = ct[v];
        return Pt === void 0 || Pt.overloadTable === void 0 && Pt.className !== Be.name && Pt.argCount === k - 2 ? (tt.argCount = k - 2, tt.className = Be.name, ct[v] = tt) : (pn(ct, v, et), ct[v].overloadTable[k - 2] = tt), lt([], Ce, function(qt) {
          var $t = ll(et, qt, Be, ee, le);
          return ct[v].overloadTable === void 0 ? ($t.argCount = k - 2, ct[v] = $t) : ct[v].overloadTable[k - 2] = $t, [];
        }), [];
      });
    };
    function dv() {
      Object.assign(ni.prototype, {
        get(f) {
          return this.allocated[f];
        },
        has(f) {
          return this.allocated[f] !== void 0;
        },
        allocate(f) {
          var v = this.freelist.pop() || this.allocated.length;
          return this.allocated[v] = f, v;
        },
        free(f) {
          this.allocated[f] = void 0, this.freelist.push(f);
        }
      });
    }
    function ni() {
      this.allocated = [void 0], this.freelist = [];
    }
    var vr = new ni(), sl = (f) => {
      f >= vr.reserved && --vr.get(f).refcount === 0 && vr.free(f);
    }, fv = () => {
      for (var f = 0, v = vr.reserved; v < vr.allocated.length; ++v)
        vr.allocated[v] !== void 0 && ++f;
      return f;
    }, vv = () => {
      vr.allocated.push({
        value: void 0
      }, {
        value: null
      }, {
        value: !0
      }, {
        value: !1
      }), vr.reserved = vr.allocated.length, r.count_emval_handles = fv;
    }, Yr = {
      toValue: (f) => (f || De("Cannot use deleted val. handle = " + f), vr.get(f).value),
      toHandle: (f) => {
        switch (f) {
          case void 0:
            return 1;
          case null:
            return 2;
          case !0:
            return 3;
          case !1:
            return 4;
          default:
            return vr.allocate({
              refcount: 1,
              value: f
            });
        }
      }
    }, pv = (f, v) => {
      v = ne(v), gt(f, {
        name: v,
        fromWireType: (k) => {
          var I = Yr.toValue(k);
          return sl(k), I;
        },
        toWireType: (k, I) => Yr.toHandle(I),
        argPackAdvance: _t,
        readValueFromPointer: xe,
        destructorFunction: null
      });
    }, mv = (f, v, k) => {
      switch (v) {
        case 1:
          return k ? function(I) {
            return this.fromWireType($[I >> 0]);
          } : function(I) {
            return this.fromWireType(w[I >> 0]);
          };
        case 2:
          return k ? function(I) {
            return this.fromWireType(L[I >> 1]);
          } : function(I) {
            return this.fromWireType(R[I >> 1]);
          };
        case 4:
          return k ? function(I) {
            return this.fromWireType(q[I >> 2]);
          } : function(I) {
            return this.fromWireType(E[I >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${v}): ${f}`);
      }
    }, hv = (f, v, k, I) => {
      v = ne(v);
      function Z() {
      }
      Z.values = {}, gt(f, {
        name: v,
        constructor: Z,
        fromWireType: function(ee) {
          return this.constructor.values[ee];
        },
        toWireType: (ee, le) => le.value,
        argPackAdvance: _t,
        readValueFromPointer: mv(v, k, I),
        destructorFunction: null
      }), or(v, Z);
    }, il = (f, v) => {
      var k = Ve[f];
      return k === void 0 && De(v + " has unknown type " + ri(f)), k;
    }, yv = (f, v, k) => {
      var I = il(f, "enum");
      v = ne(v);
      var Z = I.constructor, ee = Object.create(I.constructor.prototype, {
        value: {
          value: k
        },
        constructor: {
          value: Ot(`${I.name}_${v}`, function() {
          })
        }
      });
      Z.values[k] = ee, Z[v] = ee;
    }, ul = (f) => {
      if (f === null)
        return "null";
      var v = typeof f;
      return v === "object" || v === "array" || v === "function" ? f.toString() : "" + f;
    }, bv = (f, v) => {
      switch (v) {
        case 4:
          return function(k) {
            return this.fromWireType(Y[k >> 2]);
          };
        case 8:
          return function(k) {
            return this.fromWireType(V[k >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${v}): ${f}`);
      }
    }, gv = (f, v, k) => {
      v = ne(v), gt(f, {
        name: v,
        fromWireType: (I) => I,
        toWireType: (I, Z) => Z,
        argPackAdvance: _t,
        readValueFromPointer: bv(v, k),
        destructorFunction: null
      });
    }, _v = (f, v, k, I, Z, ee, le) => {
      var se = ol(v, k);
      f = ne(f), f = ai(f), Z = Cr(I, Z), or(f, function() {
        ao(`Cannot call ${f} due to unbound types`, se);
      }, v - 1), lt([], se, function(be) {
        var Ce = [be[0], null].concat(be.slice(1));
        return Qs(f, ll(f, Ce, null, Z, ee), v - 1), [];
      });
    }, wv = (f, v, k) => {
      switch (v) {
        case 1:
          return k ? (I) => $[I >> 0] : (I) => w[I >> 0];
        case 2:
          return k ? (I) => L[I >> 1] : (I) => R[I >> 1];
        case 4:
          return k ? (I) => q[I >> 2] : (I) => E[I >> 2];
        default:
          throw new TypeError(`invalid integer width (${v}): ${f}`);
      }
    }, kv = (f, v, k, I, Z) => {
      v = ne(v);
      var ee = (Be) => Be;
      if (I === 0) {
        var le = 32 - 8 * k;
        ee = (Be) => Be << le >>> le;
      }
      var se = v.includes("unsigned"), be = (Be, et) => {
      }, Ce;
      se ? Ce = function(Be, et) {
        return be(et, this.name), et >>> 0;
      } : Ce = function(Be, et) {
        return be(et, this.name), et;
      }, gt(f, {
        name: v,
        fromWireType: ee,
        toWireType: Ce,
        argPackAdvance: _t,
        readValueFromPointer: wv(v, k, I !== 0),
        destructorFunction: null
      });
    }, $v = (f, v, k) => {
      var I = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], Z = I[v];
      function ee(le) {
        var se = E[le >> 2], be = E[le + 4 >> 2];
        return new Z($.buffer, be, se);
      }
      k = ne(k), gt(f, {
        name: k,
        fromWireType: ee,
        argPackAdvance: _t,
        readValueFromPointer: ee
      }, {
        ignoreDuplicateRegistrations: !0
      });
    }, oi = (f, v, k, I) => {
      if (!(I > 0))
        return 0;
      for (var Z = k, ee = k + I - 1, le = 0; le < f.length; ++le) {
        var se = f.charCodeAt(le);
        if (se >= 55296 && se <= 57343) {
          var be = f.charCodeAt(++le);
          se = 65536 + ((se & 1023) << 10) | be & 1023;
        }
        if (se <= 127) {
          if (k >= ee)
            break;
          v[k++] = se;
        } else if (se <= 2047) {
          if (k + 1 >= ee)
            break;
          v[k++] = 192 | se >> 6, v[k++] = 128 | se & 63;
        } else if (se <= 65535) {
          if (k + 2 >= ee)
            break;
          v[k++] = 224 | se >> 12, v[k++] = 128 | se >> 6 & 63, v[k++] = 128 | se & 63;
        } else {
          if (k + 3 >= ee)
            break;
          v[k++] = 240 | se >> 18, v[k++] = 128 | se >> 12 & 63, v[k++] = 128 | se >> 6 & 63, v[k++] = 128 | se & 63;
        }
      }
      return v[k] = 0, k - Z;
    }, Cv = (f, v, k) => oi(f, w, v, k), li = (f) => {
      for (var v = 0, k = 0; k < f.length; ++k) {
        var I = f.charCodeAt(k);
        I <= 127 ? v++ : I <= 2047 ? v += 2 : I >= 55296 && I <= 57343 ? (v += 4, ++k) : v += 3;
      }
      return v;
    }, si = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Sv = (f, v, k) => {
      for (var I = v + k, Z = v; f[Z] && !(Z >= I); )
        ++Z;
      if (Z - v > 16 && f.buffer && si)
        return si.decode(f.subarray(v, Z));
      for (var ee = ""; v < Z; ) {
        var le = f[v++];
        if (!(le & 128)) {
          ee += String.fromCharCode(le);
          continue;
        }
        var se = f[v++] & 63;
        if ((le & 224) == 192) {
          ee += String.fromCharCode((le & 31) << 6 | se);
          continue;
        }
        var be = f[v++] & 63;
        if ((le & 240) == 224 ? le = (le & 15) << 12 | se << 6 | be : le = (le & 7) << 18 | se << 12 | be << 6 | f[v++] & 63, le < 65536)
          ee += String.fromCharCode(le);
        else {
          var Ce = le - 65536;
          ee += String.fromCharCode(55296 | Ce >> 10, 56320 | Ce & 1023);
        }
      }
      return ee;
    }, cl = (f, v) => f ? Sv(w, f, v) : "", xv = (f, v) => {
      v = ne(v);
      var k = v === "std::string";
      gt(f, {
        name: v,
        fromWireType(I) {
          var Z = E[I >> 2], ee = I + 4, le;
          if (k)
            for (var se = ee, be = 0; be <= Z; ++be) {
              var Ce = ee + be;
              if (be == Z || w[Ce] == 0) {
                var Be = Ce - se, et = cl(se, Be);
                le === void 0 ? le = et : (le += "\0", le += et), se = Ce + 1;
              }
            }
          else {
            for (var tt = new Array(Z), be = 0; be < Z; ++be)
              tt[be] = String.fromCharCode(w[ee + be]);
            le = tt.join("");
          }
          return Ur(I), le;
        },
        toWireType(I, Z) {
          Z instanceof ArrayBuffer && (Z = new Uint8Array(Z));
          var ee, le = typeof Z == "string";
          le || Z instanceof Uint8Array || Z instanceof Uint8ClampedArray || Z instanceof Int8Array || De("Cannot pass non-string to std::string"), k && le ? ee = li(Z) : ee = Z.length;
          var se = vl(4 + ee + 1), be = se + 4;
          if (E[se >> 2] = ee, k && le)
            Cv(Z, be, ee + 1);
          else if (le)
            for (var Ce = 0; Ce < ee; ++Ce) {
              var Be = Z.charCodeAt(Ce);
              Be > 255 && (Ur(be), De("String has UTF-16 code units that do not fit in 8 bits")), w[be + Ce] = Be;
            }
          else
            for (var Ce = 0; Ce < ee; ++Ce)
              w[be + Ce] = Z[Ce];
          return I !== null && I.push(Ur, se), se;
        },
        argPackAdvance: _t,
        readValueFromPointer: Js,
        destructorFunction(I) {
          Ur(I);
        }
      });
    }, ii = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, Dv = (f, v) => {
      for (var k = f, I = k >> 1, Z = I + v / 2; !(I >= Z) && R[I]; )
        ++I;
      if (k = I << 1, k - f > 32 && ii)
        return ii.decode(w.subarray(f, k));
      for (var ee = "", le = 0; !(le >= v / 2); ++le) {
        var se = L[f + le * 2 >> 1];
        if (se == 0)
          break;
        ee += String.fromCharCode(se);
      }
      return ee;
    }, Av = (f, v, k) => {
      var I;
      if ((I = k) !== null && I !== void 0 || (k = 2147483647), k < 2)
        return 0;
      k -= 2;
      for (var Z = v, ee = k < f.length * 2 ? k / 2 : f.length, le = 0; le < ee; ++le) {
        var se = f.charCodeAt(le);
        L[v >> 1] = se, v += 2;
      }
      return L[v >> 1] = 0, v - Z;
    }, Pv = (f) => f.length * 2, Ov = (f, v) => {
      for (var k = 0, I = ""; !(k >= v / 4); ) {
        var Z = q[f + k * 4 >> 2];
        if (Z == 0)
          break;
        if (++k, Z >= 65536) {
          var ee = Z - 65536;
          I += String.fromCharCode(55296 | ee >> 10, 56320 | ee & 1023);
        } else
          I += String.fromCharCode(Z);
      }
      return I;
    }, Tv = (f, v, k) => {
      var I;
      if ((I = k) !== null && I !== void 0 || (k = 2147483647), k < 4)
        return 0;
      for (var Z = v, ee = Z + k - 4, le = 0; le < f.length; ++le) {
        var se = f.charCodeAt(le);
        if (se >= 55296 && se <= 57343) {
          var be = f.charCodeAt(++le);
          se = 65536 + ((se & 1023) << 10) | be & 1023;
        }
        if (q[v >> 2] = se, v += 4, v + 4 > ee)
          break;
      }
      return q[v >> 2] = 0, v - Z;
    }, Iv = (f) => {
      for (var v = 0, k = 0; k < f.length; ++k) {
        var I = f.charCodeAt(k);
        I >= 55296 && I <= 57343 && ++k, v += 4;
      }
      return v;
    }, Mv = (f, v, k) => {
      k = ne(k);
      var I, Z, ee, le, se;
      v === 2 ? (I = Dv, Z = Av, le = Pv, ee = () => R, se = 1) : v === 4 && (I = Ov, Z = Tv, le = Iv, ee = () => E, se = 2), gt(f, {
        name: k,
        fromWireType: (be) => {
          for (var Ce = E[be >> 2], Be = ee(), et, tt = be + 4, ct = 0; ct <= Ce; ++ct) {
            var Pt = be + 4 + ct * v;
            if (ct == Ce || Be[Pt >> se] == 0) {
              var qt = Pt - tt, $t = I(tt, qt);
              et === void 0 ? et = $t : (et += "\0", et += $t), tt = Pt + v;
            }
          }
          return Ur(be), et;
        },
        toWireType: (be, Ce) => {
          typeof Ce != "string" && De(`Cannot pass non-string to C++ string type ${k}`);
          var Be = le(Ce), et = vl(4 + Be + v);
          return E[et >> 2] = Be >> se, Z(Ce, et + 4, Be + v), be !== null && be.push(Ur, et), et;
        },
        argPackAdvance: _t,
        readValueFromPointer: xe,
        destructorFunction(be) {
          Ur(be);
        }
      });
    }, qv = (f, v, k, I, Z, ee) => {
      Qe[f] = {
        name: ne(v),
        rawConstructor: Cr(k, I),
        rawDestructor: Cr(Z, ee),
        fields: []
      };
    }, Ev = (f, v, k, I, Z, ee, le, se, be, Ce) => {
      Qe[f].fields.push({
        fieldName: ne(v),
        getterReturnType: k,
        getter: Cr(I, Z),
        getterContext: ee,
        setterArgumentType: le,
        setter: Cr(se, be),
        setterContext: Ce
      });
    }, Vv = (f, v) => {
      v = ne(v), gt(f, {
        isVoid: !0,
        name: v,
        argPackAdvance: 0,
        fromWireType: () => {
        },
        toWireType: (k, I) => {
        }
      });
    }, dl = [], Lv = (f, v, k, I) => (f = dl[f], v = Yr.toValue(v), f(null, v, k, I)), Bv = {}, jv = (f) => {
      var v = Bv[f];
      return v === void 0 ? ne(f) : v;
    }, ui = () => {
      if (typeof globalThis == "object")
        return globalThis;
      function f(v) {
        v.$$$embind_global$$$ = v;
        var k = typeof $$$embind_global$$$ == "object" && v.$$$embind_global$$$ == v;
        return k || delete v.$$$embind_global$$$, k;
      }
      if (typeof $$$embind_global$$$ == "object" || (typeof global == "object" && f(global) ? $$$embind_global$$$ = global : typeof self == "object" && f(self) && ($$$embind_global$$$ = self), typeof $$$embind_global$$$ == "object"))
        return $$$embind_global$$$;
      throw Error("unable to get global object.");
    }, Hv = (f) => f === 0 ? Yr.toHandle(ui()) : (f = jv(f), Yr.toHandle(ui()[f])), Rv = (f) => {
      var v = dl.length;
      return dl.push(f), v;
    }, Fv = (f, v) => {
      for (var k = new Array(f), I = 0; I < f; ++I)
        k[I] = il(E[v + I * 4 >> 2], "parameter " + I);
      return k;
    }, Nv = Reflect.construct, Yv = (f, v, k) => {
      var I = [], Z = f.toWireType(I, k);
      return I.length && (E[v >> 2] = Yr.toHandle(I)), Z;
    }, Uv = (f, v, k) => {
      var I = Fv(f, v), Z = I.shift();
      f--;
      var ee = new Array(f), le = (be, Ce, Be, et) => {
        for (var tt = 0, ct = 0; ct < f; ++ct)
          ee[ct] = I[ct].readValueFromPointer(et + tt), tt += I[ct].argPackAdvance;
        for (var Pt = k === 1 ? Nv(Ce, ee) : Ce.apply(be, ee), ct = 0; ct < f; ++ct) {
          var qt, $t;
          (qt = ($t = I[ct]).deleteObject) === null || qt === void 0 || qt.call($t, ee[ct]);
        }
        return Yv(Z, Be, Pt);
      }, se = `methodCaller<(${I.map((be) => be.name).join(", ")}) => ${Z.name}>`;
      return Rv(Ot(se, le));
    }, zv = (f) => {
      f > 4 && (vr.get(f).refcount += 1);
    }, Wv = (f) => {
      var v = Yr.toValue(f);
      te(v), sl(f);
    }, Kv = (f, v) => {
      f = il(f, "_emval_take_value");
      var k = f.readValueFromPointer(v);
      return Yr.toHandle(k);
    }, Gv = () => {
      ae("");
    }, Zv = (f, v, k) => w.copyWithin(f, v, v + k), Xv = () => 2147483648, Jv = (f) => {
      var v = y.buffer, k = (f - v.byteLength + 65535) / 65536;
      try {
        return y.grow(k), T(), 1;
      } catch {
      }
    }, Qv = (f) => {
      var v = w.length;
      f >>>= 0;
      var k = Xv();
      if (f > k)
        return !1;
      for (var I = (be, Ce) => be + (Ce - be % Ce) % Ce, Z = 1; Z <= 4; Z *= 2) {
        var ee = v * (1 + 0.2 / Z);
        ee = Math.min(ee, f + 100663296);
        var le = Math.min(k, I(Math.max(f, ee), 65536)), se = Jv(le);
        if (se)
          return !0;
      }
      return !1;
    }, fl = {}, ep = () => l || "./this.program", mn = () => {
      if (!mn.strings) {
        var f = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", v = {
          USER: "web_user",
          LOGNAME: "web_user",
          PATH: "/",
          PWD: "/",
          HOME: "/home/web_user",
          LANG: f,
          _: ep()
        };
        for (var k in fl)
          fl[k] === void 0 ? delete v[k] : v[k] = fl[k];
        var I = [];
        for (var k in v)
          I.push(`${k}=${v[k]}`);
        mn.strings = I;
      }
      return mn.strings;
    }, tp = (f, v) => {
      for (var k = 0; k < f.length; ++k)
        $[v++ >> 0] = f.charCodeAt(k);
      $[v >> 0] = 0;
    }, rp = (f, v) => {
      var k = 0;
      return mn().forEach((I, Z) => {
        var ee = v + k;
        E[f + Z * 4 >> 2] = ee, tp(I, ee), k += I.length + 1;
      }), 0;
    }, ap = (f, v) => {
      var k = mn();
      E[f >> 2] = k.length;
      var I = 0;
      return k.forEach((Z) => I += Z.length + 1), E[v >> 2] = I, 0;
    }, np = (f) => f, no = (f) => f % 4 === 0 && (f % 100 !== 0 || f % 400 === 0), op = (f, v) => {
      for (var k = 0, I = 0; I <= v; k += f[I++])
        ;
      return k;
    }, ci = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], di = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], lp = (f, v) => {
      for (var k = new Date(f.getTime()); v > 0; ) {
        var I = no(k.getFullYear()), Z = k.getMonth(), ee = (I ? ci : di)[Z];
        if (v > ee - k.getDate())
          v -= ee - k.getDate() + 1, k.setDate(1), Z < 11 ? k.setMonth(Z + 1) : (k.setMonth(0), k.setFullYear(k.getFullYear() + 1));
        else
          return k.setDate(k.getDate() + v), k;
      }
      return k;
    };
    function sp(f, v, k) {
      var I = li(f) + 1, Z = new Array(I);
      return oi(f, Z, 0, Z.length), Z;
    }
    var ip = (f, v) => {
      $.set(f, v);
    }, up = (f, v, k, I) => {
      var Z = E[I + 40 >> 2], ee = {
        tm_sec: q[I >> 2],
        tm_min: q[I + 4 >> 2],
        tm_hour: q[I + 8 >> 2],
        tm_mday: q[I + 12 >> 2],
        tm_mon: q[I + 16 >> 2],
        tm_year: q[I + 20 >> 2],
        tm_wday: q[I + 24 >> 2],
        tm_yday: q[I + 28 >> 2],
        tm_isdst: q[I + 32 >> 2],
        tm_gmtoff: q[I + 36 >> 2],
        tm_zone: Z ? cl(Z) : ""
      }, le = cl(k), se = {
        "%c": "%a %b %d %H:%M:%S %Y",
        "%D": "%m/%d/%y",
        "%F": "%Y-%m-%d",
        "%h": "%b",
        "%r": "%I:%M:%S %p",
        "%R": "%H:%M",
        "%T": "%H:%M:%S",
        "%x": "%m/%d/%y",
        "%X": "%H:%M:%S",
        "%Ec": "%c",
        "%EC": "%C",
        "%Ex": "%m/%d/%y",
        "%EX": "%H:%M:%S",
        "%Ey": "%y",
        "%EY": "%Y",
        "%Od": "%d",
        "%Oe": "%e",
        "%OH": "%H",
        "%OI": "%I",
        "%Om": "%m",
        "%OM": "%M",
        "%OS": "%S",
        "%Ou": "%u",
        "%OU": "%U",
        "%OV": "%V",
        "%Ow": "%w",
        "%OW": "%W",
        "%Oy": "%y"
      };
      for (var be in se)
        le = le.replace(new RegExp(be, "g"), se[be]);
      var Ce = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Be = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      function et(_e, Ne, Et) {
        for (var Nt = typeof _e == "number" ? _e.toString() : _e || ""; Nt.length < Ne; )
          Nt = Et[0] + Nt;
        return Nt;
      }
      function tt(_e, Ne) {
        return et(_e, Ne, "0");
      }
      function ct(_e, Ne) {
        function Et(Ta) {
          return Ta < 0 ? -1 : Ta > 0 ? 1 : 0;
        }
        var Nt;
        return (Nt = Et(_e.getFullYear() - Ne.getFullYear())) === 0 && (Nt = Et(_e.getMonth() - Ne.getMonth())) === 0 && (Nt = Et(_e.getDate() - Ne.getDate())), Nt;
      }
      function Pt(_e) {
        switch (_e.getDay()) {
          case 0:
            return new Date(_e.getFullYear() - 1, 11, 29);
          case 1:
            return _e;
          case 2:
            return new Date(_e.getFullYear(), 0, 3);
          case 3:
            return new Date(_e.getFullYear(), 0, 2);
          case 4:
            return new Date(_e.getFullYear(), 0, 1);
          case 5:
            return new Date(_e.getFullYear() - 1, 11, 31);
          case 6:
            return new Date(_e.getFullYear() - 1, 11, 30);
        }
      }
      function qt(_e) {
        var Ne = lp(new Date(_e.tm_year + 1900, 0, 1), _e.tm_yday), Et = new Date(Ne.getFullYear(), 0, 4), Nt = new Date(Ne.getFullYear() + 1, 0, 4), Ta = Pt(Et), lo = Pt(Nt);
        return ct(Ta, Ne) <= 0 ? ct(lo, Ne) <= 0 ? Ne.getFullYear() + 1 : Ne.getFullYear() : Ne.getFullYear() - 1;
      }
      var $t = {
        "%a": (_e) => Ce[_e.tm_wday].substring(0, 3),
        "%A": (_e) => Ce[_e.tm_wday],
        "%b": (_e) => Be[_e.tm_mon].substring(0, 3),
        "%B": (_e) => Be[_e.tm_mon],
        "%C": (_e) => {
          var Ne = _e.tm_year + 1900;
          return tt(Ne / 100 | 0, 2);
        },
        "%d": (_e) => tt(_e.tm_mday, 2),
        "%e": (_e) => et(_e.tm_mday, 2, " "),
        "%g": (_e) => qt(_e).toString().substring(2),
        "%G": (_e) => qt(_e),
        "%H": (_e) => tt(_e.tm_hour, 2),
        "%I": (_e) => {
          var Ne = _e.tm_hour;
          return Ne == 0 ? Ne = 12 : Ne > 12 && (Ne -= 12), tt(Ne, 2);
        },
        "%j": (_e) => tt(_e.tm_mday + op(no(_e.tm_year + 1900) ? ci : di, _e.tm_mon - 1), 3),
        "%m": (_e) => tt(_e.tm_mon + 1, 2),
        "%M": (_e) => tt(_e.tm_min, 2),
        "%n": () => `
`,
        "%p": (_e) => _e.tm_hour >= 0 && _e.tm_hour < 12 ? "AM" : "PM",
        "%S": (_e) => tt(_e.tm_sec, 2),
        "%t": () => "	",
        "%u": (_e) => _e.tm_wday || 7,
        "%U": (_e) => {
          var Ne = _e.tm_yday + 7 - _e.tm_wday;
          return tt(Math.floor(Ne / 7), 2);
        },
        "%V": (_e) => {
          var Ne = Math.floor((_e.tm_yday + 7 - (_e.tm_wday + 6) % 7) / 7);
          if ((_e.tm_wday + 371 - _e.tm_yday - 2) % 7 <= 2 && Ne++, Ne) {
            if (Ne == 53) {
              var Et = (_e.tm_wday + 371 - _e.tm_yday) % 7;
              Et != 4 && (Et != 3 || !no(_e.tm_year)) && (Ne = 1);
            }
          } else {
            Ne = 52;
            var Nt = (_e.tm_wday + 7 - _e.tm_yday - 1) % 7;
            (Nt == 4 || Nt == 5 && no(_e.tm_year % 400 - 1)) && Ne++;
          }
          return tt(Ne, 2);
        },
        "%w": (_e) => _e.tm_wday,
        "%W": (_e) => {
          var Ne = _e.tm_yday + 7 - (_e.tm_wday + 6) % 7;
          return tt(Math.floor(Ne / 7), 2);
        },
        "%y": (_e) => (_e.tm_year + 1900).toString().substring(2),
        "%Y": (_e) => _e.tm_year + 1900,
        "%z": (_e) => {
          var Ne = _e.tm_gmtoff, Et = Ne >= 0;
          return Ne = Math.abs(Ne) / 60, Ne = Ne / 60 * 100 + Ne % 60, (Et ? "+" : "-") + ("0000" + Ne).slice(-4);
        },
        "%Z": (_e) => _e.tm_zone,
        "%%": () => "%"
      };
      le = le.replace(/%%/g, "\0\0");
      for (var be in $t)
        le.includes(be) && (le = le.replace(new RegExp(be, "g"), $t[be](ee)));
      le = le.replace(/\0\0/g, "%");
      var Ut = sp(le);
      return Ut.length > v ? 0 : (ip(Ut, f), Ut.length - 1);
    }, cp = (f, v, k, I, Z) => up(f, v, k, I);
    de = r.InternalError = class extends Error {
      constructor(f) {
        super(f), this.name = "InternalError";
      }
    }, ue(), ge = r.BindingError = class extends Error {
      constructor(f) {
        super(f), this.name = "BindingError";
      }
    }, Xn(), Wn(), rv(), ti = r.UnboundTypeError = lv(Error, "UnboundTypeError"), dv(), vv();
    var dp = {
      s: Oe,
      u: ye,
      b: ce,
      g: mt,
      q: nt,
      J: ot,
      f: ft,
      V: $e,
      d: Me,
      da: dt,
      Q: Je,
      _: ve,
      ca: sv,
      ba: uv,
      w: cv,
      Y: pv,
      x: hv,
      h: yv,
      L: gv,
      M: _v,
      t: kv,
      o: $v,
      K: xv,
      C: Mv,
      A: qv,
      ea: Ev,
      $: Vv,
      R: Lv,
      ha: sl,
      fa: Hv,
      Z: Uv,
      N: zv,
      O: Wv,
      aa: Kv,
      B: Gv,
      X: Zv,
      W: Qv,
      T: rp,
      U: ap,
      E: Dp,
      D: hp,
      F: xp,
      n: Ap,
      a: fp,
      e: bp,
      m: mp,
      k: _p,
      H: Cp,
      v: kp,
      G: Sp,
      z: Op,
      P: Ip,
      l: gp,
      j: yp,
      c: pp,
      p: vp,
      I: $p,
      r: Pp,
      i: wp,
      y: Tp,
      ga: np,
      S: cp
    }, jt = re(), Ur = r._free = (f) => (Ur = r._free = jt.ka)(f), vl = r._malloc = (f) => (vl = r._malloc = jt.la)(f), fi = (f) => (fi = jt.na)(f), At = (f, v) => (At = jt.oa)(f, v), hn = (f) => (hn = jt.pa)(f), It = () => (It = jt.qa)(), Mt = (f) => (Mt = jt.ra)(f), vi = (f) => (vi = jt.sa)(f), pi = (f) => (pi = jt.ta)(f), mi = (f, v, k) => (mi = jt.ua)(f, v, k), hi = (f) => (hi = jt.va)(f);
    r.dynCall_viijii = (f, v, k, I, Z, ee, le) => (r.dynCall_viijii = jt.wa)(f, v, k, I, Z, ee, le);
    var yi = r.dynCall_jiiii = (f, v, k, I, Z) => (yi = r.dynCall_jiiii = jt.xa)(f, v, k, I, Z);
    r.dynCall_iiiiij = (f, v, k, I, Z, ee, le) => (r.dynCall_iiiiij = jt.ya)(f, v, k, I, Z, ee, le), r.dynCall_iiiiijj = (f, v, k, I, Z, ee, le, se, be) => (r.dynCall_iiiiijj = jt.za)(f, v, k, I, Z, ee, le, se, be), r.dynCall_iiiiiijj = (f, v, k, I, Z, ee, le, se, be, Ce) => (r.dynCall_iiiiiijj = jt.Aa)(f, v, k, I, Z, ee, le, se, be, Ce);
    function fp(f, v) {
      var k = It();
      try {
        return Tt(f)(v);
      } catch (I) {
        if (Mt(k), I !== I + 0)
          throw I;
        At(1, 0);
      }
    }
    function vp(f, v, k, I) {
      var Z = It();
      try {
        Tt(f)(v, k, I);
      } catch (ee) {
        if (Mt(Z), ee !== ee + 0)
          throw ee;
        At(1, 0);
      }
    }
    function pp(f, v, k) {
      var I = It();
      try {
        Tt(f)(v, k);
      } catch (Z) {
        if (Mt(I), Z !== Z + 0)
          throw Z;
        At(1, 0);
      }
    }
    function mp(f, v, k, I) {
      var Z = It();
      try {
        return Tt(f)(v, k, I);
      } catch (ee) {
        if (Mt(Z), ee !== ee + 0)
          throw ee;
        At(1, 0);
      }
    }
    function hp(f, v, k, I, Z) {
      var ee = It();
      try {
        return Tt(f)(v, k, I, Z);
      } catch (le) {
        if (Mt(ee), le !== le + 0)
          throw le;
        At(1, 0);
      }
    }
    function yp(f, v) {
      var k = It();
      try {
        Tt(f)(v);
      } catch (I) {
        if (Mt(k), I !== I + 0)
          throw I;
        At(1, 0);
      }
    }
    function bp(f, v, k) {
      var I = It();
      try {
        return Tt(f)(v, k);
      } catch (Z) {
        if (Mt(I), Z !== Z + 0)
          throw Z;
        At(1, 0);
      }
    }
    function gp(f) {
      var v = It();
      try {
        Tt(f)();
      } catch (k) {
        if (Mt(v), k !== k + 0)
          throw k;
        At(1, 0);
      }
    }
    function _p(f, v, k, I, Z) {
      var ee = It();
      try {
        return Tt(f)(v, k, I, Z);
      } catch (le) {
        if (Mt(ee), le !== le + 0)
          throw le;
        At(1, 0);
      }
    }
    function wp(f, v, k, I, Z, ee, le, se, be, Ce, Be) {
      var et = It();
      try {
        Tt(f)(v, k, I, Z, ee, le, se, be, Ce, Be);
      } catch (tt) {
        if (Mt(et), tt !== tt + 0)
          throw tt;
        At(1, 0);
      }
    }
    function kp(f, v, k, I, Z, ee, le) {
      var se = It();
      try {
        return Tt(f)(v, k, I, Z, ee, le);
      } catch (be) {
        if (Mt(se), be !== be + 0)
          throw be;
        At(1, 0);
      }
    }
    function $p(f, v, k, I, Z) {
      var ee = It();
      try {
        Tt(f)(v, k, I, Z);
      } catch (le) {
        if (Mt(ee), le !== le + 0)
          throw le;
        At(1, 0);
      }
    }
    function Cp(f, v, k, I, Z, ee) {
      var le = It();
      try {
        return Tt(f)(v, k, I, Z, ee);
      } catch (se) {
        if (Mt(le), se !== se + 0)
          throw se;
        At(1, 0);
      }
    }
    function Sp(f, v, k, I, Z, ee, le, se) {
      var be = It();
      try {
        return Tt(f)(v, k, I, Z, ee, le, se);
      } catch (Ce) {
        if (Mt(be), Ce !== Ce + 0)
          throw Ce;
        At(1, 0);
      }
    }
    function xp(f, v, k, I) {
      var Z = It();
      try {
        return Tt(f)(v, k, I);
      } catch (ee) {
        if (Mt(Z), ee !== ee + 0)
          throw ee;
        At(1, 0);
      }
    }
    function Dp(f, v, k, I) {
      var Z = It();
      try {
        return Tt(f)(v, k, I);
      } catch (ee) {
        if (Mt(Z), ee !== ee + 0)
          throw ee;
        At(1, 0);
      }
    }
    function Ap(f) {
      var v = It();
      try {
        return Tt(f)();
      } catch (k) {
        if (Mt(v), k !== k + 0)
          throw k;
        At(1, 0);
      }
    }
    function Pp(f, v, k, I, Z, ee, le, se) {
      var be = It();
      try {
        Tt(f)(v, k, I, Z, ee, le, se);
      } catch (Ce) {
        if (Mt(be), Ce !== Ce + 0)
          throw Ce;
        At(1, 0);
      }
    }
    function Op(f, v, k, I, Z, ee, le, se, be, Ce, Be, et) {
      var tt = It();
      try {
        return Tt(f)(v, k, I, Z, ee, le, se, be, Ce, Be, et);
      } catch (ct) {
        if (Mt(tt), ct !== ct + 0)
          throw ct;
        At(1, 0);
      }
    }
    function Tp(f, v, k, I, Z, ee, le, se, be, Ce, Be, et, tt, ct, Pt, qt) {
      var $t = It();
      try {
        Tt(f)(v, k, I, Z, ee, le, se, be, Ce, Be, et, tt, ct, Pt, qt);
      } catch (Ut) {
        if (Mt($t), Ut !== Ut + 0)
          throw Ut;
        At(1, 0);
      }
    }
    function Ip(f, v, k, I, Z) {
      var ee = It();
      try {
        return yi(f, v, k, I, Z);
      } catch (le) {
        if (Mt(ee), le !== le + 0)
          throw le;
        At(1, 0);
      }
    }
    var oo;
    F = function f() {
      oo || bi(), oo || (F = f);
    };
    function bi() {
      if (G > 0 || (x(), G > 0))
        return;
      function f() {
        oo || (oo = !0, r.calledRun = !0, !_ && (D(), a(r), r.onRuntimeInitialized && r.onRuntimeInitialized(), N()));
      }
      r.setStatus ? (r.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          r.setStatus("");
        }, 1), f();
      }, 1)) : f();
    }
    if (r.preInit)
      for (typeof r.preInit == "function" && (r.preInit = [r.preInit]); r.preInit.length > 0; )
        r.preInit.pop()();
    return bi(), t.ready;
  };
})();
function Dy(e) {
  return bs(
    gs,
    e
  );
}
async function Ay(e, t) {
  return Sy(
    gs,
    e,
    t
  );
}
async function Py(e, t) {
  return xy(
    gs,
    e,
    t
  );
}
var Cn;
class _l extends EventTarget {
  constructor(t = {}) {
    var r;
    super(), ty(this, Cn, void 0);
    try {
      const a = (r = t == null ? void 0 : t.formats) == null ? void 0 : r.filter(
        (n) => n !== "unknown"
      );
      if ((a == null ? void 0 : a.length) === 0)
        throw new TypeError("Hint option provided, but is empty.");
      a == null || a.forEach((n) => {
        if (!wo.has(n))
          throw new TypeError(
            `Failed to read the 'formats' property from 'BarcodeDetectorOptions': The provided value '${n}' is not a valid enum value of type BarcodeFormat.`
          );
      }), ry(this, Cn, a ?? []), Dy().then((n) => {
        this.dispatchEvent(
          new CustomEvent("load", {
            detail: n
          })
        );
      }).catch((n) => {
        this.dispatchEvent(new CustomEvent("error", { detail: n }));
      });
    } catch (a) {
      throw Oi(
        a,
        "Failed to construct 'BarcodeDetector'"
      );
    }
  }
  static async getSupportedFormats() {
    return ay.filter((t) => t !== "unknown");
  }
  async detect(t) {
    try {
      const r = await cy(t);
      if (r === null)
        return [];
      let a;
      try {
        Gc(r) ? a = await Ay(r, {
          tryHarder: !0,
          formats: Pi(this, Cn).map((n) => wo.get(n))
        }) : a = await Py(r, {
          tryHarder: !0,
          formats: Pi(this, Cn).map((n) => wo.get(n))
        });
      } catch (n) {
        throw console.error(n), new DOMException(
          "Barcode detection service unavailable.",
          "NotSupportedError"
        );
      }
      return a.map((n) => {
        const {
          topLeft: { x: o, y: l },
          topRight: { x: s, y: u },
          bottomLeft: { x: i, y: c },
          bottomRight: { x: d, y: p }
        } = n.position, h = Math.min(o, s, i, d), y = Math.min(l, u, c, p), _ = Math.max(o, s, i, d), $ = Math.max(l, u, c, p);
        return {
          boundingBox: new DOMRectReadOnly(
            h,
            y,
            _ - h,
            $ - y
          ),
          rawValue: n.text,
          format: ny(n.format),
          cornerPoints: [
            {
              x: o,
              y: l
            },
            {
              x: s,
              y: u
            },
            {
              x: d,
              y: p
            },
            {
              x: i,
              y: c
            }
          ]
        };
      });
    } catch (r) {
      throw Oi(
        r,
        "Failed to execute 'detect' on 'BarcodeDetector'"
      );
    }
  }
}
Cn = /* @__PURE__ */ new WeakMap();
const Qc = (e, t, r = "error") => {
  let a, n;
  const o = new Promise(
    (l, s) => {
      a = l, n = s, e.addEventListener(t, a), e.addEventListener(r, n);
    }
  );
  return o.finally(() => {
    e.removeEventListener(t, a), e.removeEventListener(r, n);
  }), o;
}, qi = (e) => new Promise((t) => setTimeout(t, e));
class ed extends Error {
  constructor() {
    super("this browser has no Stream API support"), this.name = "StreamApiNotSupportedError";
  }
}
class Oy extends Error {
  constructor() {
    super(
      "camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP."
    ), this.name = "InsecureContextError";
  }
}
class Ty extends Error {
  constructor() {
    super(
      "Loading camera stream timed out after 6 seconds. If you are on iOS in PWA mode, this is a known issue (see https://github.com/gruhn/vue-qrcode-reader/issues/298)"
    ), this.name = "StreamLoadTimeoutError";
  }
}
const Iy = (e) => {
  let t = !1, r;
  return (...a) => (t || (r = e(a), t = !0), r);
};
function Ir(e, t) {
  if (e === !1)
    throw new Error(t ?? "assertion failure");
}
function Ei(e) {
  throw new Error("this code should be unreachable");
}
function My() {
  return navigator.platform.toUpperCase().includes("MAC");
}
let td;
async function qy(e) {
  if (window.BarcodeDetector === void 0)
    return console.debug("[vue-qrcode-reader] Native BarcodeDetector not supported. Will use polyfill."), new _l({ formats: e });
  const t = await window.BarcodeDetector.getSupportedFormats(), r = e.filter((a) => !t.includes(a));
  return r.length > 0 ? (console.debug(`[vue-qrcode-reader] Native BarcodeDetector does not support formats ${JSON.stringify(r)}. Will use polyfill.`), new _l({ formats: e })) : My() && e.includes("pdf417") ? (console.debug("[vue-qrcode-reader] Native BarcodeDetector is buggy for PDF417 codes on MacOS. Will use polyfill."), new _l({ formats: e })) : (console.debug("[vue-qrcode-reader] Will use native BarcodeDetector."), new window.BarcodeDetector({ formats: e }));
}
async function rd(e) {
  td = await qy(e);
}
const Ey = async (e, {
  detectHandler: t,
  locateHandler: r,
  minDelay: a,
  formats: n
}) => {
  console.debug("[vue-qrcode-reader] start scanning"), await rd(n);
  const o = (l) => async (s) => {
    if (e.readyState === 0)
      console.debug("[vue-qrcode-reader] stop scanning: video element readyState is 0");
    else {
      const { lastScanned: u, contentBefore: i, lastScanHadContent: c } = l;
      if (s - u < a)
        window.requestAnimationFrame(o(l));
      else {
        const d = await td.detect(e), p = d.some((_) => !i.includes(_.rawValue));
        p && t(d);
        const h = d.length > 0;
        h && r(d), !h && c && r(d);
        const y = {
          lastScanned: s,
          lastScanHadContent: h,
          // It can happen that a QR code is constantly in view of the camera but
          // maybe a scanned frame is a bit blurry and we detect nothing but in the
          // next frame we detect the code again. We also want to avoid emitting
          // a `detect` event in such a case. So we don't reset `contentBefore`,
          // if we detect nothing, only if we detect something new.
          contentBefore: p ? d.map((_) => _.rawValue) : i
        };
        window.requestAnimationFrame(o(y));
      }
    }
  };
  o({
    lastScanned: performance.now(),
    contentBefore: [],
    lastScanHadContent: !1
  })(performance.now());
};
var ad = {}, ir = {};
Object.defineProperty(ir, "__esModule", {
  value: !0
});
ir.compactObject = ld;
ir.deprecated = Yy;
var Vy = ir.detectBrowser = Uy;
ir.disableLog = Ry;
ir.disableWarnings = Fy;
ir.extractVersion = ko;
ir.filterStats = zy;
ir.log = Ny;
ir.walkStats = To;
ir.wrapPeerConnectionEvent = Hy;
function Ly(e, t, r) {
  return t = By(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function By(e) {
  var t = jy(e, "string");
  return va(t) === "symbol" ? t : String(t);
}
function jy(e, t) {
  if (va(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(e, t);
    if (va(a) !== "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function va(e) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, va(e);
}
var nd = !0, od = !0;
function ko(e, t, r) {
  var a = e.match(t);
  return a && a.length >= r && parseInt(a[r], 10);
}
function Hy(e, t, r) {
  if (e.RTCPeerConnection) {
    var a = e.RTCPeerConnection.prototype, n = a.addEventListener;
    a.addEventListener = function(l, s) {
      if (l !== t)
        return n.apply(this, arguments);
      var u = function(i) {
        var c = r(i);
        c && (s.handleEvent ? s.handleEvent(c) : s(c));
      };
      return this._eventMap = this._eventMap || {}, this._eventMap[t] || (this._eventMap[t] = /* @__PURE__ */ new Map()), this._eventMap[t].set(s, u), n.apply(this, [l, u]);
    };
    var o = a.removeEventListener;
    a.removeEventListener = function(l, s) {
      if (l !== t || !this._eventMap || !this._eventMap[t])
        return o.apply(this, arguments);
      if (!this._eventMap[t].has(s))
        return o.apply(this, arguments);
      var u = this._eventMap[t].get(s);
      return this._eventMap[t].delete(s), this._eventMap[t].size === 0 && delete this._eventMap[t], Object.keys(this._eventMap).length === 0 && delete this._eventMap, o.apply(this, [l, u]);
    }, Object.defineProperty(a, "on" + t, {
      get: function() {
        return this["_on" + t];
      },
      set: function(l) {
        this["_on" + t] && (this.removeEventListener(t, this["_on" + t]), delete this["_on" + t]), l && this.addEventListener(t, this["_on" + t] = l);
      },
      enumerable: !0,
      configurable: !0
    });
  }
}
function Ry(e) {
  return typeof e != "boolean" ? new Error("Argument type: " + va(e) + ". Please use a boolean.") : (nd = e, e ? "adapter.js logging disabled" : "adapter.js logging enabled");
}
function Fy(e) {
  return typeof e != "boolean" ? new Error("Argument type: " + va(e) + ". Please use a boolean.") : (od = !e, "adapter.js deprecation warnings " + (e ? "disabled" : "enabled"));
}
function Ny() {
  if ((typeof window > "u" ? "undefined" : va(window)) === "object") {
    if (nd)
      return;
    typeof console < "u" && typeof console.log == "function" && console.log.apply(console, arguments);
  }
}
function Yy(e, t) {
  od && console.warn(e + " is deprecated, please use " + t + " instead.");
}
function Uy(e) {
  var t = {
    browser: null,
    version: null
  };
  if (typeof e > "u" || !e.navigator || !e.navigator.userAgent)
    return t.browser = "Not a browser.", t;
  var r = e.navigator;
  if (r.mozGetUserMedia)
    t.browser = "firefox", t.version = ko(r.userAgent, /Firefox\/(\d+)\./, 1);
  else if (r.webkitGetUserMedia || e.isSecureContext === !1 && e.webkitRTCPeerConnection)
    t.browser = "chrome", t.version = ko(r.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
  else if (e.RTCPeerConnection && r.userAgent.match(/AppleWebKit\/(\d+)\./))
    t.browser = "safari", t.version = ko(r.userAgent, /AppleWebKit\/(\d+)\./, 1), t.supportsUnifiedPlan = e.RTCRtpTransceiver && "currentDirection" in e.RTCRtpTransceiver.prototype;
  else
    return t.browser = "Not a supported browser.", t;
  return t;
}
function Vi(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ld(e) {
  return Vi(e) ? Object.keys(e).reduce(function(t, r) {
    var a = Vi(e[r]), n = a ? ld(e[r]) : e[r], o = a && !Object.keys(n).length;
    return n === void 0 || o ? t : Object.assign(t, Ly({}, r, n));
  }, {}) : e;
}
function To(e, t, r) {
  !t || r.has(t.id) || (r.set(t.id, t), Object.keys(t).forEach(function(a) {
    a.endsWith("Id") ? To(e, e.get(t[a]), r) : a.endsWith("Ids") && t[a].forEach(function(n) {
      To(e, e.get(n), r);
    });
  }));
}
function zy(e, t, r) {
  var a = r ? "outbound-rtp" : "inbound-rtp", n = /* @__PURE__ */ new Map();
  if (t === null)
    return n;
  var o = [];
  return e.forEach(function(l) {
    l.type === "track" && l.trackIdentifier === t.id && o.push(l);
  }), o.forEach(function(l) {
    e.forEach(function(s) {
      s.type === a && s.trackId === l.id && To(e, s, n);
    });
  }), n;
}
Object.defineProperty(ad, "__esModule", {
  value: !0
});
var Wy = ad.shimGetUserMedia = Zy, Ky = Gy(ir);
function sd(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (sd = function(a) {
    return a ? r : t;
  })(e);
}
function Gy(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || ua(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = sd(t);
  if (r && r.has(e))
    return r.get(e);
  var a = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var l = n ? Object.getOwnPropertyDescriptor(e, o) : null;
      l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
    }
  return a.default = e, r && r.set(e, a), a;
}
function ua(e) {
  "@babel/helpers - typeof";
  return ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ua(e);
}
var Li = Ky.log;
function Zy(e, t) {
  var r = e && e.navigator;
  if (r.mediaDevices) {
    var a = function(u) {
      if (ua(u) !== "object" || u.mandatory || u.optional)
        return u;
      var i = {};
      return Object.keys(u).forEach(function(c) {
        if (!(c === "require" || c === "advanced" || c === "mediaSource")) {
          var d = ua(u[c]) === "object" ? u[c] : {
            ideal: u[c]
          };
          d.exact !== void 0 && typeof d.exact == "number" && (d.min = d.max = d.exact);
          var p = function(y, _) {
            return y ? y + _.charAt(0).toUpperCase() + _.slice(1) : _ === "deviceId" ? "sourceId" : _;
          };
          if (d.ideal !== void 0) {
            i.optional = i.optional || [];
            var h = {};
            typeof d.ideal == "number" ? (h[p("min", c)] = d.ideal, i.optional.push(h), h = {}, h[p("max", c)] = d.ideal, i.optional.push(h)) : (h[p("", c)] = d.ideal, i.optional.push(h));
          }
          d.exact !== void 0 && typeof d.exact != "number" ? (i.mandatory = i.mandatory || {}, i.mandatory[p("", c)] = d.exact) : ["min", "max"].forEach(function(y) {
            d[y] !== void 0 && (i.mandatory = i.mandatory || {}, i.mandatory[p(y, c)] = d[y]);
          });
        }
      }), u.advanced && (i.optional = (i.optional || []).concat(u.advanced)), i;
    }, n = function(u, i) {
      if (t.version >= 61)
        return i(u);
      if (u = JSON.parse(JSON.stringify(u)), u && ua(u.audio) === "object") {
        var c = function(y, _, $) {
          _ in y && !($ in y) && (y[$] = y[_], delete y[_]);
        };
        u = JSON.parse(JSON.stringify(u)), c(u.audio, "autoGainControl", "googAutoGainControl"), c(u.audio, "noiseSuppression", "googNoiseSuppression"), u.audio = a(u.audio);
      }
      if (u && ua(u.video) === "object") {
        var d = u.video.facingMode;
        d = d && (ua(d) === "object" ? d : {
          ideal: d
        });
        var p = t.version < 66;
        if (d && (d.exact === "user" || d.exact === "environment" || d.ideal === "user" || d.ideal === "environment") && !(r.mediaDevices.getSupportedConstraints && r.mediaDevices.getSupportedConstraints().facingMode && !p)) {
          delete u.video.facingMode;
          var h;
          if (d.exact === "environment" || d.ideal === "environment" ? h = ["back", "rear"] : (d.exact === "user" || d.ideal === "user") && (h = ["front"]), h)
            return r.mediaDevices.enumerateDevices().then(function(y) {
              y = y.filter(function($) {
                return $.kind === "videoinput";
              });
              var _ = y.find(function($) {
                return h.some(function(w) {
                  return $.label.toLowerCase().includes(w);
                });
              });
              return !_ && y.length && h.includes("back") && (_ = y[y.length - 1]), _ && (u.video.deviceId = d.exact ? {
                exact: _.deviceId
              } : {
                ideal: _.deviceId
              }), u.video = a(u.video), Li("chrome: " + JSON.stringify(u)), i(u);
            });
        }
        u.video = a(u.video);
      }
      return Li("chrome: " + JSON.stringify(u)), i(u);
    }, o = function(u) {
      return t.version >= 64 ? u : {
        name: {
          PermissionDeniedError: "NotAllowedError",
          PermissionDismissedError: "NotAllowedError",
          InvalidStateError: "NotAllowedError",
          DevicesNotFoundError: "NotFoundError",
          ConstraintNotSatisfiedError: "OverconstrainedError",
          TrackStartError: "NotReadableError",
          MediaDeviceFailedDueToShutdown: "NotAllowedError",
          MediaDeviceKillSwitchOn: "NotAllowedError",
          TabCaptureError: "AbortError",
          ScreenCaptureError: "AbortError",
          DeviceCaptureError: "AbortError"
        }[u.name] || u.name,
        message: u.message,
        constraint: u.constraint || u.constraintName,
        toString: function() {
          return this.name + (this.message && ": ") + this.message;
        }
      };
    }, l = function(u, i, c) {
      n(u, function(d) {
        r.webkitGetUserMedia(d, i, function(p) {
          c && c(o(p));
        });
      });
    };
    if (r.getUserMedia = l.bind(r), r.mediaDevices.getUserMedia) {
      var s = r.mediaDevices.getUserMedia.bind(r.mediaDevices);
      r.mediaDevices.getUserMedia = function(u) {
        return n(u, function(i) {
          return s(i).then(function(c) {
            if (i.audio && !c.getAudioTracks().length || i.video && !c.getVideoTracks().length)
              throw c.getTracks().forEach(function(d) {
                d.stop();
              }), new DOMException("", "NotFoundError");
            return c;
          }, function(c) {
            return Promise.reject(o(c));
          });
        });
      };
    }
  }
}
var id = {};
Object.defineProperty(id, "__esModule", {
  value: !0
});
var Xy = id.shimGetUserMedia = eb, Jy = Qy(ir);
function ud(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (ud = function(a) {
    return a ? r : t;
  })(e);
}
function Qy(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || Ya(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = ud(t);
  if (r && r.has(e))
    return r.get(e);
  var a = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var l = n ? Object.getOwnPropertyDescriptor(e, o) : null;
      l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
    }
  return a.default = e, r && r.set(e, a), a;
}
function Ya(e) {
  "@babel/helpers - typeof";
  return Ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ya(e);
}
function eb(e, t) {
  var r = e && e.navigator, a = e && e.MediaStreamTrack;
  if (r.getUserMedia = function(u, i, c) {
    Jy.deprecated("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia"), r.mediaDevices.getUserMedia(u).then(i, c);
  }, !(t.version > 55 && "autoGainControl" in r.mediaDevices.getSupportedConstraints())) {
    var n = function(u, i, c) {
      i in u && !(c in u) && (u[c] = u[i], delete u[i]);
    }, o = r.mediaDevices.getUserMedia.bind(r.mediaDevices);
    if (r.mediaDevices.getUserMedia = function(u) {
      return Ya(u) === "object" && Ya(u.audio) === "object" && (u = JSON.parse(JSON.stringify(u)), n(u.audio, "autoGainControl", "mozAutoGainControl"), n(u.audio, "noiseSuppression", "mozNoiseSuppression")), o(u);
    }, a && a.prototype.getSettings) {
      var l = a.prototype.getSettings;
      a.prototype.getSettings = function() {
        var u = l.apply(this, arguments);
        return n(u, "mozAutoGainControl", "autoGainControl"), n(u, "mozNoiseSuppression", "noiseSuppression"), u;
      };
    }
    if (a && a.prototype.applyConstraints) {
      var s = a.prototype.applyConstraints;
      a.prototype.applyConstraints = function(u) {
        return this.kind === "audio" && Ya(u) === "object" && (u = JSON.parse(JSON.stringify(u)), n(u, "autoGainControl", "mozAutoGainControl"), n(u, "noiseSuppression", "mozNoiseSuppression")), s.apply(this, [u]);
      };
    }
  }
}
var Hr = {};
Object.defineProperty(Hr, "__esModule", {
  value: !0
});
Hr.shimAudioContext = cb;
Hr.shimCallbacksAPI = ob;
Hr.shimConstraints = fd;
Hr.shimCreateOfferLegacy = ub;
var tb = Hr.shimGetUserMedia = lb;
Hr.shimLocalStreamsAPI = ab;
Hr.shimRTCIceServerUrls = sb;
Hr.shimRemoteStreamsAPI = nb;
Hr.shimTrackEventTransceiver = ib;
var cd = rb(ir);
function dd(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (dd = function(a) {
    return a ? r : t;
  })(e);
}
function rb(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || pa(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = dd(t);
  if (r && r.has(e))
    return r.get(e);
  var a = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var l = n ? Object.getOwnPropertyDescriptor(e, o) : null;
      l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
    }
  return a.default = e, r && r.set(e, a), a;
}
function pa(e) {
  "@babel/helpers - typeof";
  return pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pa(e);
}
function ab(e) {
  if (!(pa(e) !== "object" || !e.RTCPeerConnection)) {
    if ("getLocalStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getLocalStreams = function() {
      return this._localStreams || (this._localStreams = []), this._localStreams;
    }), !("addStream" in e.RTCPeerConnection.prototype)) {
      var t = e.RTCPeerConnection.prototype.addTrack;
      e.RTCPeerConnection.prototype.addStream = function(r) {
        var a = this;
        this._localStreams || (this._localStreams = []), this._localStreams.includes(r) || this._localStreams.push(r), r.getAudioTracks().forEach(function(n) {
          return t.call(a, n, r);
        }), r.getVideoTracks().forEach(function(n) {
          return t.call(a, n, r);
        });
      }, e.RTCPeerConnection.prototype.addTrack = function(r) {
        for (var a = this, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), l = 1; l < n; l++)
          o[l - 1] = arguments[l];
        return o && o.forEach(function(s) {
          a._localStreams ? a._localStreams.includes(s) || a._localStreams.push(s) : a._localStreams = [s];
        }), t.apply(this, arguments);
      };
    }
    "removeStream" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.removeStream = function(r) {
      var a = this;
      this._localStreams || (this._localStreams = []);
      var n = this._localStreams.indexOf(r);
      if (n !== -1) {
        this._localStreams.splice(n, 1);
        var o = r.getTracks();
        this.getSenders().forEach(function(l) {
          o.includes(l.track) && a.removeTrack(l);
        });
      }
    });
  }
}
function nb(e) {
  if (!(pa(e) !== "object" || !e.RTCPeerConnection) && ("getRemoteStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this._remoteStreams ? this._remoteStreams : [];
  }), !("onaddstream" in e.RTCPeerConnection.prototype))) {
    Object.defineProperty(e.RTCPeerConnection.prototype, "onaddstream", {
      get: function() {
        return this._onaddstream;
      },
      set: function(r) {
        var a = this;
        this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = r), this.addEventListener("track", this._onaddstreampoly = function(n) {
          n.streams.forEach(function(o) {
            if (a._remoteStreams || (a._remoteStreams = []), !a._remoteStreams.includes(o)) {
              a._remoteStreams.push(o);
              var l = new Event("addstream");
              l.stream = o, a.dispatchEvent(l);
            }
          });
        });
      }
    });
    var t = e.RTCPeerConnection.prototype.setRemoteDescription;
    e.RTCPeerConnection.prototype.setRemoteDescription = function() {
      var r = this;
      return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(a) {
        a.streams.forEach(function(n) {
          if (r._remoteStreams || (r._remoteStreams = []), !(r._remoteStreams.indexOf(n) >= 0)) {
            r._remoteStreams.push(n);
            var o = new Event("addstream");
            o.stream = n, r.dispatchEvent(o);
          }
        });
      }), t.apply(r, arguments);
    };
  }
}
function ob(e) {
  if (!(pa(e) !== "object" || !e.RTCPeerConnection)) {
    var t = e.RTCPeerConnection.prototype, r = t.createOffer, a = t.createAnswer, n = t.setLocalDescription, o = t.setRemoteDescription, l = t.addIceCandidate;
    t.createOffer = function(u, i) {
      var c = arguments.length >= 2 ? arguments[2] : arguments[0], d = r.apply(this, [c]);
      return i ? (d.then(u, i), Promise.resolve()) : d;
    }, t.createAnswer = function(u, i) {
      var c = arguments.length >= 2 ? arguments[2] : arguments[0], d = a.apply(this, [c]);
      return i ? (d.then(u, i), Promise.resolve()) : d;
    };
    var s = function(u, i, c) {
      var d = n.apply(this, [u]);
      return c ? (d.then(i, c), Promise.resolve()) : d;
    };
    t.setLocalDescription = s, s = function(u, i, c) {
      var d = o.apply(this, [u]);
      return c ? (d.then(i, c), Promise.resolve()) : d;
    }, t.setRemoteDescription = s, s = function(u, i, c) {
      var d = l.apply(this, [u]);
      return c ? (d.then(i, c), Promise.resolve()) : d;
    }, t.addIceCandidate = s;
  }
}
function lb(e) {
  var t = e && e.navigator;
  if (t.mediaDevices && t.mediaDevices.getUserMedia) {
    var r = t.mediaDevices, a = r.getUserMedia.bind(r);
    t.mediaDevices.getUserMedia = function(n) {
      return a(fd(n));
    };
  }
  !t.getUserMedia && t.mediaDevices && t.mediaDevices.getUserMedia && (t.getUserMedia = (function(n, o, l) {
    t.mediaDevices.getUserMedia(n).then(o, l);
  }).bind(t));
}
function fd(e) {
  return e && e.video !== void 0 ? Object.assign({}, e, {
    video: cd.compactObject(e.video)
  }) : e;
}
function sb(e) {
  if (e.RTCPeerConnection) {
    var t = e.RTCPeerConnection;
    e.RTCPeerConnection = function(r, a) {
      if (r && r.iceServers) {
        for (var n = [], o = 0; o < r.iceServers.length; o++) {
          var l = r.iceServers[o];
          l.urls === void 0 && l.url ? (cd.deprecated("RTCIceServer.url", "RTCIceServer.urls"), l = JSON.parse(JSON.stringify(l)), l.urls = l.url, delete l.url, n.push(l)) : n.push(r.iceServers[o]);
        }
        r.iceServers = n;
      }
      return new t(r, a);
    }, e.RTCPeerConnection.prototype = t.prototype, "generateCertificate" in t && Object.defineProperty(e.RTCPeerConnection, "generateCertificate", {
      get: function() {
        return t.generateCertificate;
      }
    });
  }
}
function ib(e) {
  pa(e) === "object" && e.RTCTrackEvent && "receiver" in e.RTCTrackEvent.prototype && !("transceiver" in e.RTCTrackEvent.prototype) && Object.defineProperty(e.RTCTrackEvent.prototype, "transceiver", {
    get: function() {
      return {
        receiver: this.receiver
      };
    }
  });
}
function ub(e) {
  var t = e.RTCPeerConnection.prototype.createOffer;
  e.RTCPeerConnection.prototype.createOffer = function(r) {
    if (r) {
      typeof r.offerToReceiveAudio < "u" && (r.offerToReceiveAudio = !!r.offerToReceiveAudio);
      var a = this.getTransceivers().find(function(o) {
        return o.receiver.track.kind === "audio";
      });
      r.offerToReceiveAudio === !1 && a ? a.direction === "sendrecv" ? a.setDirection ? a.setDirection("sendonly") : a.direction = "sendonly" : a.direction === "recvonly" && (a.setDirection ? a.setDirection("inactive") : a.direction = "inactive") : r.offerToReceiveAudio === !0 && !a && this.addTransceiver("audio", {
        direction: "recvonly"
      }), typeof r.offerToReceiveVideo < "u" && (r.offerToReceiveVideo = !!r.offerToReceiveVideo);
      var n = this.getTransceivers().find(function(o) {
        return o.receiver.track.kind === "video";
      });
      r.offerToReceiveVideo === !1 && n ? n.direction === "sendrecv" ? n.setDirection ? n.setDirection("sendonly") : n.direction = "sendonly" : n.direction === "recvonly" && (n.setDirection ? n.setDirection("inactive") : n.direction = "inactive") : r.offerToReceiveVideo === !0 && !n && this.addTransceiver("video", {
        direction: "recvonly"
      });
    }
    return t.apply(this, arguments);
  };
}
function cb(e) {
  pa(e) !== "object" || e.AudioContext || (e.AudioContext = e.webkitAudioContext);
}
const db = Iy(() => {
  const e = Vy(window);
  switch (e.browser) {
    case "chrome":
      Wy(window, e);
      break;
    case "firefox":
      Xy(window, e);
      break;
    case "safari":
      tb(window, e);
      break;
    default:
      throw new ed();
  }
});
let Ua = Promise.resolve({ type: "stop", data: {} });
async function Bi(e, t, r) {
  var a, n, o;
  if (console.debug(
    "[vue-qrcode-reader] starting camera with constraints: ",
    JSON.stringify(t)
  ), window.isSecureContext !== !0)
    throw new Oy();
  if (((a = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : a.getUserMedia) === void 0)
    throw new ed();
  db(), console.debug("[vue-qrcode-reader] calling getUserMedia");
  const l = await navigator.mediaDevices.getUserMedia({
    audio: !1,
    video: t
  });
  e.srcObject !== void 0 ? e.srcObject = l : e.mozSrcObject !== void 0 ? e.mozSrcObject = l : window.URL.createObjectURL ? e.src = window.URL.createObjectURL(l) : window.webkitURL ? e.src = window.webkitURL.createObjectURL(l) : e.src = l.id, e.play(), console.debug("[vue-qrcode-reader] waiting for video element to load"), await Promise.race([
    Qc(e, "loadeddata"),
    // On iOS devices in PWA mode, QrcodeStream works initially, but after
    // killing and restarting the PWA, all video elements fail to load camera
    // streams and never emit the `loadeddata` event. Looks like this is
    // related to a WebKit issue (see #298). No workarounds at the moment.
    // To at least detect this situation, we throw an error if the event
    // has not been emitted after a 6 second timeout.
    qi(6e3).then(() => {
      throw new Ty();
    })
  ]), console.debug("[vue-qrcode-reader] video element loaded"), await qi(500);
  const [s] = l.getVideoTracks(), u = (o = (n = s == null ? void 0 : s.getCapabilities) == null ? void 0 : n.call(s)) != null ? o : {};
  let i = !1;
  return r && u.torch && (await s.applyConstraints({ advanced: [{ torch: !0 }] }), i = !0), console.debug("[vue-qrcode-reader] camera ready"), {
    type: "start",
    data: {
      videoEl: e,
      stream: l,
      capabilities: u,
      constraints: t,
      isTorchOn: i
    }
  };
}
async function fb(e, {
  constraints: t,
  torch: r,
  restart: a = !1
}) {
  Ua = Ua.then((o) => {
    if (o.type === "start") {
      const {
        data: {
          videoEl: l,
          stream: s,
          constraints: u,
          isTorchOn: i
        }
      } = o;
      return !a && e === l && t === u && r === i ? o : vd(l, s, i).then(
        () => Bi(e, t, r)
      );
    } else if (o.type === "stop" || o.type === "failed")
      return Bi(e, t, r);
    Ei();
  }).catch((o) => (console.debug(`[vue-qrcode-reader] starting camera failed with "${o}"`), { type: "failed", error: o }));
  const n = await Ua;
  if (n.type === "stop")
    throw new Error("Something went wrong with the camera task queue (start task).");
  if (n.type === "failed")
    throw n.error;
  if (n.type === "start")
    return n.data.capabilities;
  Ei();
}
async function vd(e, t, r) {
  console.debug("[vue-qrcode-reader] stopping camera"), e.src = "", e.srcObject = null, e.load(), await Qc(e, "error");
  for (const a of t.getTracks())
    r != null || await a.applyConstraints({ advanced: [{ torch: !1 }] }), t.removeTrack(a), a.stop();
  return {
    type: "stop",
    data: {}
  };
}
async function co() {
  if (Ua = Ua.then((e) => {
    if (e.type === "stop" || e.type === "failed")
      return e;
    const {
      data: { videoEl: t, stream: r, isTorchOn: a }
    } = e;
    return vd(t, r, a);
  }), (await Ua).type === "start")
    throw new Error("Something went wrong with the camera task queue (stop task).");
}
const vb = /* @__PURE__ */ Pe({
  __name: "QrcodeStream",
  props: {
    constraints: { default: () => ({ facingMode: "environment" }) },
    formats: { default: () => ["qr_code"] },
    paused: { type: Boolean, default: !1 },
    torch: { type: Boolean, default: !1 },
    track: { type: Function, default: void 0 }
  },
  emits: ["detect", "camera-on", "camera-off", "error"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = z(r.constraints), o = z(r.formats);
    Le(
      () => r.constraints,
      (R, q) => {
        JSON.stringify(R) !== JSON.stringify(q) && (n.value = R);
      },
      { deep: !0 }
    ), Le(
      () => r.formats,
      (R, q) => {
        JSON.stringify(R) !== JSON.stringify(q) && (o.value = R);
      },
      { deep: !0 }
    );
    const l = z(), s = z(), u = z(), i = z(!1), c = z(!1);
    St(() => {
      c.value = !0;
    }), Uo(() => {
      co();
    });
    const d = C(() => ({
      torch: r.torch,
      constraints: n.value,
      shouldStream: c.value && !r.paused
    }));
    Le(
      d,
      async (R) => {
        const q = u.value;
        Ir(
          q !== void 0,
          "cameraSettings watcher should never be triggered when component is not mounted. Thus video element should always be defined."
        );
        const E = l.value;
        Ir(
          E !== void 0,
          "cameraSettings watcher should never be triggered when component is not mounted. Thus canvas should always be defined."
        );
        const Y = E.getContext("2d");
        if (Ir(Y !== null, "if cavnas is defined, canvas 2d context should also be non-null"), R.shouldStream) {
          co(), i.value = !1;
          try {
            const V = await fb(q, R);
            c.value ? (i.value = !0, a("camera-on", V)) : await co();
          } catch (V) {
            a("error", V);
          }
        } else
          E.width = q.videoWidth, E.height = q.videoHeight, Y.drawImage(q, 0, 0, q.videoWidth, q.videoHeight), co(), i.value = !1, a("camera-off");
      },
      { deep: !0 }
    ), Le(o, async (R) => {
      c.value && await rd(R);
    });
    const p = C(() => d.value.shouldStream && i.value);
    Le(p, (R) => {
      if (R) {
        Ir(
          l.value !== void 0,
          "shouldScan watcher should only be triggered when component is mounted. Thus pause frame canvas is defined"
        ), h(l.value), Ir(
          s.value !== void 0,
          "shouldScan watcher should only be triggered when component is mounted. Thus tracking canvas is defined"
        ), h(s.value);
        const q = () => r.track === void 0 ? 500 : 40;
        Ir(
          u.value !== void 0,
          "shouldScan watcher should only be triggered when component is mounted. Thus video element is defined"
        ), Ey(u.value, {
          detectHandler: (E) => a("detect", E),
          formats: o.value,
          locateHandler: y,
          minDelay: q()
        });
      }
    });
    const h = (R) => {
      const q = R.getContext("2d");
      Ir(q !== null, "canvas 2d context should always be non-null"), q.clearRect(0, 0, R.width, R.height);
    }, y = (R) => {
      const q = s.value;
      Ir(
        q !== void 0,
        "onLocate handler should only be called when component is mounted. Thus tracking canvas is always defined."
      );
      const E = u.value;
      if (Ir(
        E !== void 0,
        "onLocate handler should only be called when component is mounted. Thus video element is always defined."
      ), R.length === 0 || r.track === void 0)
        h(q);
      else {
        const Y = E.offsetWidth, V = E.offsetHeight, T = E.videoWidth, A = E.videoHeight, P = Math.max(Y / T, V / A), b = T * P, x = A * P, D = b / T, N = x / A, M = (Y - b) / 2, H = (V - x) / 2, U = ({ x: Q, y: ae }) => ({
          x: Math.floor(Q * D),
          y: Math.floor(ae * N)
        }), G = ({ x: Q, y: ae }) => ({
          x: Math.floor(Q + M),
          y: Math.floor(ae + H)
        }), F = R.map((Q) => {
          const { boundingBox: ae, cornerPoints: Te } = Q, { x: Ae, y: Ye } = G(
            U({
              x: ae.x,
              y: ae.y
            })
          ), { x: Re, y: it } = U({
            x: ae.width,
            y: ae.height
          });
          return {
            ...Q,
            cornerPoints: Te.map((he) => G(U(he))),
            boundingBox: DOMRectReadOnly.fromRect({ x: Ae, y: Ye, width: Re, height: it })
          };
        });
        q.width = E.offsetWidth, q.height = E.offsetHeight;
        const O = q.getContext("2d");
        Ir(O !== null, "canvas 2d context should always be non-null"), r.track(F, O);
      }
    }, _ = {
      width: "100%",
      height: "100%",
      position: "relative",
      // notice that we use z-index only once for the wrapper div.
      // If z-index is not defined, elements are stacked in the order they appear in the DOM.
      // The first element is at the very bottom and subsequent elements are added on top.
      "z-index": "0"
    }, $ = {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: "0",
      left: "0"
    }, w = {
      width: "100%",
      height: "100%",
      "object-fit": "cover"
    }, L = C(() => p.value ? w : {
      ...w,
      visibility: "hidden",
      position: "absolute"
    });
    return (R, q) => (m(), S("div", { style: _ }, [
      W("video", {
        ref_key: "videoRef",
        ref: u,
        style: we(L.value),
        autoplay: "",
        muted: "",
        playsinline: ""
      }, null, 4),
      Kt(W("canvas", {
        id: "qrcode-stream-pause-frame",
        ref_key: "pauseFrameRef",
        ref: l,
        style: w
      }, null, 512), [
        [_r, !p.value]
      ]),
      W("canvas", {
        id: "qrcode-stream-tracking-layer",
        ref_key: "trackingLayerRef",
        ref: s,
        style: $
      }, null, 512),
      W("div", { style: $ }, [
        at(R.$slots, "default")
      ])
    ]));
  }
});
var lr = "top", kr = "bottom", $r = "right", sr = "left", _s = "auto", Rn = [lr, kr, $r, sr], Za = "start", Mn = "end", pb = "clippingParents", pd = "viewport", bn = "popper", mb = "reference", ji = /* @__PURE__ */ Rn.reduce(function(e, t) {
  return e.concat([t + "-" + Za, t + "-" + Mn]);
}, []), md = /* @__PURE__ */ [].concat(Rn, [_s]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Za, t + "-" + Mn]);
}, []), hb = "beforeRead", yb = "read", bb = "afterRead", gb = "beforeMain", _b = "main", wb = "afterMain", kb = "beforeWrite", $b = "write", Cb = "afterWrite", Sb = [hb, yb, bb, gb, _b, wb, kb, $b, Cb];
function Br(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function fr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Sa(e) {
  var t = fr(e).Element;
  return e instanceof t || e instanceof Element;
}
function br(e) {
  var t = fr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ws(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = fr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xb(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var a = t.styles[r] || {}, n = t.attributes[r] || {}, o = t.elements[r];
    !br(o) || !Br(o) || (Object.assign(o.style, a), Object.keys(n).forEach(function(l) {
      var s = n[l];
      s === !1 ? o.removeAttribute(l) : o.setAttribute(l, s === !0 ? "" : s);
    }));
  });
}
function Db(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var n = t.elements[a], o = t.attributes[a] || {}, l = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : r[a]), s = l.reduce(function(u, i) {
        return u[i] = "", u;
      }, {});
      !br(n) || !Br(n) || (Object.assign(n.style, s), Object.keys(o).forEach(function(u) {
        n.removeAttribute(u);
      }));
    });
  };
}
const Ab = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xb,
  effect: Db,
  requires: ["computeStyles"]
};
function Lr(e) {
  return e.split("-")[0];
}
var $a = Math.max, Io = Math.min, Xa = Math.round;
function Fl() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function hd() {
  return !/^((?!chrome|android).)*safari/i.test(Fl());
}
function Ja(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var a = e.getBoundingClientRect(), n = 1, o = 1;
  t && br(e) && (n = e.offsetWidth > 0 && Xa(a.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Xa(a.height) / e.offsetHeight || 1);
  var l = Sa(e) ? fr(e) : window, s = l.visualViewport, u = !hd() && r, i = (a.left + (u && s ? s.offsetLeft : 0)) / n, c = (a.top + (u && s ? s.offsetTop : 0)) / o, d = a.width / n, p = a.height / o;
  return {
    width: d,
    height: p,
    top: c,
    right: i + d,
    bottom: c + p,
    left: i,
    x: i,
    y: c
  };
}
function ks(e) {
  var t = Ja(e), r = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: a
  };
}
function yd(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && ws(r)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Zr(e) {
  return fr(e).getComputedStyle(e);
}
function Pb(e) {
  return ["table", "td", "th"].indexOf(Br(e)) >= 0;
}
function ha(e) {
  return ((Sa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Zo(e) {
  return Br(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ws(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ha(e)
  );
}
function Hi(e) {
  return !br(e) || // https://github.com/popperjs/popper-core/issues/837
  Zr(e).position === "fixed" ? null : e.offsetParent;
}
function Ob(e) {
  var t = /firefox/i.test(Fl()), r = /Trident/i.test(Fl());
  if (r && br(e)) {
    var a = Zr(e);
    if (a.position === "fixed")
      return null;
  }
  var n = Zo(e);
  for (ws(n) && (n = n.host); br(n) && ["html", "body"].indexOf(Br(n)) < 0; ) {
    var o = Zr(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Fn(e) {
  for (var t = fr(e), r = Hi(e); r && Pb(r) && Zr(r).position === "static"; )
    r = Hi(r);
  return r && (Br(r) === "html" || Br(r) === "body" && Zr(r).position === "static") ? t : r || Ob(e) || t;
}
function $s(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Pn(e, t, r) {
  return $a(e, Io(t, r));
}
function Tb(e, t, r) {
  var a = Pn(e, t, r);
  return a > r ? r : a;
}
function bd() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function gd(e) {
  return Object.assign({}, bd(), e);
}
function _d(e, t) {
  return t.reduce(function(r, a) {
    return r[a] = e, r;
  }, {});
}
var Ib = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, gd(typeof t != "number" ? t : _d(t, Rn));
};
function Mb(e) {
  var t, r = e.state, a = e.name, n = e.options, o = r.elements.arrow, l = r.modifiersData.popperOffsets, s = Lr(r.placement), u = $s(s), i = [sr, $r].indexOf(s) >= 0, c = i ? "height" : "width";
  if (!(!o || !l)) {
    var d = Ib(n.padding, r), p = ks(o), h = u === "y" ? lr : sr, y = u === "y" ? kr : $r, _ = r.rects.reference[c] + r.rects.reference[u] - l[u] - r.rects.popper[c], $ = l[u] - r.rects.reference[u], w = Fn(o), L = w ? u === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, R = _ / 2 - $ / 2, q = d[h], E = L - p[c] - d[y], Y = L / 2 - p[c] / 2 + R, V = Pn(q, Y, E), T = u;
    r.modifiersData[a] = (t = {}, t[T] = V, t.centerOffset = V - Y, t);
  }
}
function qb(e) {
  var t = e.state, r = e.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || yd(t.elements.popper, n) && (t.elements.arrow = n));
}
const Eb = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Mb,
  effect: qb,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Qa(e) {
  return e.split("-")[1];
}
var Vb = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Lb(e, t) {
  var r = e.x, a = e.y, n = t.devicePixelRatio || 1;
  return {
    x: Xa(r * n) / n || 0,
    y: Xa(a * n) / n || 0
  };
}
function Ri(e) {
  var t, r = e.popper, a = e.popperRect, n = e.placement, o = e.variation, l = e.offsets, s = e.position, u = e.gpuAcceleration, i = e.adaptive, c = e.roundOffsets, d = e.isFixed, p = l.x, h = p === void 0 ? 0 : p, y = l.y, _ = y === void 0 ? 0 : y, $ = typeof c == "function" ? c({
    x: h,
    y: _
  }) : {
    x: h,
    y: _
  };
  h = $.x, _ = $.y;
  var w = l.hasOwnProperty("x"), L = l.hasOwnProperty("y"), R = sr, q = lr, E = window;
  if (i) {
    var Y = Fn(r), V = "clientHeight", T = "clientWidth";
    if (Y === fr(r) && (Y = ha(r), Zr(Y).position !== "static" && s === "absolute" && (V = "scrollHeight", T = "scrollWidth")), Y = Y, n === lr || (n === sr || n === $r) && o === Mn) {
      q = kr;
      var A = d && Y === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Y[V]
      );
      _ -= A - a.height, _ *= u ? 1 : -1;
    }
    if (n === sr || (n === lr || n === kr) && o === Mn) {
      R = $r;
      var P = d && Y === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Y[T]
      );
      h -= P - a.width, h *= u ? 1 : -1;
    }
  }
  var b = Object.assign({
    position: s
  }, i && Vb), x = c === !0 ? Lb({
    x: h,
    y: _
  }, fr(r)) : {
    x: h,
    y: _
  };
  if (h = x.x, _ = x.y, u) {
    var D;
    return Object.assign({}, b, (D = {}, D[q] = L ? "0" : "", D[R] = w ? "0" : "", D.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + _ + "px)" : "translate3d(" + h + "px, " + _ + "px, 0)", D));
  }
  return Object.assign({}, b, (t = {}, t[q] = L ? _ + "px" : "", t[R] = w ? h + "px" : "", t.transform = "", t));
}
function Bb(e) {
  var t = e.state, r = e.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, o = r.adaptive, l = o === void 0 ? !0 : o, s = r.roundOffsets, u = s === void 0 ? !0 : s, i = {
    placement: Lr(t.placement),
    variation: Qa(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ri(Object.assign({}, i, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ri(Object.assign({}, i, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const jb = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Bb,
  data: {}
};
var fo = {
  passive: !0
};
function Hb(e) {
  var t = e.state, r = e.instance, a = e.options, n = a.scroll, o = n === void 0 ? !0 : n, l = a.resize, s = l === void 0 ? !0 : l, u = fr(t.elements.popper), i = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && i.forEach(function(c) {
    c.addEventListener("scroll", r.update, fo);
  }), s && u.addEventListener("resize", r.update, fo), function() {
    o && i.forEach(function(c) {
      c.removeEventListener("scroll", r.update, fo);
    }), s && u.removeEventListener("resize", r.update, fo);
  };
}
const Rb = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Hb,
  data: {}
};
var Fb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function $o(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Fb[t];
  });
}
var Nb = {
  start: "end",
  end: "start"
};
function Fi(e) {
  return e.replace(/start|end/g, function(t) {
    return Nb[t];
  });
}
function Cs(e) {
  var t = fr(e), r = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Ss(e) {
  return Ja(ha(e)).left + Cs(e).scrollLeft;
}
function Yb(e, t) {
  var r = fr(e), a = ha(e), n = r.visualViewport, o = a.clientWidth, l = a.clientHeight, s = 0, u = 0;
  if (n) {
    o = n.width, l = n.height;
    var i = hd();
    (i || !i && t === "fixed") && (s = n.offsetLeft, u = n.offsetTop);
  }
  return {
    width: o,
    height: l,
    x: s + Ss(e),
    y: u
  };
}
function Ub(e) {
  var t, r = ha(e), a = Cs(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, o = $a(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), l = $a(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -a.scrollLeft + Ss(e), u = -a.scrollTop;
  return Zr(n || r).direction === "rtl" && (s += $a(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: l,
    x: s,
    y: u
  };
}
function xs(e) {
  var t = Zr(e), r = t.overflow, a = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function wd(e) {
  return ["html", "body", "#document"].indexOf(Br(e)) >= 0 ? e.ownerDocument.body : br(e) && xs(e) ? e : wd(Zo(e));
}
function On(e, t) {
  var r;
  t === void 0 && (t = []);
  var a = wd(e), n = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = fr(a), l = n ? [o].concat(o.visualViewport || [], xs(a) ? a : []) : a, s = t.concat(l);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(On(Zo(l)))
  );
}
function Nl(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function zb(e, t) {
  var r = Ja(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ni(e, t, r) {
  return t === pd ? Nl(Yb(e, r)) : Sa(t) ? zb(t, r) : Nl(Ub(ha(e)));
}
function Wb(e) {
  var t = On(Zo(e)), r = ["absolute", "fixed"].indexOf(Zr(e).position) >= 0, a = r && br(e) ? Fn(e) : e;
  return Sa(a) ? t.filter(function(n) {
    return Sa(n) && yd(n, a) && Br(n) !== "body";
  }) : [];
}
function Kb(e, t, r, a) {
  var n = t === "clippingParents" ? Wb(e) : [].concat(t), o = [].concat(n, [r]), l = o[0], s = o.reduce(function(u, i) {
    var c = Ni(e, i, a);
    return u.top = $a(c.top, u.top), u.right = Io(c.right, u.right), u.bottom = Io(c.bottom, u.bottom), u.left = $a(c.left, u.left), u;
  }, Ni(e, l, a));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function kd(e) {
  var t = e.reference, r = e.element, a = e.placement, n = a ? Lr(a) : null, o = a ? Qa(a) : null, l = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, u;
  switch (n) {
    case lr:
      u = {
        x: l,
        y: t.y - r.height
      };
      break;
    case kr:
      u = {
        x: l,
        y: t.y + t.height
      };
      break;
    case $r:
      u = {
        x: t.x + t.width,
        y: s
      };
      break;
    case sr:
      u = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var i = n ? $s(n) : null;
  if (i != null) {
    var c = i === "y" ? "height" : "width";
    switch (o) {
      case Za:
        u[i] = u[i] - (t[c] / 2 - r[c] / 2);
        break;
      case Mn:
        u[i] = u[i] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return u;
}
function qn(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = a === void 0 ? e.placement : a, o = r.strategy, l = o === void 0 ? e.strategy : o, s = r.boundary, u = s === void 0 ? pb : s, i = r.rootBoundary, c = i === void 0 ? pd : i, d = r.elementContext, p = d === void 0 ? bn : d, h = r.altBoundary, y = h === void 0 ? !1 : h, _ = r.padding, $ = _ === void 0 ? 0 : _, w = gd(typeof $ != "number" ? $ : _d($, Rn)), L = p === bn ? mb : bn, R = e.rects.popper, q = e.elements[y ? L : p], E = Kb(Sa(q) ? q : q.contextElement || ha(e.elements.popper), u, c, l), Y = Ja(e.elements.reference), V = kd({
    reference: Y,
    element: R,
    placement: n
  }), T = Nl(Object.assign({}, R, V)), A = p === bn ? T : Y, P = {
    top: E.top - A.top + w.top,
    bottom: A.bottom - E.bottom + w.bottom,
    left: E.left - A.left + w.left,
    right: A.right - E.right + w.right
  }, b = e.modifiersData.offset;
  if (p === bn && b) {
    var x = b[n];
    Object.keys(P).forEach(function(D) {
      var N = [$r, kr].indexOf(D) >= 0 ? 1 : -1, M = [lr, kr].indexOf(D) >= 0 ? "y" : "x";
      P[D] += x[M] * N;
    });
  }
  return P;
}
function Gb(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = r.boundary, o = r.rootBoundary, l = r.padding, s = r.flipVariations, u = r.allowedAutoPlacements, i = u === void 0 ? md : u, c = Qa(a), d = c ? s ? ji : ji.filter(function(y) {
    return Qa(y) === c;
  }) : Rn, p = d.filter(function(y) {
    return i.indexOf(y) >= 0;
  });
  p.length === 0 && (p = d);
  var h = p.reduce(function(y, _) {
    return y[_] = qn(e, {
      placement: _,
      boundary: n,
      rootBoundary: o,
      padding: l
    })[Lr(_)], y;
  }, {});
  return Object.keys(h).sort(function(y, _) {
    return h[y] - h[_];
  });
}
function Zb(e) {
  if (Lr(e) === _s)
    return [];
  var t = $o(e);
  return [Fi(e), t, Fi(t)];
}
function Xb(e) {
  var t = e.state, r = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, l = r.altAxis, s = l === void 0 ? !0 : l, u = r.fallbackPlacements, i = r.padding, c = r.boundary, d = r.rootBoundary, p = r.altBoundary, h = r.flipVariations, y = h === void 0 ? !0 : h, _ = r.allowedAutoPlacements, $ = t.options.placement, w = Lr($), L = w === $, R = u || (L || !y ? [$o($)] : Zb($)), q = [$].concat(R).reduce(function(Ae, Ye) {
      return Ae.concat(Lr(Ye) === _s ? Gb(t, {
        placement: Ye,
        boundary: c,
        rootBoundary: d,
        padding: i,
        flipVariations: y,
        allowedAutoPlacements: _
      }) : Ye);
    }, []), E = t.rects.reference, Y = t.rects.popper, V = /* @__PURE__ */ new Map(), T = !0, A = q[0], P = 0; P < q.length; P++) {
      var b = q[P], x = Lr(b), D = Qa(b) === Za, N = [lr, kr].indexOf(x) >= 0, M = N ? "width" : "height", H = qn(t, {
        placement: b,
        boundary: c,
        rootBoundary: d,
        altBoundary: p,
        padding: i
      }), U = N ? D ? $r : sr : D ? kr : lr;
      E[M] > Y[M] && (U = $o(U));
      var G = $o(U), F = [];
      if (o && F.push(H[x] <= 0), s && F.push(H[U] <= 0, H[G] <= 0), F.every(function(Ae) {
        return Ae;
      })) {
        A = b, T = !1;
        break;
      }
      V.set(b, F);
    }
    if (T)
      for (var O = y ? 3 : 1, Q = function(Ye) {
        var Re = q.find(function(it) {
          var he = V.get(it);
          if (he)
            return he.slice(0, Ye).every(function(X) {
              return X;
            });
        });
        if (Re)
          return A = Re, "break";
      }, ae = O; ae > 0; ae--) {
        var Te = Q(ae);
        if (Te === "break") break;
      }
    t.placement !== A && (t.modifiersData[a]._skip = !0, t.placement = A, t.reset = !0);
  }
}
const Jb = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Xb,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Yi(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Ui(e) {
  return [lr, $r, kr, sr].some(function(t) {
    return e[t] >= 0;
  });
}
function Qb(e) {
  var t = e.state, r = e.name, a = t.rects.reference, n = t.rects.popper, o = t.modifiersData.preventOverflow, l = qn(t, {
    elementContext: "reference"
  }), s = qn(t, {
    altBoundary: !0
  }), u = Yi(l, a), i = Yi(s, n, o), c = Ui(u), d = Ui(i);
  t.modifiersData[r] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: i,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const eg = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Qb
};
function tg(e, t, r) {
  var a = Lr(e), n = [sr, lr].indexOf(a) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, l = o[0], s = o[1];
  return l = l || 0, s = (s || 0) * n, [sr, $r].indexOf(a) >= 0 ? {
    x: s,
    y: l
  } : {
    x: l,
    y: s
  };
}
function rg(e) {
  var t = e.state, r = e.options, a = e.name, n = r.offset, o = n === void 0 ? [0, 0] : n, l = md.reduce(function(c, d) {
    return c[d] = tg(d, t.rects, o), c;
  }, {}), s = l[t.placement], u = s.x, i = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += i), t.modifiersData[a] = l;
}
const ag = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: rg
};
function ng(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = kd({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const og = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ng,
  data: {}
};
function lg(e) {
  return e === "x" ? "y" : "x";
}
function sg(e) {
  var t = e.state, r = e.options, a = e.name, n = r.mainAxis, o = n === void 0 ? !0 : n, l = r.altAxis, s = l === void 0 ? !1 : l, u = r.boundary, i = r.rootBoundary, c = r.altBoundary, d = r.padding, p = r.tether, h = p === void 0 ? !0 : p, y = r.tetherOffset, _ = y === void 0 ? 0 : y, $ = qn(t, {
    boundary: u,
    rootBoundary: i,
    padding: d,
    altBoundary: c
  }), w = Lr(t.placement), L = Qa(t.placement), R = !L, q = $s(w), E = lg(q), Y = t.modifiersData.popperOffsets, V = t.rects.reference, T = t.rects.popper, A = typeof _ == "function" ? _(Object.assign({}, t.rects, {
    placement: t.placement
  })) : _, P = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), b = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, x = {
    x: 0,
    y: 0
  };
  if (Y) {
    if (o) {
      var D, N = q === "y" ? lr : sr, M = q === "y" ? kr : $r, H = q === "y" ? "height" : "width", U = Y[q], G = U + $[N], F = U - $[M], O = h ? -T[H] / 2 : 0, Q = L === Za ? V[H] : T[H], ae = L === Za ? -T[H] : -V[H], Te = t.elements.arrow, Ae = h && Te ? ks(Te) : {
        width: 0,
        height: 0
      }, Ye = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : bd(), Re = Ye[N], it = Ye[M], he = Pn(0, V[H], Ae[H]), X = R ? V[H] / 2 - O - he - Re - P.mainAxis : Q - he - Re - P.mainAxis, re = R ? -V[H] / 2 + O + he + it + P.mainAxis : ae + he + it + P.mainAxis, Se = t.elements.arrow && Fn(t.elements.arrow), me = Se ? q === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, fe = (D = b == null ? void 0 : b[q]) != null ? D : 0, Oe = U + X - fe - me, Ie = U + re - fe, ye = Pn(h ? Io(G, Oe) : G, U, h ? $a(F, Ie) : F);
      Y[q] = ye, x[q] = ye - U;
    }
    if (s) {
      var Fe, Me = q === "x" ? lr : sr, He = q === "x" ? kr : $r, ce = Y[E], mt = E === "y" ? "height" : "width", nt = ce + $[Me], ot = ce - $[He], ft = [lr, sr].indexOf(w) !== -1, $e = (Fe = b == null ? void 0 : b[E]) != null ? Fe : 0, Qe = ft ? nt : ce - V[mt] - T[mt] - $e + P.altAxis, te = ft ? ce + V[mt] + T[mt] - $e - P.altAxis : ot, xe = h && ft ? Tb(Qe, ce, te) : Pn(h ? Qe : nt, ce, h ? te : ot);
      Y[E] = xe, x[E] = xe - ce;
    }
    t.modifiersData[a] = x;
  }
}
const ig = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: sg,
  requiresIfExists: ["offset"]
};
function ug(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function cg(e) {
  return e === fr(e) || !br(e) ? Cs(e) : ug(e);
}
function dg(e) {
  var t = e.getBoundingClientRect(), r = Xa(t.width) / e.offsetWidth || 1, a = Xa(t.height) / e.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function fg(e, t, r) {
  r === void 0 && (r = !1);
  var a = br(t), n = br(t) && dg(t), o = ha(t), l = Ja(e, n, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((Br(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  xs(o)) && (s = cg(t)), br(t) ? (u = Ja(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : o && (u.x = Ss(o))), {
    x: l.left + s.scrollLeft - u.x,
    y: l.top + s.scrollTop - u.y,
    width: l.width,
    height: l.height
  };
}
function vg(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var l = [].concat(o.requires || [], o.requiresIfExists || []);
    l.forEach(function(s) {
      if (!r.has(s)) {
        var u = t.get(s);
        u && n(u);
      }
    }), a.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || n(o);
  }), a;
}
function pg(e) {
  var t = vg(e);
  return Sb.reduce(function(r, a) {
    return r.concat(t.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function mg(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function hg(e) {
  var t = e.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var zi = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Wi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function yg(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, a = r === void 0 ? [] : r, n = t.defaultOptions, o = n === void 0 ? zi : n;
  return function(s, u, i) {
    i === void 0 && (i = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, zi, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, h = {
      state: c,
      setOptions: function(w) {
        var L = typeof w == "function" ? w(c.options) : w;
        _(), c.options = Object.assign({}, o, c.options, L), c.scrollParents = {
          reference: Sa(s) ? On(s) : s.contextElement ? On(s.contextElement) : [],
          popper: On(u)
        };
        var R = pg(hg([].concat(a, c.options.modifiers)));
        return c.orderedModifiers = R.filter(function(q) {
          return q.enabled;
        }), y(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var w = c.elements, L = w.reference, R = w.popper;
          if (Wi(L, R)) {
            c.rects = {
              reference: fg(L, Fn(R), c.options.strategy === "fixed"),
              popper: ks(R)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(P) {
              return c.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var q = 0; q < c.orderedModifiers.length; q++) {
              if (c.reset === !0) {
                c.reset = !1, q = -1;
                continue;
              }
              var E = c.orderedModifiers[q], Y = E.fn, V = E.options, T = V === void 0 ? {} : V, A = E.name;
              typeof Y == "function" && (c = Y({
                state: c,
                options: T,
                name: A,
                instance: h
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: mg(function() {
        return new Promise(function($) {
          h.forceUpdate(), $(c);
        });
      }),
      destroy: function() {
        _(), p = !0;
      }
    };
    if (!Wi(s, u))
      return h;
    h.setOptions(i).then(function($) {
      !p && i.onFirstUpdate && i.onFirstUpdate($);
    });
    function y() {
      c.orderedModifiers.forEach(function($) {
        var w = $.name, L = $.options, R = L === void 0 ? {} : L, q = $.effect;
        if (typeof q == "function") {
          var E = q({
            state: c,
            name: w,
            instance: h,
            options: R
          }), Y = function() {
          };
          d.push(E || Y);
        }
      });
    }
    function _() {
      d.forEach(function($) {
        return $();
      }), d = [];
    }
    return h;
  };
}
var bg = [Rb, og, jb, Ab, ag, Jb, ig, Eb, eg], gg = /* @__PURE__ */ yg({
  defaultModifiers: bg
}), _g = Object.defineProperty, wg = (e, t, r) => t in e ? _g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ue = (e, t, r) => (wg(e, typeof t != "symbol" ? t + "" : t, r), r), vo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $d(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kg = Object.prototype, $g = kg.hasOwnProperty;
function Cg(e, t) {
  return e != null && $g.call(e, t);
}
var Sg = Cg, xg = Array.isArray, Pr = xg, Dg = typeof vo == "object" && vo && vo.Object === Object && vo, Cd = Dg, Ag = Cd, Pg = typeof self == "object" && self && self.Object === Object && self, Og = Ag || Pg || Function("return this")(), Rr = Og, Tg = Rr, Ig = Tg.Symbol, Xo = Ig, Ki = Xo, Sd = Object.prototype, Mg = Sd.hasOwnProperty, qg = Sd.toString, gn = Ki ? Ki.toStringTag : void 0;
function Eg(e) {
  var t = Mg.call(e, gn), r = e[gn];
  try {
    e[gn] = void 0;
    var a = !0;
  } catch {
  }
  var n = qg.call(e);
  return a && (t ? e[gn] = r : delete e[gn]), n;
}
var Vg = Eg, Lg = Object.prototype, Bg = Lg.toString;
function jg(e) {
  return Bg.call(e);
}
var Hg = jg, Gi = Xo, Rg = Vg, Fg = Hg, Ng = "[object Null]", Yg = "[object Undefined]", Zi = Gi ? Gi.toStringTag : void 0;
function Ug(e) {
  return e == null ? e === void 0 ? Yg : Ng : Zi && Zi in Object(e) ? Rg(e) : Fg(e);
}
var Fr = Ug;
function zg(e) {
  return e != null && typeof e == "object";
}
var Or = zg, Wg = Fr, Kg = Or, Gg = "[object Symbol]";
function Zg(e) {
  return typeof e == "symbol" || Kg(e) && Wg(e) == Gg;
}
var Ds = Zg, Xg = Pr, Jg = Ds, Qg = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, e_ = /^\w*$/;
function t_(e, t) {
  if (Xg(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Jg(e) ? !0 : e_.test(e) || !Qg.test(e) || t != null && e in Object(t);
}
var As = t_;
function r_(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Qr = r_, a_ = Fr, n_ = Qr, o_ = "[object AsyncFunction]", l_ = "[object Function]", s_ = "[object GeneratorFunction]", i_ = "[object Proxy]";
function u_(e) {
  if (!n_(e))
    return !1;
  var t = a_(e);
  return t == l_ || t == s_ || t == o_ || t == i_;
}
var Da = u_, c_ = Rr, d_ = c_["__core-js_shared__"], f_ = d_, wl = f_, Xi = function() {
  var e = /[^.]+$/.exec(wl && wl.keys && wl.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function v_(e) {
  return !!Xi && Xi in e;
}
var p_ = v_, m_ = Function.prototype, h_ = m_.toString;
function y_(e) {
  if (e != null) {
    try {
      return h_.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var xd = y_, b_ = Da, g_ = p_, __ = Qr, w_ = xd, k_ = /[\\^$.*+?()[\]{}|]/g, $_ = /^\[object .+?Constructor\]$/, C_ = Function.prototype, S_ = Object.prototype, x_ = C_.toString, D_ = S_.hasOwnProperty, A_ = RegExp(
  "^" + x_.call(D_).replace(k_, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function P_(e) {
  if (!__(e) || g_(e))
    return !1;
  var t = b_(e) ? A_ : $_;
  return t.test(w_(e));
}
var O_ = P_;
function T_(e, t) {
  return e == null ? void 0 : e[t];
}
var I_ = T_, M_ = O_, q_ = I_;
function E_(e, t) {
  var r = q_(e, t);
  return M_(r) ? r : void 0;
}
var Aa = E_, V_ = Aa, L_ = V_(Object, "create"), Jo = L_, Ji = Jo;
function B_() {
  this.__data__ = Ji ? Ji(null) : {}, this.size = 0;
}
var j_ = B_;
function H_(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var R_ = H_, F_ = Jo, N_ = "__lodash_hash_undefined__", Y_ = Object.prototype, U_ = Y_.hasOwnProperty;
function z_(e) {
  var t = this.__data__;
  if (F_) {
    var r = t[e];
    return r === N_ ? void 0 : r;
  }
  return U_.call(t, e) ? t[e] : void 0;
}
var W_ = z_, K_ = Jo, G_ = Object.prototype, Z_ = G_.hasOwnProperty;
function X_(e) {
  var t = this.__data__;
  return K_ ? t[e] !== void 0 : Z_.call(t, e);
}
var J_ = X_, Q_ = Jo, ew = "__lodash_hash_undefined__";
function tw(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Q_ && t === void 0 ? ew : t, this;
}
var rw = tw, aw = j_, nw = R_, ow = W_, lw = J_, sw = rw;
function on(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
on.prototype.clear = aw;
on.prototype.delete = nw;
on.prototype.get = ow;
on.prototype.has = lw;
on.prototype.set = sw;
var iw = on;
function uw() {
  this.__data__ = [], this.size = 0;
}
var cw = uw;
function dw(e, t) {
  return e === t || e !== e && t !== t;
}
var ln = dw, fw = ln;
function vw(e, t) {
  for (var r = e.length; r--; )
    if (fw(e[r][0], t))
      return r;
  return -1;
}
var Qo = vw, pw = Qo, mw = Array.prototype, hw = mw.splice;
function yw(e) {
  var t = this.__data__, r = pw(t, e);
  if (r < 0)
    return !1;
  var a = t.length - 1;
  return r == a ? t.pop() : hw.call(t, r, 1), --this.size, !0;
}
var bw = yw, gw = Qo;
function _w(e) {
  var t = this.__data__, r = gw(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var ww = _w, kw = Qo;
function $w(e) {
  return kw(this.__data__, e) > -1;
}
var Cw = $w, Sw = Qo;
function xw(e, t) {
  var r = this.__data__, a = Sw(r, e);
  return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
}
var Dw = xw, Aw = cw, Pw = bw, Ow = ww, Tw = Cw, Iw = Dw;
function sn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
sn.prototype.clear = Aw;
sn.prototype.delete = Pw;
sn.prototype.get = Ow;
sn.prototype.has = Tw;
sn.prototype.set = Iw;
var el = sn, Mw = Aa, qw = Rr, Ew = Mw(qw, "Map"), Ps = Ew, Qi = iw, Vw = el, Lw = Ps;
function Bw() {
  this.size = 0, this.__data__ = {
    hash: new Qi(),
    map: new (Lw || Vw)(),
    string: new Qi()
  };
}
var jw = Bw;
function Hw(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Rw = Hw, Fw = Rw;
function Nw(e, t) {
  var r = e.__data__;
  return Fw(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var tl = Nw, Yw = tl;
function Uw(e) {
  var t = Yw(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var zw = Uw, Ww = tl;
function Kw(e) {
  return Ww(this, e).get(e);
}
var Gw = Kw, Zw = tl;
function Xw(e) {
  return Zw(this, e).has(e);
}
var Jw = Xw, Qw = tl;
function e0(e, t) {
  var r = Qw(this, e), a = r.size;
  return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
}
var t0 = e0, r0 = jw, a0 = zw, n0 = Gw, o0 = Jw, l0 = t0;
function un(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
un.prototype.clear = r0;
un.prototype.delete = a0;
un.prototype.get = n0;
un.prototype.has = o0;
un.prototype.set = l0;
var Os = un, Dd = Os, s0 = "Expected a function";
function Ts(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(s0);
  var r = function() {
    var a = arguments, n = t ? t.apply(this, a) : a[0], o = r.cache;
    if (o.has(n))
      return o.get(n);
    var l = e.apply(this, a);
    return r.cache = o.set(n, l) || o, l;
  };
  return r.cache = new (Ts.Cache || Dd)(), r;
}
Ts.Cache = Dd;
var i0 = Ts, u0 = i0, c0 = 500;
function d0(e) {
  var t = u0(e, function(a) {
    return r.size === c0 && r.clear(), a;
  }), r = t.cache;
  return t;
}
var f0 = d0, v0 = f0, p0 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, m0 = /\\(\\)?/g, h0 = v0(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(p0, function(r, a, n, o) {
    t.push(n ? o.replace(m0, "$1") : a || r);
  }), t;
}), y0 = h0;
function b0(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length, n = Array(a); ++r < a; )
    n[r] = t(e[r], r, e);
  return n;
}
var g0 = b0, eu = Xo, _0 = g0, w0 = Pr, k0 = Ds, tu = eu ? eu.prototype : void 0, ru = tu ? tu.toString : void 0;
function Ad(e) {
  if (typeof e == "string")
    return e;
  if (w0(e))
    return _0(e, Ad) + "";
  if (k0(e))
    return ru ? ru.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var $0 = Ad, C0 = $0;
function S0(e) {
  return e == null ? "" : C0(e);
}
var x0 = S0, D0 = Pr, A0 = As, P0 = y0, O0 = x0;
function T0(e, t) {
  return D0(e) ? e : A0(e, t) ? [e] : P0(O0(e));
}
var Pd = T0, I0 = Fr, M0 = Or, q0 = "[object Arguments]";
function E0(e) {
  return M0(e) && I0(e) == q0;
}
var V0 = E0, au = V0, L0 = Or, Od = Object.prototype, B0 = Od.hasOwnProperty, j0 = Od.propertyIsEnumerable, H0 = au(/* @__PURE__ */ function() {
  return arguments;
}()) ? au : function(e) {
  return L0(e) && B0.call(e, "callee") && !j0.call(e, "callee");
}, Is = H0, R0 = 9007199254740991, F0 = /^(?:0|[1-9]\d*)$/;
function N0(e, t) {
  var r = typeof e;
  return t = t ?? R0, !!t && (r == "number" || r != "symbol" && F0.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ms = N0, Y0 = 9007199254740991;
function U0(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Y0;
}
var qs = U0, z0 = Ds;
function W0(e) {
  if (typeof e == "string" || z0(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var rl = W0, K0 = Pd, G0 = Is, Z0 = Pr, X0 = Ms, J0 = qs, Q0 = rl;
function ek(e, t, r) {
  t = K0(t, e);
  for (var a = -1, n = t.length, o = !1; ++a < n; ) {
    var l = Q0(t[a]);
    if (!(o = e != null && r(e, l)))
      break;
    e = e[l];
  }
  return o || ++a != n ? o : (n = e == null ? 0 : e.length, !!n && J0(n) && X0(l, n) && (Z0(e) || G0(e)));
}
var Td = ek, tk = Sg, rk = Td;
function ak(e, t) {
  return e != null && rk(e, t, tk);
}
var Id = ak, nk = Fr, ok = Or, lk = "[object Date]";
function sk(e) {
  return ok(e) && nk(e) == lk;
}
var ik = sk;
function uk(e) {
  return function(t) {
    return e(t);
  };
}
var Md = uk, En = {}, ck = {
  get exports() {
    return En;
  },
  set exports(e) {
    En = e;
  }
};
(function(e, t) {
  var r = Cd, a = t && !t.nodeType && t, n = a && !0 && e && !e.nodeType && e, o = n && n.exports === a, l = o && r.process, s = function() {
    try {
      var u = n && n.require && n.require("util").types;
      return u || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(ck, En);
var dk = ik, fk = Md, nu = En, ou = nu && nu.isDate, vk = ou ? fk(ou) : dk, pk = vk, mk = Fr, hk = Pr, yk = Or, bk = "[object String]";
function gk(e) {
  return typeof e == "string" || !hk(e) && yk(e) && mk(e) == bk;
}
var Er = gk;
function _k(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length; ++r < a; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var qd = _k, wk = el;
function kk() {
  this.__data__ = new wk(), this.size = 0;
}
var $k = kk;
function Ck(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Sk = Ck;
function xk(e) {
  return this.__data__.get(e);
}
var Dk = xk;
function Ak(e) {
  return this.__data__.has(e);
}
var Pk = Ak, Ok = el, Tk = Ps, Ik = Os, Mk = 200;
function qk(e, t) {
  var r = this.__data__;
  if (r instanceof Ok) {
    var a = r.__data__;
    if (!Tk || a.length < Mk - 1)
      return a.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Ik(a);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Ek = qk, Vk = el, Lk = $k, Bk = Sk, jk = Dk, Hk = Pk, Rk = Ek;
function cn(e) {
  var t = this.__data__ = new Vk(e);
  this.size = t.size;
}
cn.prototype.clear = Lk;
cn.prototype.delete = Bk;
cn.prototype.get = jk;
cn.prototype.has = Hk;
cn.prototype.set = Rk;
var Es = cn, Fk = "__lodash_hash_undefined__";
function Nk(e) {
  return this.__data__.set(e, Fk), this;
}
var Yk = Nk;
function Uk(e) {
  return this.__data__.has(e);
}
var zk = Uk, Wk = Os, Kk = Yk, Gk = zk;
function Mo(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Wk(); ++t < r; )
    this.add(e[t]);
}
Mo.prototype.add = Mo.prototype.push = Kk;
Mo.prototype.has = Gk;
var Zk = Mo;
function Xk(e, t) {
  return e.has(t);
}
var Jk = Xk, Qk = Zk, e1 = qd, t1 = Jk, r1 = 1, a1 = 2;
function n1(e, t, r, a, n, o) {
  var l = r & r1, s = e.length, u = t.length;
  if (s != u && !(l && u > s))
    return !1;
  var i = o.get(e), c = o.get(t);
  if (i && c)
    return i == t && c == e;
  var d = -1, p = !0, h = r & a1 ? new Qk() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < s; ) {
    var y = e[d], _ = t[d];
    if (a)
      var $ = l ? a(_, y, d, t, e, o) : a(y, _, d, e, t, o);
    if ($ !== void 0) {
      if ($)
        continue;
      p = !1;
      break;
    }
    if (h) {
      if (!e1(t, function(w, L) {
        if (!t1(h, L) && (y === w || n(y, w, r, a, o)))
          return h.push(L);
      })) {
        p = !1;
        break;
      }
    } else if (!(y === _ || n(y, _, r, a, o))) {
      p = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), p;
}
var Ed = n1, o1 = Rr, l1 = o1.Uint8Array, Vd = l1;
function s1(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a, n) {
    r[++t] = [n, a];
  }), r;
}
var i1 = s1;
function u1(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(a) {
    r[++t] = a;
  }), r;
}
var c1 = u1, lu = Xo, su = Vd, d1 = ln, f1 = Ed, v1 = i1, p1 = c1, m1 = 1, h1 = 2, y1 = "[object Boolean]", b1 = "[object Date]", g1 = "[object Error]", _1 = "[object Map]", w1 = "[object Number]", k1 = "[object RegExp]", $1 = "[object Set]", C1 = "[object String]", S1 = "[object Symbol]", x1 = "[object ArrayBuffer]", D1 = "[object DataView]", iu = lu ? lu.prototype : void 0, kl = iu ? iu.valueOf : void 0;
function A1(e, t, r, a, n, o, l) {
  switch (r) {
    case D1:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case x1:
      return !(e.byteLength != t.byteLength || !o(new su(e), new su(t)));
    case y1:
    case b1:
    case w1:
      return d1(+e, +t);
    case g1:
      return e.name == t.name && e.message == t.message;
    case k1:
    case C1:
      return e == t + "";
    case _1:
      var s = v1;
    case $1:
      var u = a & m1;
      if (s || (s = p1), e.size != t.size && !u)
        return !1;
      var i = l.get(e);
      if (i)
        return i == t;
      a |= h1, l.set(e, t);
      var c = f1(s(e), s(t), a, n, o, l);
      return l.delete(e), c;
    case S1:
      if (kl)
        return kl.call(e) == kl.call(t);
  }
  return !1;
}
var P1 = A1;
function O1(e, t) {
  for (var r = -1, a = t.length, n = e.length; ++r < a; )
    e[n + r] = t[r];
  return e;
}
var T1 = O1, I1 = T1, M1 = Pr;
function q1(e, t, r) {
  var a = t(e);
  return M1(e) ? a : I1(a, r(e));
}
var E1 = q1;
function V1(e, t) {
  for (var r = -1, a = e == null ? 0 : e.length, n = 0, o = []; ++r < a; ) {
    var l = e[r];
    t(l, r, e) && (o[n++] = l);
  }
  return o;
}
var L1 = V1;
function B1() {
  return [];
}
var j1 = B1, H1 = L1, R1 = j1, F1 = Object.prototype, N1 = F1.propertyIsEnumerable, uu = Object.getOwnPropertySymbols, Y1 = uu ? function(e) {
  return e == null ? [] : (e = Object(e), H1(uu(e), function(t) {
    return N1.call(e, t);
  }));
} : R1, U1 = Y1;
function z1(e, t) {
  for (var r = -1, a = Array(e); ++r < e; )
    a[r] = t(r);
  return a;
}
var W1 = z1, en = {}, K1 = {
  get exports() {
    return en;
  },
  set exports(e) {
    en = e;
  }
};
function G1() {
  return !1;
}
var Z1 = G1;
(function(e, t) {
  var r = Rr, a = Z1, n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, l = o && o.exports === n, s = l ? r.Buffer : void 0, u = s ? s.isBuffer : void 0, i = u || a;
  e.exports = i;
})(K1, en);
var X1 = Fr, J1 = qs, Q1 = Or, e$ = "[object Arguments]", t$ = "[object Array]", r$ = "[object Boolean]", a$ = "[object Date]", n$ = "[object Error]", o$ = "[object Function]", l$ = "[object Map]", s$ = "[object Number]", i$ = "[object Object]", u$ = "[object RegExp]", c$ = "[object Set]", d$ = "[object String]", f$ = "[object WeakMap]", v$ = "[object ArrayBuffer]", p$ = "[object DataView]", m$ = "[object Float32Array]", h$ = "[object Float64Array]", y$ = "[object Int8Array]", b$ = "[object Int16Array]", g$ = "[object Int32Array]", _$ = "[object Uint8Array]", w$ = "[object Uint8ClampedArray]", k$ = "[object Uint16Array]", $$ = "[object Uint32Array]", xt = {};
xt[m$] = xt[h$] = xt[y$] = xt[b$] = xt[g$] = xt[_$] = xt[w$] = xt[k$] = xt[$$] = !0;
xt[e$] = xt[t$] = xt[v$] = xt[r$] = xt[p$] = xt[a$] = xt[n$] = xt[o$] = xt[l$] = xt[s$] = xt[i$] = xt[u$] = xt[c$] = xt[d$] = xt[f$] = !1;
function C$(e) {
  return Q1(e) && J1(e.length) && !!xt[X1(e)];
}
var S$ = C$, x$ = S$, D$ = Md, cu = En, du = cu && cu.isTypedArray, A$ = du ? D$(du) : x$, Vs = A$, P$ = W1, O$ = Is, T$ = Pr, I$ = en, M$ = Ms, q$ = Vs, E$ = Object.prototype, V$ = E$.hasOwnProperty;
function L$(e, t) {
  var r = T$(e), a = !r && O$(e), n = !r && !a && I$(e), o = !r && !a && !n && q$(e), l = r || a || n || o, s = l ? P$(e.length, String) : [], u = s.length;
  for (var i in e)
    (t || V$.call(e, i)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (i == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (i == "offset" || i == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (i == "buffer" || i == "byteLength" || i == "byteOffset") || // Skip index properties.
    M$(i, u))) && s.push(i);
  return s;
}
var Ld = L$, B$ = Object.prototype;
function j$(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || B$;
  return e === r;
}
var Ls = j$;
function H$(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Bd = H$, R$ = Bd, F$ = R$(Object.keys, Object), N$ = F$, Y$ = Ls, U$ = N$, z$ = Object.prototype, W$ = z$.hasOwnProperty;
function K$(e) {
  if (!Y$(e))
    return U$(e);
  var t = [];
  for (var r in Object(e))
    W$.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var G$ = K$, Z$ = Da, X$ = qs;
function J$(e) {
  return e != null && X$(e.length) && !Z$(e);
}
var Nn = J$, Q$ = Ld, eC = G$, tC = Nn;
function rC(e) {
  return tC(e) ? Q$(e) : eC(e);
}
var Bs = rC, aC = E1, nC = U1, oC = Bs;
function lC(e) {
  return aC(e, oC, nC);
}
var sC = lC, fu = sC, iC = 1, uC = Object.prototype, cC = uC.hasOwnProperty;
function dC(e, t, r, a, n, o) {
  var l = r & iC, s = fu(e), u = s.length, i = fu(t), c = i.length;
  if (u != c && !l)
    return !1;
  for (var d = u; d--; ) {
    var p = s[d];
    if (!(l ? p in t : cC.call(t, p)))
      return !1;
  }
  var h = o.get(e), y = o.get(t);
  if (h && y)
    return h == t && y == e;
  var _ = !0;
  o.set(e, t), o.set(t, e);
  for (var $ = l; ++d < u; ) {
    p = s[d];
    var w = e[p], L = t[p];
    if (a)
      var R = l ? a(L, w, p, t, e, o) : a(w, L, p, e, t, o);
    if (!(R === void 0 ? w === L || n(w, L, r, a, o) : R)) {
      _ = !1;
      break;
    }
    $ || ($ = p == "constructor");
  }
  if (_ && !$) {
    var q = e.constructor, E = t.constructor;
    q != E && "constructor" in e && "constructor" in t && !(typeof q == "function" && q instanceof q && typeof E == "function" && E instanceof E) && (_ = !1);
  }
  return o.delete(e), o.delete(t), _;
}
var fC = dC, vC = Aa, pC = Rr, mC = vC(pC, "DataView"), hC = mC, yC = Aa, bC = Rr, gC = yC(bC, "Promise"), _C = gC, wC = Aa, kC = Rr, $C = wC(kC, "Set"), CC = $C, SC = Aa, xC = Rr, DC = SC(xC, "WeakMap"), AC = DC, Yl = hC, Ul = Ps, zl = _C, Wl = CC, Kl = AC, jd = Fr, dn = xd, vu = "[object Map]", PC = "[object Object]", pu = "[object Promise]", mu = "[object Set]", hu = "[object WeakMap]", yu = "[object DataView]", OC = dn(Yl), TC = dn(Ul), IC = dn(zl), MC = dn(Wl), qC = dn(Kl), ga = jd;
(Yl && ga(new Yl(new ArrayBuffer(1))) != yu || Ul && ga(new Ul()) != vu || zl && ga(zl.resolve()) != pu || Wl && ga(new Wl()) != mu || Kl && ga(new Kl()) != hu) && (ga = function(e) {
  var t = jd(e), r = t == PC ? e.constructor : void 0, a = r ? dn(r) : "";
  if (a)
    switch (a) {
      case OC:
        return yu;
      case TC:
        return vu;
      case IC:
        return pu;
      case MC:
        return mu;
      case qC:
        return hu;
    }
  return t;
});
var EC = ga, $l = Es, VC = Ed, LC = P1, BC = fC, bu = EC, gu = Pr, _u = en, jC = Vs, HC = 1, wu = "[object Arguments]", ku = "[object Array]", po = "[object Object]", RC = Object.prototype, $u = RC.hasOwnProperty;
function FC(e, t, r, a, n, o) {
  var l = gu(e), s = gu(t), u = l ? ku : bu(e), i = s ? ku : bu(t);
  u = u == wu ? po : u, i = i == wu ? po : i;
  var c = u == po, d = i == po, p = u == i;
  if (p && _u(e)) {
    if (!_u(t))
      return !1;
    l = !0, c = !1;
  }
  if (p && !c)
    return o || (o = new $l()), l || jC(e) ? VC(e, t, r, a, n, o) : LC(e, t, u, r, a, n, o);
  if (!(r & HC)) {
    var h = c && $u.call(e, "__wrapped__"), y = d && $u.call(t, "__wrapped__");
    if (h || y) {
      var _ = h ? e.value() : e, $ = y ? t.value() : t;
      return o || (o = new $l()), n(_, $, r, a, o);
    }
  }
  return p ? (o || (o = new $l()), BC(e, t, r, a, n, o)) : !1;
}
var NC = FC, YC = NC, Cu = Or;
function Hd(e, t, r, a, n) {
  return e === t ? !0 : e == null || t == null || !Cu(e) && !Cu(t) ? e !== e && t !== t : YC(e, t, r, a, Hd, n);
}
var Rd = Hd, UC = Es, zC = Rd, WC = 1, KC = 2;
function GC(e, t, r, a) {
  var n = r.length, o = n, l = !a;
  if (e == null)
    return !o;
  for (e = Object(e); n--; ) {
    var s = r[n];
    if (l && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++n < o; ) {
    s = r[n];
    var u = s[0], i = e[u], c = s[1];
    if (l && s[2]) {
      if (i === void 0 && !(u in e))
        return !1;
    } else {
      var d = new UC();
      if (a)
        var p = a(i, c, u, e, t, d);
      if (!(p === void 0 ? zC(c, i, WC | KC, a, d) : p))
        return !1;
    }
  }
  return !0;
}
var ZC = GC, XC = Qr;
function JC(e) {
  return e === e && !XC(e);
}
var Fd = JC, QC = Fd, eS = Bs;
function tS(e) {
  for (var t = eS(e), r = t.length; r--; ) {
    var a = t[r], n = e[a];
    t[r] = [a, n, QC(n)];
  }
  return t;
}
var rS = tS;
function aS(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Nd = aS, nS = ZC, oS = rS, lS = Nd;
function sS(e) {
  var t = oS(e);
  return t.length == 1 && t[0][2] ? lS(t[0][0], t[0][1]) : function(r) {
    return r === e || nS(r, e, t);
  };
}
var iS = sS, uS = Pd, cS = rl;
function dS(e, t) {
  t = uS(t, e);
  for (var r = 0, a = t.length; e != null && r < a; )
    e = e[cS(t[r++])];
  return r && r == a ? e : void 0;
}
var Yd = dS, fS = Yd;
function vS(e, t, r) {
  var a = e == null ? void 0 : fS(e, t);
  return a === void 0 ? r : a;
}
var wa = vS;
function pS(e, t) {
  return e != null && t in Object(e);
}
var mS = pS, hS = mS, yS = Td;
function bS(e, t) {
  return e != null && yS(e, t, hS);
}
var gS = bS, _S = Rd, wS = wa, kS = gS, $S = As, CS = Fd, SS = Nd, xS = rl, DS = 1, AS = 2;
function PS(e, t) {
  return $S(e) && CS(t) ? SS(xS(e), t) : function(r) {
    var a = wS(r, e);
    return a === void 0 && a === t ? kS(r, e) : _S(t, a, DS | AS);
  };
}
var OS = PS;
function TS(e) {
  return e;
}
var js = TS;
function IS(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var MS = IS, qS = Yd;
function ES(e) {
  return function(t) {
    return qS(t, e);
  };
}
var VS = ES, LS = MS, BS = VS, jS = As, HS = rl;
function RS(e) {
  return jS(e) ? LS(HS(e)) : BS(e);
}
var FS = RS, NS = iS, YS = OS, US = js, zS = Pr, WS = FS;
function KS(e) {
  return typeof e == "function" ? e : e == null ? US : typeof e == "object" ? zS(e) ? YS(e[0], e[1]) : NS(e) : WS(e);
}
var Ud = KS;
function GS(e) {
  return function(t, r, a) {
    for (var n = -1, o = Object(t), l = a(t), s = l.length; s--; ) {
      var u = l[e ? s : ++n];
      if (r(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var ZS = GS, XS = ZS, JS = XS(), zd = JS, QS = zd, ex = Bs;
function tx(e, t) {
  return e && QS(e, t, ex);
}
var Wd = tx, rx = Nn;
function ax(e, t) {
  return function(r, a) {
    if (r == null)
      return r;
    if (!rx(r))
      return e(r, a);
    for (var n = r.length, o = t ? n : -1, l = Object(r); (t ? o-- : ++o < n) && a(l[o], o, l) !== !1; )
      ;
    return r;
  };
}
var nx = ax, ox = Wd, lx = nx, sx = lx(ox), ix = sx, ux = ix;
function cx(e, t) {
  var r;
  return ux(e, function(a, n, o) {
    return r = t(a, n, o), !r;
  }), !!r;
}
var dx = cx, fx = ln, vx = Nn, px = Ms, mx = Qr;
function hx(e, t, r) {
  if (!mx(r))
    return !1;
  var a = typeof t;
  return (a == "number" ? vx(r) && px(t, r.length) : a == "string" && t in r) ? fx(r[t], e) : !1;
}
var Hs = hx, yx = qd, bx = Ud, gx = dx, _x = Pr, wx = Hs;
function kx(e, t, r) {
  var a = _x(e) ? yx : gx;
  return r && wx(e, t, r) && (t = void 0), a(e, bx(t));
}
var $x = kx, Cx = Fr, Sx = Or, xx = "[object Boolean]";
function Dx(e) {
  return e === !0 || e === !1 || Sx(e) && Cx(e) == xx;
}
var Ax = Dx, Px = Fr, Ox = Or, Tx = "[object Number]";
function Ix(e) {
  return typeof e == "number" || Ox(e) && Px(e) == Tx;
}
var Dr = Ix, Mx = Aa, qx = function() {
  try {
    var e = Mx(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Kd = qx, Su = Kd;
function Ex(e, t, r) {
  t == "__proto__" && Su ? Su(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var al = Ex, Vx = al, Lx = ln, Bx = Object.prototype, jx = Bx.hasOwnProperty;
function Hx(e, t, r) {
  var a = e[t];
  (!(jx.call(e, t) && Lx(a, r)) || r === void 0 && !(t in e)) && Vx(e, t, r);
}
var Rx = Hx, Fx = al, Nx = Wd, Yx = Ud;
function Ux(e, t) {
  var r = {};
  return t = Yx(t), Nx(e, function(a, n, o) {
    Fx(r, n, t(a, n, o));
  }), r;
}
var zx = Ux;
function Wx(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Gd = Wx, Kx = Gd, xu = Math.max;
function Gx(e, t, r) {
  return t = xu(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var a = arguments, n = -1, o = xu(a.length - t, 0), l = Array(o); ++n < o; )
      l[n] = a[t + n];
    n = -1;
    for (var s = Array(t + 1); ++n < t; )
      s[n] = a[n];
    return s[t] = r(l), Kx(e, this, s);
  };
}
var Zx = Gx;
function Xx(e) {
  return function() {
    return e;
  };
}
var Jx = Xx, Qx = Jx, Du = Kd, eD = js, tD = Du ? function(e, t) {
  return Du(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Qx(t),
    writable: !0
  });
} : eD, rD = tD, aD = 800, nD = 16, oD = Date.now;
function lD(e) {
  var t = 0, r = 0;
  return function() {
    var a = oD(), n = nD - (a - r);
    if (r = a, n > 0) {
      if (++t >= aD)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var sD = lD, iD = rD, uD = sD, cD = uD(iD), dD = cD, fD = js, vD = Zx, pD = dD;
function mD(e, t) {
  return pD(vD(e, t, fD), e + "");
}
var Rs = mD;
function hD(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var yD = hD, bD = Qr, gD = Ls, _D = yD, wD = Object.prototype, kD = wD.hasOwnProperty;
function $D(e) {
  if (!bD(e))
    return _D(e);
  var t = gD(e), r = [];
  for (var a in e)
    a == "constructor" && (t || !kD.call(e, a)) || r.push(a);
  return r;
}
var CD = $D, SD = Ld, xD = CD, DD = Nn;
function AD(e) {
  return DD(e) ? SD(e, !0) : xD(e);
}
var Fs = AD, PD = Rs, OD = ln, TD = Hs, ID = Fs, Zd = Object.prototype, MD = Zd.hasOwnProperty, qD = PD(function(e, t) {
  e = Object(e);
  var r = -1, a = t.length, n = a > 2 ? t[2] : void 0;
  for (n && TD(t[0], t[1], n) && (a = 1); ++r < a; )
    for (var o = t[r], l = ID(o), s = -1, u = l.length; ++s < u; ) {
      var i = l[s], c = e[i];
      (c === void 0 || OD(c, Zd[i]) && !MD.call(e, i)) && (e[i] = o[i]);
    }
  return e;
}), Au = qD, ED = al, VD = ln;
function LD(e, t, r) {
  (r !== void 0 && !VD(e[t], r) || r === void 0 && !(t in e)) && ED(e, t, r);
}
var Xd = LD, qo = {}, BD = {
  get exports() {
    return qo;
  },
  set exports(e) {
    qo = e;
  }
};
(function(e, t) {
  var r = Rr, a = t && !t.nodeType && t, n = a && !0 && e && !e.nodeType && e, o = n && n.exports === a, l = o ? r.Buffer : void 0, s = l ? l.allocUnsafe : void 0;
  function u(i, c) {
    if (c)
      return i.slice();
    var d = i.length, p = s ? s(d) : new i.constructor(d);
    return i.copy(p), p;
  }
  e.exports = u;
})(BD, qo);
var Pu = Vd;
function jD(e) {
  var t = new e.constructor(e.byteLength);
  return new Pu(t).set(new Pu(e)), t;
}
var HD = jD, RD = HD;
function FD(e, t) {
  var r = t ? RD(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var ND = FD;
function YD(e, t) {
  var r = -1, a = e.length;
  for (t || (t = Array(a)); ++r < a; )
    t[r] = e[r];
  return t;
}
var UD = YD, zD = Qr, Ou = Object.create, WD = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!zD(t))
      return {};
    if (Ou)
      return Ou(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), KD = WD, GD = Bd, ZD = GD(Object.getPrototypeOf, Object), Jd = ZD, XD = KD, JD = Jd, QD = Ls;
function eA(e) {
  return typeof e.constructor == "function" && !QD(e) ? XD(JD(e)) : {};
}
var tA = eA, rA = Nn, aA = Or;
function nA(e) {
  return aA(e) && rA(e);
}
var oA = nA, lA = Fr, sA = Jd, iA = Or, uA = "[object Object]", cA = Function.prototype, dA = Object.prototype, Qd = cA.toString, fA = dA.hasOwnProperty, vA = Qd.call(Object);
function pA(e) {
  if (!iA(e) || lA(e) != uA)
    return !1;
  var t = sA(e);
  if (t === null)
    return !0;
  var r = fA.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Qd.call(r) == vA;
}
var mA = pA;
function hA(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var ef = hA, yA = Rx, bA = al;
function gA(e, t, r, a) {
  var n = !r;
  r || (r = {});
  for (var o = -1, l = t.length; ++o < l; ) {
    var s = t[o], u = a ? a(r[s], e[s], s, r, e) : void 0;
    u === void 0 && (u = e[s]), n ? bA(r, s, u) : yA(r, s, u);
  }
  return r;
}
var _A = gA, wA = _A, kA = Fs;
function $A(e) {
  return wA(e, kA(e));
}
var CA = $A, Tu = Xd, SA = qo, xA = ND, DA = UD, AA = tA, Iu = Is, Mu = Pr, PA = oA, OA = en, TA = Da, IA = Qr, MA = mA, qA = Vs, qu = ef, EA = CA;
function VA(e, t, r, a, n, o, l) {
  var s = qu(e, r), u = qu(t, r), i = l.get(u);
  if (i) {
    Tu(e, r, i);
    return;
  }
  var c = o ? o(s, u, r + "", e, t, l) : void 0, d = c === void 0;
  if (d) {
    var p = Mu(u), h = !p && OA(u), y = !p && !h && qA(u);
    c = u, p || h || y ? Mu(s) ? c = s : PA(s) ? c = DA(s) : h ? (d = !1, c = SA(u, !0)) : y ? (d = !1, c = xA(u, !0)) : c = [] : MA(u) || Iu(u) ? (c = s, Iu(s) ? c = EA(s) : (!IA(s) || TA(s)) && (c = AA(u))) : d = !1;
  }
  d && (l.set(u, c), n(c, u, a, o, l), l.delete(u)), Tu(e, r, c);
}
var LA = VA, BA = Es, jA = Xd, HA = zd, RA = LA, FA = Qr, NA = Fs, YA = ef;
function tf(e, t, r, a, n) {
  e !== t && HA(t, function(o, l) {
    if (n || (n = new BA()), FA(o))
      RA(e, t, l, r, tf, a, n);
    else {
      var s = a ? a(YA(e, l), o, l + "", e, t, n) : void 0;
      s === void 0 && (s = o), jA(e, l, s);
    }
  }, NA);
}
var rf = tf, UA = rf, Eu = Qr;
function af(e, t, r, a, n, o) {
  return Eu(e) && Eu(t) && (o.set(t, e), UA(e, t, void 0, af, o), o.delete(t)), e;
}
var zA = af, WA = Rs, KA = Hs;
function GA(e) {
  return WA(function(t, r) {
    var a = -1, n = r.length, o = n > 1 ? r[n - 1] : void 0, l = n > 2 ? r[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (n--, o) : void 0, l && KA(r[0], r[1], l) && (o = n < 3 ? void 0 : o, n = 1), t = Object(t); ++a < n; ) {
      var s = r[a];
      s && e(t, s, a, o);
    }
    return t;
  });
}
var ZA = GA, XA = rf, JA = ZA, QA = JA(function(e, t, r, a) {
  XA(e, t, r, a);
}), eP = QA, tP = Gd, rP = Rs, aP = zA, nP = eP, oP = rP(function(e) {
  return e.push(void 0, aP), tP(nP, void 0, e);
}), Vn = oP;
function lP(e) {
  return e && e.length ? e[0] : void 0;
}
var nf = lP;
function sP(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Ba = sP;
const iP = (e) => Object.prototype.toString.call(e).slice(8, -1), za = (e) => pk(e) && !isNaN(e.getTime()), Xr = (e) => iP(e) === "Object", of = Id, Vu = (e, t) => $x(t, (r) => Id(e, r)), wt = (e, t, r = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${r}${e}`;
  return e;
}, gr = (e) => Array.isArray(e), Wr = (e) => gr(e) && e.length > 0, Eo = (e) => e == null ? null : document && Er(e) ? document.querySelector(e) : e.$el ?? e, ca = (e, t, r, a = void 0) => {
  e.removeEventListener(t, r, a);
}, da = (e, t, r, a = void 0) => (e.addEventListener(t, r, a), () => ca(e, t, r, a)), Co = (e, t) => !!e && !!t && (e === t || e.contains(t)), mo = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, lf = (e, ...t) => {
  const r = {};
  let a;
  for (a in e)
    t.includes(a) || (r[a] = e[a]);
  return r;
}, sf = (e, t) => {
  const r = {};
  return t.forEach((a) => {
    a in e && (r[a] = e[a]);
  }), r;
};
function uP(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
var Vo = {}, cP = {
  get exports() {
    return Vo;
  },
  set exports(e) {
    Vo = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(cP, Vo);
const dP = /* @__PURE__ */ $d(Vo);
var Lo = {}, fP = {
  get exports() {
    return Lo;
  },
  set exports(e) {
    Lo = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(a) {
    var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
  }
  e.exports = t.default;
})(fP, Lo);
const Lu = /* @__PURE__ */ $d(Lo);
function vP(e, t) {
  var r = yP(t);
  return r.formatToParts ? mP(r, e) : hP(r, e);
}
var pP = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function mP(e, t) {
  try {
    for (var r = e.formatToParts(t), a = [], n = 0; n < r.length; n++) {
      var o = pP[r[n].type];
      o >= 0 && (a[o] = parseInt(r[n].value, 10));
    }
    return a;
  } catch (l) {
    if (l instanceof RangeError)
      return [NaN];
    throw l;
  }
}
function hP(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [a[3], a[1], a[2], a[4], a[5], a[6]];
}
var Cl = {};
function yP(e) {
  if (!Cl[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Cl[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Cl[e];
}
function uf(e, t, r, a, n, o, l) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(a, n, o, l), s;
}
var Bu = 36e5, bP = 6e4, Sl = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function gP(e, t, r) {
  var a, n;
  if (!e || (a = Sl.timezoneZ.exec(e), a))
    return 0;
  var o;
  if (a = Sl.timezoneHH.exec(e), a)
    return o = parseInt(a[1], 10), ju(o) ? -(o * Bu) : NaN;
  if (a = Sl.timezoneHHMM.exec(e), a) {
    o = parseInt(a[1], 10);
    var l = parseInt(a[2], 10);
    return ju(o, l) ? (n = Math.abs(o) * Bu + l * bP, o > 0 ? -n : n) : NaN;
  }
  if (kP(e)) {
    t = new Date(t || Date.now());
    var s = _P(t), u = Gl(s, e), i = wP(t, u, e);
    return -i;
  }
  return NaN;
}
function _P(e) {
  return uf(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function Gl(e, t) {
  var r = vP(e, t), a = uf(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), n = e.getTime(), o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, a - n;
}
function wP(e, t, r) {
  var a = e.getTime(), n = a - t, o = Gl(new Date(n), r);
  if (t === o)
    return t;
  n -= o - t;
  var l = Gl(new Date(n), r);
  return o === l ? o : Math.max(o, l);
}
function ju(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Hu = {};
function kP(e) {
  if (Hu[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Hu[e] = !0, !0;
  } catch {
    return !1;
  }
}
var $P = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const CP = $P;
var xl = 36e5, Ru = 6e4, SP = 2, rr = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: CP
};
function xP(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, a = r.additionalDigits == null ? SP : dP(r.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = DP(e), o = AP(n.date, a), l = o.year, s = o.restDateString, u = PP(s, l);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var i = u.getTime(), c = 0, d;
    if (n.time && (c = OP(n.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || r.timeZone) {
      if (d = gP(n.timeZone || r.timeZone, new Date(i + c)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = Lu(new Date(i + c)), d = Lu(new Date(i + c + d));
    return new Date(i + c + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function DP(e) {
  var t = {}, r = rr.dateTimePattern.exec(e), a;
  if (r ? (t.date = r[1], a = r[3]) : (r = rr.datePattern.exec(e), r ? (t.date = r[1], a = r[2]) : (t.date = null, a = e)), a) {
    var n = rr.timeZone.exec(a);
    n ? (t.time = a.replace(n[1], ""), t.timeZone = n[1].trim()) : t.time = a;
  }
  return t;
}
function AP(e, t) {
  var r = rr.YYY[t], a = rr.YYYYY[t], n;
  if (n = rr.YYYY.exec(e) || a.exec(e), n) {
    var o = n[1];
    return {
      year: parseInt(o, 10),
      restDateString: e.slice(o.length)
    };
  }
  if (n = rr.YY.exec(e) || r.exec(e), n) {
    var l = n[1];
    return {
      year: parseInt(l, 10) * 100,
      restDateString: e.slice(l.length)
    };
  }
  return {
    year: null
  };
}
function PP(e, t) {
  if (t === null)
    return null;
  var r, a, n, o;
  if (e.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(t), a;
  if (r = rr.MM.exec(e), r)
    return a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1, Nu(t, n) ? (a.setUTCFullYear(t, n), a) : /* @__PURE__ */ new Date(NaN);
  if (r = rr.DDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0);
    var l = parseInt(r[1], 10);
    return MP(t, l) ? (a.setUTCFullYear(t, 0, l), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = rr.MMDD.exec(e), r) {
    a = /* @__PURE__ */ new Date(0), n = parseInt(r[1], 10) - 1;
    var s = parseInt(r[2], 10);
    return Nu(t, n, s) ? (a.setUTCFullYear(t, n, s), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = rr.Www.exec(e), r)
    return o = parseInt(r[1], 10) - 1, Yu(t, o) ? Fu(t, o) : /* @__PURE__ */ new Date(NaN);
  if (r = rr.WwwD.exec(e), r) {
    o = parseInt(r[1], 10) - 1;
    var u = parseInt(r[2], 10) - 1;
    return Yu(t, o, u) ? Fu(t, o, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function OP(e) {
  var t, r, a;
  if (t = rr.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), Dl(r) ? r % 24 * xl : NaN;
  if (t = rr.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), a = parseFloat(t[2].replace(",", ".")), Dl(r, a) ? r % 24 * xl + a * Ru : NaN;
  if (t = rr.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), a = parseInt(t[2], 10);
    var n = parseFloat(t[3].replace(",", "."));
    return Dl(r, a, n) ? r % 24 * xl + a * Ru + n * 1e3 : NaN;
  }
  return null;
}
function Fu(e, t, r) {
  t = t || 0, r = r || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var n = a.getUTCDay() || 7, o = t * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
var TP = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], IP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function cf(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Nu(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var a = cf(e);
    if (a && r > IP[t] || !a && r > TP[t])
      return !1;
  }
  return !0;
}
function MP(e, t) {
  if (t < 1)
    return !1;
  var r = cf(e);
  return !(r && t > 366 || !r && t > 365);
}
function Yu(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function Dl(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
function Qt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function So(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? So = function(r) {
    return typeof r;
  } : So = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, So(e);
}
function ea(e) {
  Qt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || So(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function fn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var qP = {};
function Ns() {
  return qP;
}
function xa(e, t) {
  var r, a, n, o, l, s, u, i;
  Qt(1, arguments);
  var c = Ns(), d = fn((r = (a = (n = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (l = t.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : c.weekStartsOn) !== null && a !== void 0 ? a : (u = c.locale) === null || u === void 0 || (i = u.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = ea(e), h = p.getDay(), y = (h < d ? 7 : 0) + h - d;
  return p.setDate(p.getDate() - y), p.setHours(0, 0, 0, 0), p;
}
function Uu(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var EP = 6048e5;
function VP(e, t, r) {
  Qt(2, arguments);
  var a = xa(e, r), n = xa(t, r), o = a.getTime() - Uu(a), l = n.getTime() - Uu(n);
  return Math.round((o - l) / EP);
}
function LP(e) {
  Qt(1, arguments);
  var t = ea(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function BP(e) {
  Qt(1, arguments);
  var t = ea(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function jP(e, t) {
  return Qt(1, arguments), VP(LP(e), BP(e), t) + 1;
}
function HP(e, t) {
  var r, a, n, o, l, s, u, i;
  Qt(1, arguments);
  var c = ea(e), d = c.getFullYear(), p = Ns(), h = fn((r = (a = (n = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (l = t.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : p.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = p.locale) === null || u === void 0 || (i = u.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = /* @__PURE__ */ new Date(0);
  y.setFullYear(d + 1, 0, h), y.setHours(0, 0, 0, 0);
  var _ = xa(y, t), $ = /* @__PURE__ */ new Date(0);
  $.setFullYear(d, 0, h), $.setHours(0, 0, 0, 0);
  var w = xa($, t);
  return c.getTime() >= _.getTime() ? d + 1 : c.getTime() >= w.getTime() ? d : d - 1;
}
function RP(e, t) {
  var r, a, n, o, l, s, u, i;
  Qt(1, arguments);
  var c = Ns(), d = fn((r = (a = (n = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (l = t.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : c.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = c.locale) === null || u === void 0 || (i = u.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = HP(e, t), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(p, 0, d), h.setHours(0, 0, 0, 0);
  var y = xa(h, t);
  return y;
}
var FP = 6048e5;
function NP(e, t) {
  Qt(1, arguments);
  var r = ea(e), a = xa(r, t).getTime() - RP(r, t).getTime();
  return Math.round(a / FP) + 1;
}
function Bo(e) {
  return Qt(1, arguments), xa(e, {
    weekStartsOn: 1
  });
}
function YP(e) {
  Qt(1, arguments);
  var t = ea(e), r = t.getFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var n = Bo(a), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  var l = Bo(o);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= l.getTime() ? r : r - 1;
}
function UP(e) {
  Qt(1, arguments);
  var t = YP(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var a = Bo(r);
  return a;
}
var zP = 6048e5;
function WP(e) {
  Qt(1, arguments);
  var t = ea(e), r = Bo(t).getTime() - UP(t).getTime();
  return Math.round(r / zP) + 1;
}
function tr(e, t) {
  Qt(2, arguments);
  var r = ea(e), a = fn(t);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && r.setDate(r.getDate() + a), r);
}
function jo(e, t) {
  Qt(2, arguments);
  var r = ea(e), a = fn(t);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return r;
  var n = r.getDate(), o = new Date(r.getTime());
  o.setMonth(r.getMonth() + a + 1, 0);
  var l = o.getDate();
  return n >= l ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), n), r);
}
function zu(e, t) {
  Qt(2, arguments);
  var r = fn(t);
  return jo(e, r * 12);
}
const KP = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function GP({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: r
}, a) {
  const n = [], {
    firstDayOfWeek: o,
    firstWeekday: l,
    isoWeeknumbers: s,
    weeknumbers: u,
    numDays: i,
    numWeeks: c
  } = e, d = l + (l < o ? Zt : 0) - o;
  let p = !0, h = !1, y = !1, _ = 0;
  const $ = new Intl.DateTimeFormat(a.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let w = t.numDays - d + 1, L = t.numDays - w + 1, R = Math.floor((w - 1) / Zt + 1), q = 1, E = t.numWeeks, Y = 1, V = t.month, T = t.year;
  const A = /* @__PURE__ */ new Date(), P = A.getDate(), b = A.getMonth() + 1, x = A.getFullYear();
  for (let D = 1; D <= R2; D++) {
    for (let N = 1, M = o; N <= Zt; N++, M += M === Zt ? 1 - Zt : 1) {
      p && M === l && (w = 1, L = e.numDays, R = Math.floor((w - 1) / Zt + 1), q = Math.floor((i - w) / Zt + 1), E = 1, Y = c, V = e.month, T = e.year, p = !1, h = !0);
      const H = a.getDateFromParams(T, V, w, 0, 0, 0, 0), U = a.getDateFromParams(T, V, w, 12, 0, 0, 0), G = a.getDateFromParams(
        T,
        V,
        w,
        23,
        59,
        59,
        999
      ), F = H, O = `${wt(T, 4)}-${wt(V, 2)}-${wt(w, 2)}`, Q = N, ae = Zt - N, Te = u[D - 1], Ae = s[D - 1], Ye = w === P && V === b && T === x, Re = h && w === 1, it = h && w === i, he = D === 1, X = D === c, re = N === 1, Se = N === Zt, me = kf(T, V, w);
      n.push({
        locale: a,
        id: O,
        position: ++_,
        label: w.toString(),
        ariaLabel: $.format(new Date(T, V - 1, w)),
        day: w,
        dayFromEnd: L,
        weekday: M,
        weekdayPosition: Q,
        weekdayPositionFromEnd: ae,
        weekdayOrdinal: R,
        weekdayOrdinalFromEnd: q,
        week: E,
        weekFromEnd: Y,
        weekPosition: D,
        weeknumber: Te,
        isoWeeknumber: Ae,
        month: V,
        year: T,
        date: F,
        startDate: H,
        endDate: G,
        noonDate: U,
        dayIndex: me,
        isToday: Ye,
        isFirstDay: Re,
        isLastDay: it,
        isDisabled: !h,
        isFocusable: !h,
        isFocused: !1,
        inMonth: h,
        inPrevMonth: p,
        inNextMonth: y,
        onTop: he,
        onBottom: X,
        onLeft: re,
        onRight: Se,
        classes: [
          `id-${O}`,
          `day-${w}`,
          `day-from-end-${L}`,
          `weekday-${M}`,
          `weekday-position-${Q}`,
          `weekday-ordinal-${R}`,
          `weekday-ordinal-from-end-${q}`,
          `week-${E}`,
          `week-from-end-${Y}`,
          {
            "is-today": Ye,
            "is-first-day": Re,
            "is-last-day": it,
            "in-month": h,
            "in-prev-month": p,
            "in-next-month": y,
            "on-top": he,
            "on-bottom": X,
            "on-left": re,
            "on-right": Se
          }
        ]
      }), h && it ? (h = !1, y = !0, w = 1, L = i, R = 1, q = Math.floor((i - w) / Zt + 1), E = 1, Y = r.numWeeks, V = r.month, T = r.year) : (w++, L--, R = Math.floor((w - 1) / Zt + 1), q = Math.floor((i - w) / Zt + 1));
    }
    E++, Y--;
  }
  return n;
}
function ZP(e, t, r, a) {
  const n = e.reduce((o, l, s) => {
    const u = Math.floor(s / 7);
    let i = o[u];
    return i || (i = {
      id: `week-${u + 1}`,
      title: "",
      week: l.week,
      weekPosition: l.weekPosition,
      weeknumber: l.weeknumber,
      isoWeeknumber: l.isoWeeknumber,
      weeknumberDisplay: t ? l.weeknumber : r ? l.isoWeeknumber : void 0,
      days: []
    }, o[u] = i), i.days.push(l), o;
  }, Array(e.length / Zt));
  return n.forEach((o) => {
    const l = o.days[0], s = o.days[o.days.length - 1];
    l.month === s.month ? o.title = `${a.formatDate(l.date, "MMMM YYYY")}` : l.year === s.year ? o.title = `${a.formatDate(
      l.date,
      "MMM"
    )} - ${a.formatDate(s.date, "MMM YYYY")}` : o.title = `${a.formatDate(
      l.date,
      "MMM YYYY"
    )} - ${a.formatDate(s.date, "MMM YYYY")}`;
  }), n;
}
function XP(e, t) {
  return e.days.map((r) => ({
    label: t.formatDate(r.date, t.masks.weekdays),
    weekday: r.weekday
  }));
}
function JP(e, t) {
  return `${t}.${wt(e, 2)}`;
}
function df(e, t, r) {
  return sf(
    r.getDateParts(r.toDate(e)),
    KP[t]
  );
}
function ff({ day: e, week: t, month: r, year: a }, n, o, l) {
  if (o === "daily" && e) {
    const s = new Date(a, r - 1, e), u = tr(s, n);
    return {
      day: u.getDate(),
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  } else if (o === "weekly" && t) {
    const u = l.getMonthParts(r, a).firstDayOfMonth, i = tr(u, (t - 1 + n) * 7), c = l.getDateParts(i);
    return {
      week: c.week,
      month: c.month,
      year: c.year
    };
  } else {
    const s = new Date(a, r - 1, 1), u = jo(s, n);
    return {
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  }
}
function Vr(e) {
  return e != null && e.month != null && e.year != null;
}
function Zl(e, t) {
  return !Vr(e) || !Vr(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function Ho(e, t) {
  return !Vr(e) || !Vr(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function QP(e, t, r) {
  return (e || !1) && !Zl(e, t) && !Ho(e, r);
}
function e2(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function t2(e, t, r, a) {
  if (!Vr(e) || !Vr(t))
    return [];
  const n = [];
  for (; !Ho(e, t); )
    n.push(e), e = ff(e, 1, r, a);
  return n;
}
function vf(e) {
  const { day: t, week: r, month: a, year: n } = e;
  let o = `${n}-${wt(a, 2)}`;
  return r && (o = `${o}-w${r}`), t && (o = `${o}-${wt(t, 2)}`), o;
}
function r2(e, t) {
  const { month: r, year: a, showWeeknumbers: n, showIsoWeeknumbers: o } = e, l = new Date(a, r - 1, 15), s = t.getMonthParts(r, a), u = t.getPrevMonthParts(r, a), i = t.getNextMonthParts(r, a), c = GP({ monthComps: s, prevMonthComps: u, nextMonthComps: i }, t), d = ZP(c, n, o, t), p = XP(d[0], t);
  return {
    id: vf(e),
    month: r,
    year: a,
    monthTitle: t.formatDate(l, t.masks.title),
    shortMonthLabel: t.formatDate(l, "MMM"),
    monthLabel: t.formatDate(l, "MMMM"),
    shortYearLabel: a.toString().substring(2),
    yearLabel: a.toString(),
    monthComps: s,
    prevMonthComps: u,
    nextMonthComps: i,
    days: c,
    weeks: d,
    weekdays: p
  };
}
function a2(e, t) {
  const { day: r, week: a, view: n, trimWeeks: o } = e, l = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (n) {
    case "daily": {
      let s = l.days.find((i) => i.inMonth);
      r ? s = l.days.find((i) => i.day === r && i.inMonth) || s : a && (s = l.days.find((i) => i.week === a && i.inMonth));
      const u = l.weeks[s.week - 1];
      l.viewWeeks = [u], l.viewDays = [s], l.week = s.week, l.weekTitle = u.title, l.day = s.day, l.dayTitle = s.ariaLabel, l.title = l.dayTitle;
      break;
    }
    case "weekly": {
      l.week = a || 1;
      const s = l.weeks[l.week - 1];
      l.viewWeeks = [s], l.viewDays = s.days, l.weekTitle = s.title, l.title = l.weekTitle;
      break;
    }
    default: {
      l.title = l.monthTitle, l.viewWeeks = l.weeks.slice(
        0,
        o ? l.monthComps.numWeeks : void 0
      ), l.viewDays = l.days;
      break;
    }
  }
  return l;
}
class Wu {
  constructor(t, r, a) {
    Ue(this, "keys", []), Ue(this, "store", {}), this.size = t, this.createKey = r, this.createItem = a;
  }
  get(...t) {
    const r = this.createKey(...t);
    return this.store[r];
  }
  getOrSet(...t) {
    const r = this.createKey(...t);
    if (this.store[r])
      return this.store[r];
    const a = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const n = this.keys.shift();
      n != null && delete this.store[n];
    }
    return this.keys.push(r), this.store[r] = a, a;
  }
}
class Wa {
  constructor(t, r = new Ro()) {
    Ue(this, "order"), Ue(this, "locale"), Ue(this, "start", null), Ue(this, "end", null), Ue(this, "repeat", null);
    var a;
    this.locale = r;
    const { start: n, end: o, span: l, order: s, repeat: u } = t;
    za(n) && (this.start = r.getDateParts(n)), za(o) ? this.end = r.getDateParts(o) : this.start != null && l && (this.end = r.getDateParts(tr(this.start.date, l - 1))), this.order = s ?? 0, u && (this.repeat = new Fo(
      {
        from: (a = this.start) == null ? void 0 : a.date,
        ...u
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, r) {
    return (gr(t) ? t : [t]).filter((a) => a).map((a) => Wa.from(a, r));
  }
  static from(t, r) {
    if (t instanceof Wa)
      return t;
    const a = {
      start: null,
      end: null
    };
    return t != null && (gr(t) ? (a.start = t[0] ?? null, a.end = t[1] ?? null) : Xr(t) ? Object.assign(a, t) : (a.start = t, a.end = t)), a.start != null && (a.start = new Date(a.start)), a.end != null && (a.end = new Date(a.end)), new Wa(a, r);
  }
  get opts() {
    const { order: t, locale: r } = this;
    return { order: t, locale: r };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: r } = this;
    return t && r && t.year === r.year && t.month === r.month && t.day === r.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var r, a;
    return ((r = this.start) == null ? void 0 : r.dayIndex) === t.dayIndex || !!((a = this.repeat) != null && a.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var r, a;
    return this.intersectsDayRange(
      ((r = t.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      ((a = t.end) == null ? void 0 : a.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, r) {
    return !(this.start && this.start.dayIndex > r || this.end && this.end.dayIndex < t);
  }
}
class n2 {
  constructor() {
    Ue(this, "records", {});
  }
  render(t, r, a) {
    var n, o, l, s;
    let u = null;
    const i = a[0].dayIndex, c = a[a.length - 1].dayIndex;
    return r.hasRepeat ? a.forEach((d) => {
      var p, h;
      if (r.startsOnDay(d)) {
        const y = r.daySpan < 1 / 0 ? r.daySpan : 1;
        u = {
          startDay: d.dayIndex,
          startTime: ((p = r.start) == null ? void 0 : p.time) ?? 0,
          endDay: d.dayIndex + y - 1,
          endTime: ((h = r.end) == null ? void 0 : h.time) ?? xo
        }, this.getRangeRecords(t).push(u);
      }
    }) : r.intersectsDayRange(i, c) && (u = {
      startDay: ((n = r.start) == null ? void 0 : n.dayIndex) ?? -1 / 0,
      startTime: ((o = r.start) == null ? void 0 : o.time) ?? -1 / 0,
      endDay: ((l = r.end) == null ? void 0 : l.dayIndex) ?? 1 / 0,
      endTime: ((s = r.end) == null ? void 0 : s.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(u)), u;
  }
  getRangeRecords(t) {
    let r = this.records[t.key];
    return r || (r = {
      ranges: [],
      data: t
    }, this.records[t.key] = r), r.ranges;
  }
  getCell(t, r) {
    return this.getCells(r).find((o) => o.data.key === t);
  }
  cellExists(t, r) {
    const a = this.records[t];
    return a == null ? !1 : a.ranges.some(
      (n) => n.startDay <= r && n.endDay >= r
    );
  }
  getCells(t) {
    const r = Object.values(this.records), a = [], { dayIndex: n } = t;
    return r.forEach(({ data: o, ranges: l }) => {
      l.filter((s) => s.startDay <= n && s.endDay >= n).forEach((s) => {
        const u = n === s.startDay, i = n === s.endDay, c = u ? s.startTime : 0, d = new Date(t.startDate.getTime() + c), p = i ? s.endTime : xo, h = new Date(t.endDate.getTime() + p), y = c === 0 && p === xo, _ = o.order || 0;
        a.push({
          ...s,
          data: o,
          onStart: u,
          onEnd: i,
          startTime: c,
          startDate: d,
          endTime: p,
          endDate: h,
          allDay: y,
          order: _
        });
      });
    }), a.sort((o, l) => o.order - l.order), a;
  }
}
const Jr = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Jr.en = Jr["en-US"];
Jr.es = Jr["es-ES"];
Jr.no = Jr.nb;
Jr.zh = Jr["zh-CN"];
const o2 = Object.entries(Jr).reduce(
  (e, [t, { dow: r, L: a }]) => (e[t] = {
    id: t,
    firstDayOfWeek: r,
    masks: { L: a }
  }, e),
  {}
), l2 = "MMMM YYYY", s2 = "W", i2 = "MMM", u2 = "h A", c2 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], d2 = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], f2 = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], v2 = [
  "h:mm A"
], p2 = [
  "HH:mm"
], m2 = "WWW, MMM D, YYYY", h2 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], y2 = "iso", b2 = "YYYY-MM-DDTHH:mm:ss.SSSZ", g2 = {
  title: l2,
  weekdays: s2,
  navMonths: i2,
  hours: u2,
  input: c2,
  inputDateTime: d2,
  inputDateTime24hr: f2,
  inputTime: v2,
  inputTime24hr: p2,
  dayPopover: m2,
  data: h2,
  model: y2,
  iso: b2
}, _2 = 300, w2 = 60, k2 = 80, $2 = {
  maxSwipeTime: _2,
  minHorizontalSwipeDistance: w2,
  maxVerticalSwipeDistance: k2
}, C2 = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: $2,
  masks: g2,
  locales: o2,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, Xl = Gt(C2), S2 = C(() => zx(Xl.locales, (e) => (e.masks = Vn(e.masks, Xl.masks), e))), ma = (e) => typeof window < "u" && of(window.__vcalendar__, e) ? wa(window.__vcalendar__, e) : wa(Xl, e), x2 = 12, D2 = 5;
function A2(e, t) {
  const r = new Intl.DateTimeFormat().resolvedOptions().locale;
  let a;
  Er(e) ? a = e : of(e, "id") && (a = e.id), a = (a || r).toLowerCase();
  const n = Object.keys(t), o = (u) => n.find((i) => i.toLowerCase() === u);
  a = o(a) || o(a.substring(0, 2)) || r;
  const l = {
    ...t["en-IE"],
    ...t[a],
    id: a,
    monthCacheSize: x2,
    pageCacheSize: D2
  };
  return Xr(e) ? Vn(e, l) : l;
}
class Ro {
  constructor(t = void 0, r) {
    Ue(this, "id"), Ue(this, "daysInWeek"), Ue(this, "firstDayOfWeek"), Ue(this, "masks"), Ue(this, "timezone"), Ue(this, "hourLabels"), Ue(this, "dayNames"), Ue(this, "dayNamesShort"), Ue(this, "dayNamesShorter"), Ue(this, "dayNamesNarrow"), Ue(this, "monthNames"), Ue(this, "monthNamesShort"), Ue(this, "relativeTimeNames"), Ue(this, "amPm", ["am", "pm"]), Ue(this, "monthCache"), Ue(this, "pageCache");
    const { id: a, firstDayOfWeek: n, masks: o, monthCacheSize: l, pageCacheSize: s } = A2(t, S2.value);
    this.monthCache = new Wu(
      l,
      Z2,
      X2
    ), this.pageCache = new Wu(s, vf, r2), this.id = a, this.daysInWeek = Zt, this.firstDayOfWeek = uP(n, 1, Zt), this.masks = o, this.timezone = r || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Al("long", this.id), this.dayNamesShort = Al("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((u) => u.substring(0, 2)), this.dayNamesNarrow = Al("narrow", this.id), this.monthNames = Qu("long", this.id), this.monthNamesShort = Qu("short", this.id), this.relativeTimeNames = eO(this.id);
  }
  formatDate(t, r) {
    return oO(t, r, this);
  }
  parseDate(t, r) {
    return ec(t, r, this);
  }
  toDate(t, r = {}) {
    const a = /* @__PURE__ */ new Date(NaN);
    let n = a;
    const { fillDate: o, mask: l, patch: s, rules: u } = r;
    if (Dr(t) ? (r.type = "number", n = /* @__PURE__ */ new Date(+t)) : Er(t) ? (r.type = "string", n = t ? ec(t, l || "iso", this) : a) : za(t) ? (r.type = "date", n = new Date(t.getTime())) : Ys(t) && (r.type = "object", n = this.getDateFromParts(t)), n && (s || u)) {
      let i = this.getDateParts(n);
      if (s && o != null) {
        const c = this.getDateParts(this.toDate(o));
        i = this.getDateParts(
          this.toDate({ ...c, ...sf(i, H2[s]) })
        );
      }
      u && (i = nO(i, u)), n = this.getDateFromParts(i);
    }
    return n || a;
  }
  toDateOrNull(t, r = {}) {
    const a = this.toDate(t, r);
    return isNaN(a.getTime()) ? null : a;
  }
  fromDate(t, { type: r, mask: a } = {}) {
    switch (r) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, a || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return Wa.from(t, this);
  }
  ranges(t) {
    return Wa.fromMany(t, this);
  }
  getDateParts(t) {
    return G2(t, this);
  }
  getDateFromParts(t) {
    return Cf(t, this.timezone);
  }
  getDateFromParams(t, r, a, n, o, l, s) {
    return this.getDateFromParts({
      year: t,
      month: r,
      day: a,
      hours: n,
      minutes: o,
      seconds: l,
      milliseconds: s
    });
  }
  getPage(t) {
    const r = this.pageCache.getOrSet(t, this);
    return a2(t, r);
  }
  getMonthParts(t, r) {
    const { firstDayOfWeek: a } = this;
    return this.monthCache.getOrSet(t, r, a);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, r) {
    return t === 1 ? this.getMonthParts(12, r - 1) : this.getMonthParts(t - 1, r);
  }
  getNextMonthParts(t, r) {
    return t === 12 ? this.getMonthParts(1, r + 1) : this.getMonthParts(t + 1, r);
  }
  getHourLabels() {
    return Q2().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var Ea = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(Ea || {}), pf = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(pf || {}), mf = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(mf || {}), hf = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(hf || {});
class P2 {
  constructor(t, r, a) {
    Ue(this, "validated", !0), this.type = t, this.interval = r, this.from = a, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: r } = t;
    switch (this.type) {
      case "days":
        return Us(this.from.date, r) % this.interval === 0;
      case "weeks":
        return W2(this.from.date, r) % this.interval === 0;
      case "months":
        return K2(this.from.date, r) % this.interval === 0;
      case "years":
        return $f(this.from.date, r) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class vn {
  constructor(t, r, a, n) {
    Ue(this, "components", []), this.type = t, this.validator = a, this.getter = n, this.components = this.normalizeComponents(r);
  }
  static create(t, r) {
    switch (t) {
      case "days":
        return new O2(r);
      case "weekdays":
        return new T2(r);
      case "weeks":
        return new I2(r);
      case "months":
        return new M2(r);
      case "years":
        return new q2(r);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!gr(t))
      return [];
    const r = [];
    return t.forEach((a) => {
      if (!this.validator(a)) {
        console.error(
          `Component value ${a} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      r.push(a);
    }), r;
  }
  passes(t) {
    return this.getter(t).some((n) => this.components.includes(n));
  }
}
class O2 extends vn {
  constructor(t) {
    super(
      "days",
      t,
      L2,
      ({ day: r, dayFromEnd: a }) => [r, -a]
    );
  }
}
class T2 extends vn {
  constructor(t) {
    super(
      "weekdays",
      t,
      Jl,
      ({ weekday: r }) => [r]
    );
  }
}
class I2 extends vn {
  constructor(t) {
    super(
      "weeks",
      t,
      B2,
      ({ week: r, weekFromEnd: a }) => [r, -a]
    );
  }
}
class M2 extends vn {
  constructor(t) {
    super("months", t, j2, ({ month: r }) => [
      r
    ]);
  }
}
class q2 extends vn {
  constructor(t) {
    super("years", t, Dr, ({ year: r }) => [r]);
  }
}
class E2 {
  constructor(t, r) {
    Ue(this, "components"), this.type = t, this.components = this.normalizeComponents(r);
  }
  normalizeArrayConfig(t) {
    const r = [];
    return t.forEach((a, n) => {
      if (Dr(a)) {
        if (n === 0)
          return;
        if (!Ku(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Jl(a)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], a]);
      } else gr(a) && r.push(...this.normalizeArrayConfig(a));
    }), r;
  }
  normalizeComponents(t) {
    const r = [];
    return t.forEach((a, n) => {
      if (Dr(a)) {
        if (n === 0)
          return;
        if (!Ku(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Jl(a)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], a]);
      } else gr(a) && r.push(...this.normalizeArrayConfig(a));
    }), r;
  }
  passes(t) {
    const { weekday: r, weekdayOrdinal: a, weekdayOrdinalFromEnd: n } = t;
    return this.components.some(
      ([o, l]) => (o === a || o === -n) && r === l
    );
  }
}
class V2 {
  constructor(t) {
    Ue(this, "type", "function"), Ue(this, "validated", !0), this.fn = t, Da(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class Fo {
  constructor(t, r = {}, a) {
    Ue(this, "validated", !0), Ue(this, "config"), Ue(this, "type", Ea.Any), Ue(this, "from"), Ue(this, "until"), Ue(this, "rules", []), Ue(this, "locale", new Ro()), this.parent = a, r.locale && (this.locale = r.locale), this.config = t, Da(t) ? (this.type = Ea.All, this.rules = [new V2(t)]) : gr(t) ? (this.type = Ea.Any, this.rules = t.map((n) => new Fo(n, r, this))) : Xr(t) ? (this.type = Ea.All, this.from = t.from ? this.locale.getDateParts(t.from) : a == null ? void 0 : a.from, this.until = t.until ? this.locale.getDateParts(t.until) : a == null ? void 0 : a.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const r = [];
    if (t.every && (Er(t.every) && (t.every = [1, `${t.every}s`]), gr(t.every))) {
      const [a = 1, n = pf.Days] = t.every;
      r.push(new P2(n, a, this.from));
    }
    return Object.values(mf).forEach((a) => {
      a in t && r.push(vn.create(a, t[a]));
    }), Object.values(hf).forEach((a) => {
      a in t && r.push(new E2(a, t[a]));
    }), t.on != null && (gr(t.on) || (t.on = [t.on]), r.push(
      new Fo(t.on, { locale: this.locale }, this.parent)
    )), r;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === Ea.Any ? this.rules.some((r) => r.passes(t)) : this.rules.every((r) => r.passes(t)) : !0;
  }
}
function L2(e) {
  return Dr(e) ? e >= 1 && e <= 31 : !1;
}
function Jl(e) {
  return Dr(e) ? e >= 1 && e <= 7 : !1;
}
function B2(e) {
  return Dr(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function j2(e) {
  return Dr(e) ? e >= 1 && e <= 12 : !1;
}
function Ku(e) {
  return !(!Dr(e) || e < -5 || e > 5 || e === 0);
}
const H2 = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, Zt = 7, R2 = 6, yf = 1e3, bf = yf * 60, gf = bf * 60, xo = gf * 24, F2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], N2 = ["L", "iso"], Sn = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, _f = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, Y2 = /\[([^]*?)\]/gm, Gu = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return wt(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return wt(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return wt(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return wt(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return wt(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return wt(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return wt(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return wt(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return wt(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return wt(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${wt(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${wt(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${wt(Math.floor(Math.abs(t) / 60), 2)}:${wt(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, sa = /\d\d?/, U2 = /\d{3}/, z2 = /\d{4}/, _n = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Zu = () => {
}, Xu = (e) => (t, r, a) => {
  const n = a[e].indexOf(
    r.charAt(0).toUpperCase() + r.substr(1).toLowerCase()
  );
  ~n && (t.month = n);
}, Ct = {
  D: [
    sa,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(sa.source + _n.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [sa, Zu],
  W: [_n, Zu],
  M: [
    sa,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [_n, Xu("monthNamesShort")],
  MMMM: [_n, Xu("monthNames")],
  YY: [
    sa,
    (e, t) => {
      const a = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? a - 1 : a}${t}`;
    }
  ],
  YYYY: [
    z2,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    U2,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    sa,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    sa,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    sa,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    _n,
    (e, t, r) => {
      const a = t.toLowerCase();
      a === r.amPm[0] ? e.isPm = !1 : a === r.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const r = `${t}`.match(/([+-]|\d\d)/gi);
      if (r) {
        const a = +r[1] * 60 + parseInt(r[2], 10);
        e.timezoneOffset = r[0] === "+" ? a : -a;
      }
    }
  ]
};
Ct.DD = Ct.D;
Ct.dd = Ct.d;
Ct.WWWW = Ct.WWW = Ct.WW = Ct.W;
Ct.MM = Ct.M;
Ct.mm = Ct.m;
Ct.hh = Ct.H = Ct.HH = Ct.h;
Ct.ss = Ct.s;
Ct.A = Ct.a;
Ct.ZZZZ = Ct.ZZZ = Ct.ZZ = Ct.Z;
function wf(e, t) {
  return (Wr(e) && e || [
    Er(e) && e || "YYYY-MM-DD"
  ]).map(
    (r) => N2.reduce(
      (a, n) => a.replace(n, t.masks[n] || ""),
      r
    )
  );
}
function Ys(e) {
  return Xr(e) && "year" in e && "month" in e && "day" in e;
}
function Ju(e, t = 1) {
  const r = e.getDay() + 1, a = r >= t ? t - r : -(7 - (t - r));
  return tr(e, a);
}
function kf(e, t, r) {
  const a = Date.UTC(e, t - 1, r);
  return Us(/* @__PURE__ */ new Date(0), new Date(a));
}
function Us(e, t) {
  return Math.round((t.getTime() - e.getTime()) / xo);
}
function W2(e, t) {
  return Math.ceil(Us(Ju(e), Ju(t)) / 7);
}
function $f(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function K2(e, t) {
  return $f(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function Cf(e, t = "") {
  const r = /* @__PURE__ */ new Date(), {
    year: a = r.getFullYear(),
    month: n = r.getMonth() + 1,
    day: o = r.getDate(),
    hours: l = 0,
    minutes: s = 0,
    seconds: u = 0,
    milliseconds: i = 0
  } = e;
  if (t) {
    const c = `${wt(a, 4)}-${wt(n, 2)}-${wt(o, 2)}T${wt(
      l,
      2
    )}:${wt(s, 2)}:${wt(u, 2)}.${wt(i, 3)}`;
    return xP(c, { timeZone: t });
  }
  return new Date(a, n - 1, o, l, s, u, i);
}
function G2(e, t) {
  let r = new Date(e.getTime());
  t.timezone && (r = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), r.setMilliseconds(e.getMilliseconds()));
  const a = r.getMilliseconds(), n = r.getSeconds(), o = r.getMinutes(), l = r.getHours(), s = a + n * yf + o * bf + l * gf, u = r.getMonth() + 1, i = r.getFullYear(), c = t.getMonthParts(u, i), d = r.getDate(), p = c.numDays - d + 1, h = r.getDay() + 1, y = Math.floor((d - 1) / 7 + 1), _ = Math.floor((c.numDays - d) / 7 + 1), $ = Math.ceil(
    (d + Math.abs(c.firstWeekday - c.firstDayOfWeek)) / 7
  ), w = c.numWeeks - $ + 1, L = c.weeknumbers[$], R = kf(i, u, d);
  return {
    milliseconds: a,
    seconds: n,
    minutes: o,
    hours: l,
    time: s,
    day: d,
    dayFromEnd: p,
    weekday: h,
    weekdayOrdinal: y,
    weekdayOrdinalFromEnd: _,
    week: $,
    weekFromEnd: w,
    weeknumber: L,
    month: u,
    year: i,
    date: r,
    dateTime: r.getTime(),
    dayIndex: R,
    timezoneOffset: 0,
    isValid: !0
  };
}
function Z2(e, t, r) {
  return `${t}-${e}-${r}`;
}
function X2(e, t, r) {
  const a = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, n = new Date(t, e - 1, 1), o = n.getDay() + 1, l = e === 2 && a ? 29 : F2[e - 1], s = r - 1, u = jP(n, {
    weekStartsOn: s
  }), i = [], c = [];
  for (let d = 0; d < u; d++) {
    const p = tr(n, d * 7);
    i.push(NP(p, { weekStartsOn: s })), c.push(WP(p));
  }
  return {
    firstDayOfWeek: r,
    firstDayOfMonth: n,
    inLeapYear: a,
    firstWeekday: o,
    numDays: l,
    numWeeks: u,
    month: e,
    year: t,
    weeknumbers: i,
    isoWeeknumbers: c
  };
}
function J2() {
  const e = [];
  for (let n = 0; n < Zt; n++)
    e.push(
      Cf({
        year: 2020,
        month: 1,
        day: 5 + n,
        hours: 12
      })
    );
  return e;
}
function Al(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return J2().map((a) => r.format(a));
}
function Q2() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function eO(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], r = new Intl.RelativeTimeFormat(e);
  return t.reduce((a, n) => {
    const o = r.formatToParts(100, n);
    return a[n] = o[1].unit, a;
  }, {});
}
function Sf() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Qu(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Sf().map((a) => r.format(a));
}
function tO(e, t, r) {
  return Dr(t) ? t === e : gr(t) ? t.includes(e) : Da(t) ? t(e, r) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function xn(e, t, r) {
  const a = [], [n, o, l] = t;
  for (let s = n; s <= o; s++)
    (r == null || tO(s, r, e)) && a.push({
      value: s,
      label: wt(s, l)
    });
  return a;
}
function rO(e, t) {
  return {
    milliseconds: xn(
      e,
      Sn.milliseconds,
      t.milliseconds
    ),
    seconds: xn(e, Sn.seconds, t.seconds),
    minutes: xn(e, Sn.minutes, t.minutes),
    hours: xn(e, Sn.hours, t.hours)
  };
}
function aO(e, t, r, a) {
  const o = xn(e, t, a).reduce((l, s) => {
    if (s.disabled)
      return l;
    if (isNaN(l))
      return s.value;
    const u = Math.abs(l - r);
    return Math.abs(s.value - r) < u ? s.value : l;
  }, NaN);
  return isNaN(o) ? r : o;
}
function nO(e, t) {
  const r = { ...e };
  return Object.entries(t).forEach(([a, n]) => {
    const o = Sn[a], l = e[a];
    r[a] = aO(
      e,
      o,
      l,
      n
    );
  }), r;
}
function ec(e, t, r) {
  return wf(t, r).map((n) => {
    if (typeof n != "string")
      throw new Error("Invalid mask");
    let o = e;
    if (o.length > 1e3)
      return !1;
    let l = !0;
    const s = {};
    if (n.replace(_f, (c) => {
      if (Ct[c]) {
        const d = Ct[c], p = o.search(d[0]);
        ~p ? o.replace(d[0], (h) => (d[1](s, h, r), o = o.substr(p + h.length), h)) : l = !1;
      }
      return Ct[c] ? "" : c.slice(1, c.length - 1);
    }), !l)
      return !1;
    const u = /* @__PURE__ */ new Date();
    s.hours != null && (s.isPm === !0 && +s.hours != 12 ? s.hours = +s.hours + 12 : s.isPm === !1 && +s.hours == 12 && (s.hours = 0));
    let i;
    return s.timezoneOffset != null ? (s.minutes = +(s.minutes || 0) - +s.timezoneOffset, i = new Date(
      Date.UTC(
        s.year || u.getFullYear(),
        s.month || 0,
        s.day || 1,
        s.hours || 0,
        s.minutes || 0,
        s.seconds || 0,
        s.milliseconds || 0
      )
    )) : i = r.getDateFromParts({
      year: s.year || u.getFullYear(),
      month: (s.month || 0) + 1,
      day: s.day || 1,
      hours: s.hours || 0,
      minutes: s.minutes || 0,
      seconds: s.seconds || 0,
      milliseconds: s.milliseconds || 0
    }), i;
  }).find((n) => n) || new Date(e);
}
function oO(e, t, r) {
  if (e == null)
    return "";
  let a = wf(t, r)[0];
  /Z$/.test(a) && (r.timezone = "utc");
  const n = [];
  a = a.replace(Y2, (l, s) => (n.push(s), "??"));
  const o = r.getDateParts(e);
  return a = a.replace(
    _f,
    (l) => l in Gu ? Gu[l](o, r) : l.slice(1, l.length - 1)
  ), a.replace(/\?\?/g, () => n.shift());
}
let lO = 0;
class xf {
  constructor(t, r, a) {
    Ue(this, "key", ""), Ue(this, "hashcode", ""), Ue(this, "highlight", null), Ue(this, "content", null), Ue(this, "dot", null), Ue(this, "bar", null), Ue(this, "event", null), Ue(this, "popover", null), Ue(this, "customData", null), Ue(this, "ranges"), Ue(this, "hasRanges", !1), Ue(this, "order", 0), Ue(this, "pinPage", !1), Ue(this, "maxRepeatSpan", 0), Ue(this, "locale");
    const { dates: n } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++lO), this.locale = a, r.normalizeGlyphs(this), this.ranges = a.ranges(n ?? []), this.hasRanges = !!Wr(this.ranges), this.maxRepeatSpan = this.ranges.filter((o) => o.hasRepeat).map((o) => o.daySpan).reduce((o, l) => Math.max(o, l), 0);
  }
  intersectsRange({ start: t, end: r }) {
    if (t == null || r == null)
      return !1;
    const a = this.ranges.filter((l) => !l.hasRepeat);
    for (const l of a)
      if (l.intersectsDayRange(t.dayIndex, r.dayIndex))
        return !0;
    const n = this.ranges.filter((l) => l.hasRepeat);
    if (!n.length)
      return !1;
    let o = t;
    for (this.maxRepeatSpan > 1 && (o = this.locale.getDateParts(tr(o.date, -this.maxRepeatSpan))); o.dayIndex <= r.dayIndex; ) {
      for (const l of n)
        if (l.startsOnDay(o))
          return !0;
      o = this.locale.getDateParts(tr(o.date, 1));
    }
    return !1;
  }
}
function Ql(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function Ln(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Df(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Af(e) {
  const { visibility: t } = e, r = t === "click", a = t === "hover", n = t === "hover-focus", o = t === "focus";
  e.autoHide = !r;
  let l = !1, s = !1;
  const u = (y) => {
    r && (Df({
      ...e,
      target: e.target || y.currentTarget
    }), y.stopPropagation());
  }, i = (y) => {
    l || (l = !0, (a || n) && Ql({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, c = () => {
    l && (l = !1, (a || n && !s) && Ln(e));
  }, d = (y) => {
    s || (s = !0, (o || n) && Ql({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, p = (y) => {
    s && !Co(y.currentTarget, y.relatedTarget) && (s = !1, (o || n && !l) && Ln(e));
  }, h = {};
  switch (e.visibility) {
    case "click":
      h.click = u;
      break;
    case "hover":
      h.mousemove = i, h.mouseleave = c;
      break;
    case "focus":
      h.focusin = d, h.focusout = p;
      break;
    case "hover-focus":
      h.mousemove = i, h.mouseleave = c, h.focusin = d, h.focusout = p;
      break;
  }
  return h;
}
const tc = (e) => {
  const t = Eo(e);
  if (t == null)
    return;
  const r = t.popoverHandlers;
  !r || !r.length || (r.forEach((a) => a()), delete t.popoverHandlers);
}, rc = (e, t) => {
  const r = Eo(e);
  if (r == null)
    return;
  const a = [], n = Af(t);
  Object.entries(n).forEach(([o, l]) => {
    a.push(da(r, o, l));
  }), r.popoverHandlers = a;
}, Pf = {
  mounted(e, t) {
    const { value: r } = t;
    r && rc(e, r);
  },
  updated(e, t) {
    const { oldValue: r, value: a } = t, n = r == null ? void 0 : r.visibility, o = a == null ? void 0 : a.visibility;
    n !== o && (n && (tc(e), o || Ln(r)), o && rc(e, a));
  },
  unmounted(e) {
    tc(e);
  }
}, sO = (e, t, {
  maxSwipeTime: r,
  minHorizontalSwipeDistance: a,
  maxVerticalSwipeDistance: n
}) => {
  if (!e || !e.addEventListener || !Da(t))
    return null;
  let o = 0, l = 0, s = null, u = !1;
  function i(d) {
    const p = d.changedTouches[0];
    o = p.screenX, l = p.screenY, s = (/* @__PURE__ */ new Date()).getTime(), u = !0;
  }
  function c(d) {
    if (!u || !s)
      return;
    u = !1;
    const p = d.changedTouches[0], h = p.screenX - o, y = p.screenY - l;
    if ((/* @__PURE__ */ new Date()).getTime() - s < r && Math.abs(h) >= a && Math.abs(y) <= n) {
      const $ = { toLeft: !1, toRight: !1 };
      h < 0 ? $.toLeft = !0 : $.toRight = !0, t($);
    }
  }
  return da(e, "touchstart", i, { passive: !0 }), da(e, "touchend", c, { passive: !0 }), () => {
    ca(e, "touchstart", i), ca(e, "touchend", c);
  };
}, Do = {}, iO = (e, t = 10) => {
  Do[e] = Date.now() + t;
}, uO = (e, t) => {
  if (e in Do) {
    const r = Do[e];
    if (Date.now() < r)
      return;
    delete Do[e];
  }
  t();
};
function Of() {
  return typeof window < "u";
}
function cO(e) {
  return Of() && e in window;
}
function dO(e) {
  const t = z(!1), r = C(() => t.value ? "dark" : "light");
  let a, n;
  function o(h) {
    t.value = h.matches;
  }
  function l() {
    cO("matchMedia") && (a = window.matchMedia("(prefers-color-scheme: dark)"), a.addEventListener("change", o), t.value = a.matches);
  }
  function s() {
    const { selector: h = ":root", darkClass: y = "dark" } = e.value, _ = document.querySelector(h);
    t.value = _.classList.contains(y);
  }
  function u(h) {
    const { selector: y = ":root", darkClass: _ = "dark" } = h;
    if (Of() && y && _) {
      const $ = document.querySelector(y);
      $ && (n = new MutationObserver(s), n.observe($, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = $.classList.contains(_));
    }
  }
  function i() {
    d();
    const h = typeof e.value;
    h === "string" && e.value.toLowerCase() === "system" ? l() : h === "object" ? u(e.value) : t.value = !!e.value;
  }
  const c = Le(() => e.value, () => i(), {
    immediate: !0
  });
  function d() {
    a && (a.removeEventListener("change", o), a = void 0), n && (n.disconnect(), n = void 0);
  }
  function p() {
    d(), c();
  }
  return Uo(() => p()), {
    isDark: t,
    displayMode: r,
    cleanup: p
  };
}
const fO = ["base", "start", "end", "startEnd"], vO = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], pO = { base: {}, start: {}, end: {} };
function zs(e, t, r = pO) {
  let a = e, n = {};
  t === !0 || Er(t) ? (a = Er(t) ? t : a, n = { ...r }) : Xr(t) && (Vu(t, fO) ? n = { ...t } : n = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const o = Vn(
    n,
    { start: n.startEnd, end: n.startEnd },
    r
  );
  return Object.entries(o).forEach(([l, s]) => {
    let u = a;
    s === !0 || Er(s) ? (u = Er(s) ? s : u, o[l] = { color: u }) : Xr(s) && (Vu(s, vO) ? o[l] = { ...s } : o[l] = {}), Vn(o[l], { color: u });
  }), o;
}
class mO {
  constructor() {
    Ue(this, "type", "highlight");
  }
  normalizeConfig(t, r) {
    return zs(t, r, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: r, onEnd: a }, n) {
    const { key: o, highlight: l } = t;
    if (!l)
      return;
    const { highlights: s } = n, { base: u, start: i, end: c } = l;
    r && a ? s.push({
      ...i,
      key: o,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${i.color}`,
      class: [`vc-highlight vc-highlight-bg-${i.fillMode}`, i.class],
      contentClass: [
        `vc-attr vc-highlight-content-${i.fillMode} vc-${i.color}`,
        i.contentClass
      ]
    }) : r ? (s.push({
      ...u,
      key: `${o}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), s.push({
      ...i,
      key: o,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${i.color}`,
      class: [`vc-highlight vc-highlight-bg-${i.fillMode}`, i.class],
      contentClass: [
        `vc-attr vc-highlight-content-${i.fillMode} vc-${i.color}`,
        i.contentClass
      ]
    })) : a ? (s.push({
      ...u,
      key: `${o}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), s.push({
      ...c,
      key: o,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : s.push({
      ...u,
      key: `${o}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${u.fillMode}`,
        u.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    });
  }
}
class Ws {
  constructor(t, r) {
    Ue(this, "type", ""), Ue(this, "collectionType", ""), this.type = t, this.collectionType = r;
  }
  normalizeConfig(t, r) {
    return zs(t, r);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: r, onEnd: a }, n) {
    const { key: o } = t, l = t[this.type];
    if (!o || !l)
      return;
    const s = n[this.collectionType], { base: u, start: i, end: c } = l;
    r ? s.push({
      ...i,
      key: o,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${i.color} vc-attr`,
        i.class
      ]
    }) : a ? s.push({
      ...c,
      key: o,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${c.color} vc-attr`,
        c.class
      ]
    }) : s.push({
      ...u,
      key: o,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${u.color} vc-attr`,
        u.class
      ]
    });
  }
}
class hO extends Ws {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, r) {
    return zs("base", r);
  }
}
class yO extends Ws {
  constructor() {
    super("dot", "dots");
  }
}
class bO extends Ws {
  constructor() {
    super("bar", "bars");
  }
}
class gO {
  constructor(t) {
    Ue(this, "color"), Ue(this, "renderers", [
      new hO(),
      new mO(),
      new yO(),
      new bO()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((r) => {
      const a = r.type;
      t[a] != null && (t[a] = r.normalizeConfig(this.color, t[a]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((r) => {
      r.prepareRender(t);
    }), t;
  }
  render(t, r) {
    this.renderers.forEach((a) => {
      a.render(t, r);
    });
  }
}
const Tf = Symbol("__vc_base_context__"), If = {
  color: {
    type: String,
    default: () => ma("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => ma("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function Mf(e) {
  const t = C(() => e.color ?? ""), r = C(() => e.isDark ?? !1), { displayMode: a } = dO(r), n = C(() => new gO(t.value)), o = C(() => {
    if (e.locale instanceof Ro)
      return e.locale;
    const p = Xr(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new Ro(p, e.timezone);
  }), l = C(() => o.value.masks), s = C(() => e.minDate), u = C(() => e.maxDate), i = C(() => {
    const p = e.disabledDates ? [...e.disabledDates] : [];
    return s.value != null && p.push({
      start: null,
      end: tr(o.value.toDate(s.value), -1)
    }), u.value != null && p.push({
      start: tr(o.value.toDate(u.value), 1),
      end: null
    }), o.value.ranges(p);
  }), c = C(() => new xf(
    {
      key: "disabled",
      dates: i.value,
      order: 100
    },
    n.value,
    o.value
  )), d = {
    color: t,
    isDark: r,
    displayMode: a,
    theme: n,
    locale: o,
    masks: l,
    minDate: s,
    maxDate: u,
    disabledDates: i,
    disabledAttribute: c
  };
  return ar(Tf, d), d;
}
function _O(e) {
  return mr(Tf, () => Mf(e), !0);
}
function qf(e) {
  return `__vc_slot_${e}__`;
}
function Ef(e, t = {}) {
  Object.keys(e).forEach((r) => {
    ar(qf(t[r] ?? r), e[r]);
  });
}
function Vf(e) {
  return mr(qf(e), null);
}
const wO = {
  ...If,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => ma("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => ma("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, kO = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], Lf = Symbol("__vc_calendar_context__");
function $O(e, { slots: t, emit: r }) {
  const a = z(null), n = z(null), o = z((/* @__PURE__ */ new Date()).getDate()), l = z(!1), s = z(Symbol()), u = z(Symbol()), i = z(e.view), c = z([]), d = z("");
  let p = null, h = null;
  Ef(t);
  const {
    theme: y,
    color: _,
    displayMode: $,
    locale: w,
    masks: L,
    minDate: R,
    maxDate: q,
    disabledAttribute: E,
    disabledDates: Y
  } = _O(e), V = C(() => e.rows * e.columns), T = C(() => e.step || V.value), A = C(() => nf(c.value) ?? null), P = C(() => Ba(c.value) ?? null), b = C(
    () => e.minPage || (R.value ? ae(R.value) : null)
  ), x = C(
    () => e.maxPage || (q.value ? ae(q.value) : null)
  ), D = C(() => e.navVisibility), N = C(() => !!e.showWeeknumbers), M = C(() => !!e.showIsoWeeknumbers), H = C(() => i.value === "monthly"), U = C(() => i.value === "weekly"), G = C(() => i.value === "daily"), F = () => {
    l.value = !0, r("transition-start");
  }, O = () => {
    l.value = !1, r("transition-end"), p && (p.resolve(!0), p = null);
  }, Q = (ue, j, ne = i.value) => ff(ue, j, ne, w.value), ae = (ue) => df(ue, i.value, w.value), Te = (ue) => {
    !E.value || !X.value || (ue.isDisabled = X.value.cellExists(
      E.value.key,
      ue.dayIndex
    ));
  }, Ae = (ue) => {
    ue.isFocusable = ue.inMonth && ue.day === o.value;
  }, Ye = (ue, j) => {
    for (const ne of ue)
      for (const ge of ne.days)
        if (j(ge) === !1)
          return;
  }, Re = C(
    () => c.value.reduce((ue, j) => (ue.push(...j.viewDays), ue), [])
  ), it = C(() => {
    const ue = [];
    return (e.attributes || []).forEach((j, ne) => {
      !j || !j.dates || ue.push(
        new xf(
          {
            ...j,
            order: j.order || 0
          },
          y.value,
          w.value
        )
      );
    }), E.value && ue.push(E.value), ue;
  }), he = C(() => Wr(it.value)), X = C(() => {
    const ue = new n2();
    return it.value.forEach((j) => {
      j.ranges.forEach((ne) => {
        ue.render(j, ne, Re.value);
      });
    }), ue;
  }), re = C(() => Re.value.reduce((ue, j) => (ue[j.dayIndex] = { day: j, cells: [] }, ue[j.dayIndex].cells.push(...X.value.getCells(j)), ue), {})), Se = (ue, j) => {
    const ne = e.showWeeknumbers || e.showIsoWeeknumbers;
    return ne == null ? "" : Ax(ne) ? ne ? "left" : "" : ne.startsWith("right") ? j > 1 ? "right" : ne : ue > 1 ? "left" : ne;
  }, me = () => {
    var ue, j;
    if (!he.value)
      return null;
    const ne = it.value.find((yt) => yt.pinPage) || it.value[0];
    if (!ne || !ne.hasRanges)
      return null;
    const [ge] = ne.ranges, De = ((ue = ge.start) == null ? void 0 : ue.date) || ((j = ge.end) == null ? void 0 : j.date);
    return De ? ae(De) : null;
  }, fe = () => {
    if (Vr(A.value))
      return A.value;
    const ue = me();
    return Vr(ue) ? ue : ae(/* @__PURE__ */ new Date());
  }, Oe = (ue, j = {}) => {
    const { view: ne = i.value, position: ge = 1, force: De } = j, yt = ge > 0 ? 1 - ge : -(V.value + ge);
    let gt = Q(ue, yt, ne), _t = Q(gt, V.value - 1, ne);
    return De || (Zl(gt, b.value) ? gt = b.value : Ho(_t, x.value) && (gt = Q(x.value, 1 - V.value)), _t = Q(gt, V.value - 1)), { fromPage: gt, toPage: _t };
  }, Ie = (ue, j, ne = "") => {
    if (ne === "none" || ne === "fade")
      return ne;
    if ((ue == null ? void 0 : ue.view) !== (j == null ? void 0 : j.view))
      return "fade";
    const ge = Ho(j, ue), De = Zl(j, ue);
    return !ge && !De ? "fade" : ne === "slide-v" ? De ? "slide-down" : "slide-up" : De ? "slide-right" : "slide-left";
  }, ye = (ue = {}) => new Promise((j, ne) => {
    const { position: ge = 1, force: De = !1, transition: yt } = ue, gt = Vr(ue.page) ? ue.page : fe(), { fromPage: _t } = Oe(gt, {
      position: ge,
      force: De
    }), ve = [];
    for (let st = 0; st < V.value; st++) {
      const rt = Q(_t, st), vt = st + 1, ta = Math.ceil(vt / e.columns), Tr = e.rows - ta + 1, Yt = vt % e.columns || e.columns, Bt = e.columns - Yt + 1, Nr = Se(Yt, Bt);
      ve.push(
        w.value.getPage({
          ...rt,
          view: i.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: vt,
          row: ta,
          rowFromEnd: Tr,
          column: Yt,
          columnFromEnd: Bt,
          showWeeknumbers: N.value,
          showIsoWeeknumbers: M.value,
          weeknumberPosition: Nr
        })
      );
    }
    d.value = Ie(
      c.value[0],
      ve[0],
      yt
    ), c.value = ve, d.value && d.value !== "none" ? p = {
      resolve: j,
      reject: ne
    } : j(!0);
  }), Fe = (ue) => {
    const j = A.value ?? ae(/* @__PURE__ */ new Date());
    return Q(j, ue);
  }, Me = (ue, j = {}) => {
    const ne = Vr(ue) ? ue : ae(ue);
    return Object.assign(
      j,
      Oe(ne, {
        ...j,
        force: !0
      })
    ), t2(
      j.fromPage,
      j.toPage,
      i.value,
      w.value
    ).map((De) => QP(De, b.value, x.value)).some((De) => De);
  }, He = (ue, j = {}) => Me(Fe(ue), j), ce = C(() => He(-T.value)), mt = C(() => He(T.value)), nt = async (ue, j = {}) => !j.force && !Me(ue, j) ? !1 : (j.fromPage && !e2(j.fromPage, A.value) && (Ln({ id: s.value, hideDelay: 0 }), j.view && (iO("view", 10), i.value = j.view), await ye({
    ...j,
    page: j.fromPage,
    position: 1,
    force: !0
  }), r("did-move", c.value)), !0), ot = (ue, j = {}) => nt(Fe(ue), j), ft = () => ot(-T.value), $e = () => ot(T.value), Qe = (ue) => {
    const j = H.value ? ".in-month" : "", ne = `.id-${w.value.getDayId(ue)}${j}`, ge = `${ne}.vc-focusable, ${ne} .vc-focusable`, De = a.value;
    if (De) {
      const yt = De.querySelector(ge);
      if (yt)
        return yt.focus(), !0;
    }
    return !1;
  }, te = async (ue, j = {}) => Qe(ue) ? !0 : (await nt(ue, j), Qe(ue)), xe = (ue, j) => {
    o.value = ue.day, r("dayclick", ue, j);
  }, Ee = (ue, j) => {
    r("daymouseenter", ue, j);
  }, Ve = (ue, j) => {
    r("daymouseleave", ue, j);
  }, Xe = (ue, j) => {
    o.value = ue.day, n.value = ue, ue.isFocused = !0, r("dayfocusin", ue, j);
  }, de = (ue, j) => {
    n.value = null, ue.isFocused = !1, r("dayfocusout", ue, j);
  }, ke = (ue, j) => {
    r("daykeydown", ue, j);
    const ne = ue.noonDate;
    let ge = null;
    switch (j.key) {
      case "ArrowLeft": {
        ge = tr(ne, -1);
        break;
      }
      case "ArrowRight": {
        ge = tr(ne, 1);
        break;
      }
      case "ArrowUp": {
        ge = tr(ne, -7);
        break;
      }
      case "ArrowDown": {
        ge = tr(ne, 7);
        break;
      }
      case "Home": {
        ge = tr(ne, -ue.weekdayPosition + 1);
        break;
      }
      case "End": {
        ge = tr(ne, ue.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        j.altKey ? ge = zu(ne, -1) : ge = jo(ne, -1);
        break;
      }
      case "PageDown": {
        j.altKey ? ge = zu(ne, 1) : ge = jo(ne, 1);
        break;
      }
    }
    ge && (j.preventDefault(), te(ge).catch());
  }, lt = (ue) => {
    const j = n.value;
    j != null && ke(j, ue);
  }, dt = (ue, j) => {
    r("weeknumberclick", ue, j);
  };
  ye({
    page: e.initialPage,
    position: e.initialPagePosition
  }), St(() => {
    !e.disablePageSwipe && a.value && (h = sO(
      a.value,
      ({ toLeft: ue = !1, toRight: j = !1 }) => {
        ue ? $e() : j && ft();
      },
      ma("touch")
    ));
  }), Uo(() => {
    c.value = [], h && h();
  }), Le(
    () => w.value,
    () => {
      ye();
    }
  ), Le(
    () => V.value,
    () => ye()
  ), Le(
    () => e.view,
    () => i.value = e.view
  ), Le(
    () => i.value,
    () => {
      uO("view", () => {
        ye();
      }), r("update:view", i.value);
    }
  ), Le(
    () => o.value,
    () => {
      Ye(c.value, (ue) => Ae(ue));
    }
  ), an(() => {
    r("update:pages", c.value), Ye(c.value, (ue) => {
      Te(ue), Ae(ue);
    });
  });
  const Je = {
    emit: r,
    containerRef: a,
    focusedDay: n,
    inTransition: l,
    navPopoverId: s,
    dayPopoverId: u,
    view: i,
    pages: c,
    transitionName: d,
    theme: y,
    color: _,
    displayMode: $,
    locale: w,
    masks: L,
    attributes: it,
    disabledAttribute: E,
    disabledDates: Y,
    attributeContext: X,
    days: Re,
    dayCells: re,
    count: V,
    step: T,
    firstPage: A,
    lastPage: P,
    canMovePrev: ce,
    canMoveNext: mt,
    minPage: b,
    maxPage: x,
    isMonthly: H,
    isWeekly: U,
    isDaily: G,
    navVisibility: D,
    showWeeknumbers: N,
    showIsoWeeknumbers: M,
    getDateAddress: ae,
    canMove: Me,
    canMoveBy: He,
    move: nt,
    moveBy: ot,
    movePrev: ft,
    moveNext: $e,
    onTransitionBeforeEnter: F,
    onTransitionAfterEnter: O,
    tryFocusDate: Qe,
    focusDate: te,
    onKeydown: lt,
    onDayKeydown: ke,
    onDayClick: xe,
    onDayMouseenter: Ee,
    onDayMouseleave: Ve,
    onDayFocusin: Xe,
    onDayFocusout: de,
    onWeeknumberClick: dt
  };
  return ar(Lf, Je), Je;
}
function Pa() {
  const e = mr(Lf);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const CO = Pe({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let r;
    const a = z();
    let n = null, o = null;
    const l = Gt({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function s(O) {
      O && (l.direction = O.split("-")[0]);
    }
    function u({ placement: O, options: Q }) {
      s(O || (Q == null ? void 0 : Q.placement));
    }
    const i = C(() => ({
      placement: l.placement,
      strategy: l.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: u
        },
        ...l.modifiers || []
      ],
      onFirstUpdate: u
    })), c = C(() => {
      const O = l.direction === "left" || l.direction === "right";
      let Q = "";
      if (l.placement) {
        const ae = l.placement.split("-");
        ae.length > 1 && (Q = ae[1]);
      }
      return ["start", "top", "left"].includes(Q) ? O ? "top" : "left" : ["end", "bottom", "right"].includes(Q) ? O ? "bottom" : "right" : O ? "middle" : "center";
    });
    function d() {
      o && (o.destroy(), o = null);
    }
    function p() {
      ut(() => {
        const O = Eo(l.target);
        !O || !a.value || (o && o.state.elements.reference !== O && d(), o ? o.update() : o = gg(
          O,
          a.value,
          i.value
        ));
      });
    }
    function h(O) {
      Object.assign(l, lf(O, "force"));
    }
    function y(O, Q) {
      clearTimeout(r), O > 0 ? r = setTimeout(Q, O) : Q();
    }
    function _(O) {
      return !O || !o ? !1 : Eo(O) === o.state.elements.reference;
    }
    async function $(O = {}) {
      l.force || (O.force && (l.force = !0), y(O.showDelay ?? e.showDelay, () => {
        l.isVisible && (l.force = !1), h({
          ...O,
          isVisible: !0
        }), p();
      }));
    }
    function w(O = {}) {
      o && (O.target && !_(O.target) || l.force || (O.force && (l.force = !0), y(O.hideDelay ?? e.hideDelay, () => {
        l.isVisible || (l.force = !1), l.isVisible = !1;
      })));
    }
    function L(O = {}) {
      O.target != null && (l.isVisible && _(O.target) ? w(O) : $(O));
    }
    function R(O) {
      if (!o)
        return;
      const Q = o.state.elements.reference;
      if (!a.value || !Q)
        return;
      const ae = O.target;
      Co(a.value, ae) || Co(Q, ae) || w({ force: !0 });
    }
    function q(O) {
      (O.key === "Esc" || O.key === "Escape") && w();
    }
    function E({ detail: O }) {
      !O.id || O.id !== e.id || $(O);
    }
    function Y({ detail: O }) {
      !O.id || O.id !== e.id || w(O);
    }
    function V({ detail: O }) {
      !O.id || O.id !== e.id || L(O);
    }
    function T() {
      da(document, "keydown", q), da(document, "click", R), da(document, "show-popover", E), da(document, "hide-popover", Y), da(document, "toggle-popover", V);
    }
    function A() {
      ca(document, "keydown", q), ca(document, "click", R), ca(document, "show-popover", E), ca(document, "hide-popover", Y), ca(document, "toggle-popover", V);
    }
    function P(O) {
      t("before-show", O);
    }
    function b(O) {
      l.force = !1, t("after-show", O);
    }
    function x(O) {
      t("before-hide", O);
    }
    function D(O) {
      l.force = !1, d(), t("after-hide", O);
    }
    function N(O) {
      O.stopPropagation();
    }
    function M() {
      l.isHovered = !0, l.isInteractive && ["hover", "hover-focus"].includes(l.visibility) && $();
    }
    function H() {
      if (l.isHovered = !1, !o)
        return;
      const O = o.state.elements.reference;
      l.autoHide && !l.isFocused && (!O || O !== document.activeElement) && ["hover", "hover-focus"].includes(l.visibility) && w();
    }
    function U() {
      l.isFocused = !0, l.isInteractive && ["focus", "hover-focus"].includes(l.visibility) && $();
    }
    function G(O) {
      ["focus", "hover-focus"].includes(l.visibility) && (!O.relatedTarget || !Co(a.value, O.relatedTarget)) && (l.isFocused = !1, !l.isHovered && l.autoHide && w());
    }
    function F() {
      n != null && (n.disconnect(), n = null);
    }
    return Le(
      () => a.value,
      (O) => {
        F(), O && (n = new ResizeObserver(() => {
          o && o.update();
        }), n.observe(O));
      }
    ), Le(() => l.placement, s, {
      immediate: !0
    }), St(() => {
      T();
    }), Uo(() => {
      d(), F(), A();
    }), {
      ...nr(l),
      popoverRef: a,
      alignment: c,
      hide: w,
      setupPopper: p,
      beforeEnter: P,
      afterEnter: b,
      beforeLeave: x,
      afterLeave: D,
      onClick: N,
      onMouseOver: M,
      onMouseLeave: H,
      onFocusIn: U,
      onFocusOut: G
    };
  }
}), ya = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [a, n] of t)
    r[a] = n;
  return r;
};
function SO(e, t, r, a, n, o) {
  return m(), S("div", {
    class: pe(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...l) => e.onClick && e.onClick(...l)),
    onMouseover: t[1] || (t[1] = (...l) => e.onMouseOver && e.onMouseOver(...l)),
    onMouseleave: t[2] || (t[2] = (...l) => e.onMouseLeave && e.onMouseLeave(...l)),
    onFocusin: t[3] || (t[3] = (...l) => e.onFocusIn && e.onFocusIn(...l)),
    onFocusout: t[4] || (t[4] = (...l) => e.onFocusOut && e.onFocusOut(...l))
  }, [
    K(bt, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: ie(() => [
        e.isVisible ? (m(), S("div", rn({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          at(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            pt(je(e.data), 1)
          ]),
          W("span", {
            class: pe([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : B("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Ks = /* @__PURE__ */ ya(CO, [["render", SO]]), xO = { class: "vc-day-popover-row" }, DO = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, AO = { class: "vc-day-popover-row-label" }, PO = /* @__PURE__ */ Pe({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, r = C(() => {
      const { content: a, highlight: n, dot: o, bar: l, popover: s } = t.attribute;
      return s && s.hideIndicator ? null : a ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${a.base.color}`
      } : n ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${n.base.color}`
      } : o ? {
        class: `vc-dot vc-attr vc-${o.base.color}`
      } : l ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${l.base.color}`
      } : null;
    });
    return (a, n) => (m(), S("div", xO, [
      g(r) ? (m(), S("div", DO, [
        W("span", {
          class: pe(g(r).class)
        }, null, 2)
      ])) : B("", !0),
      W("div", AO, [
        at(a.$slots, "default", {}, () => [
          pt(je(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), OO = {
  inheritAttrs: !1
}, yr = /* @__PURE__ */ Pe({
  ...OO,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const r = Vf(e.name);
    return (a, n) => g(r) ? (m(), J(Yo(g(r)), An(rn({ key: 0 }, a.$attrs)), null, 16)) : at(a.$slots, "default", { key: 1 });
  }
}), TO = { class: "vc-day-popover-container" }, IO = {
  key: 0,
  class: "vc-day-popover-header"
}, MO = /* @__PURE__ */ Pe({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: r, color: a, masks: n, locale: o } = Pa();
    function l(u, i) {
      return o.value.formatDate(u, i);
    }
    function s(u) {
      return o.value.formatDate(u.date, n.value.dayPopover);
    }
    return (u, i) => (m(), J(Ks, {
      id: g(t),
      class: pe([`vc-${g(a)}`, `vc-${g(r)}`])
    }, {
      default: ie(({ data: { day: c, attributes: d }, hide: p }) => [
        K(yr, {
          name: "day-popover",
          day: c,
          "day-title": s(c),
          attributes: d,
          format: l,
          masks: g(n),
          hide: p
        }, {
          default: ie(() => [
            W("div", TO, [
              g(n).dayPopover ? (m(), S("div", IO, je(s(c)), 1)) : B("", !0),
              (m(!0), S(qe, null, We(d, (h) => (m(), J(PO, {
                key: h.key,
                attribute: h
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), qO = {}, EO = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, VO = /* @__PURE__ */ W("polyline", { points: "9 18 15 12 9 6" }, null, -1), LO = [
  VO
];
function BO(e, t) {
  return m(), S("svg", EO, LO);
}
const jO = /* @__PURE__ */ ya(qO, [["render", BO]]), HO = {}, RO = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, FO = /* @__PURE__ */ W("polyline", { points: "15 18 9 12 15 6" }, null, -1), NO = [
  FO
];
function YO(e, t) {
  return m(), S("svg", RO, NO);
}
const UO = /* @__PURE__ */ ya(HO, [["render", YO]]), zO = {}, WO = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, KO = /* @__PURE__ */ W("polyline", { points: "6 9 12 15 18 9" }, null, -1), GO = [
  KO
];
function ZO(e, t) {
  return m(), S("svg", WO, GO);
}
const XO = /* @__PURE__ */ ya(zO, [["render", ZO]]), JO = {}, QO = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, eT = /* @__PURE__ */ W("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), tT = [
  eT
];
function rT(e, t) {
  return m(), S("svg", QO, tT);
}
const aT = /* @__PURE__ */ ya(JO, [["render", rT]]), nT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: XO,
  IconChevronLeft: UO,
  IconChevronRight: jO,
  IconClock: aT
}, Symbol.toStringTag, { value: "Module" })), tn = /* @__PURE__ */ Pe({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, r = C(() => t.width || t.size), a = C(() => t.height || t.size), n = C(() => nT[`Icon${t.name}`]);
    return (o, l) => (m(), J(Yo(g(n)), {
      width: g(r),
      height: g(a),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), oT = ["disabled"], lT = {
  key: 1,
  class: "vc-title-wrapper"
}, sT = {
  type: "button",
  class: "vc-title"
}, iT = ["disabled"], Bf = /* @__PURE__ */ Pe({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: r,
      navVisibility: a,
      canMovePrev: n,
      movePrev: o,
      canMoveNext: l,
      moveNext: s
    } = Pa(), u = C(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), i = C(() => {
      const { page: _ } = t;
      return {
        id: r.value,
        visibility: a.value,
        placement: u.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: _ },
        isInteractive: !0
      };
    }), c = C(() => t.page.titlePosition.includes("left")), d = C(() => t.page.titlePosition.includes("right")), p = C(() => t.layout ? t.layout : c.value ? "tu-pn" : d.value ? "pn-tu" : "p-tu-n;"), h = C(() => ({
      prev: p.value.includes("p") && !t.hideArrows,
      title: p.value.includes("t") && !t.hideTitle,
      next: p.value.includes("n") && !t.hideArrows
    })), y = C(() => ({ gridTemplateColumns: p.value.split("").map(($) => {
      switch ($) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (_, $) => (m(), S("div", {
      class: pe(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: we(g(y))
    }, [
      g(h).prev ? (m(), S("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !g(n),
        onClick: $[0] || ($[0] = //@ts-ignore
        (...w) => g(o) && g(o)(...w)),
        onKeydown: $[1] || ($[1] = Jt(
          //@ts-ignore
          (...w) => g(o) && g(o)(...w),
          ["space", "enter"]
        ))
      }, [
        K(yr, {
          name: "header-prev-button",
          disabled: !g(n)
        }, {
          default: ie(() => [
            K(tn, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, oT)) : B("", !0),
      g(h).title ? (m(), S("div", lT, [
        K(yr, { name: "header-title-wrapper" }, {
          default: ie(() => [
            Kt((m(), S("button", sT, [
              K(yr, {
                name: "header-title",
                title: e.page.title
              }, {
                default: ie(() => [
                  W("span", null, je(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [g(Pf), g(i)]
            ])
          ]),
          _: 1
        })
      ])) : B("", !0),
      g(h).next ? (m(), S("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !g(l),
        onClick: $[2] || ($[2] = //@ts-ignore
        (...w) => g(s) && g(s)(...w)),
        onKeydown: $[3] || ($[3] = Jt(
          //@ts-ignore
          (...w) => g(s) && g(s)(...w),
          ["space", "enter"]
        ))
      }, [
        K(yr, {
          name: "header-next-button",
          disabled: !g(l)
        }, {
          default: ie(() => [
            K(tn, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, iT)) : B("", !0)
    ], 6));
  }
}), jf = Symbol("__vc_page_context__");
function uT(e) {
  const { locale: t, getDateAddress: r, canMove: a } = Pa();
  function n(s, u) {
    const { month: i, year: c } = r(/* @__PURE__ */ new Date());
    return Sf().map((d, p) => {
      const h = p + 1;
      return {
        month: h,
        year: s,
        id: JP(h, s),
        label: t.value.formatDate(d, u),
        ariaLabel: t.value.formatDate(d, "MMMM"),
        isActive: h === e.value.month && s === e.value.year,
        isCurrent: h === i && s === c,
        isDisabled: !a(
          { month: h, year: s },
          { position: e.value.position }
        )
      };
    });
  }
  function o(s, u) {
    const { year: i } = r(/* @__PURE__ */ new Date()), { position: c } = e.value, d = [];
    for (let p = s; p <= u; p += 1) {
      const h = [...Array(12).keys()].some(
        (y) => a({ month: y + 1, year: p }, { position: c })
      );
      d.push({
        year: p,
        id: p.toString(),
        label: p.toString(),
        ariaLabel: p.toString(),
        isActive: p === e.value.year,
        isCurrent: p === i,
        isDisabled: !h
      });
    }
    return d;
  }
  const l = { page: e, getMonthItems: n, getYearItems: o };
  return ar(jf, l), l;
}
function Hf() {
  const e = mr(jf);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const cT = { class: "vc-nav-header" }, dT = ["disabled"], fT = ["disabled"], vT = { class: "vc-nav-items" }, pT = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], mT = /* @__PURE__ */ Pe({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: r } = Pa(), { page: a, getMonthItems: n, getYearItems: o } = Hf(), l = z(!0), s = 12, u = z(a.value.year), i = z(p(a.value.year)), c = z(null);
    function d() {
      setTimeout(() => {
        if (c.value == null)
          return;
        const ae = c.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        ae && ae.focus();
      }, 10);
    }
    function p(ae) {
      return Math.floor(ae / s);
    }
    function h() {
      l.value = !l.value;
    }
    function y(ae) {
      return ae * s;
    }
    function _(ae) {
      return s * (ae + 1) - 1;
    }
    function $() {
      U.value && (l.value && L(), q());
    }
    function w() {
      G.value && (l.value && R(), E());
    }
    function L() {
      u.value--;
    }
    function R() {
      u.value++;
    }
    function q() {
      i.value--;
    }
    function E() {
      i.value++;
    }
    const Y = C(
      () => n(u.value, t.value.navMonths).map((ae) => ({
        ...ae,
        click: () => r(
          { month: ae.month, year: ae.year },
          { position: a.value.position }
        )
      }))
    ), V = C(
      () => n(u.value - 1, t.value.navMonths)
    ), T = C(
      () => V.value.some((ae) => !ae.isDisabled)
    ), A = C(
      () => n(u.value + 1, t.value.navMonths)
    ), P = C(
      () => A.value.some((ae) => !ae.isDisabled)
    ), b = C(
      () => o(
        y(i.value),
        _(i.value)
      ).map((ae) => ({
        ...ae,
        click: () => {
          u.value = ae.year, l.value = !0, d();
        }
      }))
    ), x = C(
      () => o(
        y(i.value - 1),
        _(i.value - 1)
      )
    ), D = C(
      () => x.value.some((ae) => !ae.isDisabled)
    ), N = C(
      () => o(
        y(i.value + 1),
        _(i.value + 1)
      )
    ), M = C(
      () => N.value.some((ae) => !ae.isDisabled)
    ), H = C(
      () => l.value ? Y.value : b.value
    ), U = C(
      () => l.value ? T.value : D.value
    ), G = C(
      () => l.value ? P.value : M.value
    ), F = C(() => nf(b.value.map((ae) => ae.year))), O = C(() => Ba(b.value.map((ae) => ae.year))), Q = C(() => l.value ? u.value : `${F.value} - ${O.value}`);
    return an(() => {
      u.value = a.value.year, d();
    }), Le(
      () => u.value,
      (ae) => i.value = p(ae)
    ), St(() => d()), (ae, Te) => (m(), S("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: c
    }, [
      W("div", cT, [
        W("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !g(U),
          onClick: $,
          onKeydown: Te[0] || (Te[0] = (Ae) => g(mo)(Ae, $))
        }, [
          K(yr, {
            name: "nav-prev-button",
            move: $,
            disabled: !g(U)
          }, {
            default: ie(() => [
              K(tn, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, dT),
        W("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: h,
          onKeydown: Te[1] || (Te[1] = (Ae) => g(mo)(Ae, h))
        }, je(g(Q)), 33),
        W("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !g(G),
          onClick: w,
          onKeydown: Te[2] || (Te[2] = (Ae) => g(mo)(Ae, w))
        }, [
          K(yr, {
            name: "nav-next-button",
            move: w,
            disabled: !g(G)
          }, {
            default: ie(() => [
              K(tn, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, fT)
      ]),
      W("div", vT, [
        (m(!0), S(qe, null, We(g(H), (Ae) => (m(), S("button", {
          key: Ae.label,
          type: "button",
          "data-id": Ae.id,
          "aria-label": Ae.ariaLabel,
          class: pe(["vc-nav-item vc-focus", [
            Ae.isActive ? "is-active" : Ae.isCurrent ? "is-current" : ""
          ]]),
          disabled: Ae.isDisabled,
          onClick: Ae.click,
          onKeydown: (Ye) => g(mo)(Ye, Ae.click)
        }, je(Ae.label), 43, pT))), 128))
      ])
    ], 512));
  }
}), Rf = /* @__PURE__ */ Pe({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return uT(dr(e, "page")), (r, a) => at(r.$slots, "default");
  }
}), hT = /* @__PURE__ */ Pe({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: r, displayMode: a } = Pa();
    return (n, o) => (m(), J(Ks, {
      id: g(t),
      class: pe(["vc-nav-popover-container", `vc-${g(r)}`, `vc-${g(a)}`])
    }, {
      default: ie(({ data: l }) => [
        K(Rf, {
          page: l.page
        }, {
          default: ie(() => [
            K(yr, { name: "nav" }, {
              default: ie(() => [
                K(mT)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), yT = Pe({
  directives: { popover: Pf },
  components: { CalendarSlot: yr },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: r,
      attributeContext: a,
      dayPopoverId: n,
      onDayClick: o,
      onDayMouseenter: l,
      onDayMouseleave: s,
      onDayFocusin: u,
      onDayFocusout: i,
      onDayKeydown: c
    } = Pa(), d = C(() => e.day), p = C(() => a.value.getCells(d.value)), h = C(
      () => p.value.map((M) => M.data)
    ), y = C(() => ({
      ...d.value,
      attributes: h.value,
      attributeCells: p.value
    }));
    function _({ data: M }, { popovers: H }) {
      const { key: U, customData: G, popover: F } = M;
      if (!F)
        return;
      const O = Au(
        {
          key: U,
          customData: G,
          attribute: M
        },
        { ...F },
        {
          visibility: F.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !F.label
        }
      );
      H.splice(0, 0, O);
    }
    const $ = C(() => {
      const M = {
        ...r.value.prepareRender({}),
        popovers: []
      };
      return p.value.forEach((H) => {
        r.value.render(H, M), _(H, M);
      }), M;
    }), w = C(() => $.value.highlights), L = C(() => !!Wr(w.value)), R = C(() => $.value.content), q = C(() => $.value.dots), E = C(() => !!Wr(q.value)), Y = C(() => $.value.bars), V = C(() => !!Wr(Y.value)), T = C(() => $.value.popovers), A = C(
      () => T.value.map((M) => M.attribute)
    ), P = Vf("day-content"), b = C(() => [
      "vc-day",
      ...d.value.classes,
      { "vc-day-box-center-center": !P },
      { "is-not-in-month": !e.day.inMonth }
    ]), x = C(() => {
      let M;
      d.value.isFocusable ? M = "0" : M = "-1";
      const H = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": d.value.isDisabled },
        wa(Ba(w.value), "contentClass"),
        wa(Ba(R.value), "class") || ""
      ], U = {
        ...wa(Ba(w.value), "contentStyle"),
        ...wa(Ba(R.value), "style")
      };
      return {
        class: H,
        style: U,
        tabindex: M,
        "aria-label": d.value.ariaLabel,
        "aria-disabled": !!d.value.isDisabled,
        role: "button"
      };
    }), D = C(() => ({
      click(M) {
        o(y.value, M);
      },
      mouseenter(M) {
        l(y.value, M);
      },
      mouseleave(M) {
        s(y.value, M);
      },
      focusin(M) {
        u(y.value, M);
      },
      focusout(M) {
        i(y.value, M);
      },
      keydown(M) {
        c(y.value, M);
      }
    })), N = C(() => Wr(T.value) ? Au(
      {
        id: n.value,
        data: { day: d, attributes: A.value }
      },
      ...T.value
    ) : null);
    return {
      attributes: h,
      attributeCells: p,
      bars: Y,
      dayClasses: b,
      dayContentProps: x,
      dayContentEvents: D,
      dayPopover: N,
      glyphs: $,
      dots: q,
      hasDots: E,
      hasBars: V,
      highlights: w,
      hasHighlights: L,
      locale: t,
      popovers: T
    };
  }
}), bT = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, gT = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, _T = { class: "vc-dots" }, wT = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, kT = { class: "vc-bars" };
function $T(e, t, r, a, n, o) {
  const l = oe("CalendarSlot"), s = Lp("popover");
  return m(), S("div", {
    class: pe(e.dayClasses)
  }, [
    e.hasHighlights ? (m(), S("div", bT, [
      (m(!0), S(qe, null, We(e.highlights, ({ key: u, wrapperClass: i, class: c, style: d }) => (m(), S("div", {
        key: u,
        class: pe(i)
      }, [
        W("div", {
          class: pe(c),
          style: we(d)
        }, null, 6)
      ], 2))), 128))
    ])) : B("", !0),
    K(l, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: ie(() => [
        Kt((m(), S("div", rn(e.dayContentProps, Bp(e.dayContentEvents, !0)), [
          pt(je(e.day.label), 1)
        ], 16)), [
          [s, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (m(), S("div", gT, [
      W("div", _T, [
        (m(!0), S(qe, null, We(e.dots, ({ key: u, class: i, style: c }) => (m(), S("span", {
          key: u,
          class: pe(i),
          style: we(c)
        }, null, 6))), 128))
      ])
    ])) : B("", !0),
    e.hasBars ? (m(), S("div", wT, [
      W("div", kT, [
        (m(!0), S(qe, null, We(e.bars, ({ key: u, class: i, style: c }) => (m(), S("span", {
          key: u,
          class: pe(i),
          style: we(c)
        }, null, 6))), 128))
      ])
    ])) : B("", !0)
  ], 2);
}
const CT = /* @__PURE__ */ ya(yT, [["render", $T]]), ST = { class: "vc-weekdays" }, xT = ["onClick"], DT = {
  inheritAttrs: !1
}, AT = /* @__PURE__ */ Pe({
  ...DT,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = Hf(), { onWeeknumberClick: r } = Pa();
    return (a, n) => (m(), S("div", {
      class: pe([
        "vc-pane",
        `row-${g(t).row}`,
        `row-from-end-${g(t).rowFromEnd}`,
        `column-${g(t).column}`,
        `column-from-end-${g(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      K(Bf, {
        page: g(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      W("div", {
        class: pe(["vc-weeks", {
          [`vc-show-weeknumbers-${g(t).weeknumberPosition}`]: g(t).weeknumberPosition
        }])
      }, [
        W("div", ST, [
          (m(!0), S(qe, null, We(g(t).weekdays, ({ weekday: o, label: l }, s) => (m(), S("div", {
            key: s,
            class: pe(`vc-weekday vc-weekday-${o}`)
          }, je(l), 3))), 128))
        ]),
        (m(!0), S(qe, null, We(g(t).viewWeeks, (o) => (m(), S("div", {
          key: `weeknumber-${o.weeknumber}`,
          class: "vc-week"
        }, [
          g(t).weeknumberPosition ? (m(), S("div", {
            key: 0,
            class: pe(["vc-weeknumber", `is-${g(t).weeknumberPosition}`])
          }, [
            W("span", {
              class: pe(["vc-weeknumber-content"]),
              onClick: (l) => g(r)(o, l)
            }, je(o.weeknumberDisplay), 9, xT)
          ], 2)) : B("", !0),
          (m(!0), S(qe, null, We(o.days, (l) => (m(), J(CT, {
            key: l.id,
            day: l
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), PT = Pe({
  components: {
    CalendarHeader: Bf,
    CalendarPage: AT,
    CalendarNavPopover: hT,
    CalendarDayPopover: MO,
    CalendarPageProvider: Rf,
    CalendarSlot: yr
  },
  props: wO,
  emit: kO,
  setup(e, { emit: t, slots: r }) {
    return $O(e, { emit: t, slots: r });
  }
}), OT = { class: "vc-pane-header-wrapper" };
function TT(e, t, r, a, n, o) {
  const l = oe("CalendarHeader"), s = oe("CalendarPage"), u = oe("CalendarSlot"), i = oe("CalendarPageProvider"), c = oe("CalendarDayPopover"), d = oe("CalendarNavPopover");
  return m(), S(qe, null, [
    W("div", rn({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = Bl(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      W("div", {
        class: pe(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        W("div", OT, [
          e.firstPage ? (m(), J(l, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : B("", !0)
        ]),
        K(bt, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: ie(() => [
            (m(), S("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: we({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (m(!0), S(qe, null, We(e.pages, (p) => (m(), J(i, {
                key: p.id,
                page: p
              }, {
                default: ie(() => [
                  K(u, {
                    name: "page",
                    page: p
                  }, {
                    default: ie(() => [
                      K(s)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        K(u, { name: "footer" })
      ], 2)
    ], 16),
    K(c),
    K(d)
  ], 64);
}
const IT = /* @__PURE__ */ ya(PT, [["render", TT]]), Ff = Symbol("__vc_date_picker_context__"), MT = {
  ...If,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => ma("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => ma("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, qT = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function ET(e, { emit: t, slots: r }) {
  Ef(r, { footer: "dp-footer" });
  const a = Mf(e), { locale: n, masks: o, disabledAttribute: l } = a, s = z(!1), u = z(Symbol()), i = z(null), c = z(null), d = z(["", ""]), p = z(null), h = z(null);
  let y, _, $ = !0;
  const w = C(() => e.isRange || e.modelModifiers.range === !0), L = C(
    () => w.value && i.value != null ? i.value.start : null
  ), R = C(
    () => w.value && i.value != null ? i.value.end : null
  ), q = C(() => e.mode.toLowerCase() === "date"), E = C(
    () => e.mode.toLowerCase() === "datetime"
  ), Y = C(() => e.mode.toLowerCase() === "time"), V = C(() => !!c.value), T = C(() => {
    let j = "date";
    e.modelModifiers.number && (j = "number"), e.modelModifiers.string && (j = "string");
    const ne = o.value.modelValue || "iso";
    return Te({ type: j, mask: ne });
  }), A = C(
    () => He(c.value ?? i.value)
  ), P = C(() => Y.value ? e.is24hr ? o.value.inputTime24hr : o.value.inputTime : E.value ? e.is24hr ? o.value.inputDateTime24hr : o.value.inputDateTime : o.value.input), b = C(() => /[Hh]/g.test(P.value)), x = C(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(P.value)
  ), D = C(() => {
    if (b.value && x.value)
      return "dateTime";
    if (x.value)
      return "date";
    if (b.value)
      return "time";
  }), N = C(() => {
    var j;
    const ne = ((j = p.value) == null ? void 0 : j.$el.previousElementSibling) ?? void 0;
    return Vn({}, e.popover, ma("datePicker.popover"), {
      target: ne
    });
  }), M = C(
    () => Af({
      ...N.value,
      id: u.value
    })
  ), H = C(() => w.value ? {
    start: d.value[0],
    end: d.value[1]
  } : d.value[0]), U = C(() => {
    const j = ["start", "end"].map((ne) => ({
      input: ye(ne),
      change: Fe(ne),
      keyup: Me,
      ...e.popover && M.value
    }));
    return w.value ? {
      start: j[0],
      end: j[1]
    } : j[0];
  }), G = C(() => {
    if (!it(i.value))
      return null;
    const j = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: i.value,
      pinPage: !0
    }, { dot: ne, bar: ge, highlight: De, content: yt } = j;
    return !ne && !ge && !De && !yt && (j.highlight = !0), j;
  }), F = C(() => {
    if (!w.value || !it(c.value))
      return null;
    const j = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: c.value
    }, { dot: ne, bar: ge, highlight: De, content: yt } = j;
    return !ne && !ge && !De && !yt && (j.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), j;
  }), O = C(() => {
    const j = gr(e.attributes) ? [...e.attributes] : [];
    return F.value ? j.unshift(F.value) : G.value && j.unshift(G.value), j;
  }), Q = C(() => Te(
    e.rules === "auto" ? ae() : e.rules ?? {}
  ));
  function ae() {
    const j = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, ne = q.value ? 0 : e.timeAccuracy;
    return [0, 1].map((ge) => {
      switch (ne) {
        case 0:
          return {
            hours: j.hr[ge],
            minutes: j.min[ge],
            seconds: j.sec[ge],
            milliseconds: j.ms[ge]
          };
        case 1:
          return {
            minutes: j.min[ge],
            seconds: j.sec[ge],
            milliseconds: j.ms[ge]
          };
        case 3:
          return { milliseconds: j.ms[ge] };
        case 4:
          return {};
        default:
          return { seconds: j.sec[ge], milliseconds: j.ms[ge] };
      }
    });
  }
  function Te(j) {
    return gr(j) ? j.length === 1 ? [j[0], j[0]] : j : [j, j];
  }
  function Ae(j) {
    return Te(j).map(
      (ne, ge) => ({
        ...ne,
        rules: Q.value[ge]
      })
    );
  }
  function Ye(j) {
    return j == null ? !1 : Dr(j) ? !isNaN(j) : za(j) ? !isNaN(j.getTime()) : Er(j) ? j !== "" : Ys(j);
  }
  function Re(j) {
    return Xr(j) && "start" in j && "end" in j && Ye(j.start ?? null) && Ye(j.end ?? null);
  }
  function it(j) {
    return Re(j) || Ye(j);
  }
  function he(j, ne) {
    if (j == null && ne == null)
      return !0;
    if (j == null || ne == null)
      return !1;
    const ge = za(j), De = za(ne);
    return ge && De ? j.getTime() === ne.getTime() : ge || De ? !1 : he(j.start, ne.start) && he(j.end, ne.end);
  }
  function X(j) {
    return !it(j) || !l.value ? !1 : l.value.intersectsRange(n.value.range(j));
  }
  function re(j, ne, ge, De) {
    if (!it(j))
      return null;
    if (Re(j)) {
      const yt = n.value.toDate(j.start, {
        ...ne[0],
        fillDate: L.value ?? void 0,
        patch: ge
      }), gt = n.value.toDate(j.end, {
        ...ne[1],
        fillDate: R.value ?? void 0,
        patch: ge
      });
      return de({ start: yt, end: gt }, De);
    }
    return n.value.toDateOrNull(j, {
      ...ne[0],
      fillDate: i.value,
      patch: ge
    });
  }
  function Se(j, ne) {
    return Re(j) ? {
      start: n.value.fromDate(j.start, ne[0]),
      end: n.value.fromDate(j.end, ne[1])
    } : w.value ? null : n.value.fromDate(j, ne[0]);
  }
  function me(j, ne = {}) {
    return clearTimeout(y), new Promise((ge) => {
      const { debounce: De = 0, ...yt } = ne;
      De > 0 ? y = window.setTimeout(() => {
        ge(fe(j, yt));
      }, De) : ge(fe(j, yt));
    });
  }
  function fe(j, {
    config: ne = T.value,
    patch: ge = "dateTime",
    clearIfEqual: De = !1,
    formatInput: yt = !0,
    hidePopover: gt = !1,
    dragging: _t = V.value,
    targetPriority: ve,
    moveToValue: st = !1
  } = {}) {
    const rt = Ae(ne);
    let vt = re(
      j,
      rt,
      ge,
      ve
    );
    if (X(vt)) {
      if (_t)
        return null;
      vt = i.value, gt = !1;
    } else vt == null && e.isRequired ? vt = i.value : (
      // Clear value if same value was passed
      vt != null && he(i.value, vt) && De && (vt = null)
    );
    const Tr = _t ? c : i, Yt = !he(Tr.value, vt);
    Tr.value = vt, _t || (c.value = null);
    const Bt = Se(
      vt,
      T.value
    );
    return Yt && ($ = !1, t(_t ? "drag" : "update:modelValue", Bt), ut(() => $ = !0)), gt && !_t && Ve(), yt && Oe(), st && ut(() => dt(ve ?? "start")), Bt;
  }
  function Oe() {
    ut(() => {
      const j = Ae({
        type: "string",
        mask: P.value
      }), ne = Se(
        c.value ?? i.value,
        j
      );
      w.value ? d.value = [ne && ne.start, ne && ne.end] : d.value = [ne, ""];
    });
  }
  function Ie(j, ne, ge) {
    d.value.splice(ne === "start" ? 0 : 1, 1, j);
    const De = w.value ? {
      start: d.value[0],
      end: d.value[1] || d.value[0]
    } : j, yt = {
      type: "string",
      mask: P.value
    };
    me(De, {
      ...ge,
      config: yt,
      patch: D.value,
      targetPriority: ne,
      moveToValue: !0
    });
  }
  function ye(j) {
    return (ne) => {
      e.updateOnInput && Ie(ne.currentTarget.value, j, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function Fe(j) {
    return (ne) => {
      Ie(ne.currentTarget.value, j, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function Me(j) {
    j.key === "Escape" && me(i.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function He(j) {
    return w.value ? [
      j && j.start ? n.value.getDateParts(j.start) : null,
      j && j.end ? n.value.getDateParts(j.end) : null
    ] : [j ? n.value.getDateParts(j) : null];
  }
  function ce() {
    c.value = null, Oe();
  }
  function mt(j) {
    t("popover-will-show", j);
  }
  function nt(j) {
    t("popover-did-show", j);
  }
  function ot(j) {
    ce(), t("popover-will-hide", j);
  }
  function ft(j) {
    t("popover-did-hide", j);
  }
  function $e(j) {
    const ne = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (w.value) {
      const ge = !V.value;
      ge ? _ = { start: j.startDate, end: j.endDate } : _ != null && (_.end = j.date), me(_, {
        ...ne,
        dragging: ge
      });
    } else
      me(j.date, {
        ...ne,
        clearIfEqual: !e.isRequired
      });
  }
  function Qe(j, ne) {
    $e(j), t("dayclick", j, ne);
  }
  function te(j, ne) {
    switch (ne.key) {
      case " ":
      case "Enter": {
        $e(j), ne.preventDefault();
        break;
      }
      case "Escape":
        Ve();
    }
    t("daykeydown", j, ne);
  }
  function xe(j, ne) {
    !V.value || _ == null || (_.end = j.date, me(de(_), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Ee(j = {}) {
    Ql({
      ...N.value,
      ...j,
      isInteractive: !0,
      id: u.value
    });
  }
  function Ve(j = {}) {
    Ln({
      hideDelay: 10,
      force: !0,
      ...N.value,
      ...j,
      id: u.value
    });
  }
  function Xe(j) {
    Df({
      ...N.value,
      ...j,
      isInteractive: !0,
      id: u.value
    });
  }
  function de(j, ne) {
    const { start: ge, end: De } = j;
    if (ge > De)
      switch (ne) {
        case "start":
          return { start: ge, end: ge };
        case "end":
          return { start: De, end: De };
        default:
          return { start: De, end: ge };
      }
    return { start: ge, end: De };
  }
  async function ke(j, ne = {}) {
    return h.value == null ? !1 : h.value.move(j, ne);
  }
  async function lt(j, ne = {}) {
    return h.value == null ? !1 : h.value.moveBy(j, ne);
  }
  async function dt(j, ne = {}) {
    const ge = i.value;
    if (h.value == null || !it(ge))
      return !1;
    const De = j !== "end", yt = De ? 1 : -1, gt = Re(ge) ? De ? ge.start : ge.end : ge, _t = df(gt, "monthly", n.value);
    return h.value.move(_t, { position: yt, ...ne });
  }
  Le(
    () => e.isRange,
    (j) => {
      j && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), Le(
    () => w.value,
    () => {
      fe(null, { formatInput: !0 });
    }
  ), Le(
    () => P.value,
    () => Oe()
  ), Le(
    () => e.modelValue,
    (j) => {
      $ && fe(j, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Le(
    () => Q.value,
    () => {
      Xr(e.rules) && fe(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Le(
    () => e.timezone,
    () => {
      fe(i.value, { formatInput: !0 });
    }
  );
  const Je = Te(T.value);
  i.value = re(
    e.modelValue ?? null,
    Je,
    "dateTime"
  ), St(() => {
    fe(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), ut(() => s.value = !0);
  const ue = {
    ...a,
    showCalendar: s,
    datePickerPopoverId: u,
    popoverRef: p,
    popoverEvents: M,
    calendarRef: h,
    isRange: w,
    isTimeMode: Y,
    isDateTimeMode: E,
    is24hr: dr(e, "is24hr"),
    hideTimeHeader: dr(e, "hideTimeHeader"),
    timeAccuracy: dr(e, "timeAccuracy"),
    isDragging: V,
    inputValue: H,
    inputEvents: U,
    dateParts: A,
    attributes: O,
    rules: Q,
    move: ke,
    moveBy: lt,
    moveToValue: dt,
    updateValue: me,
    showPopover: Ee,
    hidePopover: Ve,
    togglePopover: Xe,
    onDayClick: Qe,
    onDayKeydown: te,
    onDayMouseEnter: xe,
    onPopoverBeforeShow: mt,
    onPopoverAfterShow: nt,
    onPopoverBeforeHide: ot,
    onPopoverAfterHide: ft
  };
  return ar(Ff, ue), ue;
}
function Gs() {
  const e = mr(Ff);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const VT = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], LT = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function BT(e) {
  const t = Gs(), {
    locale: r,
    isRange: a,
    isTimeMode: n,
    dateParts: o,
    rules: l,
    is24hr: s,
    hideTimeHeader: u,
    timeAccuracy: i,
    updateValue: c
  } = t;
  function d(x) {
    x = Object.assign(h.value, x);
    let D = null;
    if (a.value) {
      const N = p.value ? x : o.value[0], M = p.value ? o.value[1] : x;
      D = { start: N, end: M };
    } else
      D = x;
    c(D, {
      patch: "time",
      targetPriority: p.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const p = C(() => e.position === 0), h = C(
    () => o.value[e.position] || { isValid: !1 }
  ), y = C(() => Ys(h.value)), _ = C(() => !!h.value.isValid), $ = C(() => !u.value && _.value), w = C(() => {
    if (!y.value)
      return null;
    let x = r.value.toDate(h.value);
    return h.value.hours === 24 && (x = new Date(x.getTime() - 1)), x;
  }), L = C({
    get() {
      return h.value.hours;
    },
    set(x) {
      d({ hours: x });
    }
  }), R = C({
    get() {
      return h.value.minutes;
    },
    set(x) {
      d({ minutes: x });
    }
  }), q = C({
    get() {
      return h.value.seconds;
    },
    set(x) {
      d({ seconds: x });
    }
  }), E = C({
    get() {
      return h.value.milliseconds;
    },
    set(x) {
      d({ milliseconds: x });
    }
  }), Y = C({
    get() {
      return h.value.hours < 12;
    },
    set(x) {
      x = String(x).toLowerCase() == "true";
      let D = L.value;
      x && D >= 12 ? D -= 12 : !x && D < 12 && (D += 12), d({ hours: D });
    }
  }), V = C(
    () => rO(h.value, l.value[e.position])
  ), T = C(() => VT.filter(
    (x) => V.value.hours.some((D) => D.value === x.value)
  )), A = C(() => LT.filter(
    (x) => V.value.hours.some((D) => D.value === x.value)
  )), P = C(() => s.value ? V.value.hours : Y.value ? T.value : A.value), b = C(() => {
    const x = [];
    return Wr(T.value) && x.push({ value: !0, label: "AM" }), Wr(A.value) && x.push({ value: !1, label: "PM" }), x;
  });
  return {
    ...t,
    showHeader: $,
    timeAccuracy: i,
    parts: h,
    isValid: _,
    date: w,
    hours: L,
    minutes: R,
    seconds: q,
    milliseconds: E,
    options: V,
    hourOptions: P,
    isAM: Y,
    isAMOptions: b,
    is24hr: s
  };
}
const jT = ["value"], HT = ["value", "disabled"], RT = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, FT = {
  inheritAttrs: !1
}, wn = /* @__PURE__ */ Pe({
  ...FT,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = C(() => {
      const a = t.options.find((n) => n.value === t.modelValue);
      return a == null ? void 0 : a.label;
    });
    return (a, n) => (m(), S("div", {
      class: pe(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      W("select", rn(a.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: n[0] || (n[0] = (o) => a.$emit("update:modelValue", o.target.value))
      }), [
        (m(!0), S(qe, null, We(e.options, (o) => (m(), S("option", {
          key: o.value,
          value: o.value,
          disabled: o.disabled
        }, je(o.label), 9, HT))), 128))
      ], 16, jT),
      e.showIcon ? (m(), J(tn, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : B("", !0),
      e.fitContent ? (m(), S("div", RT, je(g(r)), 1)) : B("", !0)
    ], 2));
  }
}), NT = {
  key: 0,
  class: "vc-time-header"
}, YT = { class: "vc-time-weekday" }, UT = { class: "vc-time-month" }, zT = { class: "vc-time-day" }, WT = { class: "vc-time-year" }, KT = { class: "vc-time-select-group" }, GT = /* @__PURE__ */ W("span", { class: "vc-time-colon" }, ":", -1), ZT = /* @__PURE__ */ W("span", { class: "vc-time-colon" }, ":", -1), XT = /* @__PURE__ */ W("span", { class: "vc-time-decimal" }, ".", -1), ac = /* @__PURE__ */ Pe({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const a = BT(e);
    t(a);
    const {
      locale: n,
      isValid: o,
      date: l,
      hours: s,
      minutes: u,
      seconds: i,
      milliseconds: c,
      options: d,
      hourOptions: p,
      isTimeMode: h,
      isAM: y,
      isAMOptions: _,
      is24hr: $,
      showHeader: w,
      timeAccuracy: L
    } = a;
    return (R, q) => (m(), S("div", {
      class: pe(["vc-time-picker", [{ "vc-invalid": !g(o), "vc-attached": !g(h) }]])
    }, [
      K(yr, { name: "time-header" }, {
        default: ie(() => [
          g(w) && g(l) ? (m(), S("div", NT, [
            W("span", YT, je(g(n).formatDate(g(l), "WWW")), 1),
            W("span", UT, je(g(n).formatDate(g(l), "MMM")), 1),
            W("span", zT, je(g(n).formatDate(g(l), "D")), 1),
            W("span", WT, je(g(n).formatDate(g(l), "YYYY")), 1)
          ])) : B("", !0)
        ]),
        _: 1
      }),
      W("div", KT, [
        K(tn, {
          name: "Clock",
          size: "17"
        }),
        K(wn, {
          modelValue: g(s),
          "onUpdate:modelValue": q[0] || (q[0] = (E) => _a(s) ? s.value = E : null),
          modelModifiers: { number: !0 },
          options: g(p),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        g(L) > 1 ? (m(), S(qe, { key: 0 }, [
          GT,
          K(wn, {
            modelValue: g(u),
            "onUpdate:modelValue": q[1] || (q[1] = (E) => _a(u) ? u.value = E : null),
            modelModifiers: { number: !0 },
            options: g(d).minutes,
            class: "vc-time-select-minutes",
            "align-left": g(L) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        g(L) > 2 ? (m(), S(qe, { key: 1 }, [
          ZT,
          K(wn, {
            modelValue: g(i),
            "onUpdate:modelValue": q[2] || (q[2] = (E) => _a(i) ? i.value = E : null),
            modelModifiers: { number: !0 },
            options: g(d).seconds,
            class: "vc-time-select-seconds",
            "align-left": g(L) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        g(L) > 3 ? (m(), S(qe, { key: 2 }, [
          XT,
          K(wn, {
            modelValue: g(c),
            "onUpdate:modelValue": q[3] || (q[3] = (E) => _a(c) ? c.value = E : null),
            modelModifiers: { number: !0 },
            options: g(d).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : B("", !0),
        g($) ? B("", !0) : (m(), J(wn, {
          key: 3,
          modelValue: g(y),
          "onUpdate:modelValue": q[4] || (q[4] = (E) => _a(y) ? y.value = E : null),
          options: g(_)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), Nf = /* @__PURE__ */ Pe({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: r,
      color: a,
      displayMode: n,
      isDateTimeMode: o,
      isTimeMode: l,
      isRange: s,
      onDayClick: u,
      onDayMouseEnter: i,
      onDayKeydown: c
    } = Gs(), d = s.value ? [0, 1] : [0];
    return (p, h) => g(l) ? (m(), S("div", {
      key: 0,
      class: pe(`vc-container vc-bordered vc-${g(a)} vc-${g(n)}`)
    }, [
      (m(!0), S(qe, null, We(g(d), (y) => (m(), J(ac, {
        key: y,
        position: y
      }, null, 8, ["position"]))), 128))
    ], 2)) : (m(), J(IT, {
      key: 1,
      attributes: g(t),
      ref_key: "calendarRef",
      ref: r,
      onDayclick: g(u),
      onDaymouseenter: g(i),
      onDaykeydown: g(c)
    }, {
      footer: ie(() => [
        g(o) ? (m(!0), S(qe, { key: 0 }, We(g(d), (y) => (m(), J(ac, {
          key: y,
          position: y
        }, null, 8, ["position"]))), 128)) : B("", !0),
        K(yr, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), JT = {
  inheritAttrs: !1
}, QT = /* @__PURE__ */ Pe({
  ...JT,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: r,
      displayMode: a,
      popoverRef: n,
      onPopoverBeforeShow: o,
      onPopoverAfterShow: l,
      onPopoverBeforeHide: s,
      onPopoverAfterHide: u
    } = Gs();
    return (i, c) => (m(), J(Ks, {
      id: g(t),
      placement: "bottom-start",
      class: pe(`vc-date-picker-content vc-${g(r)} vc-${g(a)}`),
      ref_key: "popoverRef",
      ref: n,
      onBeforeShow: g(o),
      onAfterShow: g(l),
      onBeforeHide: g(s),
      onAfterHide: g(u)
    }, {
      default: ie(() => [
        K(Nf, An(jl(i.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), eI = Pe({
  inheritAttrs: !1,
  emits: qT,
  props: MT,
  components: { DatePickerBase: Nf, DatePickerPopover: QT },
  setup(e, t) {
    const r = ET(e, t), a = Gt(lf(r, "calendarRef", "popoverRef"));
    return { ...r, slotCtx: a };
  }
});
function tI(e, t, r, a, n, o) {
  const l = oe("DatePickerPopover"), s = oe("DatePickerBase");
  return e.$slots.default ? (m(), S(qe, { key: 0 }, [
    at(e.$slots, "default", An(jl(e.slotCtx))),
    K(l, An(jl(e.$attrs)), null, 16)
  ], 64)) : (m(), J(s, An(rn({ key: 1 }, e.$attrs)), null, 16));
}
const rI = /* @__PURE__ */ ya(eI, [["render", tI]]), aI = ["for", "id", "aria-hidden"], nI = ["innerHTML"], oI = ["id", "type", "name", "aria-label", "aria-labelledby", "aria-disabled", "disabled", "readonly", "min", "max", "autocomplete"], lI = {
  key: 0,
  class: "suffix",
  "data-tag": "suffix",
  role: "presentation"
}, sI = {
  key: 0,
  class: "info value-too-long"
}, iI = {
  key: 0,
  class: "info value-too-long"
}, uI = {
  key: 0,
  class: "errors",
  role: "presentation"
}, cI = {
  key: 0,
  class: "date-picker-wrapper",
  role: "presentation"
}, dI = { class: "input-label" }, fI = {
  key: 0,
  class: "validation-error",
  role: "presentation"
}, vI = {
  class: "actions",
  role: "presentation"
}, pI = /* @__PURE__ */ Pe({
  __name: "Input",
  props: {
    ...Ge(),
    ...ys((e) => {
    }),
    type: {
      type: String,
      required: !1,
      default: "text"
    },
    min_date: {
      type: Number,
      required: !1,
      default: void 0
    },
    max_date: {
      type: Number,
      required: !1,
      default: void 0
    },
    label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    suffix: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    format: {
      type: String,
      required: !1,
      default: void 0
    },
    regex: {
      type: String,
      required: !1,
      default: void 0
    },
    min_length: {
      type: Number,
      required: !1,
      default: void 0
    },
    max_length: {
      type: Number,
      required: !1,
      default: void 0
    },
    value_too_short_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    value_too_long_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    qr: {
      type: Boolean,
      required: !1,
      default: !1
    },
    qr_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    qr_close_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    qr_not_allowed_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    qr_not_supported_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    allow_zero: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hideLabelOnValue: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: [String, Number, Object, Boolean],
      required: !1,
      default: void 0
    },
    autocomplete: {
      default: void 0
    },
    readonly: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "keyup",
    "keyup.enter",
    "update:modelValue",
    "focus",
    "blur"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((de) => ({
      "764607de": g(s).inputBorder.value.cssHSLA,
      c11ccf62: g(s).textSecondary.value.cssHSLA,
      "094d74c6": g(s).inputHoverBorder.value.cssHSLA
    }));
    const a = Dt("components/core/Input", Dt.COLOR_COMPONENT), n = e, o = r, l = Ze(n, o), { color: s, uid: u } = l, i = wm(n), c = qr(), { is_mobile: d } = Am(c), p = dr(() => n.label), h = dr(() => n.modelValue), y = dr(() => n.errors), _ = dr(() => n.disabled ?? !1), $ = dr(() => n.noInteract ?? !1), w = z(), L = z(), R = z(), q = z(), E = z(), Y = z();
    let V = (() => {
      if (typeof document > "u")
        return !1;
      let de = document.createElement("input"), ke = "definitely_not_a_date";
      return de.setAttribute("type", "date"), de.setAttribute("value", ke), de.value !== ke;
    })();
    const T = z(n.modelValue), A = z();
    if (n.type == "date" && T.value !== void 0 && T.value !== null && T.value !== "")
      if (typeof T.value == "string")
        if (gc(T.value))
          T.value = Number(T.value), A.value = new Date(T.value * 1e3), T.value = Ia(T.value);
        else {
          a.always.warnFrom("setup", "Received invalid value", T.value);
          try {
            throw new Error("Input: Invalid date received");
          } catch (de) {
            bc().send(de, ["component"], {
              tag: "acquisit-input",
              modelValue: T.value
            });
          }
        }
      else
        A.value = new Date(T.value * 1e3), T.value = Ia(T.value);
    xc(T.value) && (T.value = l.language.parse(T.value));
    const P = z(T.value), b = z(!1), x = z(!1), D = z(), N = z(!1), M = z(!1), H = z(!1), U = C(() => Array.isArray(n.errors) ? n.errors.filter((de) => de.isUserVisible) : []), G = z(!1), F = z("auto"), O = z(), Q = z(n.qr && navigator.mediaDevices), ae = C(() => {
      if (n.min_date)
        return Ia(n.min_date) || void 0;
    }), Te = C(() => {
      if (n.max_date)
        return Ia(n.max_date) || void 0;
    }), Ae = C(() => [
      "acquisit-input",
      "theme-" + n.theme,
      "type-" + n.type,
      {
        disabled: n.disabled,
        focused: b.value,
        filled: T.value || T.value === 0,
        "hide-label-on-value": n.hideLabelOnValue,
        error: Array.isArray(n.errors) ? n.errors.length : n.errors,
        "acquisit-has-errors": Array.isArray(n.errors) ? n.errors.length : n.errors,
        erroring: l.erroring.value,
        "has-icon": n.icon,
        "has-suffix": n.suffix,
        "no-interact": $.value,
        qr: n.qr && Q.value
      }
    ]), Ye = () => {
      let de = T.value;
      if (n.type == "date")
        try {
          if (de === null)
            throw new Error("Invalid date: null");
          if (de = Math.round(+new Date(de) / 1e3), isNaN(de))
            throw new Error("Invalid date: NaN");
          H.value = !1;
        } catch {
          de = null, H.value = !0;
        }
      o("update:modelValue", de);
    }, Re = async (de) => {
      if (N.value = !1, M.value = !1, n.type == "text" && n.format) {
        let ke = de.target.value, lt = P.value || "", dt = D.value, Je = "", ue = null;
        if (n.format == "number") {
          let ne = ke.replace(/\D+/g, ""), ge = Kp(ne, 3, "right").join(" ");
          Je = ne == "" ? "" : ge, P.value = Je;
        } else if (ue = /\+(?!$)/.exec(n.format))
          a.error('Property "format" contains unexpected "+" at ' + ue.index), Je = ke, P.value = Je;
        else {
          let ne = Ao(ke, n.format), ge = te(ke, n.format), De = rs(ge), yt = xe(De), gt = ne.match(yt), _t = !1;
          if (gt) {
            let ve = 1;
            for (let st = 0, rt = ge.length; st < rt; st++) {
              let vt = ge.charAt(st);
              vt == "A" || vt == "D" || vt == "S" || vt == "L" ? (Je += gt[ve], ve++) : vt == "+" ? ve++ : Je += vt;
            }
            P.value = Je;
          } else
            Je = lt, _t = ne.length > De.length;
          N.value = _t;
        }
        let j = Math.max(0, dt + (Je.length - lt.length));
        T.value = Je, w.value && (await ut(), w.value.setSelectionRange(j, j), D.value = j);
      }
    }, it = () => {
      Ye();
    }, he = (de) => {
      if (n.type == "number") {
        let ke = de.key == "Backspace", lt = /^\d+$/.test(de.key), dt = de.metaKey || de.ctrlKey, Je = de.key == "ArrowLeft" || de.key == "ArrowRight", ue = de.key == "Tab";
        !ke && !lt && !dt && !Je && !ue && de.preventDefault();
      }
    }, X = (de) => {
      Qe(de), Ye(), o("keyup", de), de.key == "Enter" && o("keyup.enter", de);
    }, re = C(() => {
      if (n.disabled)
        if (n.theme == "dark") {
          const de = s.backgroundDarkTinted.value.clone();
          return de.hsl.l = 0.67, {
            color: de.cssHSLA
          };
        } else {
          const de = s.backgroundLightTinted.value.clone();
          return de.hsl.l = 0.67, {
            color: de.cssHSLA
          };
        }
      else return b.value ? {
        color: s.baseVisuallySafe.value.cssHSLA
      } : {};
    }), Se = C(() => n.disabled ? n.theme == "dark" ? {
      background: s.backgroundDarkTinted.value.cssHSLA,
      borderColor: s.backgroundDarkTinted.value.cssHSLA
    } : {
      background: s.backgroundLightTinted.value.cssHSLA,
      borderColor: s.backgroundLightTinted.value.cssHSLA
    } : b.value ? {
      "border-color": s.baseVisuallySafe.value.cssHSLA
    } : {}), me = () => {
      b.value = !1, D.value = null, o("blur");
    }, fe = (de) => {
      n.type == "data" || n.noInteract || (b.value = !0, Qe(de), n.type == "date" && ye(), o("focus"));
    }, Oe = (de) => {
      var dt, Je, ue, j, ne;
      if (n.type == "data" || b.value || n.noInteract) {
        de == null || de.preventDefault();
        return;
      }
      const ke = de == null ? void 0 : de.target;
      if (ke && (((dt = L.value) == null ? void 0 : dt.$el.contains(ke)) || ((Je = R.value) == null ? void 0 : Je.contains(ke)) || ((ue = q.value) == null ? void 0 : ue.contains(ke)))) {
        me(), (j = w.value) == null || j.blur();
        return;
      }
      n.type !== "date" && ((ne = w.value) == null || ne.focus());
    }, Ie = (de) => {
      n.noInteract || (Qe(de), n.type == "date" && ye());
    }, ye = () => {
      V || n.type != "date" || x.value || (x.value = !0, document.body.addEventListener("click", Fe));
    }, Fe = (de) => {
      var ke;
      V || n.type != "date" || de && ((ke = E.value) != null && ke.$el.contains(de.target) || E.value == de.target) || (x.value = !1, document.body.removeEventListener("click", Fe));
    }, Me = Gt({
      left: "0px",
      top: "0px",
      width: "0px",
      height: void 0
    }), He = C(() => qr().is_mobile ? {} : Me), ce = () => {
      const de = R.value;
      if (qr().is_mobile)
        Me.left = "0px", Me.top = "0px", Me.width = "100%", Me.height = "100%";
      else if (de && Y.value) {
        const ke = Y.value.getBoundingClientRect();
        Me.left = String(ke.left) + "px", Me.top = String(ke.top) + "px", Me.width = String(ke.width) + "px", Me.height = "auto";
      }
    }, mt = async () => {
      n.qr && Q.value && (ce(), await ut(), G.value = !0);
    }, nt = () => {
      G.value = !1;
    }, ot = (de, ke) => {
      for (const lt of de) {
        const [dt, ...Je] = lt.cornerPoints;
        ke.strokeStyle = "red", ke.beginPath(), ke.moveTo(dt.x, dt.y);
        for (const { x: ue, y: j } of Je)
          ke.lineTo(ue, j);
        ke.lineTo(dt.x, dt.y), ke.closePath(), ke.stroke();
      }
    }, ft = (de) => {
      de[0] && (T.value = de[0].rawValue, nt(), Ye());
    }, $e = (de) => {
      a.errorFrom("onQrError", de), O.value = "not_allowed";
    }, Qe = (de) => {
      try {
        if (de && de.target && n.type != "data") {
          const ke = de.target;
          ke.selectionEnd === 0 || ke.selectionEnd ? D.value = ke.selectionEnd : D.value = String(ke.value || "").length;
        }
      } catch {
        D.value = String(T.value).length;
      }
    }, te = (de, ke) => {
      let lt = Ao(de, ke), dt = 0;
      for (let Je = 0, ue = lt.length; Je < ue; Je++) {
        let j = ke.charAt(dt);
        if (!j)
          break;
        j != "A" && j != "D" && j != "S" && j != "L" && j != "+" && dt++, dt++;
      }
      return ke.substring(0, dt);
    }, xe = (de) => {
      const ke = "A-Za-zäöüßÄÖÜæœåÆŒÅéèÉÈ", lt = "^" + de.replace(/A(\+)?/g, "([0-9" + ke + "]$1)").replace(/D(\+)?/g, "([\\d]$1)").replace(/S(\+)?/g, "([ " + ke + "]$1)").replace(/L(\+)?/g, "([" + ke + "]$1)") + "$";
      return new RegExp(lt);
    }, Ee = C(() => n.label && n.required ? l.language.parse(n.label) + '<span class="required">*</span>' : n.label), Ve = z(i.renderInline(Ee.value)), Xe = (de) => {
      Ve.value = i.renderInline(de ?? n.label);
    };
    return Le(h, (de) => {
      if (n.type == "date" && de) {
        if (!H.value) {
          try {
            T.value = Ia(de);
          } catch {
            T.value = null;
          }
          P.value = T.value;
        }
      } else
        n.format || (P.value = T.value), T.value = de;
    }), Le(A, (de) => {
      try {
        T.value = Ia(de), Ye();
      } catch {
        T.value = null;
      }
    }), Le(G, (de) => {
      const ke = qr();
      de ? ke.increaseOpenModals() : ke.decreaseOpenModals();
    }), Le(Ee, (de) => {
      Xe(de);
    }), Le(y, (de) => {
      if (M.value = !1, N.value = !1, Array.isArray(de))
        for (let ke of de)
          /too short/.test(ke.message.toLowerCase()) ? M.value = !0 : /too long/.test(ke.message.toLowerCase()) && (N.value = !0);
    }), Kr(window, "resize", ce), jr(() => {
      Fe();
    }), t({
      ...l.expose,
      focus: Oe,
      openDatePicker: ye,
      closeDatePicker: Fe
    }), (de, ke) => {
      const lt = oe("v-svg"), dt = oe("acquisit-string"), Je = oe("acquisit-button");
      return e.type != "data" ? (m(), S("div", {
        key: 0,
        class: pe(Ae.value),
        onClick: Oe,
        role: "presentation"
      }, [
        W("div", {
          class: "input-wrapper",
          style: we(Se.value),
          ref_key: "$inputWrapper",
          ref: Y,
          role: "presentation"
        }, [
          e.icon ? (m(), S("div", {
            key: 0,
            class: "icon",
            style: we(re.value),
            "data-tag": "icon",
            "aria-hidden": "true"
          }, [
            K(lt, { file: e.icon }, null, 8, ["file"])
          ], 4)) : B("", !0),
          p.value || de.$slots.default ? (m(), S("label", {
            key: 1,
            for: g(u).id,
            id: g(u).id + "-input-label",
            class: "label",
            "data-tag": "label",
            "aria-hidden": de.ariaLabel || de.ariaLabelledby ? "true" : "false"
          }, [
            p.value ? (m(), S("span", {
              key: 0,
              style: we(re.value),
              innerHTML: Ve.value
            }, null, 12, nI)) : B("", !0),
            at(de.$slots, "default")
          ], 8, aI)) : B("", !0),
          e.type != "data" ? Kt((m(), S("input", {
            key: 2,
            id: g(u).id,
            style: we(Se.value),
            class: pe(["input", { disabled: _.value, noInteract: $.value }]),
            type: e.type,
            name: g(u).uid.value,
            "aria-label": g(l).language.parse(de.ariaLabel),
            "aria-labelledby": de.ariaLabel ? void 0 : de.ariaLabelledby,
            "aria-disabled": _.value || $.value ? "true" : "false",
            "onUpdate:modelValue": ke[0] || (ke[0] = (ue) => T.value = ue),
            onClick: Ie,
            onFocus: fe,
            onChange: it,
            onInput: Re,
            onKeydown: he,
            onKeyup: X,
            onBlur: me,
            ref_key: "$input",
            ref: w,
            disabled: $.value || _.value,
            readonly: $.value || e.readonly || e.type == "date" && !g(V),
            min: e.type == "date" ? ae.value : void 0,
            max: e.type == "date" ? Te.value : void 0,
            tabindex: 0,
            autocomplete: e.autocomplete
          }, null, 46, oI)), [
            [jp, T.value]
          ]) : B("", !0),
          K(bt, { name: "fade" }, {
            default: ie(() => [
              e.suffix ? Kt((m(), S("div", lI, [
                K(dt, {
                  "font-size": "1rem",
                  source: e.suffix
                }, null, 8, ["source"])
              ], 512)), [
                [_r, b.value || T.value]
              ]) : B("", !0)
            ]),
            _: 1
          })
        ], 4),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            e.value_too_long_label && N.value ? (m(), S("div", sI, [
              K(lt, {
                file: "info/info-outline",
                "aria-hidden": "true"
              }),
              K(dt, { source: e.value_too_long_label }, null, 8, ["source"])
            ])) : B("", !0)
          ]),
          _: 1
        }),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            e.value_too_short_label && M.value ? (m(), S("div", iI, [
              K(lt, {
                file: "info/info-outline",
                "aria-hidden": "true"
              }),
              K(dt, { source: e.value_too_short_label }, null, 8, ["source"])
            ])) : B("", !0)
          ]),
          _: 1
        }),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            U.value.length ? (m(), S("div", uI, [
              (m(!0), S(qe, null, We(U.value, (ue) => (m(), J(hs, { error: ue }, null, 8, ["error"]))), 256))
            ])) : B("", !0)
          ]),
          _: 1
        }),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            !g(V) && x.value ? (m(), S("div", cI, [
              K(g(rI), {
                "is-inline": "",
                modelValue: A.value,
                "onUpdate:modelValue": ke[1] || (ke[1] = (ue) => A.value = ue),
                "title-position": "left",
                ref_key: "$datePicker",
                ref: E
              }, null, 8, ["modelValue"])
            ])) : B("", !0)
          ]),
          _: 1
        }),
        K(bt, { name: "move-fade-right" }, {
          default: ie(() => [
            e.qr && Q.value && !de.displayOnly ? (m(), S("div", {
              key: 0,
              class: "qr-code pdf-hidden",
              role: "presentation",
              ref_key: "$qrCodeButton",
              ref: R
            }, [
              K(Je, {
                type: "icon",
                icon: "acq/qrcode-scan",
                class: "qr-code-btn",
                iconSize: 20,
                size: 32,
                onClick: mt,
                disabled: _.value,
                "no-interact": $.value,
                "aria-label": e.qr_label
              }, null, 8, ["disabled", "no-interact", "aria-label"])
            ], 512)) : B("", !0)
          ]),
          _: 1
        }),
        (m(), J(Xt, { to: "body" }, [
          K(bt, { name: "fade" }, {
            default: ie(() => [
              G.value ? (m(), S("div", {
                key: 0,
                class: "acquisit-input-qr-overlay",
                ref_key: "$qrOverlay",
                ref: q,
                "aria-hidden": "true"
              }, null, 512)) : B("", !0)
            ]),
            _: 1
          })
        ])),
        (m(), J(Xt, { to: "body" }, [
          K(bt, {
            name: g(d) ? "zoom" : "zoom-top-right"
          }, {
            default: ie(() => [
              e.qr && G.value ? (m(), J(g(vb), {
                key: 0,
                ref_key: "$qrCodeWrapper",
                ref: L,
                camera: F.value,
                class: "acquisit-input-qr-code-wrapper",
                style: we(He.value),
                track: ot,
                onDetect: ft,
                onError: $e
              }, {
                default: ie(() => [
                  W("label", dI, [
                    K(lt, {
                      file: "acq/qrcode-scan",
                      class: "label-icon",
                      "aria-hidden": "true"
                    }),
                    K(dt, {
                      "font-size": "1.2rem",
                      color: "#fff"
                    }, {
                      default: ie(() => [
                        pt(je(p.value), 1)
                      ]),
                      _: 1
                    }),
                    at(de.$slots, "default")
                  ]),
                  O.value ? (m(), S("div", fI, [
                    e.qr_not_allowed_label && O.value == "not_allowed" ? (m(), J(dt, {
                      key: 0,
                      source: e.qr_not_allowed_label
                    }, null, 8, ["source"])) : e.qr_not_supported_label && (O.value == "not_supported" || O.value == "no_camera") ? (m(), J(dt, {
                      key: 1,
                      source: e.qr_not_supported_label
                    }, null, 8, ["source"])) : (m(), S(qe, { key: 2 }, [
                      pt(" Error: " + je(O.value), 1)
                    ], 64))
                  ])) : B("", !0),
                  W("div", vI, [
                    K(Je, {
                      type: "icon",
                      icon: "acq/clear",
                      color: "red",
                      class: "close-btn",
                      size: 32,
                      iconSize: 24,
                      "aria-label": e.qr_close_label,
                      onClick: nt
                    }, null, 8, ["aria-label"])
                  ])
                ]),
                _: 3
              }, 8, ["camera", "style"])) : B("", !0)
            ]),
            _: 3
          }, 8, ["name"])
        ]))
      ], 2)) : B("", !0);
    };
  }
}), mI = {
  key: 0,
  class: "empty"
}, hI = /* @__PURE__ */ Pe({
  __name: "Dropdown",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    searchable: {
      type: [Boolean, Number],
      required: !1,
      default: !1
    },
    searchLabel: {
      type: [String, Object],
      required: !1,
      default: null
    },
    options: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((ye) => ({
      dcba41a2: g(s).baseVisuallySafe.value.cssHSLA,
      "343a68da": g(s).baseVisuallySafe.value.withAlpha(0.13).cssHSLA
    }));
    const a = e, n = Dt("components/core/Dropdown", Dt.COLOR_COMPONENT), o = r, l = Ze(a, o), { color: s } = l, u = C(() => a.label && a.required ? l.language.parse(a.label) + '<span class="required">*</span>' : a.label), i = z(!1), c = z(ls(a.options) <= 10), d = z(0), p = z(44), h = z(), y = z(), _ = z({}), $ = z(), w = z(), L = z(), R = z(), q = z(), E = z(), Y = z(), V = z(), T = C(() => {
      let ye = [];
      for (let Fe in a.options)
        if (a.options.hasOwnProperty(Fe)) {
          const Me = a.options[Fe];
          typeof Me == "object" && Me !== null ? ye.push({
            label: Me.label,
            value: Me.value,
            disabled: Me.disabled ?? !1,
            icon: Me.icon ?? null
          }) : ye.push({
            label: Me ?? "",
            value: Fe,
            icon: null
          });
        }
      return ye;
    }), A = C(() => {
      const ye = String(G.value).toLocaleLowerCase();
      return T.value.filter((Fe) => String(l.language.parse(Fe.label)).toLocaleLowerCase().indexOf(ye) > -1);
    }), P = C(() => {
      for (let ye = 0; ye < T.value.length; ye++)
        if (T.value[ye] == D.value)
          return ye;
    }), b = C(() => typeof a.searchable == "number" ? T.value.length >= a.searchable : !!a.searchable), x = C(() => {
      for (let ye of T.value)
        if (ye.icon)
          return !0;
      return !1;
    }), D = C(() => {
      if (a.modelValue) {
        for (let ye of T.value)
          if (ye.value === a.modelValue)
            return ye;
      }
    }), N = C(() => i.value ? {
      color: s.base.value.cssHSLA,
      borderColor: s.base.value.cssHSLA
    } : a.disabled ? {
      background: s.backgroundLightTinted.value.cssHSLA,
      borderColor: s.backgroundLightTinted.value.cssHSLA
    } : void 0), M = C(() => i.value ? {
      color: s.base.value.cssHSLA
    } : {
      color: "#717E8E"
    }), H = C(() => {
      var ye;
      return {
        error: a.errors,
        erroring: l.erroring.value,
        active: i.value,
        filled: a.modelValue,
        "has-icon": ((ye = D.value) == null ? void 0 : ye.icon) || a.icon,
        "has-any-icon": x.value,
        disabled: a.disabled,
        "no-interact": a.noInteract,
        ["options-position-" + $.value]: $.value
      };
    }), U = C(() => {
      var ye;
      return {
        "has-icon": ((ye = D.value) == null ? void 0 : ye.icon) || a.icon,
        "has-any-icon": x.value,
        active: i.value
      };
    }), G = z(""), F = async () => {
      var ye;
      i.value ? O() : c.value ? (i.value = !0, await ut(), await Q(), b.value && !y.value && ((ye = Y.value) == null || ye.focus(), await ut()), he()) : (c.value = !0, await ut(), await F());
    }, O = () => {
      i.value = !1, _.value = {}, $.value = null, h.value = void 0, setTimeout(() => {
        G.value = "";
      }, 200);
    }, Q = async () => {
      var ce, mt;
      if (await ut(), !R.value) {
        $.value = null;
        return;
      }
      const ye = R.value, Fe = ((ce = E.value) == null ? void 0 : ce.getBoundingClientRect().height) ?? 0, Me = ((mt = w.value) == null ? void 0 : mt.getBoundingClientRect()) || { top: 0, left: 0, width: 10, height: 10 };
      _.value = {
        width: Me.width + "px",
        top: Me.top + "px",
        left: Me.left + "px",
        height: "fit-content"
      }, ae.value = 0, await ut();
      let He = 0;
      if (P.value !== void 0) {
        const nt = ye.querySelector(".acquisit-dropdown-item:nth-child(" + (P.value + 1) + ")");
        nt && (He = nt.offsetTop);
      }
      if (_.value.maxHeight = "100svh", await ut(), window.innerHeight - (Me.top + Me.height) < 128) {
        let nt = window.innerHeight - (Me.top + Me.height);
        nt < 0 && (nt = 0), _.value.top = "auto", _.value.bottom = nt + "px", _.value.maxHeight = window.innerHeight - nt + "px", await ut(), ye.scrollTop = He - Me.top + Fe, ae.value = ye.scrollTop;
      } else {
        let nt = Me.top - He - Fe;
        nt < 0 && (ye.scrollTop = He - Me.top + Fe, ae.value = ye.scrollTop, nt = 0), _.value.maxHeight = window.innerHeight - nt + "px", _.value.top = nt + "px";
      }
      await ut();
    }, ae = z(0), Te = (ye) => {
      var Fe, Me;
      ye.target && !((Fe = V.value) != null && Fe.contains(ye.target)) && !((Me = E.value) != null && Me.contains(ye.target)) ? O() : ye.preventDefault();
    }, Ae = (ye) => {
      y.value = ye.value, o("update:modelValue", y.value), Ie(), O();
    }, Ye = () => Ie(), Re = () => {
      h.value !== void 0 ? h.value = Math.max(0, Math.min((h.value ?? 0) + 1, A.value.length - 1)) : h.value = 0;
    }, it = () => {
      h.value !== void 0 ? h.value = Math.max(0, Math.min((h.value ?? 0) - 1, A.value.length - 1)) : h.value = A.value.length - 1;
    }, he = () => {
      const ye = (Fe) => {
        var ce;
        const Me = Fe.getOffsetTop(), He = ((ce = E.value) == null ? void 0 : ce.getBoundingClientRect().height) ?? 0;
        R.value.scrollTop = Math.max(Me - He, 0);
      };
      if (h.value !== void 0)
        ye(q.value[h.value]);
      else if (a.modelValue) {
        let Fe = 0, Me;
        for (let He of T.value) {
          if (He.value == a.modelValue) {
            Me = q[Fe];
            break;
          }
          Fe++;
        }
        Me && ye(Me);
      }
    }, X = async () => {
      i.value ? (it(), await ut(), he()) : await F();
    }, re = async () => {
      i.value ? (Re(), await ut(), he()) : await F();
    }, Se = async () => {
      i.value ? h.value !== void 0 && (Ae(A.value[h.value]), O()) : await F();
    }, me = async (ye) => {
      switch (ye.key || ye.code) {
        case "Enter":
          ye.preventDefault(), ye.stopPropagation(), await Se();
          break;
        case "ArrowUp":
          ye.preventDefault(), ye.stopPropagation(), await X();
          break;
        case "ArrowDown":
          ye.preventDefault(), ye.stopPropagation(), await re();
          break;
      }
    }, fe = async (ye) => {
      switch (ye.key || ye.code) {
        case "Tab":
        case "Enter":
          i.value && ye.preventDefault();
          break;
        case "ArrowUp":
          await X();
          break;
        case "ArrowDown":
          await re();
          break;
      }
    }, Oe = (ye) => {
      switch (ye.key || ye.code) {
        case "Enter":
          Se();
          break;
        case " ":
          ye.preventDefault(), F();
          break;
        case "Escape":
          O();
          break;
      }
    }, Ie = () => {
      if (i.value && O(), !w.value) {
        n.always.warnFrom("resize", "No wrapper found");
        return;
      }
      let ye = p.value;
      L.value && (!y.value && !d.value ? d.value = L.value.offsetHeight + 24 : d.value = 0, ye = Math.max(d.value, ye)), w.value.style.height = "auto", w.value.style.height = Math.max(ye, w.value.scrollHeight) + "px";
    };
    return Le(G, _c(() => {
      Q(), h.value = 0, he();
    }, 200)), St(() => {
      Ie();
    }), Kr(window, "click", Te), Kr(window, "resize", Ye), t({
      ...l.expose
    }), (ye, Fe) => {
      var nt, ot, ft;
      const Me = oe("v-svg"), He = oe("acquisit-string"), ce = oe("acquisit-input"), mt = oe("acquisit-dropdown-item");
      return m(), S("div", {
        class: pe(["acquisit-dropdown", H.value]),
        tabindex: 0,
        onKeydown: fe,
        onKeyup: Oe,
        ref_key: "$root",
        ref: V
      }, [
        W("button", {
          onClick: F,
          style: we(N.value),
          class: pe({ active: i.value }),
          ref_key: "$wrapper",
          ref: w,
          tabindex: -1
        }, [
          (nt = D.value) != null && nt.icon || e.icon ? (m(), J(Me, {
            key: 0,
            style: we(M.value),
            class: "icon",
            file: ((ot = D.value) == null ? void 0 : ot.icon) || e.icon
          }, null, 8, ["style", "file"])) : B("", !0),
          K(He, {
            class: "value",
            source: ((ft = D.value) == null ? void 0 : ft.label) ?? void 0
          }, null, 8, ["source"]),
          K(Me, {
            style: we(M.value),
            class: pe(["trigger", { active: i.value }]),
            file: "chevrons/up-down",
            "aria-hidden": "true"
          }, null, 8, ["style", "class"]),
          W("div", {
            class: "focus-ring",
            style: we({ borderColor: g(s).focusDark.value.cssHSLA })
          }, null, 4)
        ], 6),
        e.label ? (m(), S("label", {
          key: 0,
          class: pe(["placeholder", { active: i.value }, { filled: ye.modelValue }]),
          style: we(M.value)
        }, [
          e.label ? (m(), J(He, {
            key: 0,
            source: u.value,
            ref_key: "$label",
            ref: L
          }, null, 8, ["source"])) : B("", !0)
        ], 6)) : B("", !0),
        (m(), J(Xt, { to: "body" }, [
          K(bt, { name: "acquisit-dropdown" }, {
            default: ie(() => [
              c.value ? Kt((m(), S("ul", {
                key: 0,
                class: pe(["acquisit-dropdown-menu", U.value]),
                ref_key: "$menu",
                ref: R,
                style: we(_.value)
              }, [
                b.value ? (m(), S(qe, { key: 0 }, [
                  W("li", {
                    class: "search",
                    ref_key: "$search",
                    ref: E
                  }, [
                    K(ce, {
                      modelValue: G.value,
                      "onUpdate:modelValue": Fe[0] || (Fe[0] = ($e) => G.value = $e),
                      onKeydown: me,
                      label: e.searchLabel,
                      "hide-label-on-value": "",
                      ref_key: "$searchInput",
                      ref: Y,
                      icon: "acq/search"
                    }, null, 8, ["modelValue", "label"])
                  ], 512),
                  A.value.length ? B("", !0) : (m(), S("li", mI, " 😕 "))
                ], 64)) : B("", !0),
                (m(!0), S(qe, null, We(A.value, ($e, Qe) => (m(), J(mt, {
                  key: $e.value,
                  modelValue: $e.value,
                  label: $e.label,
                  icon: $e.icon,
                  disabled: $e.disabled ?? !1,
                  active: $e.value == ye.modelValue,
                  highlight: Qe == h.value,
                  onClick: (te) => Ae($e),
                  onMousemove: (te) => h.value = Qe,
                  ref_for: !0,
                  ref_key: "$option",
                  ref: q,
                  tabindex: 0
                }, null, 8, ["modelValue", "label", "icon", "disabled", "active", "highlight", "onClick", "onMousemove"]))), 128))
              ], 6)), [
                [_r, i.value]
              ]) : B("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
}), yI = /* @__PURE__ */ Pe({
  __name: "DropdownItem",
  props: {
    ...Ge(),
    modelValue: {
      required: !0
    },
    label: {
      type: [String, Object],
      required: !0
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    active: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    highlight: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "click",
    "keyup",
    "mousemove"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((c) => ({
      "69dbba1d": g(l).baseVisuallyAndContextSafe.value.cssHSLA
    }));
    const a = e, n = r, o = Ze(a, n), { color: l } = o;
    C(() => o.language.parse(a.label));
    const s = z(), u = () => {
      if (a.disabled)
        return !1;
      n("click", a.modelValue);
    }, i = (c) => {
      if (a.disabled)
        return !1;
      n("keyup", c);
    };
    return t({
      ...o.expose,
      $root: s,
      getBoundingClientRect: () => {
        var c;
        return (c = s.value) == null ? void 0 : c.getBoundingClientRect();
      },
      getOffsetTop: () => {
        var c;
        return (c = s.value) == null ? void 0 : c.offsetTop;
      }
    }), (c, d) => {
      const p = oe("v-svg"), h = oe("acquisit-string");
      return m(), S("li", {
        class: pe(["acquisit-dropdown-item", { active: e.active, highlight: e.highlight, disabled: e.disabled, "has-icon": e.icon }]),
        ref_key: "$root",
        ref: s,
        onClick: u,
        onKeyup: i,
        onMousemove: d[0] || (d[0] = (y) => c.$emit("mousemove", y))
      }, [
        e.icon ? (m(), J(p, {
          key: 0,
          class: "option-icon",
          file: e.icon
        }, null, 8, ["file"])) : B("", !0),
        K(h, {
          class: "label",
          source: e.label
        }, null, 8, ["source"]),
        e.active ? (m(), J(p, {
          key: 1,
          class: "active-icon",
          file: "acq/checkmark"
        })) : B("", !0)
      ], 34);
    };
  }
}), bI = ["aria-labelledby"], gI = {
  class: "string-container",
  tabindex: "-1"
}, _I = /* @__PURE__ */ Pe({
  __name: "Header",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const o = Ze(e, r), { color: l, uid: s } = o;
    return t({
      ...o.expose
    }), (u, i) => {
      const c = oe("acquisit-string");
      return m(), S("div", {
        class: "acquisit-header",
        tabindex: 0,
        role: "heading",
        "aria-labelledby": g(s).uid.value + "-label"
      }, [
        W("div", gI, [
          K(c, {
            class: "string",
            id: g(s).uid.value + "-label",
            source: e.label
          }, null, 8, ["id", "source"]),
          W("div", {
            class: "focus-ring",
            style: we({ borderColor: g(l).base.value.cssHSLA })
          }, null, 4)
        ])
      ], 8, bI);
    };
  }
}), wI = { class: "acquisit-component acquisit-icon" }, kI = /* @__PURE__ */ Pe({
  __name: "Icon",
  props: {
    ...Ge(),
    icon: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      required: !1,
      default: 20
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((i) => ({
      "080e9640": u.value,
      "29df7186": s.value.cssHSLA
    }));
    const a = e, o = Ze(a, r), { color: l } = o, s = C(() => l.base.value), u = C(() => a.size + "px");
    return t({
      ...o.expose
    }), (i, c) => {
      const d = oe("v-svg");
      return m(), S("div", wI, [
        K(d, {
          file: e.icon,
          class: "icon-svg"
        }, null, 8, ["file"])
      ]);
    };
  }
}), $I = { class: "acquisit-image" }, CI = ["src", "alt", "crossorigin"], SI = /* @__PURE__ */ Pe({
  __name: "Image",
  props: {
    ...Ge(),
    url: {
      type: [String, Object],
      required: !0
    },
    alt: {
      type: [String, Object],
      required: !1,
      default: ""
    },
    crossOrigin: {
      type: Boolean,
      required: !1,
      default: !0
    },
    spaceTop: {
      type: String,
      required: !1,
      default: "20px"
    },
    spaceBottom: {
      type: String,
      required: !1,
      default: "20px"
    },
    maxWidth: {
      type: String,
      required: !1,
      default: "100%"
    },
    maxHeight: {
      type: String,
      required: !1,
      default: "none"
    },
    align: {
      type: String,
      required: !1,
      default: "center"
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((u) => ({
      "317c6c19": e.spaceTop,
      c1186e32: e.spaceBottom,
      "3041e4ca": e.align,
      "615f5f28": e.maxWidth,
      "00eac341": e.maxHeight
    }));
    const a = e, o = Ze(a, r), { color: l } = o, s = C(() => o.language.parse(a.url));
    return t({
      ...o.expose
    }), (u, i) => (m(), S("div", $I, [
      W("div", {
        class: pe(["image-wrapper", "align-" + e.align])
      }, [
        W("img", {
          src: s.value,
          alt: g(o).language.parse(e.alt) ?? "",
          crossorigin: e.crossOrigin ? "anonymous" : void 0
        }, null, 8, CI)
      ], 2)
    ]));
  }
}), xI = ["href", "aria-label"], DI = {
  class: "image",
  tabindex: -1
}, AI = {
  key: 0,
  class: "icon-wrapper"
}, PI = {
  key: 1,
  class: "ripple-container",
  "aria-hidden": "true"
}, OI = /* @__PURE__ */ Pe({
  __name: "ImageButton",
  props: {
    ...Ge(),
    ...ds(),
    image: {
      type: [String, Object],
      required: !0
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    alt: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    maxWidth: {
      type: String,
      required: !1,
      default: "100%"
    },
    maxHeight: {
      type: String,
      required: !1,
      default: "none"
    },
    align: {
      type: String,
      required: !1,
      default: "center"
    }
  },
  emits: [
    ...Ke(),
    ...cs(),
    "click"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((y) => ({
      "32b20b1e": p.value.cssHSLA,
      "733f28b2": e.maxWidth,
      fec53544: g(i).baseVisuallySafe.value.cssHSLA,
      "27b539cb": g(i).focusDark.value.cssHSLA,
      fb2b7d1a: d.value.cssHSLA
    }));
    const a = e, n = r, o = z(), l = fs(a, n), s = vs(o), u = Ze(a, n), { color: i } = u, c = C(() => u.language.parse(a.image)), d = C(() => i.baseVisuallySafe.value.mixWith(i.parse("input-border-light"), 10).withLightness(0.94)), p = C(() => i.baseVisuallySafe.value.mixWith(i.parse("input-border-light"), 10)), h = (y) => {
      a.noInteract || (a.disabled || s.click(y), l.click(y), u.guards.emit("clicked"));
    };
    return t({
      ...u.expose
    }), (y, _) => {
      const $ = oe("acquisit-image"), w = oe("v-svg");
      return m(), S("a", {
        class: "acquisit-image-button",
        href: g(l).niceHref.value ?? void 0,
        onClick: h,
        onKeyup: Jt(h, ["enter"]),
        ref_key: "$root",
        ref: o,
        role: "button",
        "aria-label": g(u).language.parse(e.alt),
        tabindex: 0
      }, [
        W("div", DI, [
          K($, {
            url: c.value,
            align: e.align,
            "max-width": e.maxWidth,
            "max-height": e.maxHeight,
            alt: e.alt,
            "space-bottom": null,
            "space-top": null
          }, null, 8, ["url", "align", "max-width", "max-height", "alt"]),
          _[0] || (_[0] = W("div", { class: "focus-ring" }, null, -1))
        ]),
        e.icon ? (m(), S("div", AI, [
          K(w, {
            file: e.icon,
            class: "icon"
          }, null, 8, ["file"])
        ])) : B("", !0),
        y.noInteract ? B("", !0) : (m(), S("div", PI, [
          K(Sr, {
            name: "ripple",
            onBeforeEnter: g(s).onBeforeEnter,
            onAfterEnter: g(s).clearLast,
            appear: ""
          }, {
            default: ie(() => [
              (m(!0), S(qe, null, We(g(s).ripples.value, (L) => (m(), S("span", {
                class: "ripple",
                key: L,
                style: we(g(s).style)
              }, null, 4))), 128))
            ]),
            _: 1
          }, 8, ["onBeforeEnter", "onAfterEnter"])
        ]))
      ], 40, xI);
    };
  }
}), TI = ["aria-labelledby"], II = {
  class: "wrapper",
  tabindex: -1
}, MI = { class: "icon" }, qI = ["id"], EI = /* @__PURE__ */ Pe({
  __name: "InfoBox",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    type: {
      type: String,
      required: !1,
      default: "info",
      validator(e) {
        return ["branded", "plain", "info", "warning", "error", "success"].indexOf(e) > -1;
      }
    },
    theme: {
      type: String,
      required: !1,
      default: "light"
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { emit: t }) {
    zt((d) => ({
      "1bb8fa80": s.value.cssHSLA,
      "2f9c71a1": u.value.cssHSLA,
      fd7a9456: i.value.cssHSLA,
      "5a50a002": g(l).baseVisuallyAndContextSafe.value.cssHSLA
    }));
    const r = e, n = Ze(r, t), { uid: o, color: l } = n, s = C(() => l.baseVisuallyAndContextSafe.value.mixWith(l.white, 12)), u = C(() => l.baseVisuallyAndContextSafe.value.darken(8)), i = C(() => s.value.darken(6)), c = C(() => {
      switch (r.type) {
        case "info":
          return l.parse("info").darken(18);
        case "warning":
          return l.parse("orange").darken(18);
        case "error":
          return l.parse("red").darken(18);
        case "success":
          return l.parse("green").darken(18);
        default:
          return u.value;
      }
    });
    return (d, p) => {
      const h = oe("v-svg"), y = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-info-box", "type-" + e.type, "theme-" + e.theme, { erroring: g(n).erroring.value }]),
        tabindex: 0,
        "aria-labelledby": g(o).uid.value + "-label"
      }, [
        W("div", II, [
          p[0] || (p[0] = W("div", { class: "focus-ring" }, null, -1)),
          W("span", MI, [
            e.type == "warning" ? (m(), J(h, {
              key: 0,
              file: "info/warning"
            })) : e.type == "error" ? (m(), J(h, {
              key: 1,
              file: "info/error"
            })) : e.type == "plain" || e.type == "branded" ? (m(), J(h, {
              key: 2,
              file: "info/info-outline"
            })) : (m(), J(h, {
              key: 3,
              file: "info/info"
            }))
          ]),
          e.label ? (m(), J(y, {
            key: 0,
            class: "label",
            id: g(o).uid.value + "-label",
            source: e.label,
            "link-color": c.value
          }, null, 8, ["id", "source", "link-color"])) : (m(), S("span", {
            key: 1,
            class: "label",
            id: g(o).uid.value + "-label"
          }, [
            at(d.$slots, "default")
          ], 8, qI))
        ])
      ], 10, TI);
    };
  }
}), VI = {
  class: "acquisit-markdown",
  role: "presentation"
}, LI = ["innerHTML"], Yf = /* @__PURE__ */ Pe({
  __name: "Markdown",
  props: {
    anchorAttributes: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    source: {
      type: String,
      required: !1,
      default: null
    },
    prerender: {
      type: Function,
      required: !1,
      default: void 0
    },
    afterrender: {
      type: Function,
      required: !1,
      default: void 0
    }
  },
  setup(e) {
    const t = e, r = new km({
      breaks: !0,
      linkify: !0,
      typographer: !1,
      quotes: "«»„“",
      xhtmlOut: !0,
      html: !0
    }), a = r.renderer.rules.link_open || function(u, i, c, d, p) {
      return p.renderToken(u, i, c);
    };
    r.renderer.rules.link_open = (u, i, c, d, p) => (Object.keys(t.anchorAttributes).map((h) => {
      let y = u[i].attrIndex(h), _ = t.anchorAttributes[h];
      y < 0 ? u[i].attrPush([h, _]) : u[i].attrs[y][1] = _;
    }), a(u, i, c, d, p));
    const n = z(), o = (u) => {
      let i = "";
      if ((u == null ? void 0 : u.type.toString()) == Symbol("Text").toString())
        i += u.children;
      else if (Array.isArray(u == null ? void 0 : u.children))
        for (let c of u.children) {
          let d = o(c);
          d && (i += d);
        }
      return i || null;
    }, l = fc(), s = C(() => {
      var u;
      if (t.source) {
        let i = t.source;
        return t.prerender && (i = t.prerender(i)), r.render(i);
      } else if (l.default) {
        let i = "";
        if (n.value)
          i = ((u = n.value) == null ? void 0 : u.innerText) || "";
        else {
          const c = l.default({});
          for (let d of c)
            i += o(d);
        }
        return t.prerender && (i = t.prerender(i)), r.render(i);
      }
      return null;
    });
    return Le(s, (u) => {
      var i;
      (i = t.afterrender) == null || i.call(t, u);
    }, {
      immediate: !0
    }), (u, i) => (m(), S("span", VI, [
      W("span", {
        class: "rendered",
        role: "presentation",
        innerHTML: s.value
      }, null, 8, LI),
      W("span", {
        class: "acquisit-markdown-shadow",
        ref_key: "$shadow",
        ref: n
      }, [
        at(u.$slots, "default")
      ], 512)
    ]));
  }
}), BI = { class: "acquisit-pagination" }, jI = { class: "view-settings" }, HI = {
  key: 0,
  class: "total"
}, RI = {
  key: 1,
  class: "per-page"
}, FI = { class: "pagination-pages" }, NI = /* @__PURE__ */ Pe({
  __name: "Pagination",
  props: {
    ...Ge(),
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    },
    perPage: {
      type: Number,
      required: !1,
      default: void 0
    },
    perPageLabel: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    perPageOptions: {
      type: Array,
      required: !1,
      default() {
        return [10, 20, 40, 60, 80, 100];
      }
    },
    loadingPages: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    windowSize: {
      type: Number,
      required: !1,
      default: 3
    },
    showExtremeButtons: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: [
    ...Ke(),
    "switchPage",
    "update:currentPage",
    "update:perPage"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l } = o, s = C({
      get() {
        return String(a.perPage);
      },
      set(d) {
        n("update:perPage", parseInt(d, 10));
      }
    }), u = C(() => {
      let d = kt(a.perPageOptions);
      return a.perPage && d.indexOf(a.perPage) === -1 && (d.push(a.perPage), d = d.sort()), Ft(d, (p) => String(p), (p) => ({
        value: String(p),
        label: String(p),
        disabled: s.value == String(p)
      }));
    }), i = C(() => {
      let d = Math.max(a.currentPage - a.windowSize, 0), p = Math.min(a.currentPage + Math.min(a.windowSize, a.totalPages), a.totalPages - 1);
      if (a.totalPages > a.windowSize && a.currentPage < a.windowSize && (p += a.windowSize - a.currentPage), a.totalPages > a.windowSize && a.currentPage >= a.totalPages - a.windowSize) {
        const y = a.currentPage - (a.totalPages - a.windowSize) + 1;
        d -= y;
      }
      const h = p - d;
      return [...new Array(h + 1)].map((y, _) => _ + d);
    }), c = (d) => {
      d < 0 || d > a.totalPages - 1 || (n("switchPage", d), n("update:currentPage", d));
    };
    return t({
      ...o.expose
    }), (d, p) => {
      const h = oe("acquisit-dropdown"), y = oe("acquisit-button");
      return m(), S("div", BI, [
        W("div", jI, [
          d.$slots.total ? (m(), S("div", HI, [
            at(d.$slots, "total")
          ])) : B("", !0),
          e.perPage !== void 0 ? (m(), S("div", RI, [
            K(h, {
              options: u.value,
              label: e.perPageLabel,
              language: d.language,
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              modelValue: s.value,
              "onUpdate:modelValue": p[0] || (p[0] = (_) => s.value = _)
            }, null, 8, ["options", "label", "language", "color", "theme", "no-interact", "modelValue"])
          ])) : B("", !0)
        ]),
        W("ul", FI, [
          e.showExtremeButtons ? (m(), S("li", {
            key: 0,
            class: pe(["pagination-page", "first", { hidden: e.currentPage <= e.windowSize }])
          }, [
            K(y, {
              icon: "chevrons/double-left",
              bordered: "",
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              onClick: p[1] || (p[1] = (_) => c(0)),
              type: "action"
            }, null, 8, ["color", "theme", "no-interact"])
          ], 2)) : B("", !0),
          W("li", {
            class: pe(["pagination-page", "previous", { hidden: e.currentPage <= 0 }])
          }, [
            K(y, {
              icon: "chevrons/left",
              bordered: "",
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              onClick: p[2] || (p[2] = (_) => c(e.currentPage - 1)),
              type: "action"
            }, null, 8, ["color", "theme", "no-interact"])
          ], 2),
          (m(!0), S(qe, null, We(i.value, (_) => (m(), S("li", {
            key: "page-" + String(_),
            class: pe(["pagination-page", "number", { selected: _ == e.currentPage }])
          }, [
            K(y, {
              label: String(_ + 1),
              bordered: _ !== e.currentPage,
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              onClick: ($) => c(_),
              type: "action"
            }, null, 8, ["label", "bordered", "color", "theme", "no-interact", "onClick"])
          ], 2))), 128)),
          W("li", {
            class: pe(["pagination-page", "next", { hidden: e.currentPage >= e.totalPages - 1 }])
          }, [
            K(y, {
              icon: "chevrons/right",
              bordered: "",
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              onClick: p[3] || (p[3] = (_) => c(e.currentPage + 1)),
              type: "action"
            }, null, 8, ["color", "theme", "no-interact"])
          ], 2),
          e.showExtremeButtons ? (m(), S("li", {
            key: 1,
            class: pe(["pagination-page", "last", { hidden: e.currentPage > e.totalPages - e.windowSize * 2 + 1 }])
          }, [
            K(y, {
              icon: "chevrons/double-right",
              bordered: "",
              color: g(l).base.value,
              theme: g(l).theme.value,
              "no-interact": d.noInteract,
              onClick: p[4] || (p[4] = (_) => c(e.totalPages - 1)),
              type: "action"
            }, null, 8, ["color", "theme", "no-interact"])
          ], 2)) : B("", !0)
        ])
      ]);
    };
  }
}), YI = ["aria-labelledby"], UI = {
  class: "icon left",
  key: "icon-left",
  "data-tag": "icon-left"
}, zI = ["id"], WI = { key: 0 }, KI = {
  class: "icon right",
  key: "icon-icon",
  "data-tag": "icon-right"
}, GI = {
  class: "ripple-container",
  key: "ripple-container",
  "aria-hidden": "true"
}, ZI = /* @__PURE__ */ Pe({
  __name: "PillButton",
  props: {
    ...Ge(),
    ...ds(),
    icon: {
      type: String,
      required: !1,
      default: null
    },
    side: {
      type: String,
      required: !1,
      default: "left",
      validator(e) {
        return ["left", "right"].indexOf(e) > -1;
      }
    },
    bordered: {
      type: Boolean,
      required: !1,
      default: !1
    },
    dark: {
      type: Boolean,
      required: !1,
      default: !1
    },
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    ...cs(),
    "keypress",
    "keypress.enter"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((V) => ({
      "0a2e278a": g(l).textDark.value.cssHSLA
    }));
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s } = o, { noInteract: u } = nr(a), i = z(), c = vs(i), d = fs(a, n), { theme: p, container: h } = l, y = C(() => !!a.color), _ = C(() => a.colorContainer ? h.value.isWhite() ? l.base.value : h.value.isSimilarTo(l.base.value, 0.95) ? h.value.isDark() ? l.white : h.value.darken(32) : h.value.isDark() ? l.ensureIdealContrast("dark", h.value, l.base.value) : l.ensureIdealContrast("light", h.value, l.base.value) : l.base.value), $ = C(() => a.bordered ? L.value : _.value.perceivedBrightness < 230 ? l.focusLight.value : l.focusDark.value), w = C(() => {
      let V = Math.min(1, Math.max(0, _.value.alpha)), T = {}, A = {}, P = {}, b;
      if (h.value.isWhite() || y.value || h.value.contrastTo(l.base.value) > 2.4 ? b = l.base.value : b = L.value, a.bordered)
        b = l.ensureIdealContrast(l.theme.value, h.value, b, 2.4), T = {
          borderColor: b.cssHSLA,
          color: b.cssHSLA,
          boxShadow: "none"
        }, A = {
          background: b.withAlpha(0.3).cssHSLA
        }, P = {
          background: T.color
        };
      else {
        let x = l.textContrastFor(b);
        T = {
          background: b.cssHSLA,
          color: x.cssHSLA,
          boxShadow: `0px 2px 4px ${b.withAlpha(0.3 * V).cssHSLA},
							0px 2px 5px ${b.darken(16).withAlpha(0.2 * V).cssHSLA}`
        }, A = {
          background: x.withAlpha(0.3).cssHSLA
        }, P = {
          background: x.cssHSLA
        }, b.perceivedBrightness > 200 && (T.boxShadow = "none"), a.disabled && (T.background = R.value, T.color = q.value, T.boxShadow = "none");
      }
      return {
        wrapper: T,
        hover: A,
        ripple: P
      };
    }), L = C(() => l.ensureIdealContrast(p.value, l.container.value, _.value)), R = C(() => {
      let V = h.value.perceivedBrightness > 220 ? 94 : 80;
      return h.value.mixWith(L.value, V);
    }), q = C(() => l.textContrastFor(R.value).mixWith(R.value, 44)), E = (V) => {
      a.disabled || a.noInteract || (d.click(V), V.type == "click" && c.click(V));
    }, Y = (V) => {
      n("keypress", V), n("keypress.enter", V);
    };
    return t({
      ...o.expose
    }), (V, T) => {
      const A = oe("v-svg"), P = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-pill-button", { "has-icon": e.icon, "no-interact": g(u), bordered: e.bordered, disabled: e.disabled }]),
        tabindex: 0,
        style: we(w.value.wrapper),
        "aria-labelledby": g(s).id + "-label",
        onKeypress: Jt(Y, ["enter"]),
        ref_key: "$root",
        ref: i,
        role: "button"
      }, [
        W("div", {
          class: "wrapper",
          onClick: E,
          tabindex: "-1",
          "aria-hidden": "true"
        }, [
          K(Sr, {
            name: "pill-button-transition",
            tag: "div",
            class: "transition-wrapper"
          }, {
            default: ie(() => [
              e.icon && e.side == "left" ? (m(), S("div", UI, [
                K(A, {
                  "aria-hidden": "true",
                  file: e.icon,
                  class: "icon left"
                }, null, 8, ["file"])
              ])) : B("", !0),
              W("div", {
                class: "label",
                key: "label",
                id: g(s).id + "-label",
                "aria-hidden": "false",
                "data-tag": "label"
              }, [
                e.label ? (m(), S("label", WI, [
                  K(P, {
                    "font-size": "inherit",
                    source: e.label
                  }, null, 8, ["source"])
                ])) : at(V.$slots, "default", { key: 1 }, void 0, !0)
              ], 8, zI),
              e.icon && e.side == "right" ? (m(), S("div", KI, [
                K(A, {
                  file: e.icon,
                  "aria-hidden": "true"
                }, null, 8, ["file"])
              ])) : B("", !0),
              g(u) ? B("", !0) : (m(), S("div", GI, [
                K(Sr, {
                  name: "ripple",
                  onBeforeEnter: g(c).onBeforeEnter,
                  onAfterEnter: g(c).clearLast,
                  appear: ""
                }, {
                  default: ie(() => [
                    (m(!0), S(qe, null, We(g(c).ripples.value, (b) => (m(), S("span", {
                      class: "ripple",
                      key: b,
                      style: we(w.value.ripple)
                    }, null, 4))), 128))
                  ]),
                  _: 1
                }, 8, ["onBeforeEnter", "onAfterEnter"]),
                W("div", {
                  class: "hover-background",
                  style: we(w.value.hover)
                }, null, 4),
                W("div", {
                  class: "focus-ring",
                  style: we({ borderColor: $.value.cssHSLA })
                }, null, 4)
              ]))
            ]),
            _: 3
          })
        ])
      ], 46, YI);
    };
  }
}), Yn = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [a, n] of t)
    r[a] = n;
  return r;
}, XI = /* @__PURE__ */ Yn(ZI, [["__scopeId", "data-v-dd2f8d8f"]]), JI = ["disabled", "min", "max", "step", "id"], QI = /* @__PURE__ */ Pe({
  __name: "RangeSlider",
  props: {
    ...Ge(),
    min: {
      type: Number,
      required: !1,
      default: 0
    },
    max: {
      type: Number,
      required: !1,
      default: 100
    },
    step: {
      type: Number,
      required: !1,
      default: 1
    },
    modelValue: {
      type: Number,
      required: !1,
      default: 0
    },
    showValue: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((L) => ({
      "59cfb247": i.value,
      "6545feb4": u.value,
      c43793aa: c.value,
      "563cc14a": d.value,
      "563cc14b": p.value
    }));
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s } = o, u = C(() => l.baseVisuallySafe.value.cssHSLA), i = C(() => l.baseVisuallySafe.value.rgbArray.join(", ")), c = C(() => l.textContrast.value.cssHSLA), d = C(() => l.baseVisuallySafe.value.withAlpha(0.3).cssHSLA), p = C(() => l.baseVisuallySafe.value.darken(16).withAlpha(0.2).cssHSLA), h = z(a.modelValue), y = C(() => (Number(h.value) - a.min) / (a.max - a.min)), _ = C(() => ({
      width: `calc(${y.value * 100}% + 2px)`
    })), $ = C(() => ({
      left: `calc(${y.value * 100}% - (${y.value} * 18px))`
    })), w = () => {
      a.modelValue != h.value && n("update:modelValue", Number(h.value));
    };
    return an(() => {
      h.value = a.modelValue;
    }), t({
      ...o.expose
    }), (L, R) => (m(), S("div", {
      class: pe(["acquisit-range-slider", { noInteract: L.noInteract, disabled: L.disabled }])
    }, [
      W("div", {
        class: "progress-line",
        style: we(_.value)
      }, null, 4),
      W("div", {
        class: "thumb-effect",
        style: we($.value)
      }, null, 4),
      e.showValue ? (m(), S("div", {
        key: 0,
        class: "value-display",
        style: we($.value)
      }, [
        W("span", null, je(h.value), 1)
      ], 4)) : B("", !0),
      Kt(W("input", {
        type: "range",
        class: "slider",
        "onUpdate:modelValue": R[0] || (R[0] = (q) => h.value = q),
        disabled: L.disabled ? !0 : void 0,
        min: e.min,
        max: e.max,
        step: e.step,
        id: g(s).id,
        onInput: w
      }, null, 40, JI), [
        [Hp, h.value]
      ])
    ], 2));
  }
}), eM = /* @__PURE__ */ Pe({
  __name: "Spacer",
  props: {
    ...Ge(),
    size: {
      type: [String],
      required: !0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const a = {
      micro: 2,
      tiny: 8,
      small: 16,
      regular: 24,
      big: 32,
      huge: 48
    }, n = e, l = Ze(n, r), { color: s } = l, u = C(() => a[n.size] ? {
      height: a[n.size] + "px"
    } : {
      height: n.size
    });
    return t({
      ...l.expose
    }), (i, c) => (m(), S("div", {
      class: "acquisit-spacer",
      style: we(u.value)
    }, null, 4));
  }
}), tM = ["tabindex", "aria-labelledby"], rM = {
  class: "string-container",
  tabindex: "-1"
}, aM = /* @__PURE__ */ Pe({
  __name: "Span",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !0
    },
    weight: {
      type: Number,
      required: !1,
      default: 400
    },
    font_size: {
      type: String,
      required: !1,
      default: void 0
    },
    highlight: {
      type: Boolean,
      required: !1,
      default: !1
    },
    highlightColor: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    align: {
      type: String,
      required: !1,
      default: "left"
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    space_top: {
      type: Boolean,
      required: !1,
      default: !0
    },
    space_bottom: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((d) => ({
      "39da03d0": e.align,
      "268e6f0d": e.weight,
      "1e220776": c.value,
      cf81cce4: g(l).backgroundHighlight.value.cssHSLA,
      "14d7f2a2": g(l).textHighlight.value.cssHSLA
    }));
    const a = e, o = Ze(a, r), { color: l, uid: s } = o, u = C(() => o.language.parse(a.label)), i = C(() => {
      var p;
      if (typeof document > "u")
        return !!((p = u.value) != null && p.length);
      let d = document.createElement("div");
      return d.innerHTML = u.value, !!d.textContent;
    }), c = C(() => a.font_size ?? "1.067rem");
    return t({
      ...o.expose
    }), (d, p) => {
      const h = oe("v-svg");
      return m(), S("span", {
        class: pe(["acquisit-span", { "space-top": e.space_top, "space-bottom": e.space_bottom }]),
        tabindex: i.value ? 0 : void 0,
        "aria-labelledby": g(s).id + "-label"
      }, [
        W("span", rM, [
          e.icon ? (m(), J(h, {
            key: 0,
            class: "icon",
            color: g(l).hasSpecificColor.value ? g(l).base.value : void 0,
            file: e.icon
          }, null, 8, ["color", "file"])) : B("", !0),
          K(Yf, {
            class: pe(["string", { highlighted: e.highlight }]),
            anchorAttributes: { target: "_blank", style: "color: " + g(l).baseVisuallySafe.value.cssHSLA },
            id: g(s).id + "-label",
            style: we({ color: g(l).hasSpecificColor.value ? g(l).base.value.cssHSLA : void 0 }),
            source: u.value
          }, null, 8, ["class", "anchorAttributes", "id", "style", "source"]),
          W("div", {
            class: "focus-ring",
            style: we({ borderColor: g(l).baseVisuallySafe.value.cssHSLA })
          }, null, 4)
        ])
      ], 10, tM);
    };
  }
}), nM = /* @__PURE__ */ Pe({
  __name: "Spinner",
  props: {
    ...Ge(),
    spinning: {
      type: Boolean,
      required: !1,
      default: !0
    },
    size: {
      type: String,
      required: !1,
      default: "regular",
      validator: function(e) {
        return ["regular", "small", "mini", "tiny"].indexOf(e) > -1;
      }
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { emit: t }) {
    const r = e, a = t, { color: n } = Ze(r, a), o = C(() => ({
      borderColor: n.base.value.cssHex == "#ffffff" ? n.base.value.cssHSLA : n.baseVisuallySafe.value.cssHSLA
    }));
    return (l, s) => (m(), S("div", {
      class: pe(["acquisit-spinner", "size-" + e.size, { "full-width": e.fullWidth }]),
      role: "progressbar",
      "aria-busy": "true",
      "aria-live": "assertive"
    }, [
      W("span", {
        class: pe(["spinner", { spinning: e.spinning }]),
        "aria-hidden": "true"
      }, [
        W("span", {
          class: "before",
          style: we(o.value)
        }, null, 4),
        s[0] || (s[0] = W("span", { class: "after" }, null, -1))
      ], 2)
    ], 2));
  }
}), oM = ["aria-labelledby", "id"], lM = {
  class: "stepper-wrapper",
  tabindex: "-1"
}, sM = ["aria-label"], iM = { class: "meta" }, uM = ["value", "disabled"], cM = ["aria-label"], dM = /* @__PURE__ */ Pe({
  __name: "Stepper",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    min: {
      type: Number,
      required: !1,
      default: void 0
    },
    max: {
      type: Number,
      required: !1,
      default: void 0
    },
    step: {
      type: Number,
      required: !1,
      default: 1
    },
    increase_aria_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    decrease_aria_label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s, erroring: u } = o, { errors: i, noInteract: c, disabled: d } = nr(a), p = z(a.modelValue || a.min || 0), h = z(!1), y = z(), _ = C(() => a.min !== void 0 && a.min !== null && p.value <= a.min), $ = C(() => a.max !== void 0 && a.max !== null && p.value >= a.max), w = () => {
      if (a.noInteract || a.disabled)
        return;
      let T = Number(p.value) + Number(a.step);
      a.max !== void 0 && a.max !== null && T > a.max && (T = Number(a.max)), p.value = T, V();
    }, L = () => {
      if (a.noInteract || a.disabled)
        return;
      let T = Number(p.value) - Number(a.step);
      a.min !== void 0 && a.min !== null && T < a.min && (T = Number(a.min)), p.value = T, V();
    }, R = (T) => {
      if (a.noInteract || a.disabled) {
        T.preventDefault();
        return;
      }
      let A = T.key == "Backspace", P = /^\d+$/.test(T.key), b = T.metaKey || T.ctrlKey, x = T.key == "ArrowLeft" || T.key == "ArrowRight", D = T.key == "Tab";
      !A && !P && !b && !x && !D ? T.preventDefault() : (p.value = Number(T.target.value), V());
    }, q = () => {
      h.value = !0;
    }, E = (T) => {
      if (h.value = !1, a.noInteract || a.disabled)
        return;
      let A = Number(T.target.value), P = A !== p.value;
      a.max !== void 0 && a.max !== null && A > a.max ? A = a.max : a.min !== void 0 && a.min !== null && A < a.min && (A = a.min), p.value = A, T.target.value = p.value, P && V();
    }, Y = () => {
      var T;
      (T = y.value) == null || T.focus();
    }, V = () => {
      n("update:modelValue", p.value);
    };
    return t({
      ...o.expose,
      increase: w,
      decrease: L,
      focus: Y
    }), (T, A) => {
      const P = oe("v-svg"), b = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-stepper", { disabled: g(d), "no-interact": g(c), focused: h.value, error: g(i), erroring: g(u) }]),
        "aria-labelledby": g(s).id + "-label",
        id: g(s).id,
        tabindex: "-1"
      }, [
        W("div", lM, [
          W("a", {
            role: "button",
            class: pe(["action", "decrease", { disabled: _.value || g(d) || g(c) }]),
            onClick: L,
            onKeyup: Jt(L, ["enter"]),
            "aria-label": g(o).language.parse(e.increase_aria_label),
            tabindex: 0
          }, [
            K(P, {
              class: "action-icon",
              file: "acq/minus"
            }),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(l).focusDark.value.cssHSLA }),
              "aria-hidden": "true"
            }, null, 4)
          ], 42, sM),
          W("div", iM, [
            e.label ? (m(), J(b, {
              key: 0,
              id: g(s) + "-label",
              source: e.label,
              class: "label",
              onClick: Y
            }, null, 8, ["id", "source"])) : B("", !0),
            W("input", {
              type: "number",
              class: "model-input",
              value: p.value,
              onKeydown: R,
              onBlur: E,
              onFocus: q,
              disabled: g(d) || g(c),
              ref_key: "$input",
              ref: y
            }, null, 40, uM),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(l).focusDark.value.cssHSLA }),
              "aria-hidden": "true"
            }, null, 4)
          ]),
          W("a", {
            role: "button",
            class: pe(["action", "increase", { disabled: $.value || g(d) || g(c) }]),
            onClick: w,
            onKeyup: Jt(w, ["enter"]),
            "aria-label": g(o).language.parse(e.decrease_aria_label),
            tabindex: 0
          }, [
            K(P, {
              class: "action-icon",
              file: "acq/plus"
            }),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(l).focusDark.value.cssHSLA }),
              "aria-hidden": "true"
            }, null, 4)
          ], 42, cM)
        ])
      ], 10, oM);
    };
  }
}), fM = ["innerHTML"], vM = /* @__PURE__ */ Pe({
  __name: "String",
  props: {
    ...Ge(),
    weight: {
      type: Number,
      required: !1,
      default: void 0
    },
    fontSize: {
      type: String,
      required: !1,
      default: void 0
    },
    linkColor: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    align: {
      type: String,
      required: !1,
      default: void 0
    },
    source: {
      type: [String, Object],
      required: !1,
      default: ""
    },
    html: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "link-click"
  ],
  setup(e, { emit: t }) {
    const r = e, a = t, n = Ze(r, a), { color: o } = n, l = z(), s = z(), u = {}, i = C(() => n.language.parse(r.source));
    C(() => n.language.parse(r.html));
    const c = (y) => {
      y.preventDefault(), a("link-click", y.target);
    }, d = (y) => y.replace(/\n([^\n0-9\-*])/g, " $1"), p = async () => {
      await ut(), h();
    }, h = () => {
      if (!l.value)
        return;
      ((l.value.$el ? l.value.$el : l.value).querySelectorAll("a") || []).forEach(($) => {
        let w = $.cloneNode(!0);
        if (w.classList.contains("button"))
          w.style.borderColor = o.baseVisuallyAndContextSafe.value.cssHSLA, w.style.color = o.baseVisuallyAndContextSafe.value.cssHSLA;
        else {
          let L = r.linkColor || o.baseVisuallySafe.value;
          if (typeof L != "string" && (L = L.cssHSLA), w.style.color = L, w.style.borderBottom = "1px solid", w.dataset && w.dataset.action) {
            let R = xr("action-");
            u[R] = c, w.setAttribute("id", R), w.setAttribute("href", "#"), w.addEventListener("click", u[R]);
          } else
            w.setAttribute("target", "_blank");
        }
        $.parentNode.replaceChild(w, $);
      });
    };
    return St(() => {
      r.html && h();
    }), jr(() => {
      var y;
      for (let _ in u)
        if (u.hasOwnProperty(_)) {
          let $ = (y = l.value) == null ? void 0 : y.$el.querySelector("a#" + _);
          $ && $.removeEventListener("click", u[_]);
        }
    }), (y, _) => {
      const $ = oe("acquisit-markdown");
      return e.html ? (m(), S("div", {
        key: 0,
        class: pe(["acquisit-string", { weight: e.weight }]),
        ref_key: "rootHtml",
        ref: s,
        role: "presentation",
        style: we({ fontSize: e.fontSize, color: g(o).hasSpecificColor.value ? g(o).base.value.cssHSLA : void 0 }),
        innerHTML: e.html
      }, null, 14, fM)) : (m(), J($, {
        key: 1,
        class: pe(["acquisit-string", { weight: e.weight }]),
        ref_key: "root",
        ref: l,
        anchorAttributes: { target: "_blank" },
        source: i.value,
        prerender: d,
        afterrender: p,
        style: we({ fontSize: e.fontSize, color: g(o).hasSpecificColor.value ? g(o).base.value.cssHSLA : void 0 })
      }, {
        default: ie(() => [
          at(y.$slots, "default")
        ]),
        _: 3
      }, 8, ["source", "style", "class"]));
    };
  }
}), pM = ["for"], mM = ["id", "value", "rows", "readonly", "disabled"], hM = /* @__PURE__ */ Pe({
  __name: "Textarea",
  props: {
    ...Ge(),
    rows: {
      type: [String, Number],
      required: !1,
      default: 1
    },
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    minHeight: {
      type: Number,
      required: !1,
      default: 88
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s, erroring: u } = o, { noInteract: i, errors: c } = nr(a), d = z(), p = z(), h = z(), y = z(0), _ = z(!1), $ = C(() => a.label && a.required ? a.label + '<span class="required">*</span>' : a.label);
    Le(() => a.modelValue, async (b) => {
      h.value = b, await ut(), R();
    }, {
      immediate: !0
    }), Le(() => a.rows, async () => {
      await ut(), R();
    });
    const w = C(() => a.disabled ? a.theme == "dark" ? {
      color: l.backgroundDarkTinted.value.withLightness(0.67).cssHSLA
    } : {
      color: l.backgroundLightTinted.value.withLightness(0.67).cssHSLA
    } : _.value ? {
      color: l.baseVisuallySafe.value.cssHSLA
    } : {}), L = C(() => a.disabled ? a.theme == "dark" ? {
      background: l.backgroundDarkTinted.value.cssHSLA,
      borderColor: l.backgroundDarkTinted.value.cssHSLA
    } : {
      background: l.backgroundLightTinted.value.cssHSLA,
      borderColor: l.backgroundLightTinted.value.cssHSLA
    } : _.value ? {
      "border-color": l.baseVisuallySafe.value.cssHSLA
    } : {}), R = () => {
      var D;
      if (!d.value)
        return;
      const b = d.value;
      let x = a.minHeight;
      p.value && (!h.value && !y.value && (y.value = ((D = p.value) == null ? void 0 : D.offsetHeight) + 22), x = Math.max(y.value, a.minHeight)), b.style.height = "auto", b.style.height = Math.max(x, b.scrollHeight) + "px";
    }, q = () => {
      var b;
      a.noInteract || ((b = d.value) == null || b.focus(), E());
    }, E = async (b) => {
      a.noInteract || (R(), await ut(), _.value = !0);
    }, Y = () => {
      a.noInteract || (_.value = !1, R());
    }, V = () => {
      R();
    }, T = (b) => {
      h.value = b.target.value, R(), h.value != a.modelValue && n("update:modelValue", h.value);
    }, A = () => {
      let b, x;
      return d.value && (b = d.value.selectionStart, x = d.value.selectionEnd), {
        start: b,
        end: x
      };
    }, P = (b, x) => {
      var D;
      if (d.value) {
        const N = b ?? ((D = d.value.value) == null ? void 0 : D.length) ?? 0;
        d.value.setSelectionRange(N, x ?? N);
      }
    };
    return Le(() => a.minHeight, R), St(() => R()), t({
      ...o.expose,
      focus: q,
      getSelectionPosition: A,
      setSelection: P
    }), (b, x) => {
      const D = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-textarea", { focused: _.value, filled: h.value, error: g(c), erroring: g(u), disabled: b.disabled, noInteract: g(i) }]),
        onClick: q
      }, [
        W("label", {
          for: g(s).id,
          class: "label",
          ref_key: "$label",
          ref: p
        }, [
          K(D, {
            source: $.value,
            style: we(w.value)
          }, null, 8, ["source", "style"]),
          at(b.$slots, "default")
        ], 8, pM),
        W("textarea", {
          id: g(s).id,
          class: pe("textarea-" + g(s).id),
          value: h.value ?? void 0,
          rows: e.rows,
          style: we(L.value),
          resize: "none",
          onFocus: E,
          onBlur: Y,
          onKeydown: V,
          onInput: T,
          readonly: g(i),
          disabled: b.disabled || g(i),
          tabindex: 0,
          ref_key: "$textarea",
          ref: d
        }, null, 46, mM)
      ], 2);
    };
  }
});
function ka(e, t, r) {
  return Math.max(t, Math.min(e, r));
}
function er(e, t = 2) {
  return e.toFixed(t).replace(/\.?0+$/, "");
}
function nc(e) {
  return e.endsWith(".") ? NaN : (parseFloat(e) % 360 + 360) % 360 / 360;
}
function oc(e) {
  return er(360 * e);
}
function ja(e) {
  if (!e.endsWith("%")) return NaN;
  const t = e.substring(0, e.length - 1);
  if (t.endsWith(".")) return NaN;
  const r = parseFloat(t);
  return Number.isNaN(r) ? NaN : ka(r, 0, 100) / 100;
}
function ho(e) {
  return er(100 * e) + "%";
}
function Pl(e) {
  if (e.endsWith("%")) return ja(e);
  if (e.endsWith(".")) return NaN;
  const t = parseFloat(e);
  return Number.isNaN(t) ? NaN : ka(t, 0, 255) / 255;
}
function Ol(e) {
  return er(255 * e);
}
function Tl(e) {
  return e.endsWith("%") ? ja(e) : ka(parseFloat(e), 0, 1);
}
function Il(e) {
  return String(e);
}
const es = { hsl: { h: { to: oc, from: nc }, s: { to: ho, from: ja }, l: { to: ho, from: ja }, a: { to: Il, from: Tl } }, hwb: { h: { to: oc, from: nc }, w: { to: ho, from: ja }, b: { to: ho, from: ja }, a: { to: Il, from: Tl } }, rgb: { r: { to: Ol, from: Pl }, g: { to: Ol, from: Pl }, b: { to: Ol, from: Pl }, a: { to: Il, from: Tl } } };
function yo(e) {
  const t = e.replace(/^#/, ""), r = [], a = t.length > 4 ? 2 : 1;
  for (let o = 0; o < t.length; o += a) {
    const l = t.slice(o, o + a);
    r.push(l.repeat(a % 2 + 1));
  }
  r.length === 3 && r.push("ff");
  const n = r.map((o) => parseInt(o, 16) / 255);
  return { r: n[0], g: n[1], b: n[2], a: n[3] };
}
function Ml(e) {
  const t = e.l < 0.5 ? e.l * (1 + e.s) : e.l + e.s - e.l * e.s, r = 2 * e.l - t;
  return { r: ql(r, t, e.h + 1 / 3), g: ql(r, t, e.h), b: ql(r, t, e.h - 1 / 3), a: e.a };
}
function ql(e, t, r) {
  return r < 0 ? r += 1 : r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < 0.5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function kn(e) {
  return { r: El(5, e), g: El(3, e), b: El(1, e), a: e.a };
}
function El(e, t) {
  const r = (e + 6 * t.h) % 6;
  return t.v - t.v * t.s * Math.max(0, Math.min(r, 4 - r, 1));
}
function qa(e) {
  return { h: e.h, s: e.b === 1 ? 0 : 1 - e.w / (1 - e.b), v: 1 - e.b, a: e.a };
}
function Va(e) {
  const t = Math.min(e.r, e.g, e.b), r = Math.max(e.r, e.g, e.b);
  let a;
  return a = r === t ? 0 : r === e.r ? (0 + (e.g - e.b) / (r - t)) / 6 : r === e.g ? (2 + (e.b - e.r) / (r - t)) / 6 : (4 + (e.r - e.g) / (r - t)) / 6, a < 0 && (a += 1), { h: a, w: t, b: 1 - r, a: e.a };
}
function Vl(e) {
  const t = Va(e), r = t.w, a = 1 - t.b, n = (a + r) / 2;
  let o;
  return o = a === 0 || r === 1 ? 0 : (a - n) / Math.min(n, 1 - n), { h: t.h, s: o, l: n, a: e.a };
}
function bo(e) {
  return "#" + Object.values(e).map((t) => {
    const r = 255 * t, a = Math.round(r).toString(16);
    return a.length === 1 ? "0" + a : a;
  }).join("");
}
const yM = { hex: [["hsl", (e) => Mr(e, [yo, Vl])], ["hsv", (e) => Mr(e, [yo, Va, qa])], ["hwb", (e) => Mr(e, [yo, Va])], ["rgb", yo]], hsl: [["hex", (e) => Mr(e, [Ml, bo])], ["hsv", function(e) {
  const t = e.l + e.s * Math.min(e.l, 1 - e.l), r = t === 0 ? 0 : 2 - 2 * e.l / t;
  return { h: e.h, s: r, v: t, a: e.a };
}], ["hwb", (e) => Mr(e, [Ml, Va])], ["rgb", Ml]], hsv: [["hex", (e) => Mr(e, [kn, bo])], ["hsl", function(e) {
  const t = e.v - e.v * e.s / 2, r = Math.min(t, 1 - t), a = r === 0 ? 0 : (e.v - t) / r;
  return { h: e.h, s: a, l: t, a: e.a };
}], ["hwb", function(e) {
  return { h: e.h, w: (1 - e.s) * e.v, b: 1 - e.v, a: e.a };
}], ["rgb", kn]], hwb: [["hex", (e) => Mr(e, [qa, kn, bo])], ["hsl", (e) => Mr(e, [qa, kn, Vl])], ["hsv", qa], ["rgb", (e) => Mr(e, [qa, kn])]], rgb: [["hex", bo], ["hsl", Vl], ["hsv", (e) => Mr(e, [Va, qa])], ["hwb", Va]] };
function Mr(e, t) {
  return t.reduce((r, a) => a(r), e);
}
function go(e) {
  const t = {};
  for (const r in e) t[r] = e[r];
  return t;
}
const bM = { hex: (e, t) => t && [5, 9].includes(e.length) ? e.substring(0, e.length - (e.length - 1) / 4) : e, hsl: (e, t) => `hsl(${er(360 * e.h)} ${er(100 * e.s)}% ${er(100 * e.l)}%` + (t ? ")" : ` / ${er(e.a)})`), hwb: (e, t) => `hwb(${er(360 * e.h)} ${er(100 * e.w)}% ${er(100 * e.b)}%` + (t ? ")" : ` / ${er(e.a)})`), rgb: (e, t) => `rgb(${er(255 * e.r)} ${er(255 * e.g)} ${er(255 * e.b)}` + (t ? ")" : ` / ${er(e.a)})`) };
function lc(e, t, r) {
  return bM[t](e, r);
}
function Uf(e) {
  return /^#(?:(?:[A-F0-9]{2}){3,4}|[A-F0-9]{3,4})$/i.test(e);
}
function gM(e) {
  if (typeof e != "string")
    return { format: function(u) {
      return Object.prototype.hasOwnProperty.call(u, "r") ? "rgb" : Object.prototype.hasOwnProperty.call(u, "w") ? "hwb" : Object.prototype.hasOwnProperty.call(u, "v") ? "hsv" : "hsl";
    }(e), color: e };
  if (Uf(e)) return { format: "hex", color: e };
  if (!e.includes("(")) {
    const s = document.createElement("canvas").getContext("2d");
    s.fillStyle = e;
    const u = s.fillStyle;
    return u === "#000000" && e !== "black" ? null : { format: "hex", color: u };
  }
  const [t, r] = e.split("("), a = t.substring(0, 3), n = r.replace(/[,/)]/g, " ").replace(/\s+/g, " ").trim().split(" ");
  n.length === 3 && n.push("1");
  const o = (a + "a").split(""), l = Object.fromEntries(o.map((s, u) => [s, es[a][s].from(n[u])]));
  return { format: a, color: l };
}
const Ll = ["hex", "hsl", "hwb", "rgb"], _M = ["show", "hide"], wM = { class: "vacp-range-input-group" }, kM = ["for"], $M = { class: "vacp-range-input-label-text vacp-range-input-label-text--hue" }, CM = ["id", "value"], SM = ["for"], xM = { class: "vacp-range-input-label-text vacp-range-input-label-text--alpha" }, DM = ["id", "value"], AM = W("span", { class: "vacp-visually-hidden" }, "Copy color", -1), PM = W("svg", { class: "vacp-icon", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", width: "24", height: "24", viewBox: "0 0 32 32" }, [W("path", { d: "M25.313 28v-18.688h-14.625v18.688h14.625zM25.313 6.688c1.438 0 2.688 1.188 2.688 2.625v18.688c0 1.438-1.25 2.688-2.688 2.688h-14.625c-1.438 0-2.688-1.25-2.688-2.688v-18.688c0-1.438 1.25-2.625 2.688-2.625h14.625zM21.313 1.313v2.688h-16v18.688h-2.625v-18.688c0-1.438 1.188-2.688 2.625-2.688h16z", fill: "currentColor" })], -1), OM = { class: "vacp-color-inputs" }, TM = { class: "vacp-color-input-group" }, IM = ["for"], MM = W("span", { class: "vacp-color-input-label-text" }, " Hex ", -1), qM = ["id", "value"], EM = ["id", "for", "onInput"], VM = { class: "vacp-color-input-label-text" }, LM = ["id", "value", "onInput"], BM = W("span", { class: "vacp-visually-hidden" }, "Switch format", -1), jM = W("svg", { class: "vacp-icon", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", width: "16", height: "15" }, [W("path", { d: "M8 15l5-5-1-1-4 2-4-2-1 1zm4-9l1-1-5-5-5 5 1 1 4-2z", fill: "currentColor" })], -1);
var zf = { __name: "ColorPicker", props: { color: { type: [String, Object], default: "#ffffffff" }, id: { type: String, default: "color-picker" }, visibleFormats: { type: Array, default: () => Ll, validator: (e) => e.length > 0 && e.every((t) => Ll.includes(t)) }, defaultFormat: { type: String, default: "hsl", validator: (e) => Ll.includes(e) }, alphaChannel: { type: String, default: "show", validator: (e) => _M.includes(e) } }, emits: ["color-change"], setup(e, { emit: t }) {
  const r = e, a = z(null), n = z(null), o = z(null);
  let l = !1;
  const s = z(r.visibleFormats.includes(r.defaultFormat) ? r.defaultFormat : r.visibleFormats[0]), u = Gt({ hex: "#ffffffff", hsl: { h: 0, s: 0, l: 1, a: 1 }, hsv: { h: 0, s: 0, v: 1, a: 1 }, hwb: { h: 0, w: 1, b: 0, a: 1 }, rgb: { r: 1, g: 1, b: 1, a: 1 } }), i = C(function() {
    const b = Object.keys(u[s.value]);
    return s.value !== "hex" && r.alphaChannel === "hide" ? b.slice(0, 3) : b;
  }), c = C(function() {
    return r.alphaChannel === "hide" && [5, 9].includes(u.hex.length) ? u.hex.substring(0, u.hex.length - (u.hex.length - 1) / 4) : u.hex;
  });
  function d() {
    const b = (r.visibleFormats.findIndex((x) => x === s.value) + 1) % r.visibleFormats.length;
    s.value = r.visibleFormats[b];
  }
  function p(b) {
    l = !0, _(b);
  }
  function h(b) {
    l = !0, $(b);
  }
  function y() {
    l = !1;
  }
  function _(b) {
    b.buttons === 1 && l !== !1 && n.value instanceof HTMLElement && w(n.value, b.clientX, b.clientY);
  }
  function $(b) {
    if (l === !1 || !(n.value instanceof HTMLElement)) return;
    b.preventDefault();
    const x = b.touches[0];
    w(n.value, x.clientX, x.clientY);
  }
  function w(b, x, D) {
    const N = function(H, U, G) {
      const F = H.getBoundingClientRect(), O = U - F.left, Q = G - F.top;
      return { x: F.width === 0 ? 0 : ka(O / F.width, 0, 1), y: F.height === 0 ? 0 : ka(1 - Q / F.height, 0, 1) };
    }(b, x, D), M = go(u.hsv);
    M.s = N.x, M.v = N.y, V("hsv", M);
  }
  function L(b) {
    if (!["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"].includes(b.key)) return;
    b.preventDefault();
    const x = ["ArrowLeft", "ArrowDown"].includes(b.key) ? -1 : 1, D = ["ArrowLeft", "ArrowRight"].includes(b.key) ? "s" : "v", N = b.shiftKey ? 10 : 1, M = u.hsv[D] + x * N * 0.01, H = go(u.hsv);
    H[D] = ka(M, 0, 1), V("hsv", H);
  }
  function R(b) {
    const x = gM(b);
    x !== null && V(x.format, x.color);
  }
  function q(b, x) {
    const D = b.currentTarget, N = go(u.hsv);
    N[x] = parseInt(D.value) / parseInt(D.max), V("hsv", N);
  }
  function E(b) {
    const x = b.target;
    Uf(x.value) && V("hex", x.value);
  }
  function Y(b, x) {
    const D = b.target, N = go(u[s.value]), M = es[s.value][x].from(D.value);
    Number.isNaN(M) || M === void 0 || (N[x] = M, V(s.value, N));
  }
  function V(b, x) {
    let D = x;
    if (r.alphaChannel === "hide") if (typeof x != "string") x.a = 1, D = x;
    else if ([5, 9].includes(x.length)) {
      const N = (x.length - 1) / 4;
      D = x.substring(0, x.length - N) + "f".repeat(N);
    } else [4, 7].includes(x.length) && (D = x + "f".repeat((x.length - 1) / 3));
    if (!function(N, M) {
      if (typeof N == "string" || typeof M == "string") return N === M;
      for (const H in N) if (N[H] !== M[H]) return !1;
      return !0;
    }(u[b], D)) {
      (function(M, H) {
        u[M] = H;
        for (const [U, G] of yM[M]) u[U] = G(u[M]);
      })(b, D);
      const N = function() {
        const M = r.alphaChannel === "hide", H = lc(u[s.value], s.value, M);
        return { colors: u, cssColor: H };
      }();
      t("color-change", N);
    }
    (function() {
      a.value instanceof HTMLElement && n.value instanceof HTMLElement && o.value instanceof HTMLElement && (a.value.style.setProperty("--vacp-hsl-h", String(u.hsl.h)), a.value.style.setProperty("--vacp-hsl-s", String(u.hsl.s)), a.value.style.setProperty("--vacp-hsl-l", String(u.hsl.l)), a.value.style.setProperty("--vacp-hsl-a", String(u.hsl.a)), n.value.style.position = "relative", n.value.style.backgroundColor = "hsl(calc(var(--vacp-hsl-h) * 360) 100% 50%)", n.value.style.backgroundImage = "linear-gradient(to top, #000, transparent), linear-gradient(to right, #fff, transparent)", o.value.style.boxSizing = "border-box", o.value.style.position = "absolute", o.value.style.left = 100 * u.hsv.s + "%", o.value.style.bottom = 100 * u.hsv.v + "%");
    })();
  }
  async function T() {
    const b = u[s.value], x = r.alphaChannel === "hide", D = lc(b, s.value, x);
    await window.navigator.clipboard.writeText(D);
  }
  function A(b, x) {
    return es[b][x].to(u[b][x]);
  }
  function P(b) {
    if (!["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"].includes(b.key) || !b.shiftKey) return;
    const x = b.currentTarget, D = parseFloat(x.step), N = ["ArrowLeft", "ArrowDown"].includes(b.key) ? -1 : 1, M = ka(parseFloat(x.value) + N * D * 10, parseInt(x.min), parseInt(x.max));
    x.value = String(M - N * D);
  }
  return Le(() => r.color, R), St(function() {
    document.addEventListener("mousemove", _, { passive: !1 }), document.addEventListener("touchmove", $, { passive: !1 }), document.addEventListener("mouseup", y), document.addEventListener("touchend", y), R(r.color);
  }), jr(function() {
    document.removeEventListener("mousemove", _), document.removeEventListener("touchmove", $), document.removeEventListener("mouseup", y), document.removeEventListener("touchend", y);
  }), (b, x) => (m(), S("div", { ref_key: "colorPicker", ref: a, class: "vacp-color-picker" }, [W("div", { ref_key: "colorSpace", ref: n, class: "vacp-color-space", onMousedown: p, onTouchstart: h }, [W("div", { ref_key: "thumb", ref: o, class: "vacp-color-space-thumb", tabindex: "0", "aria-label": "Color space thumb", onKeydown: L }, null, 544)], 544), W("div", wM, [W("label", { class: "vacp-range-input-label vacp-range-input-label--hue", for: `${e.id}-hue-slider` }, [W("span", $M, [at(b.$slots, "hue-range-input-label", {}, () => [pt("Hue")])]), W("input", { id: `${e.id}-hue-slider`, class: "vacp-range-input vacp-range-input--hue", value: 360 * u.hsv.h, type: "range", min: "0", max: "360", step: "1", onKeydownPassive: P, onInput: x[0] || (x[0] = (D) => q(D, "h")) }, null, 40, CM)], 8, kM), e.alphaChannel === "show" ? (m(), S("label", { key: 0, class: "vacp-range-input-label vacp-range-input-label--alpha", for: `${e.id}-alpha-slider` }, [W("span", xM, [at(b.$slots, "alpha-range-input-label", {}, () => [pt("Alpha")])]), W("input", { id: `${e.id}-alpha-slider`, class: "vacp-range-input vacp-range-input--alpha", value: 100 * u.hsv.a, type: "range", min: "0", max: "100", step: "1", onKeydownPassive: P, onInput: x[1] || (x[1] = (D) => q(D, "a")) }, null, 40, DM)], 8, SM)) : B("v-if", !0)]), W("button", { class: "vacp-copy-button", type: "button", onClick: T }, [at(b.$slots, "copy-button", {}, () => [AM, PM])]), W("div", OM, [W("div", TM, [s.value === "hex" ? (m(), S("label", { key: 0, class: "vacp-color-input-label", for: `${e.id}-color-hex` }, [MM, W("input", { id: `${e.id}-color-hex`, class: "vacp-color-input", type: "text", value: c.value, onInput: E }, null, 40, qM)], 8, IM)) : (m(!0), S(qe, { key: 1 }, We(i.value, (D) => (m(), S("label", { id: `${e.id}-color-${s.value}-${D}-label`, key: `${e.id}-color-${s.value}-${D}-label`, class: "vacp-color-input-label", for: `${e.id}-color-${s.value}-${D}`, onInput: (N) => Y(N, D) }, [W("span", VM, je(D.toUpperCase()), 1), W("input", { id: `${e.id}-color-${s.value}-${D}`, class: "vacp-color-input", type: "text", value: A(s.value, D), onInput: (N) => Y(N, D) }, null, 40, LM)], 40, EM))), 128))]), e.visibleFormats.length > 1 ? (m(), S("button", { key: 0, class: "vacp-format-switch-button", type: "button", onClick: d }, [at(b.$slots, "format-switch-button", {}, () => [BM, jM])])) : B("v-if", !0)])], 512));
} };
(function(e, t) {
  t === void 0 && (t = {});
  var r = t.insertAt;
  if (typeof document < "u") {
    var a = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.type = "text/css", r === "top" && a.firstChild ? a.insertBefore(n, a.firstChild) : a.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
  }
})(".vacp-color-picker{--vacp-color:hsl(calc(var(--vacp-hsl-h)*360) calc(var(--vacp-hsl-s)*100%) calc(var(--vacp-hsl-l)*100%)/var(--vacp-hsl-a));--vacp-focus-color:#19f;--vacp-focus-outline:2px solid var(--vacp-focus-color);--vacp-border-width:1px;--vacp-border-color:#000;--vacp-border:var(--vacp-border-width) solid var(--vacp-border-color);--vacp-color-space-width:300px;--vacp-spacing:6px;grid-gap:var(--vacp-spacing);background-color:#fff;display:grid;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;font-size:.8em;grid-template-columns:1fr min-content;max-width:var(--vacp-color-space-width);padding:var(--vacp-spacing)}.vacp-color-picker,.vacp-color-picker *,.vacp-color-picker :after,.vacp-color-picker :before{box-sizing:border-box}.vacp-color-picker button::-moz-focus-inner{border:none;padding:0}.vacp-color-picker :focus{outline:var(--vacp-focus-outline)}.vacp-color-space{grid-column:1/-1;height:calc(var(--vacp-color-space-width)*.6);overflow:hidden}.vacp-color-space-thumb{--vacp-thumb-size:calc(var(--vacp-spacing)*4);border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 var(--vacp-border-width) var(--vacp-border-color);height:var(--vacp-thumb-size);margin-bottom:calc(var(--vacp-thumb-size)*-1/2);margin-left:calc(var(--vacp-thumb-size)*-1/2);transform:rotate(0);width:var(--vacp-thumb-size)}.vacp-color-space-thumb:focus{box-shadow:0 0 0 var(--vacp-border-width) var(--vacp-border-color),0 0 0 3px var(--vacp-focus-color);outline-color:transparent}.vacp-range-input-label{--vacp-slider-track-width:100%;--vacp-slider-track-height:calc(var(--vacp-spacing)*3);display:block}.vacp-range-input-group{display:flex;flex-direction:column;justify-content:center}.vacp-range-input-group>:not(:first-child){margin-top:var(--vacp-spacing)}.vacp-range-input,.vacp-range-input::-webkit-slider-thumb{-webkit-appearance:none}.vacp-range-input{background:none;border:none;display:block;height:var(--vacp-slider-track-height);margin-bottom:calc(var(--vacp-spacing)/2 + 1px);margin-left:0;margin-right:0;margin-top:calc(var(--vacp-spacing)/2 + 1px);padding:0;width:var(--vacp-slider-track-width)}.vacp-range-input:focus{outline:none}.vacp-range-input::-moz-focus-outer{border:none}.vacp-range-input--alpha{background-color:#fff;background-image:linear-gradient(45deg,#eee 25%,transparent 0,transparent 75%,#eee 0,#eee),linear-gradient(45deg,#eee 25%,transparent 0,transparent 75%,#eee 0,#eee);background-position:0 0,var(--vacp-spacing) var(--vacp-spacing);background-size:calc(var(--vacp-spacing)*2) calc(var(--vacp-spacing)*2)}.vacp-range-input::-moz-range-track{border:var(--vacp-border);box-sizing:content-box;height:var(--vacp-slider-track-height);width:var(--vacp-slider-track-width)}.vacp-range-input::-webkit-slider-runnable-track{border:var(--vacp-border);box-sizing:content-box;height:var(--vacp-slider-track-height);width:var(--vacp-slider-track-width)}.vacp-range-input::-ms-track{border:var(--vacp-border);box-sizing:content-box;height:var(--vacp-slider-track-height);width:var(--vacp-slider-track-width)}.vacp-range-input:focus::-moz-range-track{outline:var(--vacp-focus-outline)}.vacp-range-input:focus::-webkit-slider-runnable-track{outline:var(--vacp-focus-outline)}.vacp-range-input:focus::-ms-track{outline:var(--vacp-focus-outline)}.vacp-range-input--alpha::-moz-range-track{background-image:linear-gradient(to right,transparent,var(--vacp-color))}.vacp-range-input--alpha::-webkit-slider-runnable-track{background-image:linear-gradient(to right,transparent,var(--vacp-color))}.vacp-range-input--alpha::-ms-track{background-image:linear-gradient(to right,transparent,var(--vacp-color))}.vacp-range-input--hue::-moz-range-track{background-image:linear-gradient(90deg,red 0,#ff0 16.66667%,#0f0 33.33333%,#0ff 50%,#00f 66.66667%,#f0f 83.33333%,red 100%)}.vacp-range-input--hue::-webkit-slider-runnable-track{background-image:linear-gradient(90deg,red 0,#ff0 16.66667%,#0f0 33.33333%,#0ff 50%,#00f 66.66667%,#f0f 83.33333%,red 100%)}.vacp-range-input--hue::-ms-track{background-image:linear-gradient(90deg,red 0,#ff0 16.66667%,#0f0 33.33333%,#0ff 50%,#00f 66.66667%,#f0f 83.33333%,red 100%)}.vacp-range-input::-moz-range-thumb{background-color:transparent;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 var(--vacp-border-width) var(--vacp-border-color);box-sizing:content-box;height:var(--vacp-slider-track-height);isolation:isolate;width:var(--vacp-slider-track-height)}.vacp-range-input::-webkit-slider-thumb{background-color:transparent;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 var(--vacp-border-width) var(--vacp-border-color);box-sizing:content-box;height:var(--vacp-slider-track-height);isolation:isolate;margin-top:calc((var(--vacp-spacing)/2)*-1);width:var(--vacp-slider-track-height)}.vacp-range-input::-ms-thumb{background-color:transparent;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 var(--vacp-border-width) var(--vacp-border-color);box-sizing:content-box;height:var(--vacp-slider-track-height);isolation:isolate;margin-top:calc((var(--vacp-spacing)/2)*-1);width:var(--vacp-slider-track-height)}.vacp-copy-button{align-items:center;align-self:center;background-color:#fff;border:var(--vacp-border-width) solid transparent;border-radius:50%;display:flex;height:calc(var(--vacp-spacing)*6);justify-content:center;justify-self:center;overflow:hidden;position:relative;width:calc(var(--vacp-spacing)*6)}.vacp-copy-button:enabled:focus{border-color:var(--vacp-border-color);box-shadow:0 0 0 2px var(--vacp-focus-color);outline:none}.vacp-copy-button:enabled:hover{background-color:#0002}.vacp-color-inputs{align-items:center;display:flex;grid-column:1/-1}.vacp-color-inputs>:not(:first-child){margin-left:var(--vacp-spacing)}.vacp-color-input-group{column-gap:var(--vacp-spacing);display:grid;flex-grow:1;grid-auto-flow:column}.vacp-color-input-label{text-align:center}.vacp-color-input{border:var(--vacp-border);margin:0;margin-top:calc(var(--vacp-spacing)/2);text-align:center;width:100%}.vacp-color-input,.vacp-format-switch-button{background-color:#fff;color:inherit;font:inherit;padding:var(--vacp-spacing)}.vacp-format-switch-button{align-items:center;border:var(--vacp-border-width) solid transparent;border-radius:50%;display:flex;justify-content:center;margin:0}.vacp-format-switch-button:enabled:focus{border-color:var(--vacp-border-color)}.vacp-format-switch-button:enabled:hover{background-color:#0002}.vacp-visually-hidden{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}"), zf.__file = "src/ColorPicker.vue";
const HM = { key: 0 }, RM = { class: "meta" }, FM = {
  key: 1,
  class: "color-value"
}, NM = { class: "item hue" }, YM = { class: "item saturation" }, UM = { class: "item lightness" }, zM = { class: "color-picker-wrapper" }, WM = {
  key: 0,
  class: "presets"
}, KM = /* @__PURE__ */ Pe({
  __name: "ColorPicker",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    noColorLabel: {
      type: [String, Object],
      required: !1,
      default: null
    },
    resetLabel: {
      type: [String, Object],
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    modelValue: {
      type: [String, Object],
      required: !1,
      default: null
    },
    withAlpha: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue",
    "open",
    "close"
  ],
  setup(e, { expose: t, emit: r }) {
    zt((A) => ({
      e38b7ef0: y.value,
      "719c127e": E.top,
      "7acf673c": E.bottom,
      "71b79614": E.maxHeight,
      "337e7cdc": g(l).baseVisuallySafe.value.cssHSLA
    }));
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s } = o, u = z(), i = z(), c = z(), d = (A) => {
      if (A instanceof zr)
        return A;
      if (typeof A == "string")
        return zr.fromString(A);
      if (A && typeof A == "object") {
        if (A.h !== void 0)
          return zr.fromHSL(A, a.withAlpha ? A.a : 1);
        if (A.r !== void 0)
          return zr.fromRGB(A, a.withAlpha ? A.a : 1);
      }
      return null;
    }, p = z(d(a.modelValue)), h = C(() => {
      const A = p.value ?? zr.BLACK;
      return {
        h: A.hsl.h,
        s: A.hsl.s,
        l: A.hsl.l,
        a: A.alpha
      };
    }), y = C(() => {
      var A;
      return ((A = d(p.value)) == null ? void 0 : A.cssHSLA) ?? "transparent";
    }), _ = z(!1), $ = (A) => {
      !_.value && !p.value || n("update:modelValue", d(A.colors.hsl));
    }, w = (A) => {
      var P;
      a.disabled || a.noInteract || (P = c.value) != null && P.contains(A.target) || L();
    }, L = async () => {
      a.disabled || a.noInteract || (_.value = !0, await ut(), Y(), n("open"));
    }, R = () => {
      _.value = !1, n("close");
    }, q = () => {
      a.disabled || a.noInteract || (p.value = null, n("update:modelValue", null), R());
    }, E = Gt({
      top: "0px",
      bottom: "auto",
      maxHeight: "none"
    }), Y = () => {
      if (!i.value)
        return;
      const A = i.value.getBoundingClientRect(), P = 128, b = 128, x = A.top - P, D = window.innerHeight - A.top - b;
      x > D ? (E.top = "auto", E.bottom = "calc(100% - 1px)", E.maxHeight = x + "px") : (E.top = "calc(100% - 1px)", E.bottom = "auto", E.maxHeight = D + "px");
    };
    Le(() => a.modelValue, (A) => p.value = d(A));
    const V = () => {
      Y();
    }, T = (A) => {
      var x, D;
      const P = !((x = u.value) != null && x.contains(A.target)), b = (D = c.value) == null ? void 0 : D.contains(A.target);
      (P || b) && (Gp(A.target, ["acquisit-no-window-click-close"]) || R());
    };
    return Kr(window, "click", T), Kr(window, "touchend", T), Kr(window, "resize", _c(V, 200)), t({
      ...o.expose,
      open: L,
      close: R,
      reset: q
    }), (A, P) => {
      const b = oe("v-svg"), x = oe("acquisit-string"), D = oe("acquisit-button");
      return m(), S("div", {
        class: pe(["acquisit-color-picker", { "no-interact": A.noInteract, active: _.value, disabled: A.disabled }]),
        ref_key: "$root",
        ref: u
      }, [
        W("div", {
          class: "color-wrapper",
          onClick: w,
          ref_key: "$wrapper",
          ref: i
        }, [
          W("div", {
            class: pe(["color", { bordered: p.value && p.value.hsl.l > 0.95 && (p.value.hsl.s > 0.9 || p.value.hsl.s == 0) }])
          }, [
            p.value ? (m(), S("span", HM)) : (m(), J(b, {
              key: 1,
              file: "acq/color-select",
              class: "icon"
            }))
          ], 2),
          W("div", RM, [
            e.label ? (m(), J(x, {
              key: 0,
              class: "label",
              source: e.label,
              id: g(s).id
            }, null, 8, ["source", "id"])) : B("", !0),
            p.value ? (m(), S("div", FM, [
              at(A.$slots, "value", {}, () => [
                W("span", NM, "H: " + je(Math.round(p.value.hsl.h * 360 * 1e3) / 1e3) + "°", 1),
                W("span", YM, "S: " + je(Math.round(p.value.hsl.s * 100 * 1e3) / 1e3) + "%", 1),
                W("span", UM, "L: " + je(Math.round(p.value.hsl.l * 100 * 1e3) / 1e3) + "%", 1)
              ])
            ])) : e.noColorLabel ? (m(), J(x, {
              key: 2,
              class: "no-color-label",
              source: e.noColorLabel
            }, null, 8, ["source"])) : B("", !0)
          ]),
          e.resetLabel ? (m(), S("div", {
            key: 0,
            class: "actions",
            ref_key: "$actions",
            ref: c
          }, [
            K(bt, { name: "fade" }, {
              default: ie(() => [
                Kt(K(D, {
                  type: "icon",
                  size: 24,
                  "icon-size": 20,
                  disabled: A.disabled || A.noInteract,
                  "no-interact": A.noInteract || A.disabled,
                  color: "red",
                  icon: "acq/clear",
                  "aria-label": e.resetLabel,
                  onClick: q
                }, null, 8, ["disabled", "no-interact", "aria-label"]), [
                  [_r, p.value]
                ])
              ]),
              _: 1
            })
          ], 512)) : B("", !0)
        ], 512),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            Kt(W("div", zM, [
              K(g(zf), {
                color: h.value,
                "visible-formats": ["hex", "hsl", "rgb"],
                "default-format": "hsl",
                id: g(s).id,
                "alpha-channel": e.withAlpha ? "show" : "hide",
                onColorChange: $
              }, null, 8, ["color", "id", "alpha-channel"]),
              A.$slots.presets ? (m(), S("div", WM, [
                at(A.$slots, "presets")
              ])) : B("", !0)
            ], 512), [
              [_r, _.value]
            ])
          ]),
          _: 3
        })
      ], 2);
    };
  }
}), GM = /* @__PURE__ */ Pe({
  __name: "CheckboxGroup",
  props: {
    ...Ge(),
    allow: {
      type: String,
      required: !1,
      default: "multiple"
    },
    require: {
      type: String,
      required: !1,
      default: "none"
    },
    layout: {
      type: String,
      required: !1,
      default: "vertical"
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), l = z({}), s = C(() => {
      const p = {};
      return Rt(l.value, (h, y) => {
        p[y] = $n("acquisit-checkbox", {
          uid: y,
          modelValue: h.modelValue.get(),
          disabled: h.disabled.get()
        }), a.allow == "one" && (p[y].linked = Object.keys(l.value).filter((_) => _ != y));
      }), p;
    }), u = () => {
      n("update:modelValue", xr("update-"));
    }, i = (p, h, y) => {
      l.value[p] = {
        modelValue: h,
        disabled: y
      };
    }, c = (p) => {
      delete l.value[p];
    };
    return ar("checkboxGroupEmitChange", async (p, h) => {
      const y = _o();
      if (y.isValueUpdateDisabledFor("checkbox"))
        return;
      const _ = Vc({
        checkboxes: s.value,
        clickedCheckbox: s.value[p],
        modelValue: h
      });
      y.disableValueUpdates(["checkbox"]);
      for (let $ in _)
        if (_.hasOwnProperty($)) {
          let w = _[$];
          w.modelValue, l.value[$].modelValue.set(w.modelValue), l.value[$].disabled.set(w.disabled);
        }
      await Ka(50), y.enableValueUpdates(["checkbox"]), u();
    }), ar("checkboxGroupRegister", i), ar("checkboxGroupUnregister", c), t({
      ...o.expose
    }), (p, h) => (m(), S("div", {
      class: pe(["acquisit-checkbox-group", "layout-" + e.layout])
    }, [
      at(p.$slots, "default")
    ], 2));
  }
}), ZM = {
  class: /* @__PURE__ */ pe(["button-wrapper", "add-button-wrapper", "pdf-hidden"]),
  key: "add"
}, XM = {
  key: 0,
  class: "button-wrapper close-button-wrapper pdf-hidden"
}, JM = /* @__PURE__ */ Pe({
  __name: "Comment",
  props: {
    ...Ge(),
    comment: {
      type: Object,
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    add_label: {
      type: [String, Object],
      required: !0
    },
    delete_label: {
      type: [String, Object],
      required: !0
    },
    align: {
      type: String,
      required: !1,
      default: "center"
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, { noInteract: u, errors: i } = nr(a), c = z(), d = z(a.modelValue || a.comment.value), p = z(!!(a.modelValue || a.comment.value)), h = z(1), y = () => {
      n("update:modelValue", d.value);
    }, _ = async () => {
      var w;
      p.value = !0, await Ka(220), (w = c.value) == null || w.focus();
    }, $ = () => {
      d.value = null, y(), p.value = !1;
    };
    return Le(d, () => y()), t({
      ...o.expose,
      openComment: _,
      closeComment: $
    }), (w, L) => {
      const R = oe("acquisit-button"), q = oe("acquisit-textarea");
      return m(), S("div", {
        class: pe(["acquisit-comment", "align-" + e.align, { open: p.value }])
      }, [
        K(bt, {
          mode: "out-in",
          name: "move-fade-bottom"
        }, {
          default: ie(() => [
            !p.value && !w.displayOnly ? (m(), S("div", ZM, [
              K(R, {
                class: "button",
                onClick: _,
                type: "raised",
                errors: g(i),
                "has-current-errors": g(s),
                icon: "acq/comment-add",
                label: e.add_label,
                "no-interact": g(u),
                disabled: e.disabled
              }, null, 8, ["errors", "has-current-errors", "label", "no-interact", "disabled"])
            ])) : (m(), S("div", {
              class: pe(["textarea-wrapper", { open: p.value }]),
              key: "textarea"
            }, [
              K(q, {
                modelValue: d.value,
                "onUpdate:modelValue": L[0] || (L[0] = (E) => d.value = E),
                disabled: e.disabled,
                "no-interact": g(u),
                rows: h.value,
                label: e.comment.label,
                errors: g(i),
                "has-current-errors": g(s),
                ref_key: "$textarea",
                ref: c
              }, null, 8, ["modelValue", "disabled", "no-interact", "rows", "label", "errors", "has-current-errors"]),
              w.displayOnly ? B("", !0) : (m(), S("div", XM, [
                K(R, {
                  onClick: $,
                  class: "delete-button",
                  type: "flat",
                  color: "red",
                  label: e.delete_label,
                  icon: "acq/delete"
                }, null, 8, ["label"])
              ]))
            ], 2))
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), QM = /* @__PURE__ */ Yn(JM, [["__scopeId", "data-v-3ca2fc8e"]]), eq = {
  class: /* @__PURE__ */ pe(["acquisit-container-layout"])
}, tq = /* @__PURE__ */ Pe({
  __name: "ContainerLayout",
  props: {
    ...Ge(),
    paddingTop: {
      type: Number,
      required: !1,
      default: 0
    },
    paddingBottom: {
      type: Number,
      required: !1,
      default: 0
    },
    paddingLeft: {
      type: Number,
      required: !1,
      default: 0
    },
    paddingRight: {
      type: Number,
      required: !1,
      default: 0
    },
    padding: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((u) => ({
      "4a4aa944": n.value.top + "px",
      "916d8708": n.value.bottom + "px",
      "6609fda0": n.value.left + "px",
      "7f739992": n.value.right + "px"
    }));
    const a = e, n = C(() => {
      const u = a.padding;
      return {
        top: u + a.paddingTop,
        bottom: u + a.paddingBottom,
        left: u + a.paddingLeft,
        right: u + a.paddingRight
      };
    }), l = Ze(a, r), { color: s } = l;
    return t({
      ...l.expose
    }), (u, i) => (m(), S("div", eq, [
      at(u.$slots, "default")
    ]));
  }
}), rq = /* @__PURE__ */ Pe({
  __name: "CountryChooser",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1
    },
    exclude: {
      type: Array,
      required: !1,
      default: () => []
    },
    include: {
      type: Array,
      required: !1,
      default: () => []
    },
    prefer: {
      type: Array,
      required: !1,
      default: () => []
    },
    modelValue: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = C(() => Ft(Hl, (y) => y.country, (y) => y.label)), i = C(() => {
      const y = {};
      let _ = 0;
      for (let $ = 0; $ < a.prefer.length; $++)
        u.value[a.prefer[$]] ? y[a.prefer[$]] = {
          index: $ - _,
          country: a.prefer[$]
        } : _ += 1;
      return y;
    }), c = C(() => Ft(a.exclude ?? [], (y) => y, (y) => !0)), d = C(() => Ft(a.include ?? [], (y) => y, (y) => !0)), p = C(() => {
      const y = [];
      let _ = Hl, $ = 0;
      if (a.include.length) {
        let w = _.length;
        _ = _.filter((L) => d.value[L.country]), $ += w - _.length;
      }
      if (a.exclude.length) {
        let w = _.length;
        _ = _.filter((L) => !c.value[L.country]), $ += w - _.length;
      }
      _ = _.sort(Zp("label"));
      for (let w of a.prefer) {
        const L = i.value[w];
        if (L) {
          const R = _.findIndex((q) => q.country == L.country);
          R > -1 && Xp(_, R, L.index - $);
        }
      }
      for (let w of _)
        y.push({
          label: _m(w.country) + "  " + w.label,
          value: w.country
        });
      return y;
    }), h = (y) => {
      for (let _ of p.value)
        y === _.value && n("update:modelValue", _);
    };
    return t({
      ...o.expose
    }), (y, _) => {
      var w;
      const $ = oe("acquisit-dropdown");
      return m(), J($, {
        class: "acquisit-country-chooser",
        label: e.label,
        options: p.value,
        modelValue: ((w = e.modelValue) == null ? void 0 : w.value) ?? null,
        disabled: y.disabled,
        "no-interact": y.noInteract,
        "has-current-errors": g(s),
        errors: y.errors,
        required: y.required,
        "onUpdate:modelValue": h
      }, null, 8, ["label", "options", "modelValue", "disabled", "no-interact", "has-current-errors", "errors", "required"]);
    };
  }
}), aq = { class: "acquisit-file-upload" }, nq = ["for"], oq = ["id", "disabled", "accept", "multiple"], lq = /* @__PURE__ */ Pe({
  __name: "FileInput",
  props: {
    ...Ge(),
    accept: {
      type: Array,
      required: !1,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: Object,
      required: !1,
      default: () => []
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    label: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, uid: s } = o, u = (d) => {
      var p;
      (p = d.target) != null && p.files && n("update:modelValue", [...d.target.files]);
    }, i = z(), c = (d) => {
      var p;
      a.disabled || a.noInteract || (p = i.value) == null || p.click();
    };
    return Le(() => a.modelValue, (d) => {
      i.value && (d != null && d.length || (i.value.value = ""));
    }), t({
      ...o.expose
    }), (d, p) => {
      const h = oe("acquisit-button");
      return m(), S("div", aq, [
        W("label", {
          class: "trigger",
          for: g(s).id
        }, [
          at(d.$slots, "trigger", {
            files: a.modelValue,
            openFileDialog: c
          }, () => [
            e.label || e.icon ? (m(), J(h, {
              key: 0,
              type: !e.label && e.icon ? "icon" : "raised",
              label: e.label,
              icon: e.icon,
              disabled: d.disabled,
              "no-interact": d.disabled || d.noInteract,
              color: g(l).baseVisuallySafe.value,
              theme: d.theme,
              onClick: c
            }, null, 8, ["type", "label", "icon", "disabled", "no-interact", "color", "theme"])) : B("", !0)
          ])
        ], 8, nq),
        W("input", {
          type: "file",
          id: g(s).id,
          ref_key: "$fileInput",
          ref: i,
          class: "file-input",
          disabled: d.disabled || d.noInteract,
          onChange: u,
          accept: e.accept.join(","),
          multiple: e.multiple
        }, null, 40, oq)
      ]);
    };
  }
}), sq = /* @__PURE__ */ Pe({
  __name: "HorizontalLayout",
  props: {
    ...Ge(),
    align_horizontal: {
      type: String,
      required: !1,
      default: "center"
    },
    align_vertical: {
      type: String,
      required: !1,
      default: "center"
    },
    column_widths: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    column_horizontal_alignments: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    column_gap: {
      type: String,
      required: !1,
      default: null
    },
    margin_top: {
      type: String,
      required: !1,
      default: null
    },
    margin_bottom: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt(($) => ({
      "71075dba": h.value.marginTop,
      "298067a6": h.value.marginBottom,
      "6caac7c2": s.value
    }));
    const a = e;
    Ar("components/extended/HorizontalLayout", a);
    const o = Ze(a, r), { color: l } = o, s = z("1fr");
    C(() => a.align_horizontal == "center" ? "auto" : 100 / i.value.length + "%");
    const u = C(() => a.column_gap == "small" || a.column_gap == "regular" || a.column_gap == "big"), i = z(o.ui.getChildren()), c = ($) => {
      switch ($) {
        case "tiny":
          return "8px";
        case "small":
          return "12px";
        case "regular":
          return "16px";
        case "big":
          return "24px";
        case "huge":
          return "32px";
      }
      return $ ?? "0px";
    }, d = C(() => c(a.margin_top)), p = C(() => c(a.margin_bottom)), h = C(() => ({
      marginTop: d.value,
      marginBottom: p.value
    })), y = () => {
      var w;
      let $ = [];
      if ((w = a.column_widths) != null && w.length)
        $ = a.column_widths;
      else
        for (let L = 0, R = i.value.length; L < R; L++)
          $.push("1fr");
      s.value = $.join(" ");
    }, _ = () => {
      var $;
      if (($ = a.column_horizontal_alignments) != null && $.length)
        for (let w = 0, L = a.column_horizontal_alignments.length; w < L; w++) {
          let R = a.column_horizontal_alignments[w], q = i.value[w];
          q != null && q.$el ? q.$el.classList.add("child-horizontal-align-" + R) : q != null && q.classList && q.classList.add("child-horizontal-align-" + R);
        }
    };
    return St(() => {
      i.value = o.ui.getChildren(), y(), _();
    }), t({
      ...o.expose
    }), ($, w) => (m(), S("div", {
      class: pe(["acquisit-horizontal-layout", "horizontal-align-" + e.align_horizontal, "vertical-align-" + e.align_vertical, { ["column-gap-" + e.column_gap]: u.value }])
    }, [
      at($.$slots, "default")
    ], 2));
  }
}), iq = { class: "collections" }, uq = {
  key: 0,
  class: "accented-background single-collection-wrapper"
}, cq = {
  key: 0,
  class: "collection-title"
}, dq = ["src"], fq = { class: "actions" }, vq = {
  key: 0,
  class: "add-collection"
}, pq = /* @__PURE__ */ Pe({
  __name: "ImageInput",
  props: {
    ...Ge(),
    add_collection_label: {
      type: [String, Object],
      required: !1
    },
    delete_collection_label: {
      type: [String, Object],
      required: !1
    },
    semantic: {
      type: [String, Array],
      required: !1,
      default: null
    },
    upload_button_bordered: {
      type: Boolean,
      required: !1,
      default: !1
    },
    align: {
      type: String,
      required: !1,
      default: "left",
      validator(e) {
        return ["left", "center", "right"].indexOf(e) > -1;
      }
    },
    modelValue: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue",
    "change"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = z(), i = z([]), c = z();
    Le(() => a.modelValue, (Y) => {
      i.value = Y;
    }, {
      immediate: !0,
      deep: !0
    }), C(() => Ft(i.value, (Y) => Y.id));
    const d = C(() => {
      var Y;
      return !!((Y = i.value[0]) != null && Y.images.length);
    }), p = C(() => {
      var Y;
      return !!((Y = i.value[0]) != null && Y.images.filter((V) => !V.deleted).length);
    }), h = C(() => i.value.filter((Y) => !Y.deleted)), y = () => {
      const Y = i.value[0];
      return Gt({
        id: xr("collection-"),
        hash_id: null,
        title: null,
        title_label: Y == null ? void 0 : Y.title_label,
        description: null,
        image_description_label: Y == null ? void 0 : Y.add_image_label,
        images: [],
        add_image_label: Y == null ? void 0 : Y.add_image_label,
        required: !1,
        error: null,
        deleted: !1
      });
    }, _ = () => Gt({
      id: xr("image-"),
      hash_id: null,
      title: null,
      url: null,
      base64: null,
      error: null,
      deleted: !1
    }), $ = () => {
      n("update:modelValue", i.value);
    }, w = (Y) => {
      let V = Y.target;
      for (let T of V.files)
        if (/\.(jpe?g|png|gif)$/i.test(T.name)) {
          let A = new FileReader();
          A.readAsDataURL(T);
          let P = window.URL.createObjectURL(T);
          A.onload = (b) => {
            var N;
            let x = A.result, D = _();
            D.url = P, D.base64 = x, (N = c.value) == null || N.images.push(D), $(), n("change"), V.value = "";
          };
        } else
          alert("Not a valid format: " + T.name);
    }, L = (Y) => {
      var V, T;
      c.value = Y, (T = (V = u.value) == null ? void 0 : V.querySelector(".file-input")) == null || T.click(), $();
    }, R = (Y, V) => {
      V.hash_id ? V.deleted = !0 : Y.images = Y.images.filter((T) => T.id != V.id), $(), n("change");
    }, q = () => {
      i.value.push(y()), $(), n("change");
    }, E = (Y) => {
      Y.hash_id ? Y.deleted = !0 : i.value = i.value.filter((V) => V.id != Y.id), $(), n("change");
    };
    return t({
      ...o.expose
    }), (Y, V) => {
      const T = oe("acquisit-button"), A = oe("acquisit-input");
      return m(), S("div", {
        class: pe(["acquisit-image-collections", "align-" + e.align, { "has-images": d.value && p.value, error: Y.errors }]),
        ref_key: "$root",
        ref: u
      }, [
        W("input", {
          type: "file",
          name: "file",
          class: "file-input",
          accept: "image/*",
          multiple: "",
          onChange: V[0] || (V[0] = (P) => w(P))
        }, null, 32),
        W("div", iq, [
          (m(!0), S(qe, null, We(h.value, (P) => (m(), S("div", {
            class: pe(["image-collection-wrapper", { "has-images": P.images.length }]),
            key: P.id
          }, [
            Y.displayOnly ? B("", !0) : (m(), J(T, {
              key: 0,
              class: "add-image-btn pdf-hidden",
              onClick: (b) => L(P),
              label: P.add_image_label,
              disabled: Y.disabled,
              "no-interact": Y.noInteract,
              icon: "acq/camera",
              "icon-position": "left",
              errors: Y.errors,
              color: g(l).base.value,
              "has-current-errors": g(s),
              bordered: e.upload_button_bordered,
              type: e.upload_button_bordered ? "flat" : "raised"
            }, null, 8, ["onClick", "label", "disabled", "no-interact", "errors", "color", "has-current-errors", "bordered", "type"])),
            K(bt, { name: "move-fade-top" }, {
              default: ie(() => [
                P.images.filter((b) => !b.deleted).length ? (m(), S("div", uq, [
                  P.title_label ? (m(), S("div", cq, [
                    K(A, {
                      modelValue: P.title,
                      "onUpdate:modelValue": (b) => P.title = b,
                      label: P.title_label,
                      disabled: Y.disabled,
                      "no-interact": Y.noInteract
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled", "no-interact"])
                  ])) : B("", !0),
                  K(Sr, {
                    tag: "ul",
                    name: "list-complete",
                    class: pe(["image-collection", { "has-description": P.image_description_label }])
                  }, {
                    default: ie(() => [
                      (m(!0), S(qe, null, We(P.images.filter((b) => !b.deleted), (b) => (m(), S("li", {
                        class: "image list-complete-item",
                        key: b.id
                      }, [
                        W("img", {
                          class: "image",
                          src: b.url ?? void 0,
                          alt: ""
                        }, null, 8, dq),
                        P.image_description_label ? (m(), J(A, {
                          key: 0,
                          modelValue: b.description,
                          "onUpdate:modelValue": (x) => b.description = x,
                          class: "image-description-label",
                          "no-interact": Y.noInteract,
                          disabled: Y.disabled,
                          label: P.image_description_label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "no-interact", "disabled", "label"])) : B("", !0),
                        Y.displayOnly ? B("", !0) : (m(), J(T, {
                          key: 1,
                          class: "delete-image-btn",
                          color: "white",
                          "icon-size": 24,
                          type: "icon",
                          icon: "acq/delete",
                          "no-interact": Y.noInteract,
                          onClick: (x) => R(P, b)
                        }, null, 8, ["no-interact", "onClick"]))
                      ]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ])) : B("", !0)
              ]),
              _: 2
            }, 1024),
            W("div", fq, [
              !Y.displayOnly && i.value.length > 1 ? (m(), J(T, {
                key: 0,
                class: "delete-collection-btn",
                color: "#6e6e6e",
                size: 22,
                type: "icon",
                icon: "acq/delete",
                "no-interact": Y.noInteract,
                label: e.delete_collection_label,
                onClick: (b) => E(P)
              }, null, 8, ["no-interact", "label", "onClick"])) : B("", !0)
            ])
          ], 2))), 128)),
          !Y.displayOnly && e.add_collection_label && d.value ? (m(), S("div", vq, [
            K(T, {
              class: "add-collection-button",
              type: "flat",
              color: "#6e6e6e",
              icon: "acq/add",
              disabled: Y.disabled,
              "no-interact": Y.noInteract,
              label: e.add_collection_label,
              onClick: q
            }, null, 8, ["disabled", "no-interact", "label"])
          ])) : B("", !0)
        ])
      ], 2);
    };
  }
}), mq = ["aria-labelledby", "aria-describedby"], hq = ["id"], yq = {
  key: 0,
  class: "title"
}, bq = {
  key: 1,
  class: "close"
}, gq = ["id"], _q = {
  key: 0,
  class: "body-icon"
}, wq = { class: "body-content" }, kq = { class: "left" }, $q = { class: "right" }, Cq = /* @__PURE__ */ Pe({
  __name: "Modal",
  props: {
    ...Ge(),
    button: {
      type: Object,
      required: !1,
      default: null
    },
    modal: {
      type: Object,
      required: !1,
      default: null
    },
    valid: {
      type: Boolean,
      required: !1,
      default: !0
    },
    type: {
      type: String,
      required: !1,
      default: "modal"
    },
    icon: {
      type: String,
      required: !1,
      default: null
    },
    title: {
      type: [String, Object],
      required: !1,
      default: null
    },
    title_icon: {
      type: String,
      required: !1,
      default: null
    },
    show_close_button: {
      type: Boolean,
      required: !1,
      default: !1
    },
    close_button_color: {
      type: String,
      required: !1,
      default: null
    },
    close_on_overlay_click: {
      type: Boolean,
      required: !1,
      default: !0
    },
    full_page: {
      type: Boolean,
      required: !1,
      default: !1
    },
    full_height: {
      type: Boolean,
      required: !1,
      default: !1
    },
    padding: {
      type: Boolean,
      required: !1,
      default: !0
    },
    no_scroll: {
      type: Boolean,
      required: !1,
      default: !1
    },
    switch_button_styles: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "click",
    "accept",
    "decline"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = Ar("components/extended/Modal", a), o = r, l = fc(), s = Ze(a, o), { color: u, uid: i } = s, c = z(!1), d = z(!1), p = z(!1), h = z(), y = z(), _ = z(), $ = z(), w = z(), L = z(), R = z(), q = C(() => a.button && a.button.pill ? "acquisit-pill-button" : "acquisit-button"), E = C(() => {
      var re;
      return ((re = a.modal) == null ? void 0 : re.button_accept_label) || l.accept;
    }), Y = C(() => {
      var re;
      return ((re = a.modal) == null ? void 0 : re.button_decline_label) || l.decline;
    }), V = C(() => a.type == "sheet" ? "slide" : "scale"), T = C(() => {
      if (a.type != "modal")
        return {
          background: u.base.value.cssHSLA,
          color: u.textContrast.value.cssHSLA
        };
    }), A = C(() => ({
      type: "raised",
      color: u.baseContextSafe.value.cssHSLA
    })), P = C(
      () => {
        var re;
        return a.switch_button_styles || (re = a.modal) != null && re.switch_button_styles ? b.value : A.value;
      }
    ), b = C(() => ({
      type: "flat",
      color: "red"
    })), x = C(
      () => {
        var re;
        return a.switch_button_styles || (re = a.modal) != null && re.switch_button_styles ? A.value : b.value;
      }
    ), D = (re = !1) => (o("click"), c.value = !0, setTimeout(() => {
      d.value = !0;
    }, 1), setTimeout(() => {
      Ye(), re && O();
    }, 100), window.addEventListener("keyup", U), qr().increaseOpenModals(), he(), h.value = new Promise((Se) => {
      Q.value = Se;
    }), h.value), N = () => new Promise((re) => {
      Re(), X(), d.value = !1, qr().decreaseOpenModals(), window.removeEventListener("keyup", U), setTimeout(() => {
        c.value = !1, re(!0);
      }, 300);
    }), M = (re) => {
      Q.value && (Q.value(re), Q.value = null, h.value = null);
    }, H = (re) => {
      a.close_on_overlay_click && re.target == y.value && N().then(() => {
        M(!1);
      });
    }, U = (re) => {
      if (!d.value || re.keyCode != 27)
        return;
      const Se = E.value, me = Y.value;
      me && !Se ? F() : !me && Se ? G() : !Y && !E && N();
    }, G = async () => {
      o("accept");
      for (let re = 0; re < 32; re++)
        await ut();
      a.valid ? (await N(), M(!0)) : M(!1);
    }, F = async () => {
      o("decline"), await N(), M(!1);
    }, O = () => {
      $.value && ($.value.$el && !$.value.focus ? $.value.$el.focus() : $.value.focus());
    }, Q = z(), ae = z(), Te = z(), Ae = z(), Ye = () => {
      const re = Ae.value, Se = L.value || R.value;
      if (!Se || !re) {
        n.warnFrom("jailFocus", "Could not find bounding content");
        return;
      }
      Te.value = (me) => {
        me.key == "Tab" && !me.shiftKey && me.preventDefault();
      }, ae.value = (me) => {
        me.key == "Tab" && me.shiftKey && me.preventDefault();
      }, re.addEventListener("keydown", Te.value), Se.addEventListener("keydown", ae.value);
    }, Re = () => {
      const re = L.value || R.value;
      re && re.removeEventListener("keydown", ae.value), Ae.value && Ae.value.removeEventListener("keydown", Te.value);
    }, it = () => {
      if (!_.value)
        return null;
      const re = (Se) => Se != null && Se.classList.contains("acquisit-modal") ? Se : Se != null && Se.parentElement ? re(Se.parentElement) : null;
      return re(_.value.parentElement);
    }, he = () => {
      const re = it();
      re && re.classList.add("child-scroll-locked");
    }, X = () => {
      const re = it();
      re && re.classList.remove("child-scroll-locked");
    };
    return ts(() => {
      s.registerAction("open", () => D(!0));
    }), St(() => {
      typeof window < "u" && (p.value = /(Macintosh.*?Safari|iPad|iPod|iPhone)/.test(navigator.userAgent) && !window.MSStream && window.matchMedia("(max-width: 600px)").matches);
    }), jr(() => {
      s.unregisterAction("open"), N(), M(!1);
    }), t({
      ...s.expose,
      openModal: D,
      closeModal: N
    }), (re, Se) => {
      const me = oe("v-svg"), fe = oe("acquisit-string"), Oe = oe("acquisit-button");
      return m(), S("div", {
        class: pe(["acquisit-modal", ["type-" + e.type, { ios: p.value }]]),
        ref_key: "root",
        ref: _
      }, [
        e.button ? (m(), J(Yo(q.value), {
          key: 0,
          label: e.button.label,
          class: "open-btn",
          type: e.button.type,
          onClick: Se[0] || (Se[0] = (Ie) => D(!0)),
          color: e.button.color,
          icon: e.button.icon,
          size: e.button.size,
          iconSize: e.button.iconSize,
          iconPosition: e.button.iconPosition
        }, null, 8, ["label", "type", "color", "icon", "size", "iconSize", "iconPosition"])) : B("", !0),
        re.$slots.open ? (m(), S("div", {
          key: 1,
          class: "open",
          onClick: Se[1] || (Se[1] = (Ie) => D(!0))
        }, [
          at(re.$slots, "open", {}, void 0, !0)
        ])) : B("", !0),
        K(bt, { name: "fade" }, {
          default: ie(() => [
            Kt(W("div", {
              class: "modal-wrapper",
              onClick: H,
              ref_key: "modalWrapper",
              ref: y
            }, [
              K(bt, { name: V.value }, {
                default: ie(() => {
                  var Ie, ye;
                  return [
                    d.value ? (m(), S("div", {
                      key: 0,
                      class: pe(["modal", "type-" + e.type, { "full-page": e.full_page, "full-height": e.full_height, "default-padding": e.padding, "no-scroll": e.no_scroll }]),
                      role: "dialog",
                      "aria-labelledby": g(i).uid.value + "_aria_label",
                      "aria-describedby": g(i).uid.value + "_aria_description"
                    }, [
                      re.$slots.header || e.modal && e.modal.title || e.title || e.show_close_button ? (m(), S("div", {
                        key: 0,
                        class: "header",
                        id: g(i).uid.value + "_aria_label",
                        ref_key: "header",
                        ref: L,
                        tabindex: 0,
                        style: we(T.value)
                      }, [
                        at(re.$slots, "header", {}, void 0, !0),
                        e.modal && e.modal.title || e.title || e.title_icon || e.modal && e.modal.title_icon ? (m(), S("div", yq, [
                          e.modal && e.modal.title_icon || e.title_icon ? (m(), J(me, {
                            key: 0,
                            file: e.modal && e.modal.title_icon || e.title_icon,
                            class: "icon"
                          }, null, 8, ["file"])) : B("", !0),
                          W("h3", null, [
                            K(fe, {
                              source: e.modal && e.modal.title || e.title
                            }, null, 8, ["source"])
                          ])
                        ])) : B("", !0),
                        e.show_close_button ? (m(), S("div", bq, [
                          K(Oe, {
                            type: "action",
                            "icon-size": 24,
                            size: 36,
                            icon: "acq/clear",
                            color: e.close_button_color,
                            onClick: Se[2] || (Se[2] = (Fe) => Y.value ? F() : G())
                          }, null, 8, ["color"])
                        ])) : B("", !0)
                      ], 12, hq)) : B("", !0),
                      W("div", {
                        class: "body",
                        id: g(i).uid.value + "_aria_description",
                        ref_key: "body",
                        ref: R,
                        tabindex: 0
                      }, [
                        e.icon || (Ie = e.modal) != null && Ie.icon ? (m(), S("div", _q, [
                          K(me, {
                            file: e.icon || e.modal.icon || "",
                            color: g(u).baseVisuallySafe.value
                          }, null, 8, ["file", "color"])
                        ])) : B("", !0),
                        W("div", wq, [
                          at(re.$slots, "body", {}, void 0, !0),
                          at(re.$slots, "default", {}, void 0, !0),
                          e.modal && e.modal.body ? (m(), J(fe, {
                            key: 0,
                            source: e.modal.body
                          }, null, 8, ["source"])) : B("", !0)
                        ])
                      ], 8, gq),
                      re.$slots.accept || re.$slots.decline || re.$slots.left || re.$slots.right || e.modal && (e.modal.button_accept_label || e.modal.button_decline_label) ? (m(), S("div", {
                        key: 1,
                        class: pe(["footer", { switched: e.switch_button_styles || ((ye = e.modal) == null ? void 0 : ye.switch_button_styles) }])
                      }, [
                        W("div", kq, [
                          at(re.$slots, "left", {}, void 0, !0),
                          re.$slots.decline || e.modal && e.modal.button_decline_label ? (m(), J(Oe, {
                            key: 0,
                            class: "cancel-button",
                            onClick: F,
                            label: e.modal && e.modal.button_decline_label ? e.modal.button_decline_label : void 0,
                            type: x.value.type,
                            color: x.value.color,
                            ref_key: "declineButton",
                            ref: w
                          }, {
                            default: ie(() => [
                              at(re.$slots, "decline", {}, void 0, !0)
                            ]),
                            _: 3
                          }, 8, ["label", "type", "color"])) : B("", !0)
                        ]),
                        W("div", $q, [
                          re.$slots.accept || e.modal && e.modal.button_accept_label ? (m(), J(Oe, {
                            key: 0,
                            class: "accept-button",
                            onClick: G,
                            label: e.modal && e.modal.button_accept_label ? e.modal.button_accept_label : void 0,
                            type: P.value.type,
                            color: P.value.color,
                            ref_key: "acceptButton",
                            ref: $
                          }, {
                            default: ie(() => [
                              at(re.$slots, "accept", {}, void 0, !0)
                            ]),
                            _: 3
                          }, 8, ["label", "type", "color"])) : B("", !0),
                          at(re.$slots, "right", {}, void 0, !0)
                        ])
                      ], 2)) : B("", !0),
                      W("div", {
                        class: "tab-key-bound",
                        ref_key: "tabKeyBound",
                        ref: Ae,
                        tabindex: 0
                      }, null, 512)
                    ], 10, mq)) : B("", !0)
                  ];
                }),
                _: 3
              }, 8, ["name"])
            ], 512), [
              [_r, c.value]
            ])
          ]),
          _: 3
        })
      ], 2);
    };
  }
}), Sq = /* @__PURE__ */ Yn(Cq, [["__scopeId", "data-v-e88546b9"]]), xq = { class: "meta" }, Dq = {
  key: 0,
  class: "items"
}, Aq = { class: "actions" }, Pq = /* @__PURE__ */ Pe({
  __name: "ItemsEditorPreset",
  props: {
    ...Ge(),
    preset: {
      type: Object,
      required: !0
    },
    itemsByUid: {
      type: Object,
      reqired: !1,
      default: {}
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((i) => ({
      "925ed958": g(l).backgroundLightTinted.value.cssHSLA,
      32555749: g(l).baseVisuallySafe.value.cssHSLA
    }));
    const a = e, o = Ze(a, r), { color: l } = o, s = C(() => {
      if (!a.itemsByUid || !ls(a.itemsByUid))
        return null;
      const i = [];
      for (let c of a.preset.items)
        a.itemsByUid[c] && i.push(o.language.parse(a.itemsByUid[c].title));
      return i.join(", ") || null;
    }), u = C(() => !!s.value);
    return t({
      ...o.expose
    }), (i, c) => {
      const d = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-items-editor-preset", { "has-items-description": u.value, "no-interact": i.noInteract }])
      }, [
        W("div", xq, [
          K(d, {
            class: "label",
            source: e.preset.label
          }, null, 8, ["source"]),
          u.value ? (m(), S("div", Dq, je(s.value), 1)) : B("", !0)
        ]),
        W("div", Aq, [
          at(i.$slots, "actions")
        ])
      ], 2);
    };
  }
}), Oq = { class: "acquisit-items-editor" }, Tq = { class: "items" }, Iq = {
  key: 0,
  class: "empty"
}, Mq = {
  key: 1,
  class: "presets"
}, qq = {
  key: 0,
  class: "actions"
}, Eq = { class: "item-presets" }, Vq = ["onKeyup", "onClick"], Lq = {
  key: 0,
  class: "icon"
}, Bq = /* @__PURE__ */ Pe({
  __name: "ItemsEditor",
  props: {
    ...Ge(),
    items: {
      type: Array,
      required: !1,
      default: []
    },
    presets: {
      type: Array,
      required: !1,
      default: []
    },
    add_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    edit_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    delete_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    delete_all_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    delete_all_confirmation_modal: {
      type: [Object],
      required: !1,
      default: null
    },
    empty_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    ok_label: {
      type: [String, Object],
      required: !1,
      default: "OK"
    },
    max_items: {
      type: Number,
      required: !1,
      default: void 0
    },
    guards: {
      type: Array,
      required: !1,
      default: null
    },
    modelValue: {
      type: Array,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = nr(a), { items: i } = u, c = Ar("components/extended/ItemsEditor", a), d = z([]), p = z(), h = z(), y = z(), _ = z(), $ = z(), w = z(), L = z(), R = C(() => a.delete_all_confirmation_modal ? {
      ...a.delete_all_confirmation_modal,
      switch_button_styles: !0
    } : null);
    an(() => {
      d.value = kt(i.value.filter((F) => !F.hidden));
    }), St(() => {
      a.modelValue === null ? T() : Array.isArray(a.modelValue) && (d.value = a.modelValue);
    });
    const q = C(() => {
      var ae, Te;
      let F = {}, O = (Ae, Ye) => {
        Ae.uid in F || (F[Ae.uid] = {}), Array.isArray(F[Ae.uid][Ye.reference.properties.uid]) || (F[Ae.uid][Ye.reference.properties.uid] = []), F[Ae.uid][Ye.reference.properties.uid].push(Ye);
      };
      const Q = Array.isArray(a.errors) ? a.errors : [];
      for (let Ae of Q) {
        let Ye = (ae = Ae.owner) != null && ae.path ? kt(Ae.owner.path) : [Ae.owner], Re;
        for (; Re = Ye.pop(); )
          Re != null && Re.item && E.value[Re.item.uid] && O(Re.item, Ae);
        if ((Te = Ae.owner) != null && Te.item) {
          let it = Ae.owner.item;
          O(it, Ae);
        }
      }
      return F;
    }), E = C(() => Ft(d.value, (F) => F.uid)), Y = C(() => Ft(i.value, (F) => F.uid));
    C(() => {
      const F = {};
      for (let O of d.value)
        F[O.uid] = {
          item: O,
          componentsByUID: wr(O.components)
        };
      return F;
    });
    const V = C(() => a.max_items === void 0 || a.max_items === null ? !!a.add_item_label : a.add_item_label && Object.keys(E.value).length < a.max_items), T = () => {
      n("update:modelValue", d.value);
    }, A = async (F, O = !0) => {
      let Q = kt(F);
      return Q.template_uid = Q.uid, Q.uid = xr("item-"), d.value.length ? o.guards.emit("add-nth-item") : o.guards.emit("add-first-item"), d.value.push(Q), o.guards.emit("add-item"), T(), await ut(), O && await P(Q), Q;
    }, P = async (F) => {
      var O;
      p.value = F, await ut(), (O = $.value) == null || O.openModal().then((Q) => {
        p.value = null;
      });
    }, b = (F) => {
      let O = d.value.findIndex((Q) => Q.uid === F.uid);
      O > -1 && (d.value.splice(O, 1), T());
    }, x = (F = !1) => {
      const O = L.value;
      !O || F ? (d.value = d.value.filter((Q) => !Q.allows_deletion), T()) : O.openModal();
    }, D = (F) => {
      if (h.value) {
        let O = { x: F.clientX, y: F.clientY };
        h.value.isOpen ? h.value.updatePosition(O) : h.value.open(_.value.$el, O);
      } else y.value ? y.value.openModal() : c.errorFrom("onAddItemClick", "Couldn't find either $addItemMenu or $addItemModal");
    }, N = (F) => {
      var O;
      (O = y.value) == null || O.closeModal();
      for (let Q of i.value)
        if (Q.uid == F.uid) {
          A(Q);
          return;
        }
    }, M = async (F) => {
      for (let O of F.items) {
        const Q = Y.value[O];
        Q ? await A(Q, !1) : c.warnFrom("addPreset", "Could not find item UID", O);
      }
    }, H = (F, O) => {
      if (F) {
        for (let Q = 0, ae = d.value.length; Q < ae; Q++)
          if (d.value[Q].uid == F.uid) {
            d.value[Q].components = O, T();
            break;
          }
      }
    }, U = async () => {
      var F, O;
      try {
        await G(), (F = $.value) == null || F.closeModal();
      } catch (Q) {
        if (Array.isArray(Q))
          for (let ae of Q)
            (O = w.value) == null || O.triggerErrorAnimation(ae);
        else
          c.always.errorFrom("onAcceptClick", Q);
      }
    }, G = async () => (p.value && await Gr({
      components: p.value.components,
      owner: p.value,
      componentsByTag: nn(p.value.components),
      componentsByUID: wr(p.value.components),
      pagesByUID: {},
      productsByUID: {},
      personsByID: {},
      setProperties: as
    }), !0);
    return Le(i, (F) => {
      d.value = kt(F.filter((O) => !O.hidden)), T();
    }, {
      deep: !0
    }), t({
      ...o.expose
    }), (F, O) => {
      var he;
      const Q = oe("acquisit-string"), ae = oe("acquisit-button"), Te = oe("acquisit-items-editor-item"), Ae = oe("acquisit-context-menu"), Ye = oe("v-svg"), Re = oe("acquisit-modal"), it = oe("acquisit-components-container");
      return m(), S("div", Oq, [
        W("ul", Tq, [
          e.empty_label && !d.value.length ? (m(), S("li", Iq, [
            e.empty_label ? (m(), J(Q, {
              key: 0,
              source: e.empty_label,
              class: "empty-label"
            }, null, 8, ["source"])) : B("", !0),
            (he = a.presets) != null && he.length && !F.displayOnly ? (m(), S("ul", Mq, [
              (m(!0), S(qe, null, We(a.presets, (X) => (m(), J(Pq, {
                preset: X,
                "items-by-uid": Y.value,
                "no-interact": F.noInteract,
                onClick: (re) => M(X)
              }, {
                actions: ie(() => [
                  K(ae, {
                    type: "action",
                    bordered: "",
                    icon: "acq/add",
                    size: 32,
                    "icon-size": 20
                  })
                ]),
                _: 2
              }, 1032, ["preset", "items-by-uid", "no-interact", "onClick"]))), 256))
            ])) : B("", !0)
          ])) : B("", !0),
          (m(!0), S(qe, null, We(d.value, (X) => (m(), J(Te, {
            tag: "li",
            key: X.uid,
            item: X,
            edit_item_label: e.edit_item_label,
            delete_item_label: e.delete_item_label,
            errors: q.value[X.uid] ?? null,
            "has-current-errors": g(s),
            "no-interact": F.noInteract,
            onEdit: O[0] || (O[0] = (re) => P(re)),
            onDelete: O[1] || (O[1] = (re) => b(re))
          }, null, 8, ["item", "edit_item_label", "delete_item_label", "errors", "has-current-errors", "no-interact"]))), 128))
        ]),
        V.value && !F.noInteract ? (m(), S("div", qq, [
          K(ae, {
            label: e.add_item_label,
            type: "flat",
            bordered: "",
            icon: "acq/add",
            ref_key: "$addItemButton",
            ref: _,
            onClick: D
          }, null, 8, ["label"]),
          e.delete_all_label && d.value.length ? (m(), J(ae, {
            key: 0,
            onClick: O[2] || (O[2] = (X) => x(!1)),
            type: "flat",
            label: e.delete_all_label,
            bordered: "",
            class: "on-white",
            color: "red",
            icon: "acq/delete"
          }, null, 8, ["label"])) : B("", !0),
          g(i).length <= 3 ? (m(), J(Ae, {
            key: 1,
            items: g(i).map((X) => ({ uid: X.uid, label: X.title, icon: X.icon })),
            onClick: N,
            ref_key: "$addItemMenu",
            ref: h
          }, null, 8, ["items"])) : B("", !0),
          (m(), J(Xt, { to: "body" }, [
            g(i).length > 3 ? (m(), J(Re, {
              key: 0,
              ref_key: "$addItemModal",
              ref: y,
              class: "acquisit-items-editor-add-item-modal",
              show_close_button: "",
              type: "sheet"
            }, {
              header: ie(() => [
                W("h3", null, je(g(o).language.parse(e.add_item_label)), 1)
              ]),
              default: ie(() => [
                W("ul", Eq, [
                  (m(!0), S(qe, null, We(g(i), (X) => (m(), S("li", {
                    class: "item",
                    tabindex: 0,
                    onKeyup: Jt((re) => N(X), ["enter"]),
                    onClick: (re) => N(X)
                  }, [
                    X.icon ? (m(), S("div", Lq, [
                      K(Ye, {
                        file: X.icon,
                        color: g(l).base.value
                      }, null, 8, ["file", "color"])
                    ])) : B("", !0),
                    K(Q, {
                      class: "title",
                      source: X.title || "?"
                    }, null, 8, ["source"]),
                    W("div", {
                      class: "focus-ring",
                      style: we({ borderColor: g(l).base.value.cssHSLA })
                    }, null, 4)
                  ], 40, Vq))), 256))
                ])
              ]),
              _: 1
            }, 512)) : B("", !0)
          ])),
          (m(), J(Xt, { to: "body" }, [
            R.value ? (m(), J(Re, {
              key: 0,
              ref_key: "$deleteAllConfirmationModal",
              ref: L,
              class: "acquisit-items-editor-delete-all-items-modal",
              type: "modal",
              onAccept: O[3] || (O[3] = (X) => x(!0)),
              modal: R.value
            }, null, 8, ["modal"])) : B("", !0)
          ]))
        ])) : B("", !0),
        (m(), J(Xt, { to: "body" }, [
          p.value && !F.noInteract ? (m(), J(Re, {
            key: 0,
            ref_key: "$editItemModal",
            ref: $,
            class: "acquisit-items-editor-edit-item-modal",
            full_height: "",
            show_close_button: "",
            title: p.value.title,
            title_icon: p.value.icon ?? void 0,
            type: "sheet"
          }, {
            right: ie(() => [
              K(ae, {
                type: "raised",
                onClick: U,
                color: g(l).baseVisuallyAndContextSafe.value,
                label: e.ok_label
              }, null, 8, ["color", "label"])
            ]),
            default: ie(() => [
              K(it, {
                uid: "items-editor-components-" + p.value.uid,
                class: "edit-item-component-container",
                ref: "edit_item_components_container",
                components: p.value.components,
                "has-current-errors": g(s),
                guards: e.guards,
                owner: p.value,
                "onUpdate:modelValue": O[4] || (O[4] = (X) => H(p.value, X))
              }, null, 8, ["uid", "components", "has-current-errors", "guards", "owner"])
            ]),
            _: 1
          }, 8, ["title", "title_icon"])) : B("", !0)
        ]))
      ]);
    };
  }
}), jq = ["aria-label"], Hq = { class: "f" }, Rq = {
  class: "meta",
  "aria-hidden": "true"
}, Fq = {
  key: 1,
  class: "actions"
}, Nq = /* @__PURE__ */ Pe({
  __name: "ItemsEditorItem",
  props: {
    ...Ge(),
    item: {
      type: Object,
      required: !0
    },
    edit_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    delete_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    tag: {
      type: String,
      required: !1,
      default: "div"
    }
  },
  emits: [
    ...Ke(),
    "edit",
    "delete"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, o = Ze(a, r), { color: l, erroring: s } = o, u = z({}), i = C(() => {
      if (a.item.title_reference_uid) {
        let h = u.value[a.item.title_reference_uid];
        if (h && h.properties.modelValue) {
          let y = h.properties.modelValue;
          if (xc(y) ? y = o.language.parse(y) : y = String(y), Jp(y) != "")
            return y;
        }
      }
      return a.item.title;
    }), c = C(() => a.item.title_reference_uid && i.value ? a.item.title : null), d = C(
      () => c.value && o.language.parse(c.value) != (o.language.parse(i.value) || "").trim()
    ), p = (h = null) => {
      a.item.title_reference_uid ? u.value = wr(h ?? a.item.components) : u.value = {};
    };
    return Le(() => a.item.title_reference_uid, () => p()), Le(() => a.item.components, (h) => p(h), {
      deep: !0
    }), St(() => {
      p();
    }), t({
      ...o.expose
    }), (h, y) => {
      const _ = oe("v-svg"), $ = oe("acquisit-string"), w = oe("acquisit-button");
      return m(), S("li", {
        class: pe(["acquisit-items-editor-item", { "has-icon": e.item.icon, error: h.errors, erroring: g(s) }]),
        "aria-label": i.value
      }, [
        W("div", Hq, [
          e.item.icon ? (m(), S("div", {
            key: 0,
            class: "icon",
            style: we({ color: g(l).baseVisuallyAndContextSafe.value.cssHSLA }),
            "aria-hidden": "true"
          }, [
            K(_, {
              file: e.item.icon
            }, null, 8, ["file"])
          ], 4)) : B("", !0),
          W("div", Rq, [
            d.value ? (m(), J($, {
              key: 0,
              class: "type",
              source: c.value
            }, null, 8, ["source"])) : B("", !0),
            i.value ? (m(), J($, {
              key: 1,
              class: "title",
              source: i.value
            }, null, 8, ["source"])) : B("", !0)
          ]),
          !h.noInteract && (e.edit_item_label || e.delete_item_label) ? (m(), S("div", Fq, [
            e.edit_item_label ? (m(), J(w, {
              key: 0,
              "icon-size": 20,
              size: 36,
              icon: "acq/edit",
              type: "action",
              onClick: y[0] || (y[0] = (L) => h.$emit("edit", e.item)),
              title: e.edit_item_label,
              color: g(l).baseVisuallyAndContextSafe.value,
              "aria-label": e.edit_item_label
            }, null, 8, ["title", "color", "aria-label"])) : B("", !0),
            e.delete_item_label && (e.item.allows_deletion ?? !0) ? (m(), J(w, {
              key: 1,
              "icon-size": 20,
              size: 36,
              icon: "acq/delete",
              type: "action",
              color: "red",
              title: e.delete_item_label,
              onClick: y[1] || (y[1] = (L) => h.$emit("delete", e.item)),
              "aria-label": e.delete_item_label
            }, null, 8, ["title", "aria-label"])) : B("", !0)
          ])) : B("", !0)
        ])
      ], 10, jq);
    };
  }
}), Wf = () => ({
  constraints: {
    type: Array,
    required: !1,
    default: []
  }
}), Yq = ["data-item-uid"], Uq = {
  key: 2,
  class: "add-item pdf-hidden"
}, zq = /* @__PURE__ */ Pe({
  __name: "ItemsInput",
  props: {
    ...Ge(),
    ...Wf(),
    items: {
      type: Array,
      required: !0
    },
    no_items_checkbox: {
      type: Object,
      required: !1,
      default: null
    },
    add_item_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    add_item_template_uid: {
      type: String,
      required: !1,
      default: null
    },
    allow_delete_all: {
      type: Boolean,
      required: !1,
      default: !1
    },
    add_icon: {
      type: String,
      required: !1,
      default: null
    },
    max_items: {
      type: Number,
      required: !1,
      default: null
    },
    guards: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      required: !1,
      default: void 0
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ar("components/extended/ItemsInput", a), l = Ze(a, n), { color: s, erroring: u } = l, i = qr(), c = z(), d = z([]), p = z(!1), h = $m(z({}));
    an(() => {
      if (a.add_item_template_uid) {
        for (let b of a.items)
          if (b.uid === a.add_item_template_uid) {
            c.value = kt(b);
            break;
          }
      }
      !c.value && Array.isArray(a.items) && (c.value = a.items.length ? kt(a.items[a.items.length - 1]) : null);
    }), St(() => {
      var b, x;
      (b = a.no_items_checkbox) != null && b.value ? d.value = [] : (x = a.modelValue) != null && x.length ? d.value = kt(a.modelValue) : d.value = kt(a.items), d.value = d.value.filter((D) => !D.hidden), (a.modelValue === null || a.modelValue === void 0) && q();
    });
    const y = C(() => {
      var x;
      const b = ((x = a.no_items_checkbox) == null ? void 0 : x.value) ?? !1;
      return a.noInteract ? !b : !b || !p.value;
    }), _ = C(() => {
      const b = d.value.length > 1 || a.allow_delete_all;
      for (let x of d.value)
        if (x.allows_deletion && b)
          return !0;
      return !1;
    }), $ = C(() => a.max_items === null || a.max_items === void 0 ? !0 : d.value.length < a.max_items), w = C(() => a.add_icon === null ? "acq/add" : a.add_icon), L = C(() => {
      var x, D, N, M;
      let b = {};
      if (!Array.isArray(a.errors))
        return b;
      for (let H of a.errors) {
        let U = (D = (x = H.owner) == null ? void 0 : x.item) == null ? void 0 : D.uid, G = (M = (N = H.reference) == null ? void 0 : N.properties) == null ? void 0 : M.uid;
        if (U && G) {
          let F = 0, O = 0;
          for (let Q of d.value) {
            if (Q.uid == U) {
              let ae = 0;
              for (let Te of Q.components) {
                if (Te.properties.uid == G) {
                  O = ae;
                  break;
                }
                ae++;
              }
              break;
            }
            F++;
          }
          b[U + "-" + G] = {
            item: F,
            component: O,
            error: H
          };
        }
      }
      return b;
    }), R = C(() => {
      var x, D;
      let b = {};
      if (!Array.isArray(a.errors))
        return b;
      for (let N of a.errors) {
        let M = (D = (x = N.owner) == null ? void 0 : x.item) == null ? void 0 : D.uid;
        M && (b[M] || (b[M] = []), b[M].push(N));
      }
      return b;
    }), q = () => {
      var b;
      (b = a.no_items_checkbox) != null && b.value ? n("update:modelValue", p.value ? [] : d.value) : n("update:modelValue", d.value);
    }, E = () => {
      var D;
      if (!c.value)
        return null;
      const b = kt(c.value.components);
      let x = null;
      return (D = c.value.image_collections) != null && D.length && (x = [
        {
          ...kt(c.value.image_collections[0]),
          id: xr("collection-"),
          images: [],
          title: null,
          description: null,
          hash_id: null,
          deleted: !1
        }
      ]), Gt({
        components: b,
        uid: xr("item-"),
        template_uid: c.value.uid,
        image_collections: x,
        allows_deletion: !0,
        hidden: !1,
        export: c.value.export
      });
    }, Y = async () => {
      const b = E();
      if (!b) {
        o.always.error("No template item found");
        return;
      }
      d.value.length ? l.guards.emit("add-nth-item") : l.guards.emit("add-first-item"), d.value.push(b), l.guards.emit("add-item"), a.no_items_checkbox && (a.no_items_checkbox.value = !1), q(), await ut();
      const x = h.refs.value[b.uid];
      i.is_mobile && (x != null && x.focusFirstComponent) && x.focusFirstComponent();
    }, V = (b) => {
      let x = d.value.findIndex((D) => D.uid === b.uid);
      x > -1 && (d.value.splice(x, 1), q());
    }, T = (b, x) => {
      for (let D = 0, N = d.value.length; D < N; D++)
        if (d.value[D].uid == b.uid) {
          d.value[D].components = x;
          break;
        }
    }, A = (b, x) => {
      if (!Array.isArray(a.errors))
        return;
      L.value[b.uid + "-" + x.properties.uid] && (o.debugFrom("onComponentChange", "Emitting value to reset errors for", x.properties.uid, "in", b.uid), q());
    }, P = (b) => {
      var U, G, F;
      let x = (G = (U = b.reference) == null ? void 0 : U.properties) == null ? void 0 : G.uid, D = b.owner;
      if (!x) {
        o.warnFrom("triggerErrorAnimationForSubComponent", "Cannot trigger error animation for error", b);
        return;
      }
      let N = D != null && D.path ? kt(D.path) : [D], M = !1, H;
      for (; H = N.pop(); ) {
        let O = h.refs.value[(F = H.item) == null ? void 0 : F.uid];
        O != null && O.triggerErrorAnimation && (O.triggerErrorAnimation(b), M = !0);
      }
      M || o.warnFrom("triggerErrorAnimationForSubComponent", "Could not find $ref for uid", x, "with owner", D);
    };
    return Le(() => a.items, (b) => {
      d.value = b, q();
    }, {
      deep: !0
    }), Le(() => a.no_items_checkbox, (b) => {
      q(), p.value = !0, !(b != null && b.value) && !d.value.length && Y();
    }, {
      deep: !0
    }), Le(() => a.modelValue, (b) => {
      d.value = b || [];
    }, {
      deep: !0
    }), Le(d, (b) => {
      b.length && (a.no_items_checkbox && (a.no_items_checkbox.value = !1), p.value = !0, wc(Ht(d), Ht(a.modelValue)) || q());
    }, {
      deep: !0
    }), t({
      ...l.expose,
      addItem: Y,
      deleteItem: V,
      triggerErrorAnimationForSubComponent: P
    }), (b, x) => {
      const D = oe("acquisit-checkbox"), N = oe("acquisit-button"), M = oe("acquisit-components-container"), H = oe("acquisit-image-input");
      return m(), S("div", {
        class: pe(["acquisit-items-input", { "has-no-items-checkbox": e.no_items_checkbox, "has-items": d.value.length > 0, disabled: b.disabled }])
      }, [
        e.no_items_checkbox ? (m(), J(D, {
          key: 0,
          modelValue: e.no_items_checkbox.value,
          "onUpdate:modelValue": x[0] || (x[0] = (U) => e.no_items_checkbox.value = U),
          uid: b.uid + "no-item",
          class: "no-items-checkbox",
          "no-interact": b.noInteract,
          disabled: b.disabled,
          label: e.no_items_checkbox.label,
          labelPosition: "right"
        }, null, 8, ["modelValue", "uid", "no-interact", "disabled", "label"])) : B("", !0),
        y.value ? (m(), S("div", {
          key: 1,
          class: pe(["items", { multiple: !b.displayOnly && _.value }])
        }, [
          (m(!0), S(qe, null, We(d.value, (U) => (m(), S("div", {
            key: U.uid,
            "data-tag": "item",
            "data-item-uid": U.uid,
            class: "item"
          }, [
            !b.displayOnly && (d.value.length > 1 || e.allow_delete_all) && U.allows_deletion ? (m(), J(N, {
              key: 0,
              class: "delete-item-button pdf-hidden",
              uid: "delete-item-" + U.uid,
              "data-tag": "delete-item-button",
              onClick: (G) => V(U),
              type: "icon",
              bordered: "",
              size: 24,
              "icon-size": 18,
              disabled: b.disabled,
              "no-interact": b.noInteract,
              color: "red",
              icon: "acq/delete"
            }, null, 8, ["uid", "onClick", "disabled", "no-interact"])) : B("", !0),
            (m(), J(M, {
              components: U.components,
              errors: R.value[U.uid],
              "has-current-errors": g(u),
              guards: e.guards,
              ref_for: !0,
              ref: (G) => g(h).add(U.uid, G),
              key: U.uid + "-components",
              "no-interact": b.noInteract,
              "display-only": b.displayOnly,
              disabled: b.disabled,
              owner: U,
              "data-tag": "item-components",
              "onUpdate:modelValue": (G) => T(U, G),
              onComponentChange: (G) => A(U, G)
            }, null, 8, ["components", "errors", "has-current-errors", "guards", "no-interact", "display-only", "disabled", "owner", "onUpdate:modelValue", "onComponentChange"])),
            U.image_collections && U.image_collections.length ? (m(), J(H, {
              key: 1,
              class: "image-collections-input pdf-hidden",
              "data-tag": "item-images",
              errors: U.image_collections[0].error,
              modelValue: U.image_collections,
              "onUpdate:modelValue": (G) => U.image_collections = G,
              onChange: q,
              "no-interact": b.noInteract,
              "display-only": b.displayOnly,
              disabled: b.disabled,
              add_collection_label: U.add_collection_label
            }, null, 8, ["errors", "modelValue", "onUpdate:modelValue", "no-interact", "display-only", "disabled", "add_collection_label"])) : B("", !0)
          ], 8, Yq))), 128))
        ], 2)) : B("", !0),
        $.value && !b.displayOnly && e.add_item_label && y.value ? (m(), S("div", Uq, [
          K(N, {
            uid: b.uid + "-add-item",
            class: "add-item-button",
            "data-tag": "add-item-button",
            onClick: Y,
            type: "flat",
            color: g(s).baseVisuallySafe.value,
            bordered: "",
            "no-interact": b.noInteract,
            label: e.add_item_label,
            disabled: b.disabled,
            icon: w.value
          }, null, 8, ["uid", "color", "no-interact", "label", "disabled", "icon"])
        ])) : B("", !0)
      ], 2);
    };
  }
}), Wq = /* @__PURE__ */ Pe({
  __name: "Tab",
  props: {
    ...Ge(),
    icon: {
      type: String,
      required: !1,
      default: null
    },
    title: {
      type: [String, Object],
      required: !0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, o = Ze(a, r), { uid: l } = o, s = z(!0), u = mr("tabsProvider"), i = mr("addTab"), c = mr("updateTab"), d = mr("removeTab");
    return Le(() => u.active_tab_uid, (p) => {
      s.value = a.uid !== p;
    }), Le(() => Object.assign({}, a), () => {
      c(a.uid, {
        ...a,
        hidden: s.value
      });
    }), ts(() => {
      i({
        ...a,
        hidden: !0
      });
    }), jr(() => {
      d(a.uid);
    }), t({
      uid: l.uid
    }), (p, h) => Kt((m(), S("div", {
      class: pe(["acquisit-tab", { hidden: s.value }]),
      key: g(l).uid.value
    }, [
      at(p.$slots, "default")
    ], 2)), [
      [_r, !s.value]
    ]);
  }
}), Kq = ["onClick", "onKeyup"], Gq = {
  class: "f",
  tabindex: -1
}, Zq = {
  key: 0,
  class: "icon"
}, Xq = { class: "title" }, Jq = { class: "tabs" }, Qq = /* @__PURE__ */ Pe({
  __name: "Tabs",
  props: {
    ...Ge(),
    iconPosition: {
      type: String,
      required: !1,
      default: "left"
    },
    selectedTab: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "change",
    "clickTab",
    "update:selectedTab"
  ],
  setup(e, { emit: t }) {
    const r = e, a = t, n = Ze(r, a), o = Gt({
      tabs: [],
      active_tab_uid: null
    }), l = C(() => Ft(o.tabs, (_) => _.uid)), s = z("move-fade-right"), { color: u } = n;
    ar("tabsProvider", o), ar("addTab", (_) => {
      _.index = o.tabs.length - 1, o.tabs.push(_);
    }), ar("updateTab", (_, $) => {
      const w = o.tabs.findIndex((L) => L.uid === _);
      w > -1 && Rt($, (L, R) => {
        o.tabs[w][R] = L;
      });
    }), ar("removeTab", (_) => {
      const $ = o.tabs.findIndex((w) => w.uid === _);
      $ > -1 && o.tabs.splice($, 1);
    });
    const i = (_) => {
      _.disabled || _.uid == o.active_tab_uid || (o.active_tab_uid = _.uid, d());
    }, c = (_) => {
      const $ = o.tabs.findIndex((w) => w.uid === _);
      $ > -1 && i(o.tabs[$]);
    }, d = () => {
      if (!o.active_tab_uid) {
        if (!o.tabs.length)
          return;
        o.active_tab_uid = o.tabs[0].uid;
      }
      for (let _ of o.tabs)
        _.hidden = _.uid !== o.active_tab_uid, _.uid == o.active_tab_uid && (a("change", _), a("update:selectedTab", _.uid));
    }, p = async (_) => {
      const $ = o.active_tab_uid ? l.value[o.active_tab_uid] : null;
      o.active_tab_uid && $ && $.index > _.index ? s.value = "move-fade-left" : s.value = "move-fade-right", await ut(), i(_), a("clickTab", _);
    }, h = C(() => {
      switch (r.theme) {
        case "integrated":
          return {
            color: u.baseVisuallyAndContextSafe.value.cssHex,
            borderColor: u.baseVisuallyAndContextSafe.value.withAlpha(0.27).cssHSLA
          };
        case "integrated-dark":
          return {
            color: u.baseVisuallyAndContextSafe.value.cssHex,
            borderColor: u.baseVisuallyAndContextSafe.value.withAlpha(0.4).cssHSLA
          };
        default:
          return {
            color: u.baseVisuallyAndContextSafe.value.cssHex
          };
      }
    }), y = C(() => {
      switch (r.theme) {
        case "integrated":
        case "integrated-dark":
          return {
            background: u.baseVisuallyAndContextSafe.value.withAlpha(0.17).cssHSLA,
            borderColor: u.baseVisuallyAndContextSafe.value.withAlpha(0.4).cssHSLA
          };
        case "dark":
          return {
            borderTopColor: u.baseVisuallyAndContextSafe.value.cssHex,
            background: "linear-gradient(to bottom, " + u.baseVisuallyAndContextSafe.value.withAlpha(0.07).cssHSLA + " 0%, rgba(0,0,0,0) 100%)"
          };
        default:
          return {
            borderTopColor: u.baseVisuallyAndContextSafe.value.lighten(24).cssHex,
            background: "linear-gradient(to bottom, " + u.baseVisuallyAndContextSafe.value.withAlpha(0.07).cssHSLA + " 0%, rgba(255,255,255,0) 100%)"
          };
      }
    });
    return St(() => {
      d(), r.selectedTab && c(r.selectedTab);
    }), (_, $) => {
      const w = oe("v-svg"), L = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-tabs", "acquisit-component", "theme-" + _.theme])
      }, [
        W("nav", {
          class: "tab-navigation",
          style: we(h.value)
        }, [
          W("ul", null, [
            (m(!0), S(qe, null, We(o.tabs, (R) => (m(), S("li", {
              class: pe(["tab", "icon-position-" + e.iconPosition, { active: !R.hidden }]),
              tabindex: 0,
              style: we(R.hidden ? void 0 : y.value),
              onClick: (q) => p(R),
              onKeyup: Jt((q) => i(R), ["enter"])
            }, [
              W("div", Gq, [
                R.icon ? (m(), S("div", Zq, [
                  K(w, {
                    file: R.icon
                  }, null, 8, ["file"])
                ])) : B("", !0),
                W("div", Xq, [
                  K(L, {
                    class: "string",
                    source: R.title
                  }, null, 8, ["source"])
                ]),
                W("div", {
                  class: "focus-ring",
                  style: we({ borderColor: g(u).textContextSafeContrast.value.cssHSLA })
                }, null, 4)
              ])
            ], 46, Kq))), 256))
          ])
        ], 4),
        W("div", Jq, [
          K(Sr, { name: s.value }, {
            default: ie(() => [
              at(_.$slots, "default")
            ]),
            _: 3
          }, 8, ["name"])
        ])
      ], 2);
    };
  }
}), eE = { class: "acquisit-viewfinder-image-input" }, tE = {
  key: 3,
  class: "delete-all"
}, rE = { class: "image-wrapper" }, aE = {
  key: 0,
  class: "error-overlay"
}, nE = {
  key: 0,
  class: "loading-overlay"
}, oE = {
  key: 1,
  class: "actions"
}, lE = { class: "viewfinder-actions" }, sE = {
  key: 0,
  class: "metadata-overlay"
}, iE = { class: "primary" }, uE = { class: "secondary" }, cE = /* @__PURE__ */ Pe({
  __name: "ViewfinderImageInput",
  props: {
    ...Ge(),
    modelValue: {
      type: Array,
      required: !0
    },
    take_photo_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    upload_image_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    viewfinder: {
      type: Object,
      required: !1,
      default: null
    },
    image_metadata: {
      type: Object,
      required: !1,
      default: null
    },
    align: {
      type: String,
      required: !1,
      default: "left"
    }
  },
  emits: [
    ...Ke(),
    "change",
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ar("components/extended/ViewfinderImageInput", a), l = Ze(a, n), { color: s } = l, u = Cm(), i = qr(), c = z([]);
    an(() => {
      c.value = a.modelValue.map((te) => ({
        ...te,
        id: te.id || xr("image-"),
        hash_id: te.hash_id || null,
        metadata: te.metadata || {},
        deleted: te.deleted || !1,
        error: te.error || null
      }));
    });
    const d = z(), p = z(), h = z(), y = z([]), _ = z(), $ = z({}), w = z(!1), L = z(!1);
    z({});
    const R = z(), q = z(), E = z(), Y = z(), V = z(), T = z(), A = z(), P = z(), b = z(), x = C(() => c.value.filter((te) => !te.deleted)), D = C(() => process.env.NODE_ENV == "development"), N = C(() => c.value.length ? null : c.value[c.value.length - 1]);
    C(() => {
      let te = {}, xe = 0;
      for (let Ee of y.value)
        te[Ee.deviceId] = Ee.label ?? "Kamera " + xe++;
      return te;
    });
    const M = C(() => {
      if (!_.value || !y.value.length)
        return null;
      for (let te of y.value)
        if (te.deviceId === _.value)
          return te;
      return null;
    }), H = C(() => {
      let te = new URL(self.location.href);
      return te.protocol = "https", te.toString();
    }), U = C(() => D.value && x.value.length), G = () => {
      var te;
      return !!((te = navigator == null ? void 0 : navigator.mediaDevices) != null && te.getUserMedia);
    }, F = async () => (await navigator.mediaDevices.enumerateDevices()).filter((xe) => xe.kind == "videoinput"), O = async (te = null) => {
      if (G()) {
        o.infoFrom("setupCamera", "Setting up…");
        const xe = {
          width: { ideal: 2560 },
          height: { ideal: 1440 }
        };
        te ? xe.deviceId = te.deviceId : xe.facingMode = "environment";
        const Ee = {
          audio: !1,
          video: xe
        };
        o.debugFrom("setupCamera", "Getting stream…");
        const Ve = await navigator.mediaDevices.getUserMedia(Ee), Xe = q.value;
        return h.value = void 0, Xe.srcObject = Ve, Xe.onloadedmetadata = () => {
          o.debugFrom("setupCamera", "Getting tracks…");
          let de = Ve.getVideoTracks();
          de.length && (o.debugFrom("setupCamera", "Using track", de[0].label), h.value = de[0].label);
        }, p.value = Ve, o.debugFrom("setupCamera", "Playing stream…"), q.value.play();
      } else
        o.warnFrom("setupCamera", "Camera unsupported");
    }, Q = async (te) => (o.infoFrom("switchCamera", "device", te), te ? (o.debugFrom("switchCamera", "Closing camera…"), nt(), O(te)) : (o.warnFrom("switchCamera", "No device passed"), !1)), ae = async (te) => {
      const xe = te.target;
      for (let Ee of xe.files)
        try {
          const Ve = await Te(Ee);
          c.value.push(Ve), $e.push(() => X(Ve).then((Xe) => {
            Me(), n("change"), He(Ve);
          })).then((Xe) => {
          });
        } catch (Ve) {
          o.always.errorFrom("onImageInput", Ve);
        }
      xe.value = "";
    }, Te = (te) => (o.infoFrom("readImageFile", "Reading file", te), new Promise((xe, Ee) => {
      if (/\.(jpe?g|png|gif)$/i.test(te.name)) {
        let Ve = new FileReader();
        Ve.readAsDataURL(te);
        let Xe = window.URL.createObjectURL(te);
        Ve.onload = (de) => {
          let ke = Ve.result, lt = Fe();
          lt.url = Xe, lt.base64 = ke, xe(lt);
        };
      } else
        Ee(new Error("Invalid image format: " + te.name));
    })), Ae = async () => {
      o.infoFrom("takePhoto", "Taking photo…");
      const te = E.value, xe = te.getContext("2d"), Ee = q.value;
      te.width = Ee.videoWidth, te.height = Ee.videoHeight, o.debugFrom("takePhoto", "canvas", "width", te.width, "height", te.height), o.debugFrom("takePhoto", "Drawing image…"), xe.drawImage(Ee, 0, 0, Ee.videoWidth, Ee.videoHeight), o.debugFrom("takePhoto", "Converting to JPEG data URI…");
      const Ve = te.toDataURL("image/jpeg", 0.9);
      o.debugFrom("takePhoto", "Clearing canvas…"), xe.clearRect(0, 0, te.width, te.height), o.debugFrom("takePhoto", "Creating image model");
      let Xe = Fe();
      o.debugFrom("takePhoto", "Converting data URI to Blob…");
      const de = Qp(Ve);
      return Xe.url = URL.createObjectURL(de), Xe.base64 = Ve, o.debugFrom("takePhoto", "Created object URL", Xe.url), o.debugFrom("takePhoto", "Adding image to component…"), c.value.push(Xe), $e.push(async () => {
        await X(Xe), Me(), He(Xe), o.debugFrom("takePhoto", "Uploaded");
      }), Xe;
    }, Ye = () => {
      var te;
      o.debugFrom("selectImage", "Asking for image from disk…"), (te = P.value) == null || te.click();
    }, Re = (te) => {
      for (let xe = 0, Ee = c.value.length; xe < Ee; xe++) {
        const Ve = c.value[xe];
        if (Ve.id == te && !Ve.loading) {
          (async () => {
            var de;
            ((de = Ve.url) == null ? void 0 : de.substring(0, 4)) == "blob" && URL.revokeObjectURL(Ve.url);
            try {
              Ve.loading = !0, Ve.hash_id && await u.deleteImage(Ve.collection_hash_id, Ve.hash_id), Ve.collection_hash_id && await u.deleteImageCollection(Ve.collection_hash_id);
            } catch (ke) {
              o.always.errorFrom("deleteImage", ke);
            }
            const Xe = c.value.indexOf(Ve);
            Xe > -1 ? (c.value.splice(Xe, 1), Me(), mt(Ve)) : o.warnFrom("deleteImage", "Could not find index of image to remove", te);
          })();
          return;
        }
      }
      o.always.warnFrom("deleteImage", "Could not find image with ID", te);
    }, it = async () => {
      const te = [];
      for (let Ee = 0, Ve = c.value.length; Ee < Ve; Ee++) {
        const Xe = c.value[Ee];
        if (!Xe) {
          o.warnFrom("image was undefined at index", Ee);
          continue;
        }
        Xe.hash_id && te.push(async () => (await u.deleteImage(Xe.collection_hash_id, Xe.hash_id), await u.deleteImageCollection(Xe.collection_hash_id), Xe));
      }
      const xe = await Promise.allSettled(te.map((Ee) => Ee()));
      for (let Ee of xe)
        if (Ee.status == "fulfilled") {
          const Ve = c.value.indexOf(Ee.value);
          if (Ve > -1) {
            const Xe = c.value[Ve];
            c.value.splice(Ve, 1), mt(Xe);
          }
        } else
          o.always.errorFrom("deleteAllImages", "Could not delete image", Ee.reason);
      Me();
    }, he = (te) => {
      var Ee;
      if (!((Ee = te.metadata) != null && Ee.length))
        return {
          values: {}
        };
      const xe = wr(te.metadata);
      return os({
        componentsByUID: xe,
        productsByUID: {},
        personsByID: {}
      }, !0);
    }, X = async (te) => {
      if (!te.hash_id && !te.loading)
        return o.infoFrom("uploadImage", "Uploading image to backend…"), new Promise(async (xe, Ee) => {
          te.loading = !0;
          try {
            if (!te.collection_hash_id) {
              o.debugFrom("uploadImage", "Creating image collection");
              const Xe = em(""), de = await u.addImageCollection(Xe, he(te));
              te.collection_hash_id = de.hash_id, o.debugFrom("uploadImage", "Created image collection with ID", te.collection_hash_id);
            }
            o.debugFrom("uploadImage", "Uploading image itself…");
            const Ve = await u.addImage(te.collection_hash_id, te);
            te.hash_id = Ve.hash_id, te.url = Ve.url, te.base64 = null, te.error = null, o.debugFrom("uploadImage", "Uploaded image with ID", te.hash_id, "at", te.url), xe();
          } catch (Ve) {
            o.always.errorFrom("uploadImage", Ve), Ee(Ve);
          } finally {
            te.loading = !1;
          }
        });
    }, re = async (te, xe) => {
      if (te.collection_hash_id)
        return o.infoFrom("updateImageMetadata", "Updating image metadata in backend…"), new Promise(async (Ee, Ve) => {
          te.loading = !0;
          try {
            await u.updateImageCollection(te.collection_hash_id, null, xe), te.error = null, o.debugFrom("updateImageMetadata", "Updated image metadata"), Ee();
          } catch (Xe) {
            o.always.errorFrom("updateImageMetadata", Xe), Ve(Xe);
          } finally {
            te.loading = !1;
          }
        });
    }, Se = async () => {
      var te;
      (te = V.value) == null || te.openModal(), await ut(), await O();
    }, me = async (te) => {
      var Ee, Ve;
      y.value = await F(), await ut();
      const xe = {
        x: te.clientX,
        y: te.clientY
      };
      (Ee = T.value) != null && Ee.isOpen ? T.value.updatePosition(xe) : (Ve = T.value) == null || Ve.open(A.value, xe);
    }, fe = (te) => {
      _.value = te.uid;
    }, Oe = async (te) => {
      var xe;
      if (!te)
        return !1;
      d.value = te, await ut(), (xe = R.value) == null || xe.openModal();
    }, Ie = (te, xe) => {
      if (!te)
        return !1;
      te.metadata = xe, Me();
    }, ye = async (te) => {
      var de;
      if (!te)
        return !1;
      let xe = wr(te.metadata), Ee = nn(te.metadata), Ve = { component_uid: a.uid, image: te }, Xe = (ke, lt) => {
        for (let dt in lt)
          lt.hasOwnProperty(dt) && (ke.properties[dt] = lt[dt]);
      };
      try {
        await Gr({
          components: te.metadata,
          componentsByUID: xe,
          componentsByTag: Ee,
          productsByUID: {},
          // FIXME Add
          personsByID: {},
          // FIXME Add
          pagesByUID: {},
          // FIXME Add
          owner: Ve,
          setProperties: Xe
        });
        const ke = he(te);
        $e.push(async () => {
          await re(te, ke), Me(), ce(te);
        }), (de = R.value) == null || de.closeModal();
      } catch (ke) {
        o.warnFrom("onImageMetadataSave", "Validation rejected", ke);
      }
    }, Fe = () => {
      let te = [];
      return a.image_metadata && (te = kt(a.image_metadata.components), tm(te)), {
        id: xr("image-"),
        hash_id: null,
        collection_hash_id: null,
        metadata: te,
        url: null,
        base64: null,
        error: null,
        deleted: !1,
        loading: !1
      };
    }, Me = () => {
      n("update:modelValue", c.value);
    }, He = (te) => {
      Ra.$emit(Hm, {
        image: te
      });
    }, ce = (te) => {
      Ra.$emit(Fm, {
        image: te
      });
    }, mt = (te) => {
      Ra.$emit(Rm, {
        image: te
      });
    }, nt = () => {
      if (!p.value) {
        o.infoFrom("closeCamera", "No stream set up");
        return;
      }
      let te = p.value.getTracks();
      for (let xe of te)
        o.infoFrom("closeCamera", "Stopping track", xe), xe.stop();
      o.infoFrom("closeCamera", "Stream reset"), p.value = void 0;
    }, ot = () => {
      Qe.value = $e.isFull();
    }, ft = () => {
      Qe.value = $e.isFull();
    }, $e = new Ym(
      6,
      ot,
      ft
    ), Qe = z(!1);
    return jr(() => {
      nt();
    }), Le(_, () => {
      M.value && Q(M.value);
    }), t({
      ...l.expose
    }), (te, xe) => {
      const Ee = oe("acquisit-button"), Ve = oe("acquisit-info-box"), Xe = oe("v-svg"), de = oe("acquisit-spinner"), ke = oe("acquisit-context-menu"), lt = oe("acquisit-modal"), dt = oe("acquisit-components-container");
      return m(), S("div", eE, [
        W("input", {
          type: "file",
          name: "file",
          class: "file-input",
          accept: "image/*",
          multiple: "",
          onChange: xe[0] || (xe[0] = (Je) => ae(Je)),
          ref_key: "$fileInput",
          ref: P
        }, null, 544),
        e.take_photo_label || e.upload_image_label ? (m(), S("div", {
          key: 0,
          class: pe(["actions", "align-" + e.align])
        }, [
          D.value && !G() ? (m(), J(Ve, {
            key: 0,
            type: "warning"
          }, {
            default: ie(() => [
              xe[5] || (xe[5] = pt(" Camera access requires ")),
              K(Ee, {
                href: H.value,
                type: "text",
                color: g(s).base.value
              }, {
                default: ie(() => xe[4] || (xe[4] = [
                  pt("HTTPS ›")
                ])),
                _: 1
              }, 8, ["href", "color"])
            ]),
            _: 1
          })) : B("", !0),
          e.take_photo_label && !te.displayOnly ? (m(), J(Ee, {
            key: 1,
            type: "raised",
            onClick: Se,
            color: g(s).base.value,
            label: e.take_photo_label,
            "no-interact": !G() || te.noInteract,
            disabled: !G(),
            icon: "acq/camera"
          }, null, 8, ["color", "label", "no-interact", "disabled"])) : B("", !0),
          e.upload_image_label && !te.displayOnly ? (m(), J(Ee, {
            key: 2,
            type: "flat",
            onClick: Ye,
            color: g(s).base.value,
            bordered: "",
            "no-interact": te.noInteract,
            label: e.upload_image_label,
            icon: "acq/upload"
          }, null, 8, ["color", "no-interact", "label"])) : B("", !0),
          U.value && !te.displayOnly ? (m(), S("div", tE, [
            K(Ee, {
              onClick: it,
              icon: "acq/delete",
              color: "red",
              type: "flat",
              bordered: ""
            }, {
              default: ie(() => xe[6] || (xe[6] = [
                pt(" Delete all ")
              ])),
              _: 1
            })
          ])) : B("", !0)
        ], 2)) : B("", !0),
        K(bt, { name: "move-fade-top" }, {
          default: ie(() => [
            Kt(K(Sr, {
              tag: "div",
              name: "list-complete",
              class: pe(["images"])
            }, {
              default: ie(() => [
                (m(!0), S(qe, null, We(x.value, (Je) => (m(), S("div", {
                  key: Je.id,
                  class: "image list-complete-item"
                }, [
                  W("div", rE, [
                    W("div", {
                      class: "img",
                      style: we({ backgroundImage: "url('" + Je.url + "')" })
                    }, null, 4),
                    K(bt, { name: "fade" }, {
                      default: ie(() => [
                        Je.error ? (m(), S("div", aE, [
                          K(Xe, {
                            file: "info/warning",
                            class: "icon"
                          }),
                          K(Ee, {
                            icon: "acq/refresh",
                            type: "raised",
                            label: "Retry",
                            disabled: Je.loading,
                            onClick: (ue) => X(Je)
                          }, null, 8, ["disabled", "onClick"])
                        ])) : B("", !0)
                      ]),
                      _: 2
                    }, 1024),
                    K(bt, { name: "fade" }, {
                      default: ie(() => [
                        Je.loading ? (m(), S("div", nE, [
                          K(de, { size: "mini" })
                        ])) : B("", !0)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  te.displayOnly ? B("", !0) : (m(), J(Ee, {
                    key: 0,
                    class: "delete-image-btn",
                    color: "white",
                    "icon-size": 24,
                    type: "icon",
                    icon: "acq/delete",
                    "no-interact": te.noInteract,
                    onClick: (ue) => Re(Je.id)
                  }, null, 8, ["no-interact", "onClick"])),
                  e.image_metadata ? (m(), S("div", oE, [
                    K(Ee, {
                      class: "open-image-metadata-btn",
                      "no-interact": te.noInteract,
                      type: "flat",
                      "icon-size": 24,
                      color: g(s).base.value,
                      label: e.image_metadata.title,
                      icon: e.image_metadata.icon ?? void 0,
                      onClick: (ue) => Oe(Je)
                    }, null, 8, ["no-interact", "color", "label", "icon", "onClick"])
                  ])) : B("", !0)
                ]))), 128))
              ]),
              _: 1
            }, 512), [
              [_r, x.value.length]
            ])
          ]),
          _: 1
        }),
        (m(), J(Xt, { to: "body" }, [
          K(lt, {
            ref_key: "$viewfinderModal",
            ref: V,
            class: "acquisit-viewfinder-image-input-viewfinder-modal",
            type: "sheet",
            close_on_overlay_click: !1,
            full_page: "",
            padding: !1,
            title: h.value,
            title_icon: "acq/camera",
            close_button_color: "white",
            show_close_button: ""
          }, {
            default: ie(() => {
              var Je;
              return [
                W("video", {
                  ref_key: "$viewfinderVideo",
                  ref: q,
                  autoplay: "",
                  playsinline: ""
                }, null, 512),
                W("canvas", {
                  ref_key: "$viewfinderCanvas",
                  ref: E
                }, null, 512),
                W("div", {
                  style: we($.value),
                  ref_key: "$shotAnimation",
                  ref: b,
                  class: pe(["shot-animation", { visible: w.value, transition: L.value }])
                }, null, 6),
                W("div", lE, [
                  W("section", {
                    class: "last-image",
                    onClick: xe[1] || (xe[1] = (ue) => Oe(N.value))
                  }, [
                    W("div", {
                      class: pe(["image-wrapper", [{ visible: N.value && !w.value }]]),
                      ref_key: "$viewfinderLastImage",
                      ref: Y
                    }, [
                      Kt(W("div", {
                        class: "img",
                        style: we({ backgroundImage: "url('" + (N.value ? N.value.url : "/") + "')" })
                      }, null, 4), [
                        [_r, N.value]
                      ]),
                      (Je = e.image_metadata) != null && Je.icon && N.value ? (m(), S("div", sE, [
                        K(Xe, {
                          file: e.image_metadata.icon,
                          class: "icon"
                        }, null, 8, ["file"])
                      ])) : B("", !0)
                    ], 2)
                  ]),
                  W("section", iE, [
                    K(Ee, {
                      type: "action",
                      size: 56,
                      iconSize: 32,
                      icon: "acq/camera",
                      onClick: Ae,
                      disabled: Qe.value || w.value,
                      "no-interact": Qe.value || w.value,
                      loading: Qe.value,
                      class: "take-photo-btn"
                    }, null, 8, ["disabled", "no-interact", "loading"])
                  ]),
                  W("section", uE, [
                    K(Ee, {
                      type: "action",
                      color: g(s).secondary.value,
                      size: 36,
                      iconSize: 24,
                      icon: "acq/settings",
                      onClick: me,
                      ref_key: "$settingsButton",
                      ref: A,
                      class: "open-settings-btn"
                    }, null, 8, ["color"])
                  ]),
                  y.value.length ? (m(), J(ke, {
                    key: 0,
                    items: y.value.map((ue) => ({ uid: ue.deviceId, label: ue.label || "Camera" })),
                    onClick: fe,
                    anchor: g(i).is_landscape ? "top-right" : "bottom-right",
                    ref_key: "$devicesMenu",
                    ref: T
                  }, null, 8, ["items", "anchor"])) : B("", !0)
                ])
              ];
            }),
            _: 1
          }, 8, ["title"])
        ])),
        (m(), J(Xt, { to: "body" }, [
          e.image_metadata && d.value ? (m(), J(lt, {
            key: 0,
            ref_key: "$metadataModal",
            ref: R,
            class: "metadata-modal",
            type: "sheet",
            close_on_overlay_click: !1,
            title: e.image_metadata.title,
            title_icon: e.image_metadata.icon ?? void 0
          }, {
            right: ie(() => [
              K(Ee, {
                onClick: xe[3] || (xe[3] = (Je) => ye(d.value)),
                type: "raised",
                label: e.image_metadata.save_label
              }, null, 8, ["label"])
            ]),
            default: ie(() => [
              K(dt, {
                components: d.value.metadata,
                "onUpdate:modelValue": xe[2] || (xe[2] = (Je) => Ie(d.value, Je))
              }, null, 8, ["components"])
            ]),
            _: 1
          }, 8, ["title", "title_icon"])) : B("", !0)
        ]))
      ]);
    };
  }
}), dE = { class: "acquisit-persons-address" }, fE = { class: "person" }, vE = {
  key: 0,
  class: "person-header"
}, pE = { class: "postcode-city-wrapper" }, mE = {
  key: 1,
  class: "empty"
}, hE = /* @__PURE__ */ Pe({
  __name: "PersonsAddress",
  props: {
    ...Ge(),
    ...Bn(),
    /**
     * Person types to show in this component
     */
    person_types: {
      type: Array,
      required: !0
    },
    address_label: {
      type: [String, Object],
      required: !0
    },
    postcode_label: {
      type: [String, Object],
      required: !0
    },
    postcode_format: {
      type: String,
      required: !1,
      default: "DDDD+"
    },
    city_label: {
      type: [String, Object],
      required: !0
    },
    date_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * The label for the action to copy the same address as above
     */
    copy_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * The label for defining a temporary address
     */
    temporary_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * The label for stating an address doesn't exist, yet
     */
    undefined_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * How many persons to show per person type
     * 'one' or 'all'
     */
    persons_per_type: {
      type: String,
      required: !1,
      default: "one"
    },
    /**
     * Whether to show name, even if only one person
     */
    show_single_name: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = jn(), i = z({}), c = z(!1), d = Hn(), p = C(() => Ht(d.persons)), h = C(() => In(p.value, (V) => V.type)), y = C(() => {
      let V = [];
      for (let A of a.person_types) {
        let P = h.value[A] ?? [];
        a.persons_per_type == "one" ? V = V.concat(P.slice(0, 1)) : V = V.concat(P);
      }
      const T = (A) => {
        var P;
        return (P = a.persons_conditions) != null && P[A.type] ? u.evaluate(a.persons_conditions[A.type], A) : !0;
      };
      return V.filter(T);
    }), _ = C(() => {
      var T, A;
      let V = {};
      if (Array.isArray(a.errors)) {
        for (let P of a.errors)
          if (P.key != "modelValue" && ((A = (T = P.owner) == null ? void 0 : T.change) != null && A.person_id)) {
            let b = P.owner.change.person_id;
            V[b] || (V[b] = {}), V[b][P.key] = [P];
          }
      }
      return V;
    }), $ = () => {
      let V = [];
      for (let T of y.value)
        V.push({
          person_id: T.id,
          address: i.value[T.id]
        });
      n("update:modelValue", V);
    }, w = () => {
      var D, N, M, H, U, G, F;
      let V = {}, T = {}, A = {}, P = !1, b = a.modelValue || [];
      for (let O of b)
        T[O.person_id] = !0;
      let x = 0;
      for (let O of y.value) {
        let Q = { ...O.address };
        Q.copied && x > 0 ? (Q = kt(V[y.value[x - 1].id]), Q.copied = !0) : (Q.address = ((D = i.value[O.id]) == null ? void 0 : D.address) || Q.address || null, Q.postcode = ((N = i.value[O.id]) == null ? void 0 : N.postcode) || Q.postcode || null, Q.city = ((M = i.value[O.id]) == null ? void 0 : M.city) || Q.city || null, Q.copied = ((H = i.value[O.id]) == null ? void 0 : H.copied) ?? Q.copied ?? !1, a.date_label && (Q.date = ((U = i.value[O.id]) == null ? void 0 : U.date) ?? Q.date ?? null), a.undefined_address_label && (Q.undefined_address = ((G = i.value[O.id]) == null ? void 0 : G.undefined_address) ?? Q.undefined_address ?? !1), a.temporary_address_label && (Q.temporary = ((F = i.value[O.id]) == null ? void 0 : F.temporary) ?? Q.temporary ?? !1)), V[O.id] = Q, A[O.id] = !0, x++;
      }
      for (let O of Object.keys(A))
        if (!(O in T)) {
          P = !0;
          break;
        }
      for (let O of Object.keys(T))
        if (!(O in A)) {
          P = !0;
          break;
        }
      i.value = V, c.value = !0, (P || !a.modelValue) && $();
    }, L = (V, T) => {
      y.value[V] && y.value[T] && (y.value[T].address = kt(y.value[V].address), y.value[T].address.copied = !0, w(), $());
    }, R = async (V, T) => {
      if (y.value[V]) {
        const A = y.value[V];
        A.address.undefined_address = T, T && (A.address.temporary !== void 0 && (A.address.temporary = !1), await ut(), E(V)), w(), $();
      }
    }, q = async (V, T) => {
      if (y.value[V]) {
        const A = y.value[V];
        A.address.temporary = T, T && (A.address.undefined_address !== void 0 && (A.address.undefined_address = !1), await ut(), E(V)), w(), $();
      }
    }, E = (V, T = !1) => {
      if (y.value[V]) {
        const A = y.value[V];
        T || A.address.copied, a.date_label, a.temporary_address_label && (T || A.address.temporary), a.undefined_address_label && (T || A.address.undefined_address);
      }
    }, Y = () => {
      w(), $();
    };
    return St(() => {
      w();
    }), Le(() => a.person_types, () => w()), Le(() => y.value, () => w()), t({
      ...o.expose
    }), (V, T) => {
      const A = oe("v-svg"), P = oe("acquisit-checkbox"), b = oe("acquisit-input"), x = oe("acquisit-string");
      return m(), S("div", dE, [
        c.value ? (m(!0), S(qe, { key: 0 }, We(y.value, (D, N) => {
          var M, H, U, G;
          return m(), S("div", fE, [
            e.show_single_name || y.value.length > 1 ? (m(), S("span", vE, [
              K(A, {
                class: "icon",
                file: "acq/person"
              }),
              pt(" " + je([D.firstname, D.name].filter((F) => !!F).join(" ")), 1)
            ])) : B("", !0),
            i.value[D.id] ? (m(), S(qe, { key: 1 }, [
              e.copy_label && N > 0 ? (m(), J(P, {
                key: 0,
                label: e.copy_label,
                modelValue: i.value[D.id].copied,
                "onUpdate:modelValue": [(F) => i.value[D.id].copied = F, (F) => F ? L(N - 1, N) : E(N, !0)],
                "no-interact": V.noInteract
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "no-interact"])) : B("", !0),
              K(b, {
                label: e.address_label,
                modelValue: i.value[D.id].address,
                "onUpdate:modelValue": [(F) => i.value[D.id].address = F, Y],
                errors: (M = _.value[D.id]) == null ? void 0 : M.address,
                "has-current-errors": g(s),
                "no-interact": V.noInteract,
                disabled: i.value[D.id].copied || i.value[D.id].undefined_address
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "errors", "has-current-errors", "no-interact", "disabled"]),
              W("div", pE, [
                K(b, {
                  label: e.postcode_label,
                  modelValue: i.value[D.id].postcode,
                  "onUpdate:modelValue": [(F) => i.value[D.id].postcode = F, Y],
                  errors: (H = _.value[D.id]) == null ? void 0 : H.postcode,
                  "has-current-errors": g(s),
                  "no-interact": V.noInteract,
                  disabled: i.value[D.id].copied || i.value[D.id].undefined_address,
                  format: e.postcode_format || "DDDD+",
                  class: "postcode"
                }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "errors", "has-current-errors", "no-interact", "disabled", "format"]),
                K(b, {
                  label: e.city_label,
                  modelValue: i.value[D.id].city,
                  "onUpdate:modelValue": [(F) => i.value[D.id].city = F, Y],
                  errors: (U = _.value[D.id]) == null ? void 0 : U.city,
                  "has-current-errors": g(s),
                  "no-interact": V.noInteract,
                  disabled: i.value[D.id].copied || i.value[D.id].undefined_address,
                  class: "city"
                }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "errors", "has-current-errors", "no-interact", "disabled"])
              ]),
              e.date_label ? (m(), J(b, {
                key: 1,
                label: e.date_label,
                modelValue: i.value[D.id].date,
                "onUpdate:modelValue": [(F) => i.value[D.id].date = F, Y],
                errors: (G = _.value[D.id]) == null ? void 0 : G.date,
                "has-current-errors": g(s),
                "no-interact": V.noInteract,
                disabled: i.value[D.id].copied || i.value[D.id].undefined_address,
                type: "date",
                class: "date"
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "errors", "has-current-errors", "no-interact", "disabled"])) : B("", !0),
              e.temporary_address_label ? (m(), J(P, {
                key: 2,
                label: e.temporary_address_label,
                disabled: i.value[D.id].undefined_address || i.value[D.id].copied,
                "no-interact": V.noInteract || i.value[D.id].copied,
                modelValue: i.value[D.id].temporary,
                "onUpdate:modelValue": [(F) => i.value[D.id].temporary = F, (F) => q(N, F)]
              }, null, 8, ["label", "disabled", "no-interact", "modelValue", "onUpdate:modelValue"])) : B("", !0),
              e.undefined_address_label ? (m(), J(P, {
                key: 3,
                label: e.undefined_address_label,
                disabled: i.value[D.id].temporary || i.value[D.id].copied,
                "no-interact": V.noInteract || i.value[D.id].copied,
                modelValue: i.value[D.id].undefined_address,
                "onUpdate:modelValue": [(F) => i.value[D.id].undefined_address = F, (F) => R(N, F)]
              }, null, 8, ["label", "disabled", "no-interact", "modelValue", "onUpdate:modelValue"])) : B("", !0)
            ], 64)) : B("", !0)
          ]);
        }), 256)) : B("", !0),
        y.value.length == 0 && V.persons_conditions_no_match_label ? (m(), S("div", mE, [
          K(x, { source: V.persons_conditions_no_match_label }, null, 8, ["source"])
        ])) : B("", !0)
      ]);
    };
  }
}), yE = ["id"], bE = ["for"], gE = {
  key: 0,
  class: "chooser",
  tabindex: -1
}, _E = {
  class: "person",
  tabindex: -1
}, wE = {
  key: 1,
  class: "empty"
}, kE = {
  key: 0,
  class: "chooser",
  tabindex: -1
}, $E = {
  class: "person",
  tabindex: -1
}, CE = {
  key: 1,
  class: "empty"
}, SE = /* @__PURE__ */ Pe({
  __name: "PersonsChooser",
  props: {
    ...Ge(),
    ...Bn(),
    /**
     * Person types to show in this component
     */
    person_types: {
      type: Array,
      required: !0
    },
    label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    multiple: {
      type: Boolean,
      required: !1,
      default: !1
    },
    type: {
      type: String,
      required: !1,
      default: "sheet"
    },
    empty_label: {
      type: [String, Object],
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = Ar("components/person/PersonsChooser", a), o = r, l = Ze(a, o), { color: s, uid: u, erroring: i } = l, c = nr(a), d = c.modelValue, p = z(), h = z(), y = jn(), _ = C(() => a.type ?? (a.inline ? "inline" : "sheet")), $ = z({}), w = Hn(), L = C(() => Ht(w.persons)), R = C(() => In(L.value, (M) => M.type)), q = C(() => {
      var H;
      let M = [];
      for (let U of a.person_types) {
        let G = R.value[U] ?? [];
        (H = a.persons_conditions) != null && H[U] && (G = G.filter((F) => y.evaluate(a.persons_conditions[U], F))), M = M.concat(G);
      }
      return M.sort((U, G) => {
        const F = [U.firstname, U.name].filter((Q) => !!Q).join(" "), O = [G.firstname, G.name].filter((Q) => !!Q).join(" ");
        return F.localeCompare(O);
      });
    }), E = C(() => L.value.filter((M) => {
      var H;
      return (H = $.value[M.id]) == null ? void 0 : H.selected;
    })), Y = C(() => {
      var H;
      const M = [];
      for (let U of q.value)
        (H = $.value[U.id]) != null && H.selected && M.push(U.id);
      return M;
    }), V = C(() => {
      var H;
      if (_.value != "dropdown")
        return {};
      let M = {};
      for (let U of q.value)
        M[U.id] = {
          value: U.id,
          label: [U.firstname, U.name].filter((G) => !!G).join(" "),
          disabled: !!(((H = $.value[U.id]) == null ? void 0 : H.selected) ?? !1)
        };
      return M;
    }), T = () => {
      o("update:modelValue", Y.value);
    }, A = (M = !0) => {
      var U;
      const H = {};
      for (let G of L.value)
        H[G.id] = {
          person: G,
          selected: !1
        };
      if (M) {
        for (let G of L.value)
          $.value[G.id] && (H[G.id].selected = ((U = $.value[G.id]) == null ? void 0 : U.selected) || !1);
        if (Array.isArray(d.value))
          for (let G of d.value)
            H[G] && (H[G].selected = !0);
      }
      $.value = H;
    }, P = (M) => {
      $.value[M] && ($.value[M].selected = !0);
    }, b = (M) => {
      $.value[M] && ($.value[M].selected = !1);
    }, x = () => {
      var M;
      if (!a.noInteract) {
        if (a.type == "inline") {
          n.warnFrom("openSelection", "openSelection() does not work with inline mode");
          return;
        }
        a.type == "sheet" && ((M = p.value) == null || M.openModal());
      }
    }, D = async (M) => {
      a.multiple || Rt($.value, (H, U) => {
        M != U && H && b(U);
      }), await ut(), await T();
    }, N = C({
      get() {
        return E.value.length ? E.value[0].id : null;
      },
      set(M) {
        for (let H of E.value)
          b(H.id);
        M && P(M), T();
      }
    });
    return Le(L, () => {
      A(), T();
    }), Le(d, (M) => {
      if (A(!1), Array.isArray(M))
        for (let H of M)
          P(H);
    }), St(() => {
      A(), a.required && q.value.length == 1 && (P(q.value[0].id), T()), (d.value === null || d.value === void 0) && T();
    }), t({
      ...l.expose
    }), (M, H) => {
      const U = oe("v-svg"), G = oe("acquisit-string"), F = oe("acquisit-dropdown"), O = oe("acquisit-checkbox"), Q = oe("acquisit-modal");
      return m(), S("div", {
        class: pe(["acquisit-persons-chooser", { error: M.errors, erroring: g(i), inline: _.value == "inline", "no-interact": M.noInteract }])
      }, [
        _.value == "sheet" ? (m(), S("div", {
          key: 0,
          class: "button-wrapper",
          tabindex: 0,
          onKeypress: Jt(x, ["enter"])
        }, [
          W("button", {
            onClick: x,
            ref: "$wrapper",
            tabindex: -1,
            id: g(u).id + "-trigger"
          }, [
            K(Sr, {
              tag: "div",
              class: "current-value",
              name: "list-complete"
            }, {
              default: ie(() => [
                (m(!0), S(qe, null, We(E.value, (ae) => (m(), S("div", {
                  class: "person list-complete-item",
                  key: ae.id,
                  style: we({ background: g(s).baseContextSafe.value.cssHSLA, color: g(s).textContextSafeContrast.value.cssHSLA })
                }, je([ae.firstname, ae.name].filter((Te) => !!Te).join(" ")), 5))), 128))
              ]),
              _: 1
            }),
            K(U, {
              class: "icon",
              file: "chevrons/right"
            }),
            W("div", {
              class: "focus-ring",
              style: we({ borderColor: g(s).focusDark.value.cssHSLA })
            }, null, 4)
          ], 8, yE),
          e.label ? (m(), S("label", {
            key: 0,
            for: g(u).id + "-trigger",
            class: pe([{ filled: Y.value.length }]),
            tabindex: -1
          }, [
            K(G, {
              for: g(u).id,
              "font-size": "1rem",
              source: e.label
            }, null, 8, ["for", "source"]),
            at(M.$slots, "default")
          ], 10, bE)) : B("", !0)
        ], 32)) : B("", !0),
        _.value == "dropdown" ? (m(), J(F, {
          key: 1,
          label: e.label,
          ref_key: "$dropdown",
          ref: h,
          modelValue: N.value,
          "onUpdate:modelValue": H[0] || (H[0] = (ae) => N.value = ae),
          options: V.value
        }, null, 8, ["label", "modelValue", "options"])) : B("", !0),
        (m(), J(Xt, { to: "body" }, [
          _.value == "sheet" ? (m(), J(Q, {
            key: 0,
            ref_key: "$chooserModal",
            ref: p,
            type: "sheet"
          }, Ca({
            accept: ie(() => [
              H[1] || (H[1] = pt("OK"))
            ]),
            default: ie(() => [
              Object.keys($.value).length ? (m(), S("ul", gE, [
                (m(!0), S(qe, null, We(q.value, (ae) => (m(), S("li", _E, [
                  K(O, {
                    label: [ae.firstname, ae.name].filter((Te) => !!Te).join(" "),
                    radio: !e.multiple && q.value.length > 1,
                    onClick: (Te) => D(ae.id),
                    modelValue: $.value[ae.id].selected,
                    "onUpdate:modelValue": (Te) => $.value[ae.id].selected = Te
                  }, null, 8, ["label", "radio", "onClick", "modelValue", "onUpdate:modelValue"])
                ]))), 256))
              ])) : e.empty_label ? (m(), S("div", wE, [
                K(G, { source: e.empty_label }, null, 8, ["source"])
              ])) : B("", !0)
            ]),
            _: 2
          }, [
            e.label ? {
              name: "header",
              fn: ie(() => [
                W("h3", null, je(g(l).language.parse(e.label)), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1536)) : B("", !0)
        ])),
        _.value == "inline" ? (m(), S(qe, { key: 2 }, [
          Object.keys($.value).length ? (m(), S("ul", kE, [
            (m(!0), S(qe, null, We(q.value, (ae) => (m(), S("li", $E, [
              K(O, {
                label: [ae.firstname, ae.name].filter((Te) => !!Te).join(" "),
                radio: !e.multiple && q.value.length > 1,
                "has-current-errors": g(i),
                errors: M.errors,
                onClick: (Te) => D(ae.id),
                modelValue: $.value[ae.id].selected,
                "onUpdate:modelValue": (Te) => $.value[ae.id].selected = Te
              }, null, 8, ["label", "radio", "has-current-errors", "errors", "onClick", "modelValue", "onUpdate:modelValue"])
            ]))), 256))
          ])) : e.empty_label ? (m(), S("div", CE, [
            K(G, { source: e.empty_label }, null, 8, ["source"])
          ])) : B("", !0)
        ], 64)) : B("", !0)
      ], 2);
    };
  }
}), xE = { class: "acquisit-persons-editor" }, DE = ["aria-label"], AE = {
  key: 0,
  class: "collection-item-edit"
}, PE = { class: "collection-item-content" }, OE = ["onClick"], TE = { class: "person-wrapper" }, IE = ["aria-label"], ME = {
  class: "person-first-name",
  "aria-hidden": "true"
}, qE = {
  class: "person-name",
  "aria-hidden": "true"
}, EE = {
  key: 1,
  class: /* @__PURE__ */ pe(["person-no-name"])
}, VE = ["aria-label"], LE = {
  class: "content",
  "aria-hidden": "true"
}, BE = ["aria-label"], jE = {
  class: "content",
  "aria-hidden": "true"
}, HE = ["aria-label"], RE = {
  class: "content",
  "aria-hidden": "true"
}, FE = ["aria-label"], NE = {
  class: "content",
  "aria-hidden": "true"
}, YE = {
  class: "person-errors",
  role: "presentation"
}, UE = {
  key: 0,
  class: "additional-components",
  role: "presentation"
}, zE = {
  key: 0,
  class: "collection-item-delete pdf-hidden",
  role: "presentation"
}, WE = { class: "actions-wrapper pdf-hidden" }, KE = {
  key: 0,
  class: "name-inputs"
}, GE = /* @__PURE__ */ Pe({
  __name: "PersonsEditor",
  props: {
    ...Ge(),
    ...Bn(),
    edit_person_modal: {
      type: Object,
      required: !1,
      default: null
    },
    /**
     * @deprecated unused
     */
    add_person_modal: {
      type: Object,
      required: !1,
      default: null
    },
    types: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    required_types: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    additional_components: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    additional_components_guards: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    noInteract: {
      type: Boolean,
      required: !1,
      default: !1
    },
    delete_person_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    email_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    phone_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    birthdate_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    org_number_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    max_persons: {
      type: Number,
      required: !1,
      default: null
    },
    max_persons_error_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    missing_email_modal: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ar("components/person/PersonsEditor", a), l = Ze(a, n), { color: s, erroring: u } = l, i = z([]), c = z(!0), d = Hn(), p = Sm(), h = jn(), y = C(() => {
      let he = {};
      for (let X in a.types)
        a.types.hasOwnProperty(X) && (he[X] = []);
      for (let X of i.value)
        X.type && a.types[X.type] && he[X.type].push(X);
      return he;
    });
    C(() => Ft(i.value, (he) => he.id));
    const _ = () => {
      const he = Ht(d.persons).filter((X) => a.persons_conditions && a.persons_conditions[X.type] ? h.evaluate(a.persons_conditions[X.type], X) : !0).map((X) => (X.birthdate || (X.org_number || o.warnFrom("fetchPersons", F(X) + " is missing a birthdate"), X.birthdate = {
        iso: null,
        timestamp: null
      }), a.additional_components && !X.additional_components && (X.additional_components = kt(a.additional_components)), X));
      i.value = kt(he);
    }, $ = () => pl(pr.BUYER, gm), w = z($()), L = z({}), R = z("tab-private"), q = z("edit"), E = z(), Y = z(), V = () => {
      n("update:modelValue", i.value.map((he) => he.id));
    }, T = async (he, X) => {
      var Se, me, fe, Oe, Ie, ye, Fe, Me;
      let re = {};
      return (Se = a.edit_person_modal) != null && Se.email_input_label && !pc(he.contact.email || "") && (re.email = [
        new ze("Invalid email", void 0, "email")
      ]), X ? ((me = a.edit_person_modal) != null && me.name_input_label && La(he.name || "") && (re.name = [
        new ze("Invalid name", void 0, "name")
      ]), (fe = a.edit_person_modal) != null && fe.org_number_required && (La(he.org_number) || !rm(he.org_number || "")) && (re.org_number = [
        new ze("Invalid org number", void 0, "org_number")
      ])) : ((Oe = a.edit_person_modal) != null && Oe.name_input_label && !ki(he.name || "") && (re.name = [
        new ze("Invalid name", void 0, "name")
      ]), (Ie = a.edit_person_modal) != null && Ie.firstname_input_label && !ki(he.firstname || "") && (re.firstname = [
        new ze("Invalid firstname", void 0, "firstname")
      ]), (ye = a.edit_person_modal) != null && ye.birthdate_input_label && ((Fe = a.edit_person_modal) != null && Fe.birthdate_required) && !((Me = he.birthdate) != null && Me.timestamp) && (re.birthdate = [
        new ze("Birthdate missing", void 0, "birthdate")
      ])), re;
    }, A = (he) => he ? kc(he) : "–", P = async () => {
      q.value == "add" ? await N() : await D();
    }, b = (he, X) => {
      var re;
      if (X)
        he.firstname = null, he.birthdate = {
          timestamp: null,
          iso: null
        }, typeof he.org_number == "string" && (he.org_number = he.org_number.replace(/ /g, ""));
      else if (he.org_number = null, fa((re = he.birthdate) == null ? void 0 : re.timestamp)) {
        let Se = Wo.fromTimestamp(he.birthdate.timestamp);
        Se.setTime(12, 0, 0), he.birthdate.timestamp = Se.getTimestamp();
      }
    }, x = () => {
      const he = Ht(p), X = he.pagesWithComponentOfTag("persons-layout").concat(he.pagesWithSemantic("product_person"));
      for (let re of X)
        he.invalidatePage(re);
      he.invalidateSignaturePage(), a.hostPage && he.invalidatePage(a.hostPage);
    }, D = async () => {
      c.value = !0;
      const he = R.value == "tab-commercial", X = await T(w.value, he), re = Object.values(X).length > 0;
      L.value = X;
      const Se = Ht(d);
      x(), re ? (o.warnFrom("onClickUpdatePerson", "Person validation failed", X), c.value = !1) : (b(w.value, he), Se.update(w.value), _());
    }, N = async () => {
      c.value = !0;
      const he = R.value == "tab-commercial", X = await T(w.value, he), re = Object.values(X).length > 0;
      L.value = X;
      const Se = Ht(d);
      re ? (o.warnFrom("onClickAddPerson", "Person validation failed", X), c.value = !1) : (b(w.value, he), Se.add(w.value), x(), _(), w.value = pl(w.value.role, w.value.type));
    }, M = async (he) => {
      var X;
      a.noInteract || !a.edit_person_modal || (w.value = pl(ml(he), he), R.value = !((X = a.edit_person_modal) != null && X.company_name_input_label) || La(w.value.org_number) ? "tab-private" : "tab-commercial", q.value = "add", await ut(), Y.value && (Y.value.openModal(), setTimeout(() => {
        var re;
        (re = E.value) == null || re.focus();
      }, 300)));
    }, H = async (he) => {
      var X;
      if (!(a.noInteract || !a.edit_person_modal)) {
        if (w.value = kt(he), R.value = !((X = a.edit_person_modal) != null && X.company_name_input_label) || La(w.value.org_number) ? "tab-private" : "tab-commercial", q.value = "edit", await ut(), !Y.value) {
          o.warnFrom("openEditPersonModal", "Could not find edit person modal");
          return;
        }
        Y.value.openModal(), setTimeout(() => {
          var re;
          (re = E.value) == null || re.focus();
        }, 300);
      }
    }, U = () => {
      w.value = $(), _();
    }, G = (he) => {
      const X = Ht(d), re = Ht(p);
      X.delete(he), re.invalidateSignaturePage(), a.hostPage && re.invalidatePage(a.hostPage), _();
      const Se = re.pagesWithComponentOfTag("persons-layout").concat(re.pagesWithSemantic("product_person"));
      for (let me of Se)
        re.invalidatePage(me);
      V();
    }, F = (he) => [he.firstname, he.name].filter((X) => !!X).join(" "), O = C(() => {
      var X;
      let he = {};
      for (let re in a.types)
        a.types.hasOwnProperty(re) && (he[re] = a.types[re]);
      for (let re of i.value)
        re.type && a.types[re.type] && (he[re.type] = a.types[re.type]);
      return (X = a.edit_person_modal) != null && X.edit_person_label || Rt(he, (re, Se) => {
        var me;
        (me = y.value[Se]) != null && me.length || delete he[Se];
      }), he;
    }), Q = C(() => a.delete_person_label ? Object.keys(a.types).length > 1 ? i.value.length > 1 : y.value[Object.keys(a.types)[0]].length > 1 : !1), ae = z({}), Te = (he, X) => {
      const re = Ht(d);
      he.additional_components = X, re.update(he), V();
    }, Ae = (he, X) => {
      ae.value[String(he)] = X;
    }, Ye = (he) => {
      var fe, Oe;
      let X = (Oe = (fe = he.reference) == null ? void 0 : fe.properties) == null ? void 0 : Oe.uid, re = he.owner, Se = kt(re.path || []), me = !1;
      if (!X) {
        o.warnFrom("triggerErrorAnimationForSubComponent", "Cannot trigger error animation for error", he);
        return;
      }
      for (; Se.length; ) {
        let Ie = Se.pop();
        if (Ie.person.id) {
          let ye = ae.value[Ie.person.id];
          ye != null && ye.triggerErrorAnimation && (ye.triggerErrorAnimation(he), me = !0);
        }
      }
      me || o.warnFrom("triggerErrorAnimationForSubComponent", "Could not find $ref for uid", X, "with owner", re);
    }, Re = C(() => {
      let he = {}, X = {}, re = {}, Se = {}, me = new Set(i.value.map((fe) => fe.type).concat(Object.keys(a.types)));
      for (let fe of i.value)
        he[fe.id] = {
          name: [],
          contact: [],
          person_number: [],
          birthdate: [],
          org_number: []
        };
      for (let fe of me)
        re[fe] || (re[fe] = {
          max_persons: [],
          required: []
        });
      for (let fe of $i)
        X[fe] = [];
      if (Array.isArray(a.errors))
        for (let fe of a.errors)
          fe.owner && (fe.owner.person ? he[fe.owner.person.id] && (he[fe.owner.person.id][fe.key] = [fe], fe.owner.key == "additional_components" && (Se[fe.owner.person.id] || (Se[fe.owner.person.id] = []), Se[fe.owner.person.id].push(fe))) : $i.indexOf(fe.owner.role) > -1 ? X[fe.owner.role] = [fe] : fe.owner.type && re[fe.owner.type] && fe.key == "max_persons" ? re[fe.owner.type].max_persons = [fe] : fe.owner.type && re[fe.owner.type] && fe.key == "required_types" && (re[fe.owner.type].required = [fe]));
      return {
        persons: he,
        roles: X,
        types: re,
        additionalComponents: Se
      };
    }), it = (he) => {
      var X, re;
      return Re.value.roles[ml(he)] || ((X = Re.value.types[he]) == null ? void 0 : X.required) || ((re = Re.value.types[he]) == null ? void 0 : re.max_persons);
    };
    return St(() => {
      _();
    }), Le(() => d.persons, () => {
      _();
    }), t({
      ...l.expose,
      triggerErrorAnimationForSubComponent: Ye
    }), (he, X) => {
      const re = oe("acquisit-string"), Se = oe("acquisit-button"), me = oe("v-svg"), fe = oe("acquisit-info-box"), Oe = oe("acquisit-input"), Ie = oe("acquisit-dropdown"), ye = oe("acquisit-tab"), Fe = oe("acquisit-tabs"), Me = oe("acquisit-modal");
      return m(), S("div", xE, [
        (m(!0), S(qe, null, We(O.value, (He, ce) => {
          var mt, nt, ot, ft;
          return m(), S("div", {
            class: pe(["person-collection", { erroring: g(u) && Re.value.roles[g(ml)(ce)], error: it(ce), editable: e.edit_person_modal, "no-interact": e.noInteract }]),
            role: "list",
            key: ce
          }, [
            K(re, {
              source: He,
              class: "person-type"
            }, null, 8, ["source"]),
            y.value[ce].length ? (m(), J(Sr, {
              key: 0,
              name: "slide-down"
            }, {
              default: ie(() => [
                (m(!0), S(qe, null, We(y.value[ce], ($e) => {
                  var Qe, te, xe, Ee, Ve, Xe, de, ke, lt, dt, Je, ue, j, ne;
                  return m(), S("div", {
                    class: pe(["collection-item"]),
                    key: $e.id,
                    role: "listitem",
                    "aria-label": F($e)
                  }, [
                    e.noInteract ? B("", !0) : (m(), S("div", AE, [
                      e.edit_person_modal ? (m(), J(Se, {
                        key: 0,
                        type: "action",
                        icon: (Qe = e.additional_components) != null && Qe.length ? "acq/person-edit" : "acq/edit",
                        color: "#6e6e6e",
                        size: 36,
                        "icon-size": 18,
                        class: "edit-person-button",
                        "aria-label": e.edit_person_modal.edit_person_label ? e.edit_person_modal.edit_person_label + ": " + F($e) : void 0,
                        onClick: (ge) => H($e)
                      }, null, 8, ["icon", "aria-label", "onClick"])) : (m(), J(Se, {
                        key: 1,
                        type: "action",
                        icon: "acq/person",
                        color: g(s).secondary.value,
                        size: 36,
                        "icon-size": 18,
                        class: "edit-person-button",
                        noInteract: ""
                      }, null, 8, ["color"]))
                    ])),
                    W("div", PE, [
                      W("div", {
                        class: "person-details",
                        onClick: (ge) => H($e)
                      }, [
                        W("div", TE, [
                          $e.firstname || $e.name ? (m(), S("span", {
                            key: 0,
                            class: pe(["person-name-wrapper", { error: g(u) && ((te = Re.value.persons[$e.id]) == null ? void 0 : te.name) }]),
                            "aria-label": F($e)
                          }, [
                            W("span", ME, je($e.firstname), 1),
                            X[30] || (X[30] = pt()),
                            W("span", qE, je($e.name), 1)
                          ], 10, IE)) : (m(), S("span", EE, "–"))
                        ]),
                        e.email_label ? (m(), S("span", {
                          key: 0,
                          class: pe(["person-email", { error: g(u) && ((Ee = (xe = Re.value.persons[$e.id]) == null ? void 0 : xe.contact) == null ? void 0 : Ee.length) }]),
                          "aria-label": (e.email_label || "") + ": " + ($e.contact.email || "–")
                        }, [
                          K(me, {
                            class: "icon",
                            file: "acq/email",
                            "aria-hidden": "true"
                          }),
                          W("span", LE, je($e.contact.email || "-"), 1)
                        ], 10, VE)) : B("", !0),
                        e.phone_label ? (m(), S("span", {
                          key: 1,
                          class: pe(["person-phone", { error: g(u) && ((Xe = (Ve = Re.value.persons[$e.id]) == null ? void 0 : Ve.contact) == null ? void 0 : Xe.length) }]),
                          "aria-label": (e.phone_label || "") + ": " + ($e.contact.phone.national || "–")
                        }, [
                          K(me, {
                            class: "icon",
                            file: "acq/phone",
                            "aria-hidden": "true"
                          }),
                          W("span", jE, je($e.contact.phone.national || $e.contact.phone.international || "-"), 1)
                        ], 10, BE)) : B("", !0),
                        e.birthdate_label && ((de = e.edit_person_modal) != null && de.birthdate_input_label || e.birthdate_label) && !$e.org_number ? (m(), S("span", {
                          key: 2,
                          class: pe(["person-birthdate", { error: g(u) && ((lt = (ke = Re.value.persons[$e.id]) == null ? void 0 : ke.birthdate) == null ? void 0 : lt.length) }]),
                          "aria-label": (e.birthdate_label || "") + ": " + (A((dt = $e.birthdate) == null ? void 0 : dt.timestamp) || "–")
                        }, [
                          K(me, {
                            class: "icon",
                            file: "acq/cake",
                            "aria-hidden": "true"
                          }),
                          W("span", RE, je(A((Je = $e.birthdate) == null ? void 0 : Je.timestamp) || "-"), 1)
                        ], 10, HE)) : B("", !0),
                        e.org_number_label && $e.org_number ? (m(), S("span", {
                          key: 3,
                          class: pe(["person-org-number", { error: g(u) && ((j = (ue = Re.value.persons[$e.id]) == null ? void 0 : ue.org_number) == null ? void 0 : j.length) }]),
                          "aria-label": (e.org_number_label || "") + ": " + ($e.org_number || "–")
                        }, [
                          K(me, {
                            class: "icon",
                            file: "acq/business",
                            "aria-hidden": "true"
                          }),
                          W("span", NE, je($e.org_number), 1)
                        ], 10, FE)) : B("", !0),
                        W("div", YE, [
                          (m(!0), S(qe, null, We(Re.value.persons[$e.id] ?? {}, (ge, De) => (m(), S(qe, null, [
                            (m(!0), S(qe, null, We(ge, (yt) => (m(), S(qe, null, [
                              yt.isUserVisible ? (m(), J(hs, {
                                key: 0,
                                error: yt
                              }, null, 8, ["error"])) : B("", !0)
                            ], 64))), 256))
                          ], 64))), 256))
                        ])
                      ], 8, OE),
                      (ne = $e.additional_components) != null && ne.length ? (m(), S("div", UE, [
                        (m(), J(jc, {
                          class: "components",
                          uid: "additional-components-" + $e.id,
                          components: $e.additional_components,
                          key: "persons-components-" + $e.id,
                          "has-current-errors": g(u),
                          errors: Re.value.additionalComponents[$e.id] ?? [],
                          guards: e.additional_components_guards,
                          ref_for: !0,
                          ref: (ge) => Ae($e.id, ge),
                          "no-interact": e.noInteract,
                          "onUpdate:modelValue": (ge) => Te($e, ge)
                        }, null, 8, ["uid", "components", "has-current-errors", "errors", "guards", "no-interact", "onUpdate:modelValue"]))
                      ])) : B("", !0)
                    ]),
                    K(bt, { name: "fade" }, {
                      default: ie(() => [
                        !e.noInteract && Q.value ? (m(), S("div", zE, [
                          e.edit_person_modal && e.edit_person_modal.open_modal_label ? (m(), J(Se, {
                            key: 0,
                            uid: "collection-item-delete",
                            onClick: (ge) => G($e),
                            color: "red",
                            size: 24,
                            "icon-size": 18,
                            class: "delete-button",
                            bordered: "",
                            type: "icon",
                            "aria-label": e.delete_person_label ? e.delete_person_label + ": " + F($e) : void 0,
                            icon: "acq/delete"
                          }, null, 8, ["onClick", "aria-label"])) : B("", !0)
                        ])) : B("", !0)
                      ]),
                      _: 2
                    }, 1024)
                  ], 8, DE);
                }), 128))
              ]),
              _: 2
            }, 1024)) : B("", !0),
            W("div", WE, [
              (mt = e.edit_person_modal) != null && mt.open_modal_label && !e.noInteract ? (m(), J(Se, {
                key: 0,
                onClick: ($e) => M(ce),
                type: "flat",
                bordered: "",
                icon: "acq/person-add",
                "icon-size": 36,
                label: e.edit_person_modal.open_modal_label,
                color: g(s).baseVisuallyAndContextSafe.value,
                "has-current-errors": ((ot = (nt = Re.value.types[ce]) == null ? void 0 : nt.required) == null ? void 0 : ot.length) > 0,
                errors: (ft = Re.value.types[ce]) == null ? void 0 : ft.required,
                class: "add-person-btn"
              }, null, 8, ["onClick", "label", "color", "has-current-errors", "errors"])) : B("", !0)
            ]),
            K(bt, { name: "move-fade-top" }, {
              default: ie(() => {
                var $e, Qe;
                return [
                  (Qe = ($e = Re.value.types[ce]) == null ? void 0 : $e.max_persons) != null && Qe.length && e.max_persons_error_label ? (m(), J(fe, {
                    key: 0,
                    type: "error",
                    label: e.max_persons_error_label
                  }, null, 8, ["label"])) : B("", !0)
                ];
              }),
              _: 2
            }, 1024)
          ], 2);
        }), 128)),
        (m(), J(Xt, { to: "body" }, [
          w.value && e.edit_person_modal ? (m(), J(Me, {
            key: 0,
            valid: c.value,
            onAccept: P,
            onDecline: U,
            ref_key: "$editPersonModal",
            ref: Y,
            class: pe(["edit-person-modal", { "single-type": !e.edit_person_modal.company_name_input_label }]),
            title: q.value == "add" ? e.edit_person_modal.open_modal_label : e.edit_person_modal.edit_person_label,
            title_icon: "acq/person",
            type: "sheet"
          }, Ca({
            default: ie(() => [
              K(Fe, {
                theme: "integrated",
                selectedTab: R.value,
                "onUpdate:selectedTab": X[29] || (X[29] = (He) => R.value = He),
                color: g(s).baseVisuallyAndContextSafe.value
              }, {
                default: ie(() => [
                  K(ye, {
                    title: "Privat",
                    uid: "tab-private",
                    icon: "acq/person",
                    class: "inputs"
                  }, {
                    default: ie(() => {
                      var He;
                      return [
                        e.edit_person_modal.firstname_input_label || e.edit_person_modal.name_input_label ? (m(), S("div", KE, [
                          e.edit_person_modal.firstname_input_label ? (m(), J(Oe, {
                            key: 0,
                            ref_key: "$editPersonFirstname",
                            ref: E,
                            label: e.edit_person_modal.firstname_input_label,
                            modelValue: w.value.firstname,
                            "onUpdate:modelValue": X[0] || (X[0] = (ce) => w.value.firstname = ce),
                            errors: L.value.firstname ?? [],
                            onKeydown: X[1] || (X[1] = (ce) => delete L.value.firstname),
                            icon: "acq/person"
                          }, null, 8, ["label", "modelValue", "errors"])) : B("", !0),
                          e.edit_person_modal.name_input_label ? (m(), J(Oe, {
                            key: 1,
                            label: e.edit_person_modal.name_input_label,
                            errors: L.value.name ?? [],
                            onKeydown: X[2] || (X[2] = (ce) => delete L.value.name),
                            modelValue: w.value.name,
                            "onUpdate:modelValue": X[3] || (X[3] = (ce) => w.value.name = ce)
                          }, null, 8, ["label", "errors", "modelValue"])) : B("", !0)
                        ])) : B("", !0),
                        Object.keys(e.types).length > 1 ? (m(), J(Ie, {
                          key: 1,
                          options: e.types,
                          modelValue: w.value.type,
                          "onUpdate:modelValue": X[4] || (X[4] = (ce) => w.value.type = ce)
                        }, null, 8, ["options", "modelValue"])) : B("", !0),
                        e.edit_person_modal.postcode_input_label || e.edit_person_modal.city_input_label ? (m(), S("div", {
                          key: 2,
                          class: pe(["postcode-city-inputs", { single: !(e.edit_person_modal.postcode_input_label && e.edit_person_modal.city_input_label) }])
                        }, [
                          e.edit_person_modal.postcode_input_label ? (m(), J(Oe, {
                            key: 0,
                            modelValue: w.value.address.postcode,
                            "onUpdate:modelValue": X[5] || (X[5] = (ce) => w.value.address.postcode = ce),
                            errors: L.value.postcode ?? [],
                            onKeydown: X[6] || (X[6] = (ce) => delete L.value.postcode),
                            label: e.edit_person_modal.postcode_input_label,
                            class: "postcode"
                          }, null, 8, ["modelValue", "errors", "label"])) : B("", !0),
                          e.edit_person_modal.city_input_label ? (m(), J(Oe, {
                            key: 1,
                            modelValue: w.value.address.city,
                            "onUpdate:modelValue": X[7] || (X[7] = (ce) => w.value.address.city = ce),
                            errors: L.value.city ?? [],
                            onKeydown: X[8] || (X[8] = (ce) => delete L.value.city),
                            label: e.edit_person_modal.city_input_label,
                            class: "city"
                          }, null, 8, ["modelValue", "errors", "label"])) : B("", !0)
                        ], 2)) : B("", !0),
                        e.edit_person_modal.email_input_label ? (m(), J(Oe, {
                          key: 3,
                          label: e.edit_person_modal.email_input_label,
                          modelValue: w.value.contact.email,
                          "onUpdate:modelValue": X[9] || (X[9] = (ce) => w.value.contact.email = ce),
                          onKeydown: X[10] || (X[10] = (ce) => delete L.value.email),
                          errors: L.value.email ?? [],
                          type: "email",
                          icon: "acq/email"
                        }, null, 8, ["label", "modelValue", "errors"])) : B("", !0),
                        e.edit_person_modal.phone_input_label && w.value.contact.phone ? (m(), J(Oe, {
                          key: 4,
                          label: e.edit_person_modal.phone_input_label,
                          modelValue: w.value.contact.phone.national,
                          "onUpdate:modelValue": X[11] || (X[11] = (ce) => w.value.contact.phone.national = ce),
                          errors: L.value.phone ?? [],
                          onKeydown: X[12] || (X[12] = (ce) => delete L.value.phone),
                          type: "phone",
                          icon: "acq/phone"
                        }, null, 8, ["label", "modelValue", "errors"])) : B("", !0),
                        e.edit_person_modal.birthdate_input_label ? (m(), J(Oe, {
                          key: 5,
                          label: e.edit_person_modal.birthdate_input_label,
                          modelValue: ((He = w.value.birthdate) == null ? void 0 : He.timestamp) ?? void 0,
                          "onUpdate:modelValue": X[13] || (X[13] = (ce) => (w.value.birthdate ?? { timestamp: void 0 }).timestamp = ce),
                          errors: L.value.birthdate ?? [],
                          onKeydown: X[14] || (X[14] = (ce) => delete L.value.birthdate),
                          onChange: X[15] || (X[15] = (ce) => delete L.value.birthdate),
                          icon: "acq/cake",
                          type: "date"
                        }, null, 8, ["label", "modelValue", "errors"])) : B("", !0)
                      ];
                    }),
                    _: 1
                  }),
                  e.edit_person_modal.company_name_input_label ? (m(), J(ye, {
                    key: 0,
                    title: "Bedrift",
                    uid: "tab-commercial",
                    icon: "acq/business",
                    class: "inputs"
                  }, {
                    default: ie(() => [
                      e.edit_person_modal.company_name_input_label ? (m(), J(Oe, {
                        key: 0,
                        label: e.edit_person_modal.company_name_input_label,
                        errors: L.value.name ?? [],
                        onKeydown: X[16] || (X[16] = (He) => delete L.value.name),
                        icon: "acq/business",
                        modelValue: w.value.name,
                        "onUpdate:modelValue": X[17] || (X[17] = (He) => w.value.name = He)
                      }, null, 8, ["label", "errors", "modelValue"])) : B("", !0),
                      Object.keys(e.types).length > 1 ? (m(), J(Ie, {
                        key: 1,
                        options: e.types,
                        modelValue: w.value.type,
                        "onUpdate:modelValue": X[18] || (X[18] = (He) => w.value.type = He)
                      }, null, 8, ["options", "modelValue"])) : B("", !0),
                      e.edit_person_modal.postcode_input_label || e.edit_person_modal.city_input_label ? (m(), S("div", {
                        key: 2,
                        class: pe(["postcode-city-inputs", { single: !(e.edit_person_modal.postcode_input_label && e.edit_person_modal.city_input_label) }])
                      }, [
                        e.edit_person_modal.postcode_input_label ? (m(), J(Oe, {
                          key: 0,
                          modelValue: w.value.address.postcode,
                          "onUpdate:modelValue": X[19] || (X[19] = (He) => w.value.address.postcode = He),
                          errors: L.value.postcode ?? [],
                          onKeydown: X[20] || (X[20] = (He) => delete L.value.postcode),
                          label: e.edit_person_modal.postcode_input_label,
                          class: "postcode"
                        }, null, 8, ["modelValue", "errors", "label"])) : B("", !0),
                        e.edit_person_modal.city_input_label ? (m(), J(Oe, {
                          key: 1,
                          modelValue: w.value.address.city,
                          "onUpdate:modelValue": X[21] || (X[21] = (He) => w.value.address.city = He),
                          errors: L.value.city ?? [],
                          onKeydown: X[22] || (X[22] = (He) => delete L.value.city),
                          label: e.edit_person_modal.city_input_label,
                          class: "city"
                        }, null, 8, ["modelValue", "errors", "label"])) : B("", !0)
                      ], 2)) : B("", !0),
                      e.edit_person_modal.email_input_label ? (m(), J(Oe, {
                        key: 3,
                        label: e.edit_person_modal.email_input_label,
                        modelValue: w.value.contact.email,
                        "onUpdate:modelValue": X[23] || (X[23] = (He) => w.value.contact.email = He),
                        errors: L.value.email ?? [],
                        onKeydown: X[24] || (X[24] = (He) => delete L.value.email),
                        type: "email",
                        icon: "acq/email"
                      }, null, 8, ["label", "modelValue", "errors"])) : B("", !0),
                      e.edit_person_modal.phone_input_label && w.value.contact.phone ? (m(), J(Oe, {
                        key: 4,
                        label: e.edit_person_modal.phone_input_label,
                        modelValue: w.value.contact.phone.national,
                        "onUpdate:modelValue": X[25] || (X[25] = (He) => w.value.contact.phone.national = He),
                        errors: L.value.phone ?? [],
                        onKeydown: X[26] || (X[26] = (He) => delete L.value.phone),
                        type: "phone",
                        icon: "acq/phone"
                      }, null, 8, ["label", "modelValue", "errors"])) : B("", !0),
                      e.edit_person_modal.org_number_input_label ? (m(), J(Oe, {
                        key: 5,
                        label: e.edit_person_modal.org_number_input_label,
                        format: "DDDDDDDDD",
                        modelValue: w.value.org_number,
                        "onUpdate:modelValue": X[27] || (X[27] = (He) => w.value.org_number = He),
                        errors: L.value.org_number ?? [],
                        onKeydown: X[28] || (X[28] = (He) => delete L.value.org_number)
                      }, null, 8, ["label", "modelValue", "errors"])) : B("", !0)
                    ]),
                    _: 1
                  })) : B("", !0)
                ]),
                _: 1
              }, 8, ["selectedTab", "color"])
            ]),
            _: 2
          }, [
            e.edit_person_modal.cancel_button_label ? {
              name: "decline",
              fn: ie(() => [
                K(re, {
                  source: e.edit_person_modal.cancel_button_label
                }, null, 8, ["source"])
              ]),
              key: "0"
            } : void 0,
            e.edit_person_modal.save_button_label ? {
              name: "accept",
              fn: ie(() => [
                K(re, {
                  source: e.edit_person_modal.save_button_label
                }, null, 8, ["source"])
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["valid", "class", "title"])) : B("", !0)
        ]))
      ]);
    };
  }
}), No = Dt("import-export/import", Dt.COLOR_LIB), Kf = async (e, t) => {
  const r = [];
  am(e, (a, n) => {
    r.push(Gf(n, t));
  }), await Promise.allSettled(r);
}, Gf = async (e, t) => await (aV[e.tag_normalized] ?? ZE)(e, t), ZE = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    return r ? (e.properties.modelValue = r.value ?? void 0, !!r.value) : !1;
  }
  return !1;
}, XE = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r)
      return !1;
    if (fa(r.value))
      return e.properties.modelValue = !!r.value, !0;
  }
  return !1;
}, JE = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r)
      return !1;
    if (e.properties.type == "date")
      if (gc(r.value))
        e.properties.modelValue = r.value;
      else {
        const a = Wo.fromString(r.value);
        a ? e.properties.modelValue = a.getTimestamp() ?? null : No.always.warnFrom("importToInput", "Could not parse date", r.value);
      }
    else e.properties.format, e.properties.modelValue = r.value ?? void 0;
    return !0;
  }
  return !1;
}, sc = async (e, t) => {
  const r = e.properties.items, a = [];
  if (Array.isArray(r)) {
    for (let n of r)
      if (n.import) {
        const o = t.availableByUID[n.import.uid];
        if (!o || !Array.isArray(o.value))
          continue;
        for (let l of o.value) {
          const s = kt(n);
          s.template_uid = s.uid, s.uid = xr("item-");
          const u = o.children.map((i) => (fa(l[i.uid]) && (i.value = l[i.uid]), i));
          await Kf(s.components, {
            availableByUID: Ft(u, (i) => i.uid),
            personsByID: t.personsByID
          }), a.push(s);
        }
      }
  }
  return a.length ? (e.properties.modelValue = a, !0) : !1;
}, QE = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r || !r.value || typeof r.value != "object" || !r.children.length)
      return !1;
    const a = {}, n = ss(t.personsByID), o = Ft(n, (l) => String(l.external_id ?? "undefined"));
    return Rt(r.value, (l, s) => {
      const u = o[String(s)];
      if (u) {
        const i = r.children.map((c) => (c = kt(c), c.value = l[c.uid], c));
        a[u.id] = i;
      }
    }), e.properties.imports = a, !0;
  }
  return !1;
}, eV = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r || !r.value)
      return !1;
    if (typeof r.value != "object" || !r.value)
      return No.infoFrom("importToPersonsEditor", "Unsupported or empty import value"), !1;
    if (!Array.isArray(e.properties.additional_components))
      return No.infoFrom("importToPersonsEditor", "No components available to import into"), !1;
    const a = ss(t.personsByID), n = Ft(a, (o) => String(o.external_id ?? "undefined"));
    return await is(r.value, async (o, l) => {
      const s = n[l];
      if (s) {
        const u = r.children.map((c) => (c = kt(c), c.value = o[c.uid], c)), i = kt(e.properties.additional_components);
        await Kf(i, {
          availableByUID: Ft(u, (c) => c.uid),
          personsByID: t.personsByID
        }), s.additional_components = i;
      }
    }), !0;
  }
  return !1;
}, tV = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r || !r.value)
      return !1;
    if (!Array.isArray(r.value))
      return No.infoFrom("importToPersonsChooser", "Unsupported import value"), !1;
    const a = ss(t.personsByID), n = Ft(a, (l) => String(l.external_id ?? "undefined")), o = [];
    for (const l of r.value)
      n[l] && o.push(n[l].id);
    e.properties.modelValue = o;
  }
  return !1;
}, rV = async (e, t) => {
  if (e.import) {
    const r = t.availableByUID[e.import.uid];
    if (!r || !r.value)
      return !1;
    if (typeof r.value == "object")
      return e.properties.modelValue = {
        label: r.value.label,
        value: r.value.value
      }, !0;
    if (typeof r.value == "string") {
      const a = Hl.find(
        (n) => n.country == r.value || n.label == r.value
      );
      a && (e.properties.modelValue = {
        label: a.label,
        value: a.country
      });
    }
    return !1;
  }
  return !1;
}, aV = {
  checkbox: XE,
  "country-chooser": rV,
  "items-editor": sc,
  "items-input": sc,
  input: JE,
  "persons-chooser": tV,
  "persons-editor": eV,
  "persons-layout": QE
}, Un = Dt("import-export/export", Dt.COLOR_LIB), Zs = async (e, t) => {
  let r = {};
  return await nm(e, async (a, n) => {
    if (t.validatedOnly && !n.validated)
      return;
    if (n.tag_normalized == "items-input" || n.tag_normalized == "items-editor") {
      const l = await ic(n, {
        availableByUID: t.availableByUID,
        export: {
          uid: "x",
          children: [],
          required: !1,
          dataType: Lt.COMPLEX
        },
        // ItemsInput exporter does not use context export
        personsByID: t.personsByID
      });
      l !== void 0 && (r = Ko(r, l));
    } else if (n.export && t.availableByUID[n.export.uid]) {
      if (t.validatedOnly && !n.validated)
        return;
      const l = await ic(n, {
        availableByUID: t.availableByUID,
        export: t.availableByUID[n.export.uid],
        personsByID: t.personsByID
      });
      l !== void 0 && (r[n.export.uid] = l);
    }
  }), r;
}, ic = async (e, t) => await (cV[e.tag_normalized] ?? Zf)(e, t), Zf = async (e, t) => {
  if (e.export) {
    if (e.properties.modelValue === null)
      return null;
    switch (t.export.dataType) {
      case Lt.BOOLEAN:
        return !!e.properties.modelValue;
      case Lt.NUMBER:
      case Lt.FLOAT:
        return Number(e.properties.modelValue);
      case Lt.INTEGER:
        return Number(e.properties.modelValue) | 0;
      case Lt.STRING:
        return String(e.properties.modelValue);
      case Lt.DATE:
      case Lt.DATETIME:
      case Lt.COMPLEX:
        return;
      default:
        return e.properties.modelValue;
    }
  }
}, nV = async (e, t) => {
  if (e.export) {
    if (t.export.dataType != Lt.COMPLEX)
      return;
    if (!e.properties.modelValue)
      return null;
    const r = {};
    return await is(e.properties.modelValue, async (a, n) => {
      r[n] = await Zs(a.components, {
        availableByUID: Ft(t.export.children, (o) => o.uid),
        personsByID: t.personsByID
      });
    }), r;
  }
}, uc = async (e, t) => {
  if (!Array.isArray(e.properties.modelValue))
    return null;
  const r = {};
  let a = !1;
  for (let n of e.properties.modelValue)
    if (n.export && t.availableByUID[n.export.uid]) {
      a = !0;
      const o = t.availableByUID[n.export.uid];
      if (o.dataType != Lt.COMPLEX) {
        Un.debugFrom("exportFromItemsInput", "Export for ItemsInput not compatible", t.export);
        return;
      }
      const l = zo(n.components), s = await Zs(l, {
        availableByUID: Ft(o.children, (u) => u.uid),
        personsByID: t.personsByID
      });
      r[o.uid] || (r[o.uid] = []), r[o.uid].push(s);
    }
  return a ? r : void 0;
}, oV = async (e, t) => {
  if (e.export) {
    if (t.export.dataType == Lt.COMPLEX) {
      const r = {};
      return await is(t.personsByID, async (a, n) => {
        var o;
        (o = e.properties.types) != null && o[a.type] && (Array.isArray(a.additional_components) ? r[n] = await Zs(a.additional_components, {
          availableByUID: Ft(t.export.children, (l) => l.uid),
          personsByID: t.personsByID
        }) : r[n] = {});
      }), r;
    }
    Un.warnFrom("exportFromPersonsEditor", "Export to unsupported data type", t.export.dataType, "for UID", e.properties.uid);
    return;
  }
}, lV = async (e, t) => {
  if (e.export) {
    if (t.export.dataType == Lt.COMPLEX)
      return e.properties.modelValue;
    Un.warnFrom("exportFromPersonsChooser", "Export to unsupported data type", t.export.dataType, "for UID", e.properties.uid);
    return;
  }
}, sV = async (e, t) => {
  var r;
  if (e.export) {
    if (t.export.dataType == Lt.STRING)
      return ((r = e.properties.modelValue) == null ? void 0 : r.label) ?? null;
    if (t.export.dataType == Lt.COMPLEX)
      return e.properties.modelValue ? e.properties.modelValue : null;
  }
}, iV = async (e, t) => {
  if (e.export) {
    if (t.export.dataType == Lt.STRING)
      return e.properties.modelValue ?? null;
    Un.warnFrom("exportFromComment", "Export to unsupported data type", t.export.dataType, "for UID", e.properties.uid);
    return;
  }
}, uV = async (e, t) => {
  if (e.properties.type == "date") {
    if (e.export)
      switch (t.export.dataType) {
        case Lt.STRING:
        case Lt.DATE:
          return fa(e.properties.modelValue) ? kc(Number(e.properties.modelValue)) : null;
        case Lt.DATETIME:
          return fa(e.properties.modelValue) ? Wo.fromTimestamp(Number(e.properties.modelValue)).format("DD.MM.YYYY, HH:mm") : void 0;
        case Lt.NUMBER:
        case Lt.INTEGER:
          return Number(e.properties.modelValue);
        default:
          Un.warnFrom("exportFromInput", "Export to unsupported data type", t.export.dataType, "for UID", e.properties.uid);
          return;
      }
    return;
  } else
    return await Zf(e, t);
}, cV = {
  "country-chooser": sV,
  comment: iV,
  "items-input": uc,
  "items-editor": uc,
  input: uV,
  "persons-chooser": lV,
  "persons-editor": oV,
  "persons-layout": nV
}, dV = ["aria-labelledby"], fV = ["id"], vV = {
  key: 0,
  class: "empty"
}, pV = /* @__PURE__ */ Pe({
  __name: "PersonsLayout",
  props: {
    ...Ge(),
    ...Bn(),
    ...Wf(),
    person_types: {
      type: Array,
      required: !1,
      default: () => []
    },
    use_all_person_types: {
      type: Boolean,
      required: !1,
      default: !1
    },
    ignore_duplicate_persons: {
      type: Boolean,
      required: !1,
      default: !1
    },
    components: {
      type: Array,
      required: !0
    },
    guards: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    show_single_name: {
      type: Boolean,
      required: !1,
      default: !0
    },
    empty_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    imports: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = Dt("components/person/PersonsLayout", Dt.COLOR_COMPONENT), o = r, l = Ze(a, o), s = jn(), { color: u, erroring: i } = l, c = nr(a), d = c.errors, p = c.components, h = z({}), y = (b, x) => {
      h.value[String(b)] = x;
    }, _ = z({}), $ = Hn(), w = C(() => Ht($.byID)), L = C(() => Ht($.persons)), R = C(() => In(L.value, (b) => b.type)), q = C(() => {
      let b = [];
      if (a.use_all_person_types)
        b = L.value;
      else if (a.person_types.length)
        for (let D of a.person_types)
          b = b.concat(R.value[D] ?? []);
      const x = (D) => {
        var M;
        let N = a.use_all_person_types || a.person_types.indexOf(D.type) > -1;
        return N && ((M = a.persons_conditions) != null && M[D.type]) ? s.evaluate(a.persons_conditions[D.type], D) : N;
      };
      if (b = b.filter(x), a.ignore_duplicate_persons) {
        let D = In(
          om(
            b,
            (N) => String(N.external_id)
          ),
          (N) => String(N.external_id)
        );
        if (a.person_types.length) {
          const N = lm(a.person_types), M = {};
          Rt(D, (H, U) => {
            const G = H.sort((F, O) => {
              const Q = Number(N[F.type] ?? "9000"), ae = Number(N[O.type] ?? "9000");
              return Q < ae ? -1 : Q > ae ? 1 : 0;
            });
            M[U] = G[0];
          }), b = b.filter((H) => {
            const U = M[H.external_id];
            return !(U !== void 0 && H.type != U.type);
          });
        }
      }
      return b;
    }), E = C(() => a.show_single_name || q.value.length > -1), Y = C(() => {
      var x, D, N;
      let b = {};
      if (!ls(_.value) || (Rt(_.value, (M, H) => {
        b[H] = {};
      }), !Array.isArray(a.errors)))
        return b;
      for (let M of a.errors) {
        const H = (x = M.owner) == null ? void 0 : x.person_id, U = (N = (D = M.reference) == null ? void 0 : D.properties) == null ? void 0 : N.uid;
        H && U && (b[H] || (b[H] = {}), b[H][U] || (b[H][U] = []), b[H][U].push(M));
      }
      return b;
    }), V = async (b, x) => {
      var U;
      let D = {}, N = {};
      const M = (G) => {
        let F = {};
        for (let O of G)
          F[O.properties.uid] = O, sm(O, (Q) => {
            F = Ko(F, M(Q));
          });
        return F;
      }, H = (G, F) => {
        F[G.properties.uid] && (G.properties.modelValue = F[G.properties.uid].properties.modelValue, G.properties.disabled = F[G.properties.uid].properties.disabled, G.properties.errors = F[G.properties.uid].properties.errors || null), ns(G, (O) => {
          H(O, F);
        });
      };
      for (let G in x)
        x.hasOwnProperty(G) && (N[G] = M(x[G].components || x[G]));
      for (let G of q.value) {
        let F = [];
        for (let O of b) {
          let Q = kt(O);
          N[G.id] ? H(Q, N[G.id]) : (U = a.imports) != null && U[G.id] && await Gf(Q, {
            availableByUID: Ft(a.imports[G.id], (ae) => ae.uid),
            personsByID: w.value
          }), F.push(Q);
        }
        D[G.id] = {
          components: F
        };
      }
      return D;
    }, T = (b, x) => {
      _.value[b].components = x, P();
    }, A = (b) => {
      var H, U;
      let x = (U = (H = b.reference) == null ? void 0 : H.properties) == null ? void 0 : U.uid, D = b.owner, N = kt(D.path || []), M = !1;
      if (!x) {
        n.warnFrom("triggerErrorAnimationForSubComponent", "Cannot trigger error animation for error", b);
        return;
      }
      for (; N.length; ) {
        let G = N.pop();
        if (G.person_id) {
          let F = h.value[G.person_id];
          F != null && F.triggerErrorAnimation && (F.triggerErrorAnimation(b), M = !0);
        }
      }
      M || n.warnFrom("triggerErrorAnimationForSubComponent", "Could not find $ref for uid", x, "with owner", D);
    }, P = () => {
      o("update:modelValue", _.value);
    };
    return Le(d, (b) => {
      var x, D;
      if (Array.isArray(b)) {
        for (let N of b)
          if (N.owner && N.owner.person_id in _.value)
            for (let M of _.value[N.owner.person_id].components)
              M.properties.uid === ((D = (x = N.reference) == null ? void 0 : x.properties) == null ? void 0 : D.uid) && (Array.isArray(M.properties.errors) || (M.properties.errors = []), M.properties.errors.push(N));
      }
    }), Le(L, async () => {
      _.value = await V(a.components, a.modelValue || {}), P();
    }), Le(p, async (b) => {
      _.value = await V(b, a.modelValue || {});
    }, {
      deep: !0
    }), ts(async () => {
      _.value = await V(p.value, a.modelValue || {}), vc(Object.keys(_.value), Object.keys(a.modelValue || {})) || P();
    }), t({
      ...l.expose,
      triggerErrorAnimationForSubComponent: A
    }), (b, x) => {
      const D = oe("v-svg"), N = oe("acquisit-components-container"), M = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-persons-layout", { "has-names": E.value }])
      }, [
        (m(!0), S(qe, null, We(_.value, (H, U) => {
          var G, F;
          return m(), S("div", {
            class: "person-item",
            key: "person-item-" + U
          }, [
            E.value ? (m(), S("span", {
              class: "person-name",
              key: "persons-layout-name-" + U,
              tabindex: 0,
              "aria-labelledby": b.uid + "-name-" + U
            }, [
              K(D, {
                file: "acq/person",
                class: "icon",
                "aria-hidden": "true"
              }),
              W("span", {
                id: b.uid + "-name-" + U
              }, je([(G = w.value[U]) == null ? void 0 : G.firstname, (F = w.value[U]) == null ? void 0 : F.name].filter((O) => !!O).join(" ")), 9, fV),
              W("div", {
                class: "focus-ring",
                style: we({ borderColor: g(u).baseVisuallySafe.value.cssHSLA })
              }, null, 4)
            ], 8, dV)) : B("", !0),
            (m(), J(N, {
              class: "components",
              key: "persons-layout-container-" + U,
              "has-current-errors": g(i),
              errors: Object.values(Y.value[U]),
              components: H.components,
              guards: e.guards,
              ref_for: !0,
              ref: (O) => y(U, O),
              "no-interact": b.noInteract,
              "onUpdate:modelValue": (O) => T(U, O)
            }, null, 8, ["has-current-errors", "errors", "components", "guards", "no-interact", "onUpdate:modelValue"])),
            x[0] || (x[0] = W("div", { class: "divider" }, null, -1))
          ]);
        }), 128)),
        (b.persons_conditions_no_match_label || e.empty_label) && Object.keys(_.value).length < 1 ? (m(), S("div", vV, [
          K(M, {
            source: b.persons_conditions_no_match_label || e.empty_label
          }, null, 8, ["source"])
        ])) : B("", !0)
      ], 2);
    };
  }
}), mV = { class: "checkbox" }, hV = ["id"], yV = {
  key: 0,
  class: "billing-address"
}, cc = /* @__PURE__ */ Pe({
  __name: "ProductPersonChooserPerson",
  props: {
    ...Ge(),
    person: {
      type: Object,
      required: !0
    },
    radio: {
      type: Boolean,
      required: !1,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    selected: {
      type: Boolean,
      required: !1,
      default: !1
    },
    billing_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_postcode_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_city_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /*
     Choices of addresses
     */
    use_person_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_person_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    use_estate_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_estate_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    use_custom_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_custom_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: Object,
      required: !0
    }
  },
  emits: [
    ...Ke(),
    "click",
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = Ar("components/person/ProductPersonChooserPerson", a), o = r, l = Ze(a, o), { color: s, erroring: u } = l, i = z(), c = z(a.modelValue), d = z(), p = z([]), h = Dc(), y = C(() => {
      var P, b, x;
      let A = {
        generic: [],
        billing_address: []
      };
      if (!Array.isArray(a.errors) || !a.errors.length)
        return A;
      for (let D of a.errors)
        if ((b = (P = D.owner) == null ? void 0 : P.person) != null && b.id)
          switch (D.key) {
            case "billing_address.address":
            case "billing_address.postcode":
            case "billing_address.city":
              D = D.clone(), D.reference = (x = d.value) == null ? void 0 : x.custom_address, A.billing_address.push(D);
              break;
            case "billing_address":
              for (let N in d.value)
                if (d.value.hasOwnProperty(N)) {
                  let M = D.clone();
                  M.reference = d.value[N], M.key = "modelValue", A.generic.push(M);
                }
              break;
            default:
              n.warnFrom("errorsMapped", "Unknown error reference:", D.key);
          }
        else
          A.generic.push(D);
      return A;
    }), _ = C(() => [a.person.firstname, a.person.name].filter((A) => !!A).join(" ")), $ = C(
      () => [!!a.use_person_address_label, !!a.use_estate_address_label].filter((A) => A).length > 0
    ), w = C({
      get() {
        return c.value.use_person_address;
      },
      set(A) {
        c.value.use_person_address = A;
      }
    }), L = C({
      get() {
        return c.value.use_estate_address;
      },
      set(A) {
        c.value.use_estate_address = A;
      }
    }), R = C({
      get() {
        return c.value.use_custom_address;
      },
      set(A) {
        c.value.use_custom_address = A;
      }
    }), q = (A, P) => {
      let b = P.address ?? "";
      return (P.postcode || P.city) && (b += '<br /><span class="city">'), P.postcode && (b += P.postcode), P.city && (b += " " + P.city), (P.postcode || P.city) && (b += "</span>"), Wt(A, void 0, "", {
        address: b,
        "address.address": P.address ?? "",
        "address.city": P.city ?? "",
        "address.postcode": P.postcode ?? ""
      });
    }, E = () => {
      let A = null, P = null, b = null, x = $n("acquisit-product-person-chooser-address", {
        uid: "custom-address",
        modelValue: c.value,
        address_label: a.billing_address_label,
        postcode_label: a.billing_postcode_label,
        city_label: a.billing_city_label
      }, !0);
      a.use_person_address_label && a.person.address.address && (A = $n("acquisit-checkbox", {
        uid: "use-person-address",
        label: q(a.use_person_address_label, a.person.address),
        radio: !0,
        modelValue: w.value,
        disabled: !!(!w.value && (L.value || R.value))
      }, !0)), a.use_estate_address_label && (P = $n("acquisit-checkbox", {
        uid: "use-estate-address",
        label: q(a.use_estate_address_label, Ht(h.estateAddress)),
        radio: !0,
        modelValue: L.value,
        disabled: !!(!L.value && (w.value || R.value))
      }, !0)), a.use_custom_address_label && (b = $n("acquisit-checkbox", {
        uid: "use-custom-address",
        label: a.use_custom_address_label,
        radio: !0,
        modelValue: R.value,
        disabled: !!(!R.value && (L.value || w.value))
      }, !0, [
        x
      ]));
      let D = [A, P, b].filter((N) => N !== null);
      for (let N of D)
        for (let M of D)
          N.properties.uid != M.properties.uid && (N.linked || (N.linked = []), N.linked.push(M.properties.uid));
      return P && a.use_estate_address_checked && !((A == null ? void 0 : A.properties.modelValue) ?? !1) && !((b == null ? void 0 : b.properties.modelValue) ?? !1) && (P.properties.modelValue = !0, P.properties.disabled = !1, L.value = !0, A && (w.value = !1), b && (R.value = !1)), A && a.use_person_address_checked && !((P == null ? void 0 : P.properties.modelValue) ?? !1) && !((b == null ? void 0 : b.properties.modelValue) ?? !1) && (A.properties.modelValue = !0, A.properties.disabled = !1, w.value = !0, P && (L.value = !1), b && (R.value = !1)), b && a.use_custom_address_checked && !((A == null ? void 0 : A.properties.modelValue) ?? !1) && !((P == null ? void 0 : P.properties.modelValue) ?? !1) && (b.properties.modelValue = !0, b.properties.disabled = !1, R.value = !0, A && (w.value = !1), P && (L.value = !1)), {
        use_person_address: A,
        use_estate_address: P,
        use_custom_address: b,
        custom_address: x
      };
    }, Y = () => {
      let A = E();
      if (d.value = A, $.value) {
        let P = [
          A.use_person_address,
          A.use_estate_address,
          A.use_custom_address
        ].filter((b) => !!b);
        P.length > 1 ? p.value = P : (R.value = !0, p.value = [
          A.custom_address
        ]);
      } else
        p.value = [
          A.custom_address
        ];
    }, V = (A) => {
      p.value = A;
      let P = os({
        componentsByUID: wr(A),
        personsByID: {},
        productsByUID: {}
      }, !1);
      if (w.value = P.values["use-person-address"] ?? null, L.value = P.values["use-estate-address"] ?? null, R.value = P.values["use-custom-address"] ?? null, !$.value || c.value.use_custom_address) {
        let b = P.values["custom-address"];
        for (let x in b)
          b.hasOwnProperty(x) && (c.value[x] = b[x]);
      }
      T();
    }, T = () => {
      o("update:modelValue", c.value);
    };
    return St(() => {
      Y();
    }), Le(c, () => {
      T();
    }), Le(u, (A) => {
      var P;
      if (A) {
        for (let b in y.value)
          if (y.value.hasOwnProperty(b))
            for (let x of y.value[b])
              (P = i.value) == null || P.triggerErrorAnimation(x);
      }
    }), t({
      ...l.expose
    }), (A, P) => {
      const b = oe("acquisit-checkbox"), x = oe("acquisit-components-container");
      return m(), S("div", {
        class: pe(["acquisit-product-person-chooser-person", { error: g(u) && y.value.generic.length, "no-interact": A.noInteract }])
      }, [
        W("div", {
          class: "flex",
          onClick: P[0] || (P[0] = (D) => A.$emit("click", D))
        }, [
          W("div", mV, [
            K(b, {
              uid: "person-" + e.person.id + "-selected",
              radio: e.radio,
              disabled: e.disabled,
              errors: y.value.generic,
              "has-current-errors": A.hasCurrentErrors || g(u),
              "no-interact": "",
              "display-only": A.displayOnly,
              modelValue: e.selected,
              "aria-label": _.value
            }, null, 8, ["uid", "radio", "disabled", "errors", "has-current-errors", "display-only", "modelValue", "aria-label"])
          ]),
          W("div", {
            class: "meta",
            id: A.uid + "-label"
          }, je(_.value), 9, hV)
        ]),
        e.billing_address_label && e.selected && p.value ? (m(), S("div", yV, [
          K(x, {
            components: p.value,
            ref_key: "$addressComponents",
            ref: i,
            "onUpdate:modelValue": V,
            "no-interact": A.noInteract,
            "display-only": A.displayOnly,
            errors: y.value.billing_address.concat(y.value.generic),
            "has-current-errors": g(u)
          }, null, 8, ["components", "no-interact", "display-only", "errors", "has-current-errors"])
        ])) : B("", !0)
      ], 2);
    };
  }
}), bV = { class: "acquisit-product-person-chooser" }, gV = {
  key: 1,
  class: /* @__PURE__ */ pe(["seller"])
}, _V = { key: 0 }, wV = {
  key: 2,
  class: /* @__PURE__ */ pe(["buyer"])
}, kV = { key: 0 }, $V = {
  key: 3,
  class: "no-persons"
}, CV = ["aria-labelledby"], SV = /* @__PURE__ */ Pe({
  __name: "ProductPersonChooser",
  props: {
    ...Ge(),
    ...Bn(),
    component_uids: {
      type: Array,
      required: !0
    },
    /**
     * Label to show above the chooser as a header
     */
    header_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * Label to use for the group responding to sellers
     */
    role_seller_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * Label to use for the group responding to buyers
     */
    role_buyer_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_postcode_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_city_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    billing_footer_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    /**
     * Is this chooser a default chooser, meaning it is valid as a fallback for all products
     * with no specific chooser?
     */
    is_default: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /*
     Choices of addresses
     */
    use_person_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_person_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    use_estate_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_estate_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    use_custom_address_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    use_custom_address_checked: {
      type: Boolean,
      required: !1,
      default: !1
    },
    no_persons_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    modelValue: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = jn(), i = z(a.modelValue), c = Hn(), d = Dc();
    c.byID;
    const p = C(() => Ht(c.persons)), h = C(() => In(p.value, (H) => String(H.role))), y = C(() => h.value[pr.BUYER] ?? []), _ = C(() => h.value[pr.SELLER] ?? []), $ = C(() => {
      let H = (U) => {
        var G;
        return (G = a.persons_conditions) != null && G[U.type] ? u.evaluate(a.persons_conditions[U.type], U) : !0;
      };
      return p.value.filter(H).sort((U, G) => U.type.localeCompare(G.type));
    }), w = C(() => y.value.filter((H) => {
      var U, G;
      return (G = (U = i.value) == null ? void 0 : U.internal_billing_addresses) == null ? void 0 : G[H.id];
    })), L = C(() => _.value.filter((H) => {
      var U, G;
      return (G = (U = i.value) == null ? void 0 : U.internal_billing_addresses) == null ? void 0 : G[H.id];
    })), R = C(() => {
      var H;
      for (let U of p.value)
        if (U.id == ((H = i.value) == null ? void 0 : H.selected_buyer_id))
          return U;
      return null;
    }), q = C(() => {
      var H;
      for (let U of p.value)
        if (U.id == ((H = i.value) == null ? void 0 : H.selected_seller_id))
          return U;
      return null;
    }), E = C(() => a.role_seller_label && a.role_buyer_label), Y = C(() => y.value.length > 1), V = C(() => _.value.length > 1), T = C(() => !(a.role_seller_label && !_.value.length) && !(a.role_buyer_label && !y.value.length)), A = C(() => {
      if (!a.billing_footer_label)
        return null;
      let H = String(o.language.parse(a.billing_footer_label));
      if (H.match(/{buyer\..*?}/)) {
        let U = R.value;
        if (!U)
          return null;
        H = H.replace(/{buyer\.name}/g, `**${[U.firstname, U.name].filter((G) => !!G).join(" ")}**`);
      }
      if (H.match(/{seller\..*?}/)) {
        let U = q.value;
        if (!U)
          return null;
        H = H.replace(/{seller\.name}/g, `**${[U.firstname, U.name].filter((G) => !!G).join(" ")}**`);
      }
      return H;
    }), P = C(() => {
      var U, G;
      let H = {
        generic: []
      };
      if (!a.errors || !Array.isArray(a.errors))
        return H;
      for (let F of a.errors)
        if ((G = (U = F.owner) == null ? void 0 : U.person) != null && G.id) {
          let O = F.owner.person;
          H[O.id] || (H[O.id] = []), H[O.id].push(F);
        } else
          H.generic.push(F);
      return H;
    }), b = () => {
      var G, F;
      let H = i.value, U = {
        selected_seller_id: (H == null ? void 0 : H.selected_seller_id) ?? null,
        selected_buyer_id: (H == null ? void 0 : H.selected_buyer_id) ?? null,
        billing_addresses: {},
        internal_billing_addresses: {}
      };
      for (let O of $.value)
        (G = H == null ? void 0 : H.billing_addresses) != null && G[O.id] ? U.billing_addresses[O.id] = H.billing_addresses[O.id] : (U.billing_addresses[O.id] = Gt({
          address: null,
          city: null,
          postcode: null,
          use_estate_address: a.use_estate_address_checked,
          use_person_address: a.use_person_address_checked,
          use_custom_address: a.use_custom_address_checked
        }), a.use_estate_address_checked && N(Ht(d.estateAddress), U.billing_addresses[O.id])), (F = H == null ? void 0 : H.internal_billing_addresses) != null && F[O.id] ? U.internal_billing_addresses[O.id] = H.internal_billing_addresses[O.id] : U.internal_billing_addresses[O.id] = Gt({
          address: null,
          city: null,
          postcode: null,
          use_estate_address: a.use_estate_address_checked,
          use_person_address: a.use_person_address_checked,
          use_custom_address: a.use_custom_address_checked
        });
      return i.value = U, !wc(H || {}, i.value);
    }, x = () => {
      let H = kt(i.value);
      a.billing_address_label || (H = im(H, (U, G) => G != "billing_addresses" && G != "internal_billing_addresses")), n("update:modelValue", H);
    }, D = (H, U) => {
      i.value && (U == pr.SELLER ? i.value.selected_seller_id = H.id : i.value.selected_buyer_id = H.id, x());
    }, N = (H, U) => {
      U.address = H.address, U.city = H.city, U.postcode = H.postcode;
    }, M = (H, U) => {
      i.value && (i.value.billing_addresses[H.id] = kt(U), i.value.internal_billing_addresses[H.id] = U, U.use_person_address ? N(H.address, i.value.billing_addresses[H.id]) : U.use_estate_address && N(Ht(d.estateAddress), i.value.billing_addresses[H.id]), x());
    };
    return St(() => {
      b() && x();
    }), t({
      ...o.expose
    }), (H, U) => {
      const G = oe("acquisit-header"), F = oe("acquisit-info-box"), O = oe("acquisit-string");
      return m(), S("div", bV, [
        e.header_label && (T.value || !e.no_persons_label) ? (m(), J(G, {
          key: 0,
          class: "header",
          label: e.header_label
        }, null, 8, ["label"])) : B("", !0),
        e.role_seller_label && i.value && (T.value || !e.no_persons_label) ? (m(), S("section", gV, [
          E.value ? (m(), S("h3", _V, je(e.role_seller_label), 1)) : B("", !0),
          (m(!0), S(qe, null, We(L.value, (Q) => {
            var ae, Te;
            return m(), J(cc, {
              onClick: (Ae) => D(Q, g(pr).SELLER),
              selected: ((ae = i.value) == null ? void 0 : ae.selected_seller_id) == Q.id,
              uid: H.uid + "-" + Q.id,
              key: Q.id,
              person: Q,
              radio: L.value.length > 1,
              billing_address_label: e.billing_address_label,
              billing_postcode_label: e.billing_postcode_label,
              billing_city_label: e.billing_city_label,
              use_person_address_label: e.use_person_address_label,
              use_person_address_checked: e.use_person_address_checked,
              use_estate_address_label: e.use_estate_address_label,
              use_estate_address_checked: e.use_estate_address_checked,
              use_custom_address_label: e.use_custom_address_label,
              use_custom_address_checked: e.use_custom_address_checked,
              errors: P.value.generic.concat(P.value[Q.id] || []),
              "has-current-errors": g(s),
              "no-interact": H.noInteract,
              "display-only": H.displayOnly,
              disabled: !V.value,
              modelValue: (Te = i.value) == null ? void 0 : Te.internal_billing_addresses[Q.id],
              "onUpdate:modelValue": (Ae) => M(Q, Ae)
            }, null, 8, ["onClick", "selected", "uid", "person", "radio", "billing_address_label", "billing_postcode_label", "billing_city_label", "use_person_address_label", "use_person_address_checked", "use_estate_address_label", "use_estate_address_checked", "use_custom_address_label", "use_custom_address_checked", "errors", "has-current-errors", "no-interact", "display-only", "disabled", "modelValue", "onUpdate:modelValue"]);
          }), 128))
        ])) : B("", !0),
        e.role_buyer_label && i.value && (T.value || !e.no_persons_label) ? (m(), S("section", wV, [
          E.value ? (m(), S("h3", kV, je(e.role_buyer_label), 1)) : B("", !0),
          (m(!0), S(qe, null, We(w.value, (Q) => {
            var ae, Te;
            return m(), J(cc, {
              onClick: (Ae) => D(Q, g(pr).BUYER),
              selected: ((ae = i.value) == null ? void 0 : ae.selected_buyer_id) == Q.id,
              uid: H.uid + "-" + Q.id,
              key: Q.id,
              person: Q,
              radio: w.value.length > 1,
              billing_address_label: e.billing_address_label,
              billing_postcode_label: e.billing_postcode_label,
              billing_city_label: e.billing_city_label,
              use_person_address_label: e.use_person_address_label,
              use_person_address_checked: e.use_person_address_checked,
              use_estate_address_label: e.use_estate_address_label,
              use_estate_address_checked: e.use_estate_address_checked,
              use_custom_address_label: e.use_custom_address_label,
              use_custom_address_checked: e.use_custom_address_checked,
              errors: P.value.generic.concat(P.value[Q.id] || []),
              "has-current-errors": g(s),
              "no-interact": H.noInteract,
              "display-only": H.displayOnly,
              disabled: !Y.value,
              modelValue: (Te = i.value) == null ? void 0 : Te.internal_billing_addresses[Q.id],
              "onUpdate:modelValue": (Ae) => M(Q, Ae)
            }, null, 8, ["onClick", "selected", "uid", "person", "radio", "billing_address_label", "billing_postcode_label", "billing_city_label", "use_person_address_label", "use_person_address_checked", "use_estate_address_label", "use_estate_address_checked", "use_custom_address_label", "use_custom_address_checked", "errors", "has-current-errors", "no-interact", "display-only", "disabled", "modelValue", "onUpdate:modelValue"]);
          }), 128))
        ])) : B("", !0),
        e.no_persons_label && !T.value ? (m(), S("section", $V, [
          K(F, {
            type: "warning",
            label: e.no_persons_label
          }, null, 8, ["label"])
        ])) : B("", !0),
        A.value && T.value ? (m(), S("footer", {
          key: 4,
          tabindex: 0,
          class: "footer",
          "aria-labelledby": H.uid + "-footer"
        }, [
          K(O, {
            source: A.value,
            id: H.uid + "-footer"
          }, null, 8, ["source", "id"])
        ], 8, CV)) : B("", !0)
      ]);
    };
  }
}), xV = { class: "city-wrapper" }, DV = /* @__PURE__ */ Pe({
  __name: "ProductPersonChooserAddress",
  props: {
    ...Ge(),
    address_label: {
      type: [String, Object],
      required: !0
    },
    postcode_label: {
      type: [String, Object],
      required: !0
    },
    city_label: {
      type: [String, Object],
      required: !0
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    modelValue: {
      type: Object,
      required: !0
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ar("components/person/ProductPersonChooserAddress", a), l = nr(a), s = Ze(a, n), { color: u, erroring: i } = s, c = C(() => {
      var y, _;
      let p = {
        generic: [],
        address: [],
        postcode: [],
        city: []
      };
      if (!a.errors || Array.isArray(a.errors) && !a.errors.length)
        return p;
      const h = a.errors;
      for (let $ of h)
        if ((_ = (y = $.owner) == null ? void 0 : y.person) != null && _.id)
          switch ($.key) {
            case "billing_address.address":
              p.address.push($);
              break;
            case "billing_address.postcode":
              p.postcode.push($);
              break;
            case "billing_address.city":
              p.city.push($);
              break;
            default:
              o.warnFrom("errorsMapped", "Unknown error reference:", $.key);
          }
        else
          p.generic.push($);
      return p;
    }), d = () => n("update:modelValue", a.modelValue);
    return Le(l.modelValue, () => d(), {
      deep: !0,
      immediate: !0
    }), t({
      ...s.expose
    }), (p, h) => {
      const y = oe("acquisit-input");
      return m(), S("div", {
        class: pe(["acquisit-product-person-chooser-address", { disabled: e.disabled }])
      }, [
        K(y, {
          modelValue: e.modelValue.address,
          "onUpdate:modelValue": h[0] || (h[0] = (_) => e.modelValue.address = _),
          label: e.address_label,
          errors: c.value.address,
          "has-current-errors": p.hasCurrentErrors || g(i),
          "no-interact": p.noInteract || e.disabled,
          disabled: e.disabled,
          color: g(u).base.value,
          class: "address"
        }, null, 8, ["modelValue", "label", "errors", "has-current-errors", "no-interact", "disabled", "color"]),
        W("div", xV, [
          K(y, {
            modelValue: e.modelValue.postcode,
            "onUpdate:modelValue": h[1] || (h[1] = (_) => e.modelValue.postcode = _),
            label: e.postcode_label,
            errors: c.value.postcode,
            "has-current-errors": p.hasCurrentErrors || g(i),
            "no-interact": p.noInteract || e.disabled,
            disabled: e.disabled,
            color: g(u).base.value,
            class: "postcode"
          }, null, 8, ["modelValue", "label", "errors", "has-current-errors", "no-interact", "disabled", "color"]),
          K(y, {
            modelValue: e.modelValue.city,
            "onUpdate:modelValue": h[2] || (h[2] = (_) => e.modelValue.city = _),
            label: e.city_label,
            errors: c.value.city,
            "has-current-errors": p.hasCurrentErrors || g(i),
            "no-interact": p.noInteract || e.disabled,
            disabled: e.disabled,
            color: g(u).base.value,
            class: "city"
          }, null, 8, ["modelValue", "label", "errors", "has-current-errors", "no-interact", "disabled", "color"])
        ])
      ], 2);
    };
  }
}), AV = { class: "acquisit-badge-wrapper" }, PV = { class: "badge-ribbon-wrapper" }, OV = /* @__PURE__ */ Pe({
  __name: "Badge",
  props: {
    ...Ge(),
    label: {
      type: [String, Object],
      required: !1,
      default: void 0
    },
    icon: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const o = Ze(e, r), { color: l } = o, s = C(() => {
      if (!l.base.value)
        return;
      let i = l.base.value.alpha || 1;
      return {
        color: l.textContrast.value.cssHSLA,
        background: l.base.value.cssHSLA,
        boxShadow: `0px 2px 4px ${l.base.value.withAlpha(0.3 * i).cssHSLA},
								0px 2px 5px ${l.base.value.darken(16).withAlpha(0.2 * i).cssHSLA}`
      };
    }), u = C(() => {
      const i = l.base.value.darken(12);
      return {
        borderTopColor: i.cssHSLA,
        borderLeftColor: i.cssHSLA
      };
    });
    return t({
      ...o.expose
    }), (i, c) => {
      const d = oe("v-svg"), p = oe("acquisit-string");
      return m(), S("div", AV, [
        W("div", {
          class: pe(["badge-content", { "icon-only": e.icon && !e.label }]),
          style: we(s.value)
        }, [
          e.icon ? (m(), J(d, {
            key: 0,
            class: "badge-icon",
            file: e.icon
          }, null, 8, ["file"])) : B("", !0),
          e.label ? (m(), J(p, {
            key: 1,
            source: e.label
          }, null, 8, ["source"])) : B("", !0),
          W("div", PV, [
            W("div", {
              class: "badge-ribbon",
              style: we(u.value)
            }, null, 4)
          ])
        ], 6)
      ]);
    };
  }
}), TV = /* @__PURE__ */ Yn(OV, [["__scopeId", "data-v-0d7aa573"]]), IV = {
  key: 0,
  class: "product-logo"
}, MV = ["src", "alt"], qV = {
  key: 1,
  class: "title"
}, EV = {
  key: 2,
  class: "description"
}, VV = {
  key: 3,
  class: "checklist"
}, LV = {
  key: 4,
  class: "footer"
}, BV = {
  key: 5,
  class: "fineprint"
}, jV = { class: "actions" }, HV = {
  key: 0,
  class: "checkbox"
}, RV = /* @__PURE__ */ Pe({
  __name: "MultiProductCard",
  props: {
    ...Ge(),
    product: {
      type: Object,
      required: !0
    },
    acceptCheckboxLabel: {
      type: [String, Object],
      required: !1,
      default: void 0
    }
  },
  emits: [
    ...Ke(),
    "selectProduct"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l } = o, s = C(() => a.product.background || void 0);
    return t({
      ...o.expose
    }), (u, i) => {
      const c = oe("acquisit-string"), d = oe("acquisit-checklist"), p = oe("acquisit-checkbox");
      return m(), S("div", {
        class: "acquisit-multi-product-card",
        style: we({ borderTopColor: g(l).base.value.cssHSLA })
      }, [
        W("div", {
          class: "product-wrapper background",
          style: we({ background: s.value })
        }, [
          e.product.logo ? (m(), S("div", IV, [
            W("img", {
              src: e.product.logo,
              alt: e.product.provider_name ?? void 0
            }, null, 8, MV)
          ])) : B("", !0),
          e.product.title ? (m(), S("div", qV, [
            W("h3", null, je(g(o).language.parse(e.product.title)), 1)
          ])) : B("", !0),
          e.product.description ? (m(), S("div", EV, [
            K(c, {
              class: "product-description",
              source: e.product.description
            }, null, 8, ["source"])
          ])) : B("", !0),
          e.product.list ? (m(), S("div", VV, [
            K(d, {
              items: e.product.list
            }, null, 8, ["items"])
          ])) : B("", !0),
          e.product.footer ? (m(), S("div", LV, [
            K(c, {
              class: "product-footer",
              source: e.product.footer
            }, null, 8, ["source"])
          ])) : B("", !0),
          e.product.fineprint ? (m(), S("div", BV, [
            K(c, {
              class: "product-fineprint",
              source: e.product.fineprint
            }, null, 8, ["source"])
          ])) : B("", !0),
          W("div", jV, [
            e.acceptCheckboxLabel ? (m(), S("div", HV, [
              K(p, {
                class: "accept-checkbox",
                modelValue: e.product.selected,
                "onUpdate:modelValue": i[0] || (i[0] = (h) => n("selectProduct", h)),
                label: e.acceptCheckboxLabel
              }, null, 8, ["modelValue", "label"])
            ])) : B("", !0),
            at(u.$slots, "actions", {}, void 0, !0)
          ])
        ], 4)
      ], 4);
    };
  }
}), FV = /* @__PURE__ */ Yn(RV, [["__scopeId", "data-v-d8613635"]]), NV = { class: "acquisit-multi-product-chooser" }, YV = { class: "products" }, UV = /* @__PURE__ */ Pe({
  __name: "MultiProductChooser",
  props: {
    ...Ge(),
    products: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    accept_checkbox_label: {
      type: [String, Object],
      required: !0
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l, erroring: s } = o, u = Go(), i = Ar("components/product/MultiProductChooser", a), c = C(() => {
      var V;
      return (V = a.products) != null && V.length ? a.products.map((T) => Ac(T)) : [];
    }), d = xm(), p = Gt({}), h = C(() => {
      var T, A;
      const V = {};
      for (let P of c.value)
        if (V[P.uid] || (V[P.uid] = {}), (T = P.terms) != null && T.terms_modal && (V[P.uid]._generic = P.terms.terms_modal), (A = P.checkboxes) != null && A.length)
          for (let b of P.checkboxes)
            for (let x of b.actions)
              x.type == hr.TERMS && (V[P.uid][x.uid] = x.modal);
      return V;
    }), y = (V, T, A) => {
      p[V] || (p[V] = {}), p[V][T] = A;
    }, _ = Gt({}), $ = (V) => {
      var T;
      if ((T = V.checkboxes) != null && T.length) {
        if (!_[V.uid]) {
          const A = (V.checkboxes ?? []).find((P) => P.multiProductChooserPrimary);
          A && (_[V.uid] = A);
        }
        return _[V.uid];
      }
    }, w = async (V, T) => {
      var P, b;
      const A = await d.getTerms(V, T);
      A ? (b = (P = p[V.uid]) == null ? void 0 : P[(T == null ? void 0 : T.uid) ?? "_generic"]) == null || b.openModal() : i.warnFrom("openTermsModal", "Received invalid terms", A);
    }, L = (V, T) => {
      if (!V)
        return;
      V.checkboxes_values || (V.checkboxes_values = {});
      const A = !(V.checkboxes_values[T.uid] ?? !1);
      if ((T.multiProductChooserPrimary ?? !1) && (R(V, A), !A))
        for (let P of V.checkboxes ?? [])
          P !== T && u.setCheckboxValue(V, P.uid, !1);
      u.setCheckboxValue(V, T.uid, A), Y();
    }, R = (V, T) => {
      const A = T ? [V] : [], P = T ? [] : [V];
      u.bulkSelect(A, P, a.uid);
    }, q = C(() => a.products.filter((V) => V.selected)), E = C(() => {
      var A;
      const V = {}, T = Array.isArray(a.errors) ? a.errors : [];
      for (let P of T)
        (A = P.owner) != null && A.product && (V[P.owner.product.uid] || (V[P.owner.product.uid] = {}), V[P.owner.product.uid][P.key] = [P]);
      return V;
    }), Y = () => {
      n("update:modelValue", q.value.map((V) => V.uid));
    };
    return Le(() => a.products, () => {
      Y();
    }, {
      deep: !0
    }), t({
      ...o.expose
    }), (V, T) => {
      const A = oe("acquisit-checkbox"), P = oe("acquisit-button"), b = oe("acquisit-multi-product-card"), x = oe("acquisit-string"), D = oe("acquisit-modal");
      return m(), S("div", NV, [
        W("div", YV, [
          (m(!0), S(qe, null, We(c.value, (N) => {
            var M;
            return m(), J(b, {
              class: "product",
              key: N.uid,
              "accept-checkbox-label": $(N) ? void 0 : e.accept_checkbox_label,
              product: N,
              color: N.color || null,
              onSelectProduct: (H) => R(N, H)
            }, Ca({ _: 2 }, [
              (M = N.checkboxes) != null && M.length ? {
                name: "actions",
                fn: ie(() => [
                  (m(!0), S(qe, null, We(N.checkboxes, (H) => {
                    var U, G;
                    return m(), S("div", {
                      class: "checkbox",
                      key: "checkbox-" + H.uid
                    }, [
                      K(A, {
                        uid: H.uid,
                        label: H.label,
                        modelValue: ((U = N.checkboxes_values) == null ? void 0 : U[H.uid]) ?? !1,
                        onClick: (F) => L(N, H),
                        errors: (G = E.value[N.uid]) == null ? void 0 : G[H.uid],
                        "has-current-errors": g(s),
                        color: N.color
                      }, null, 8, ["uid", "label", "modelValue", "onClick", "errors", "has-current-errors", "color"]),
                      (m(), S("div", {
                        class: "actions",
                        key: "actions-" + H.uid
                      }, [
                        (m(!0), S(qe, null, We(H.actions, (F) => {
                          var O, Q, ae;
                          return m(), S(qe, null, [
                            F.type == g(hr).MODAL ? (m(), J(P, {
                              key: 0,
                              label: F.label,
                              modal: F.modal,
                              type: "text",
                              color: "lightgrey",
                              errors: (O = E.value[N.uid]) == null ? void 0 : O[H.uid],
                              "has-current-errors": g(s)
                            }, null, 8, ["label", "modal", "errors", "has-current-errors"])) : F.type == g(hr).HREF ? (m(), J(P, {
                              key: 1,
                              label: F.label,
                              href: F.href,
                              type: "text",
                              color: "lightgrey",
                              errors: (Q = E.value[N.uid]) == null ? void 0 : Q[H.uid],
                              "has-current-errors": g(s),
                              target: "_blank"
                            }, null, 8, ["label", "href", "errors", "has-current-errors"])) : F.type == g(hr).TERMS ? (m(), J(P, {
                              key: 2,
                              label: F.label,
                              onClick: (Te) => w(N, F),
                              type: "text",
                              color: "lightgrey",
                              errors: (ae = E.value[N.uid]) == null ? void 0 : ae[H.uid],
                              "has-current-errors": g(s)
                            }, null, 8, ["label", "onClick", "errors", "has-current-errors"])) : B("", !0)
                          ], 64);
                        }), 256))
                      ]))
                    ]);
                  }), 128))
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["accept-checkbox-label", "product", "color", "onSelectProduct"]);
          }), 128))
        ]),
        (m(!0), S(qe, null, We(g(d).store, (N, M) => (m(), S(qe, null, [
          (m(!0), S(qe, null, We(N, (H, U) => (m(), J(D, {
            key: "terms-" + M + "-" + U,
            ref_for: !0,
            ref: (G) => y(M, U, G)
          }, {
            header: ie(() => [
              K(x, null, {
                default: ie(() => {
                  var G, F;
                  return [
                    pt(je((F = (G = h.value[M]) == null ? void 0 : G[U]) == null ? void 0 : F.title), 1)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            accept: ie(() => [
              K(x, null, {
                default: ie(() => {
                  var G, F;
                  return [
                    pt(je((F = (G = h.value[M]) == null ? void 0 : G[U]) == null ? void 0 : F.button_accept_label), 1)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            default: ie(() => [
              K(x, null, {
                default: ie(() => {
                  var G, F;
                  return [
                    pt(je(((F = (G = h.value[M]) == null ? void 0 : G[U]) == null ? void 0 : F.body) || H), 1)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ], 64))), 256))
      ]);
    };
  }
}), zV = ["data-product-uid"], WV = ["aria-label"], KV = {
  key: 5,
  class: "generic product-label"
}, GV = {
  class: "action-show-more",
  key: "action"
}, ZV = {
  class: "hidden full product-label",
  key: "text"
}, XV = {
  key: 6,
  class: "fineprint product-label"
}, JV = /* @__PURE__ */ Pe({
  __name: "SingleProductCard",
  props: {
    ...Ge(),
    product: {
      type: Object,
      required: !0
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    zt((L) => ({
      "47138c67": y.value.cssHSLA,
      "126a4f27": _.value.cssHSLA,
      ac7a2226: d.value,
      "4e27d254": $.value
    }));
    const a = e, n = C(() => Ac({ ...a.product })), l = Ze(a, r), { color: s } = l, { noInteract: u } = nr(a), i = z(), c = z(!!a.product.hidden_text_show_label), d = dr(() => a.product.logo_background ?? "linear-gradient(to bottom, #f9f9f9 0%, #fff 100%)");
    dr(() => a.product.list_icon ?? void 0);
    const p = dr(() => a.product.list_icon_color ?? void 0), h = dr(() => a.product.merge_logo_title ?? !1), y = C(() => a.product.card_background ? zr.detectType(a.product.card_background) == $c.str ? s.white : zr.fromString(a.product.card_background) ?? s.white : s.white), _ = C(() => s.textContrastFor(y.value)), $ = C(() => a.product.card_background ? s.textContrastFor(y.value).withAlpha(0.67) : s.parse("light-grey").darken(18)), w = () => {
      if (!i.value)
        return;
      const L = i.value;
      let R = L.querySelectorAll(".acquisit-colorize"), q = L.querySelectorAll(".acquisit-text-colorize"), E = (Y, V) => {
        for (let T of Y)
          T.$el && (T = T.$el), T.style.color = V;
      };
      E(R, s.baseVisuallySafe.value.cssHSLA), E(q, s.textDark.value.cssHSLA);
    };
    return St(() => {
      w();
    }), t({
      ...l.expose
    }), (L, R) => {
      const q = oe("acquisit-badge"), E = oe("acquisit-string"), Y = oe("acquisit-checklist"), V = oe("acquisit-button");
      return m(), S("div", {
        class: pe(["acquisit-product-card", { "no-interact": g(u), "has-logo-background": a.product.logo_background }]),
        style: we({ borderTopColor: g(s).parse(n.value.color).cssHSLA }),
        role: "section",
        ref_key: "$root",
        ref: i,
        "data-product-uid": e.product.uid
      }, [
        n.value.badge ? (m(), J(q, {
          key: 0,
          color: n.value.badge.color,
          label: n.value.badge.label,
          icon: n.value.badge.icon,
          class: "badge"
        }, null, 8, ["color", "label", "icon"])) : B("", !0),
        W("header", {
          class: pe([{ "has-title": h.value && n.value.title, "size-large": !n.value.title && !n.value.description && !n.value.list }])
        }, [
          W("div", {
            class: "logo",
            style: we({ backgroundImage: "url(" + n.value.logo + ")" }),
            role: "img",
            "aria-label": n.value.provider_name || n.value.title || void 0
          }, null, 12, WV),
          h.value && n.value.title ? (m(), S(qe, { key: 0 }, [
            n.value.title_html ? (m(), J(E, {
              key: 0,
              class: "title",
              html: n.value.title_html
            }, null, 8, ["html"])) : (m(), J(E, {
              key: 1,
              class: "title"
            }, {
              default: ie(() => [
                pt(je(e.product.title), 1)
              ]),
              _: 1
            }))
          ], 64)) : B("", !0)
        ], 2),
        h.value ? B("", !0) : (m(), S(qe, { key: 1 }, [
          n.value.title_html ? (m(), J(E, {
            key: 0,
            class: "title product-label",
            html: n.value.title_html
          }, null, 8, ["html"])) : (m(), J(E, {
            key: 1,
            class: "title product-label"
          }, {
            default: ie(() => [
              pt(je(e.product.title), 1)
            ]),
            _: 1
          }))
        ], 64)),
        n.value.description_html ? (m(), J(E, {
          key: 2,
          class: "description product-label",
          html: n.value.description_html
        }, null, 8, ["html"])) : (m(), J(E, {
          key: 3,
          class: "description product-label"
        }, {
          default: ie(() => [
            pt(je(n.value.description), 1)
          ]),
          _: 1
        })),
        n.value.list ? (m(), J(Y, {
          key: 4,
          class: "product-label",
          items: n.value.list,
          icon: n.value.list_icon ?? void 0,
          iconColor: p.value
        }, null, 8, ["items", "icon", "iconColor"])) : B("", !0),
        n.value.generic_text ? (m(), S("div", KV, [
          K(E, {
            "link-color": g(s).baseVisuallySafe,
            "font-size": "14px"
          }, {
            default: ie(() => [
              pt(je(n.value.generic_text), 1)
            ]),
            _: 1
          }, 8, ["link-color"])
        ])) : B("", !0),
        K(bt, {
          name: "move-fade-bottom",
          mode: "out-in"
        }, {
          default: ie(() => [
            n.value.hidden_text && c.value ? (m(), S("div", GV, [
              K(V, {
                type: "flat",
                underlined: "",
                class: "action-show-more-btn",
                onClick: R[0] || (R[0] = (T) => c.value = !1),
                color: g(s).baseVisuallySafe
              }, {
                default: ie(() => [
                  pt(je(n.value.hidden_text_show_label), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ])) : n.value.hidden_text && !c.value ? (m(), S("div", ZV, [
              K(E, {
                "link-color": g(s).baseVisuallySafe,
                "font-size": "14px"
              }, {
                default: ie(() => [
                  pt(je(n.value.hidden_text), 1)
                ]),
                _: 1
              }, 8, ["link-color"])
            ])) : B("", !0)
          ]),
          _: 1
        }),
        n.value.fineprint ? (m(), S("div", XV, [
          K(E, {
            "link-color": g(s).baseVisuallySafe,
            color: $.value,
            "font-size": "0.91rem"
          }, {
            default: ie(() => [
              pt(je(e.product.fineprint), 1)
            ]),
            _: 1
          }, 8, ["link-color", "color"])
        ])) : B("", !0),
        n.value.footer || n.value.footer_html ? (m(), S("footer", {
          key: 7,
          style: we({ background: g(s).base.value.cssHSLA }),
          class: "footer"
        }, [
          K(E, {
            style: we({ color: g(s).textContrast.value.cssHSLA }),
            html: n.value.footer_html || null,
            "font-size": "14px",
            "link-color": g(s).textContrast
          }, {
            default: ie(() => [
              pt(je(n.value.footer_html ? null : n.value.footer), 1)
            ]),
            _: 1
          }, 8, ["style", "html", "link-color"])
        ], 4)) : B("", !0)
      ], 14, zV);
    };
  }
}), QV = ["aria-label"], eL = { class: "side-left" }, tL = ["aria-label"], rL = {
  key: 1,
  class: "no-products"
}, aL = {
  key: 1,
  class: "products-bullets"
}, nL = {
  key: 0,
  class: "conditions-wrapper"
}, oL = { class: "buttons" }, lL = { class: "buttons" }, dc = "linear-gradient(to bottom, #f9f9f9 0%, #f9f9f9 50%, #fff 100%)", sL = /* @__PURE__ */ Pe({
  __name: "SingleProductChooserCarousel",
  props: {
    ...Ge(),
    ...Pc(),
    previous_product_label: {
      type: [String, Object],
      required: !1,
      default: "Previous product"
    },
    next_product_label: {
      type: [String, Object],
      required: !1,
      default: "Next product"
    },
    already_ordered_label: {
      type: [String, Object],
      required: !1,
      default: null
    },
    modelValue: {
      type: Array,
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke(),
    "update:modelValue",
    "currentProducts"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r;
    Ar("ui/extended/ProductChooserCarousel", a);
    const o = Ze(a, n), { color: l, erroring: s, uid: u } = o, i = Oc(a), { availableProducts: c, errorsByProduct: d, terms: p } = i, h = z(), y = z(), _ = z(), $ = z(), w = z(), L = z(), R = Gt({}), q = z(a.already_ordered), E = z(!1), Y = z(), V = z(), T = z(), A = z(0), P = z(!1), b = z(0), x = z(0), D = z(0), N = z(!1), M = z(!1), H = z(!0), U = z(64), G = z(0), F = Go(), O = C(() => c.value.length ? c.value[G.value] ?? null : null), Q = C(() => c.value.length - 1), ae = C(() => G.value == 0), Te = C(() => G.value == c.value.length - 1), Ae = C(() => Ko(T.value ?? {}, Y.value ?? {})), Ye = C(() => O.value && zr.detectType(O.value.background) == $c.str ? O.value.background ?? void 0 : dc), Re = C(() => Ye.value != dc), it = C(() => Re.value), he = C(() => O.value ? [O.value.uid] : []), X = () => {
      n("update:modelValue", he.value);
    }, re = () => {
      let ve = [];
      c.value.length && !q.value && (ve = [c.value[G.value]]), F.setCurrent(ve), n("currentProducts", ve);
    }, Se = (ve) => {
      const st = (rt) => rt ? rt.classList.contains("control") ? rt : rt.classList.contains("product-slider-wrapper") ? null : st(rt.parentElement) : !1;
      return !!st(ve);
    }, me = (ve) => {
      const st = (rt) => {
        var vt;
        return rt ? (vt = rt.$el) != null && vt.classList.contains("product-actions") || rt.classList.contains("product-actions") ? rt : st(rt.parentElement) : !1;
      };
      return !!st(ve);
    }, fe = (ve) => ve.tagName == "A" && ve.href, Oe = () => {
      if (!h.value || !_.value)
        return;
      const ve = _.value.offsetWidth, st = 640;
      let rt, vt;
      h.value.offsetWidth >= 480 ? (c.value.length < 2 ? rt = h.value.offsetWidth - 2 * 24 : rt = h.value.offsetWidth - 2 * 32, rt = Math.min(rt, st), vt = (ve - rt) / 2 - 64) : (c.value.length < 2 ? rt = h.value.offsetWidth - 2 * 24 : rt = h.value.offsetWidth - 2 * 32, rt = Math.min(rt, st), vt = 8), A.value = rt, x.value = vt, D.value = vt, V.value = {
        width: `${rt}px`
      }, T.value = {
        width: `${Math.ceil(c.value.length * rt)}px`,
        left: `${(h.value.offsetWidth - rt) / 2}px`
      }, b.value = rt * -G.value, Y.value = {
        transform: `translateX(${b.value}px)`
      };
    }, Ie = (ve) => {
      ve == 0 || (ve == 1 && ae.value ? (b.value = A.value * Q.value * -1, G.value = Q.value) : ve == -1 && Te.value ? (b.value = 0, G.value = 0) : (b.value = b.value + A.value * ve, G.value -= ve)), Y.value = {
        transition: "0.3s",
        transform: `translateX(${b.value}px)`
      }, q.value && (q.value = !1), re();
    }, ye = () => {
      Ie(
        1
        /* left */
      ), X();
    }, Fe = () => {
      Ie(
        -1
        /* right */
      ), X();
    }, Me = z(0), He = z(0), ce = C(() => He.value - Me.value), mt = z(0), nt = z(0), ot = C(() => nt.value - mt.value), ft = (ve, st) => {
      if (N.value && c.value.length != 1 && !P.value) {
        He.value = st(ve);
        const rt = Math.sign(ce.value), vt = 20;
        (ce.value > vt || ce.value < -20) && (M.value = !0, rt < 1 ? Y.value = {
          transform: `translateX(${ce.value + vt + b.value}px)`
        } : Y.value = {
          transform: `translateX(${ce.value - vt + b.value}px)`
        });
      }
    }, $e = (ve) => {
      Se(ve.target) || me(ve.target) || fe(ve.target) || (Me.value = ve.pageX, mt.value = ve.pageY, N.value = !0);
    }, Qe = (ve) => {
      Se(ve.target) || me(ve.target) || fe(ve.target) || (Me.value = ve.touches[0].pageX, mt.value = ve.touches[0].pageY, N.value = !0);
    }, te = (ve) => {
      Se(ve.target) || ft(ve, (st) => st.pageX);
    }, xe = (ve) => {
      Se(ve.target) || (He.value = ve.touches[0].pageX, nt.value = ve.touches[0].pageY, Math.abs(ot.value) < Math.abs(ce.value) && (ft(ve, (st) => st.touches[0].pageX), ve.preventDefault()));
    }, Ee = async (ve) => {
      Se(ve.target) || me(ve.target) || fe(ve.target) || (N.value = !1, P.value = !1, M.value = !1, Math.abs(ot.value) > Math.abs(ce.value) ? Ie(0) : ce.value > U.value && G.value != 0 ? (Ie(
        1
        /* left */
      ), X()) : ce.value < -U.value && G.value != c.value.length - 1 ? (Ie(
        -1
        /* right */
      ), X()) : Ie(0));
    }, Ve = (ve) => {
      Ee(ve);
    }, Xe = (ve) => {
      switch (ve.key) {
        case "ArrowLeft":
          Ie(
            1
            /* left */
          );
          break;
        case "ArrowRight":
          Ie(
            -1
            /* right */
          );
          break;
      }
    }, de = C(() => a.already_ordered_label ? !(o.language.parse(a.already_ordered_label) ?? "").match(/<a/) : !1), ke = async () => {
      await ut(), o.emitProperty("already_ordered", q.value), await ut();
    }, lt = async (ve) => {
      ve.dataset && ve.dataset.action == "next-page" && (L.value ? L.value.openModal() : (q.value = !0, await ke(), X(), Ra.$emit("single-product-chooser:accept-product")));
    }, dt = async () => {
      var ve;
      (ve = L.value) == null || ve.closeModal(), q.value = !0, await ke(), de.value || (await ke(), X(), Ra.$emit("single-product-chooser:accept-product"));
    }, Je = async () => {
      var ve;
      (ve = L.value) == null || ve.closeModal(), q.value = !1;
    }, ue = C(() => {
      var ve;
      return O.value && (ve = O.value.terms) != null && ve.terms_modal ? O.value.terms.terms_modal : null;
    }), j = C(() => {
      if (!O.value)
        return [];
      let ve = [];
      for (const st of O.value.checkboxes ?? [])
        ve = ve.concat(st.actions.filter((rt) => rt.type == hr.TERMS));
      return ve;
    }), ne = C(() => Ft(j.value, (ve) => ve.uid)), ge = (ve) => {
      ve && (F.setTermsAgreed(ve, !ve.terms_agreed), X());
    }, De = (ve, st) => {
      ve && (ve.checkboxes_values || (ve.checkboxes_values = {}), F.setCheckboxValue(ve, st.uid, !(ve.checkboxes_values[st.uid] ?? !1)), X());
    }, yt = async () => {
      if (O.value) {
        if (p.contain(O.value))
          $.value && $.value.openModal();
        else if (await p.getTerms(O.value), await ut(), p.contain(O.value))
          return await yt();
      }
    }, gt = async (ve) => {
      if (O.value) {
        if (p.contain(O.value, ve))
          R[ve.uid] && R[ve.uid].openModal();
        else if (await p.getTerms(O.value, ve), await ut(), p.contain(O.value, ve))
          return await gt(ve);
      }
    }, _t = () => {
      var ve;
      (ve = w.value) == null || ve.openModal();
    };
    return Le(q, async (ve) => {
      de.value ? (o.emitProperty("disabled", ve), ve && L.value && L.value.openModal(), X(), re(), await ke()) : (X(), re(), await ke());
    }), St(async () => {
      if (c.value.length) {
        const ve = Array.isArray(a.modelValue) && a.modelValue.length ? a.modelValue[0] : null;
        if (ve !== null) {
          let st = 0;
          for (let rt of c.value)
            ve == rt.uid && (G.value = st), st++;
        }
      }
      H.value = !1, await ut(), H.value = !0, setTimeout(() => Oe(), 600), de.value || q.value && (q.value = !1), re(), a.modelValue === null && X();
    }), jr(() => {
      M.value = !1, F.setCurrent([]), n("currentProducts", []);
    }), Kr(window, "resize", () => Oe()), Kr(document, "keyup", Xe), Le(() => a.products, async () => {
      await ut(), Oe();
    }), t({
      ...o.expose
    }), (ve, st) => {
      const rt = oe("acquisit-header"), vt = oe("v-svg"), ta = oe("acquisit-single-product-card"), Tr = oe("acquisit-checkbox"), Yt = oe("acquisit-button"), Bt = oe("acquisit-string"), Nr = oe("acquisit-modal");
      return m(), S("div", {
        class: pe(["acquisit-single-product-chooser", { fixed: M.value, dark: it.value || ve.theme == "dark", disabled: ve.disabled, "multiple-products": g(c).length }]),
        onScroll: st[3] || (st[3] = (ur) => P.value = !0),
        style: we({ background: Ye.value }),
        onKeyup: Xe,
        ref_key: "$root",
        ref: _
      }, [
        ve.header ? (m(), J(rt, {
          key: 0,
          class: "header",
          label: ve.header
        }, null, 8, ["label"])) : B("", !0),
        W("div", {
          class: "product-slider-wrapper",
          onMousedown: $e,
          onMouseup: Ee,
          onMousemove: te,
          onTouchstart: Qe,
          onTouchend: Ve,
          onTouchmove: xe,
          ref_key: "$sliderWrapper",
          ref: y
        }, [
          g(c).length ? (m(), S("div", {
            key: 0,
            class: "window",
            ref_key: "$window",
            ref: h
          }, [
            K(bt, { name: "product-control-move-fade-right" }, {
              default: ie(() => [
                Q.value > 0 && !ve.disabled ? (m(), S("div", {
                  key: 0,
                  class: "control left",
                  tabindex: 0,
                  role: "button",
                  "aria-label": g(o).language.parse(e.previous_product_label),
                  onKeypress: Jt(ye, ["enter"]),
                  onClick: ye,
                  "data-tag": "previous-product-button",
                  style: we({ backgroundColor: g(l).baseVisuallySafe.value.cssHSLA, left: x.value + "px" })
                }, [
                  K(vt, {
                    file: "chevrons/left",
                    "aria-hidden": "true"
                  }),
                  W("div", {
                    class: "focus-ring",
                    style: we({ boxShadow: "0px 0px 16px " + g(l).baseVisuallySafe.value.withAlpha(0.8).cssHSLA }),
                    tabindex: "-1"
                  }, null, 4)
                ], 44, QV)) : B("", !0)
              ]),
              _: 1
            }),
            W("div", eL, [
              W("div", {
                class: pe(["product-slider", { animating: E.value }]),
                style: we(Ae.value)
              }, [
                (m(!0), S(qe, null, We(g(c), (ur, ra) => (m(), S("div", {
                  class: pe(["slide", { selected: G.value == ra, disabled: ve.disabled }]),
                  key: ur.uid,
                  style: we(V.value)
                }, [
                  K(ta, {
                    class: "product-card",
                    color: ur.color || void 0,
                    product: ur,
                    "data-tag": "product-card"
                  }, null, 8, ["color", "product"])
                ], 6))), 128))
              ], 6)
            ]),
            K(bt, { name: "product-control-move-fade-left" }, {
              default: ie(() => [
                Q.value > 0 && !ve.disabled ? (m(), S("div", {
                  key: 0,
                  class: "control right",
                  onKeypress: Jt(Fe, ["enter"]),
                  onClick: Fe,
                  tabindex: 0,
                  role: "button",
                  "data-tag": "next-product-button",
                  "aria-label": g(o).language.parse(e.next_product_label),
                  style: we({ backgroundColor: g(l).baseVisuallySafe.value.cssHSLA, right: D.value + "px" })
                }, [
                  K(vt, {
                    file: "chevrons/right",
                    "aria-hidden": "true"
                  }),
                  W("div", {
                    class: "focus-ring",
                    style: we({ boxShadow: "0px 0px 16px " + g(l).baseVisuallySafe.value.withAlpha(0.8).cssHSLA }),
                    tabindex: "-1"
                  }, null, 4)
                ], 44, tL)) : B("", !0)
              ]),
              _: 1
            })
          ], 512)) : B("", !0),
          g(c).length ? B("", !0) : (m(), S("p", rL, "No products available"))
        ], 544),
        g(c).length > 1 ? (m(), S("div", aL, [
          (m(!0), S(qe, null, We(g(c), (ur, ra) => (m(), S("div", {
            key: ur.uid,
            class: pe(["bullet", { selected: G.value == ra }])
          }, [
            W("div", {
              class: "bullet-select",
              style: we({ backgroundColor: g(l).baseVisuallySafe.value.cssHSLA })
            }, null, 4)
          ], 2))), 128))
        ])) : B("", !0),
        ve.footer ? (m(), J(rt, {
          key: 2,
          class: "footer",
          label: ve.footer,
          style: we({ width: A.value + "px" })
        }, null, 8, ["label", "style"])) : B("", !0),
        K(bt, {
          name: "move-fade-bottom",
          duration: 300
        }, {
          default: ie(() => {
            var ur, ra, aa, Oa, na, zn, Wn, oa, Kn, Gn, ba, Zn, la, Xn;
            return [
              O.value && (O.value.terms || O.value.checkboxes) ? (m(), S("div", nL, [
                W("div", {
                  class: "checkboxes-wrapper",
                  style: we({ width: A.value + "px" })
                }, [
                  O.value.terms ? (m(), S("div", {
                    key: 0,
                    class: pe(["item", { centered: !O.value.terms.checkbox_label }])
                  }, [
                    O.value.terms.checkbox_label ? (m(), J(Tr, {
                      key: 0,
                      ref: "$termsCheckbox",
                      uid: "terms-checkbox",
                      label: O.value.terms.checkbox_label,
                      errors: (ur = g(d)[O.value.uid]) == null ? void 0 : ur.terms_agreed,
                      "has-current-errors": g(s),
                      onClick: st[0] || (st[0] = (ht) => ge(O.value)),
                      color: O.value.color,
                      modelValue: O.value.terms_agreed,
                      "onUpdate:modelValue": st[1] || (st[1] = (ht) => O.value.terms_agreed = ht)
                    }, null, 8, ["label", "errors", "has-current-errors", "color", "modelValue"])) : B("", !0),
                    W("div", oL, [
                      O.value.terms.terms_modal ? (m(), J(Yt, {
                        key: 0,
                        type: O.value.terms.terms_modal.button_open_type ?? "text",
                        class: "open-terms-btn",
                        "data-tag": "open-terms-button",
                        onClick: yt,
                        color: "lightgrey",
                        errors: (ra = g(d)[O.value.uid]) == null ? void 0 : ra.terms_agreed,
                        "has-current-errors": g(s),
                        loading: g(p).isLoading[O.value.uid] || !1,
                        label: (aa = O.value.terms.terms_modal) == null ? void 0 : aa.button_open_label
                      }, null, 8, ["type", "errors", "has-current-errors", "loading", "label"])) : B("", !0),
                      (Oa = O.value.terms) != null && Oa.withdrawal_form_label && ((na = O.value.terms) != null && na.withdrawal_form_href) ? (m(), J(Yt, {
                        key: 1,
                        href: O.value.terms.withdrawal_form_href,
                        target: "_blank",
                        type: ((zn = O.value.terms.terms_modal) == null ? void 0 : zn.button_open_type) ?? "text",
                        color: "lightgrey",
                        class: pe(["open-withdrawal-form-btn"]),
                        "data-tag": "open-withdrawal-form-button",
                        label: O.value.terms.withdrawal_form_label,
                        errors: (Wn = g(d)[O.value.uid]) == null ? void 0 : Wn.terms_agreed,
                        "has-current-errors": g(s)
                      }, null, 8, ["href", "type", "label", "errors", "has-current-errors"])) : B("", !0),
                      (oa = O.value.terms) != null && oa.withdrawal_modal ? (m(), J(Yt, {
                        key: 2,
                        type: ((Gn = (Kn = O.value.terms) == null ? void 0 : Kn.withdrawal_modal) == null ? void 0 : Gn.button_open_type) ?? "text",
                        class: "open-withdrawal-btn",
                        "data-tag": "open-withdrawal-button",
                        color: "lightgrey",
                        errors: (ba = g(d)[O.value.uid]) == null ? void 0 : ba.terms_agreed,
                        "has-current-errors": g(s),
                        onClick: _t,
                        target: "_blank",
                        label: (la = (Zn = O.value.terms) == null ? void 0 : Zn.withdrawal_modal) == null ? void 0 : la.button_open_label
                      }, null, 8, ["type", "errors", "has-current-errors", "label"])) : B("", !0)
                    ])
                  ], 2)) : B("", !0),
                  (m(!0), S(qe, null, We(O.value.checkboxes ?? [], (ht) => {
                    var Ot, pn;
                    return m(), S("div", {
                      key: "checkbox-" + O.value.uid + "-" + ht.uid,
                      class: pe(["item"])
                    }, [
                      K(Tr, {
                        uid: ht.uid,
                        label: ht.label,
                        errors: (Ot = g(d)[O.value.uid]) == null ? void 0 : Ot[ht.uid],
                        "has-current-errors": g(s),
                        onClick: (or) => De(O.value, ht),
                        color: O.value.color,
                        modelValue: ((pn = O.value.checkboxes_values) == null ? void 0 : pn[ht.uid]) ?? !1
                      }, null, 8, ["uid", "label", "errors", "has-current-errors", "onClick", "color", "modelValue"]),
                      W("div", lL, [
                        (m(!0), S(qe, null, We(ht.actions, (or) => {
                          var Jn, Qn, eo;
                          return m(), S(qe, null, [
                            or.type == g(hr).MODAL ? (m(), J(Yt, {
                              key: 0,
                              label: or.label,
                              modal: or.modal,
                              type: "text",
                              color: "lightgrey",
                              errors: (Jn = g(d)[O.value.uid]) == null ? void 0 : Jn[ht.uid],
                              "has-current-errors": g(s)
                            }, null, 8, ["label", "modal", "errors", "has-current-errors"])) : or.type == g(hr).HREF ? (m(), J(Yt, {
                              key: 1,
                              label: or.label,
                              href: or.href,
                              type: "text",
                              color: "lightgrey",
                              errors: (Qn = g(d)[O.value.uid]) == null ? void 0 : Qn[ht.uid],
                              "has-current-errors": g(s),
                              target: "_blank"
                            }, null, 8, ["label", "href", "errors", "has-current-errors"])) : or.type == g(hr).TERMS ? (m(), J(Yt, {
                              key: 2,
                              label: or.label,
                              onClick: (Xs) => gt(or),
                              type: "text",
                              color: "lightgrey",
                              errors: (eo = g(d)[O.value.uid]) == null ? void 0 : eo[ht.uid],
                              "has-current-errors": g(s)
                            }, null, 8, ["label", "onClick", "errors", "has-current-errors"])) : B("", !0)
                          ], 64);
                        }), 256))
                      ])
                    ]);
                  }), 128))
                ], 4),
                (m(), J(Xt, { to: "body" }, [
                  ue.value ? (m(), J(Nr, {
                    key: 0,
                    class: "terms-modal",
                    "data-tag": "terms-modal",
                    ref_key: "$termsModalLegacy",
                    ref: $
                  }, {
                    header: ie(() => {
                      var ht;
                      return [
                        K(Bt, {
                          source: (ht = ue.value) == null ? void 0 : ht.title
                        }, null, 8, ["source"])
                      ];
                    }),
                    accept: ie(() => {
                      var ht;
                      return [
                        K(Bt, {
                          source: (ht = ue.value) == null ? void 0 : ht.button_accept_label
                        }, null, 8, ["source"])
                      ];
                    }),
                    default: ie(() => [
                      K(Bt, null, {
                        default: ie(() => {
                          var ht, Ot;
                          return [
                            pt(je(((ht = ue.value) == null ? void 0 : ht.body) || ((Ot = g(p).store[O.value.uid]) == null ? void 0 : Ot._generic)), 1)
                          ];
                        }),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)) : B("", !0),
                  (m(!0), S(qe, null, We(j.value, (ht) => (m(), J(Nr, {
                    class: "terms-modal",
                    "data-tag": "terms-modal",
                    ref_for: !0,
                    ref: (Ot) => R[ht.uid] = Ot
                  }, {
                    header: ie(() => [
                      K(Bt, null, {
                        default: ie(() => {
                          var Ot;
                          return [
                            pt(je((Ot = ne.value[ht.uid ?? "_generic"]) == null ? void 0 : Ot.modal.title), 1)
                          ];
                        }),
                        _: 2
                      }, 1024)
                    ]),
                    accept: ie(() => [
                      K(Bt, null, {
                        default: ie(() => {
                          var Ot;
                          return [
                            pt(je((Ot = ne.value[ht.uid ?? "_generic"]) == null ? void 0 : Ot.modal.button_accept_label), 1)
                          ];
                        }),
                        _: 2
                      }, 1024)
                    ]),
                    default: ie(() => [
                      K(Bt, null, {
                        default: ie(() => {
                          var Ot;
                          return [
                            pt(je(((Ot = ne.value[ht.uid ?? "_generic"]) == null ? void 0 : Ot.modal.body) || g(p).store[O.value.uid][ht.uid]), 1)
                          ];
                        }),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1536))), 256))
                ])),
                (m(), J(Xt, { to: "body" }, [
                  (Xn = O.value.terms) != null && Xn.withdrawal_modal ? (m(), J(Nr, {
                    key: 0,
                    class: "withdrawal-modal",
                    "data-tag": "withdrawal-modal",
                    ref_key: "$withdrawalModal",
                    ref: w
                  }, Ca({
                    default: ie(() => [
                      K(Bt, {
                        source: O.value.terms.withdrawal_modal.body
                      }, null, 8, ["source"]),
                      O.value.terms.withdrawal_form_href && !O.value.terms.withdrawal_form_label ? (m(), J(Yt, {
                        key: 0,
                        label: O.value.terms.withdrawal_form_href.replace(/https?:\/\//, "").split("").map((ht) => "<span>" + ht + "</span>").join(""),
                        style: { "margin-top": "16px" },
                        type: "text",
                        bordered: "",
                        target: "_blank",
                        href: O.value.terms.withdrawal_form_href
                      }, null, 8, ["label", "href"])) : B("", !0)
                    ]),
                    accept: ie(() => [
                      K(Bt, {
                        source: O.value.terms.withdrawal_modal.button_accept_label
                      }, null, 8, ["source"])
                    ]),
                    _: 2
                  }, [
                    O.value.terms.withdrawal_modal.title ? {
                      name: "header",
                      fn: ie(() => [
                        K(Bt, {
                          source: O.value.terms.withdrawal_modal.title
                        }, null, 8, ["source"])
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1536)) : B("", !0)
                ]))
              ])) : B("", !0)
            ];
          }),
          _: 1
        }),
        e.already_ordered_label ? (m(), S("div", {
          key: 3,
          class: "already-ordered-wrapper",
          style: we({ maxWidth: A.value + "px" })
        }, [
          de.value ? (m(), J(Tr, {
            key: 0,
            label: e.already_ordered_label,
            modelValue: q.value,
            "onUpdate:modelValue": st[2] || (st[2] = (ur) => q.value = ur),
            "data-tag": "already-ordered-checkbox"
          }, null, 8, ["label", "modelValue"])) : (m(), J(Bt, {
            key: 1,
            class: "already-ordered-label",
            "data-tag": "already-ordered-label",
            source: e.already_ordered_label,
            onLinkClick: lt
          }, null, 8, ["source"])),
          (m(), J(Xt, { to: "body" }, [
            ve.already_ordered_modal ? (m(), J(Nr, {
              key: 0,
              class: "already-ordered-modal",
              ref_key: "$alreadyOrderedModal",
              ref: L,
              "data-tag": "already-ordered-modal"
            }, Ca({
              left: ie(() => [
                ve.already_ordered_modal.button_decline_label ? (m(), J(Yt, {
                  key: 0,
                  onClick: Je,
                  color: "light-grey-blue",
                  type: "raised",
                  style: { "margin-left": "16px" }
                }, {
                  default: ie(() => [
                    pt(je(ve.already_ordered_modal.button_decline_label), 1)
                  ]),
                  _: 1
                })) : B("", !0)
              ]),
              right: ie(() => [
                ve.already_ordered_modal.button_accept_label ? (m(), J(Yt, {
                  key: 0,
                  type: de.value ? "raised" : "flat",
                  onClick: dt,
                  style: we(de.value ? {} : "margin-right: -16px;")
                }, {
                  default: ie(() => [
                    pt(je(ve.already_ordered_modal.button_accept_label), 1)
                  ]),
                  _: 1
                }, 8, ["type", "style"])) : B("", !0)
              ]),
              default: ie(() => [
                K(Bt, null, {
                  default: ie(() => [
                    pt(je(ve.already_ordered_modal.body), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, [
              ve.already_ordered_modal.title ? {
                name: "header",
                fn: ie(() => [
                  K(Bt, null, {
                    default: ie(() => [
                      pt(je(ve.already_ordered_modal.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1536)) : B("", !0)
          ]))
        ], 4)) : B("", !0),
        ve.$slots.default ? (m(), S("div", {
          key: 4,
          class: "children",
          style: we({ width: A.value + "px" }),
          "data-tag": "children"
        }, [
          at(ve.$slots, "default")
        ], 4)) : B("", !0)
      ], 38);
    };
  }
}), iL = {
  class: "product-item-wrapper",
  tabindex: "-1"
}, uL = ["aria-label"], cL = ["src"], dL = {
  class: "meta",
  role: "presentation"
}, fL = ["aria-labelledby"], vL = {
  class: "terms-action-clickzone",
  role: "presentation"
}, pL = {
  class: "selected-indicator",
  "aria-hidden": "true"
}, Xf = /* @__PURE__ */ Pe({
  __name: "SingleProductListItem",
  props: {
    ...Ge(),
    product: {
      type: Object,
      required: !0
    },
    selected: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    ...Ke(),
    "click"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Ze(a, n), { color: l } = o, s = nr(a), { disabled: u } = s, i = z(), c = z(), d = C(() => {
      if (a.selected) {
        const y = l.baseVisuallySafe.value;
        return `0px 4px 3px ${y.withAlpha(0.08).cssHSLA},
					0px 4px 8px ${y.withAlpha(0.04).cssHSLA},
					0px 6px 20px ${y.withAlpha(0.1).darken(20).cssHSLA}`;
      }
    }), p = () => {
      if (!c.value)
        return;
      const y = c.value;
      let _ = y.querySelectorAll(".acquisit-colorize"), $ = y.querySelectorAll(".acquisit-text-colorize"), w = (L, R) => {
        for (let q of L)
          q.$el && (q = q.$el), q.style.color = R;
      };
      w(_, l.baseVisuallySafe.value.cssHSLA), w($, l.textDark.value.cssHSLA);
    }, h = (y) => {
      var _;
      (_ = i.value) != null && _.contains(y.target) && i.value != y.target || n("click", y);
    };
    return St(() => {
      p();
    }), t({
      ...o.expose
    }), (y, _) => {
      const $ = oe("acquisit-string"), w = oe("v-svg");
      return m(), S("div", {
        class: pe(["acquisit-single-product-list-item", { selected: e.selected, disabled: g(u) }]),
        style: we({ borderTopColor: g(l).parse(e.product.color).cssHSLA, boxShadow: d.value }),
        onClick: h,
        onKeyup: Jt(h, ["enter"]),
        role: "listitem",
        ref_key: "$root",
        ref: c,
        tabindex: 0
      }, [
        W("div", iL, [
          e.product.logo ? (m(), S("div", {
            key: 0,
            class: "logo",
            "aria-label": g(o).language.parse(e.product.provider_name || e.product.title || e.product.description || void 0),
            role: "img"
          }, [
            W("img", {
              src: e.product.logo,
              "aria-hidden": "true",
              alt: ""
            }, null, 8, cL)
          ], 8, uL)) : B("", !0),
          W("div", dL, [
            K($, {
              class: "title",
              role: "heading",
              source: e.product.title
            }, null, 8, ["source"]),
            e.product.description_html ? (m(), J($, {
              key: 0,
              html: e.product.description_html,
              class: "description"
            }, null, 8, ["html"])) : B("", !0),
            e.product.generic ? (m(), J($, {
              key: 1,
              class: "generic"
            }, {
              default: ie(() => [
                pt(je(e.product.generic), 1)
              ]),
              _: 1
            })) : B("", !0),
            e.product.fineprint ? (m(), J($, {
              key: 2,
              class: "fineprint"
            }, {
              default: ie(() => [
                pt(je(e.product.fineprint), 1)
              ]),
              _: 1
            })) : B("", !0)
          ]),
          e.product.footer ? (m(), S("footer", {
            key: 1,
            class: "footer",
            "aria-labelledby": e.product.uid + "-list-footer"
          }, [
            K($, {
              "font-size": "14px",
              html: e.product.footer_html,
              "link-color": g(l).baseVisuallySafe.value.cssHSLA,
              id: e.product.uid + "-list-footer"
            }, null, 8, ["html", "link-color", "id"])
          ], 8, fL)) : B("", !0),
          y.$slots["terms-action"] ? (m(), S("div", {
            key: 2,
            class: "terms-action",
            ref_key: "$termsAction",
            ref: i,
            role: "presentation"
          }, [
            W("span", vL, [
              at(y.$slots, "terms-action")
            ])
          ], 512)) : B("", !0),
          K(bt, { name: "product-selected" }, {
            default: ie(() => [
              Kt(W("div", pL, [
                K(w, { file: "acq/checkmark" })
              ], 512), [
                [_r, e.selected]
              ])
            ]),
            _: 1
          }),
          W("div", {
            class: "focus-ring",
            style: we({ borderColor: g(l).baseVisuallySafe.value.cssHSLA, boxShadow: "0px 0px 12px " + g(l).baseVisuallySafe.value.withAlpha(0.4).cssHSLA })
          }, null, 4)
        ])
      ], 38);
    };
  }
}), mL = { class: "header-wrapper" }, hL = { class: "max-width-wrapper" }, yL = {
  key: 2,
  class: "search-placeholder"
}, bL = { class: "max-width-wrapper" }, gL = { class: "products" }, _L = /* @__PURE__ */ Pe({
  __name: "SingleProductChooserList",
  props: {
    ...Ge(),
    ...Pc()
  },
  emits: [
    ...Ke(),
    "update:modelValue",
    "current-products"
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Dt("components/product/SingleProductChooserList", Dt.COLOR_COMPONENT), l = Ze(a, n), s = Oc(a), { color: u, erroring: i } = l, { availableProducts: c, availableProductsByUID: d, terms: p, searchQuery: h } = s, y = nr(a), { header: _, footer: $, search_placeholder_label: w, products: L } = y, R = y.modelValue, q = Dm(), E = z(), Y = Gt({}), V = z({}), T = z(), A = z(), P = z(null);
    z(null);
    const b = Go(), x = z(), D = z(!1), N = z({ x: 0, y: 0 }), M = C(() => w.value && c.value.length > 3), H = C(() => {
      let me;
      if (h.value) {
        const fe = h.value.toLocaleLowerCase();
        me = c.value.filter((Oe) => {
          if (Oe.provider_name && String(Oe.provider_name).toLocaleLowerCase().indexOf(fe) > -1 || String(Oe.title).toLocaleLowerCase().indexOf(fe) > -1)
            return !0;
          if (Array.isArray(Oe.tags)) {
            for (let Ie of Oe.tags)
              if (Ie == fe || String(Ie).indexOf(fe) > -1)
                return !0;
          }
          return !1;
        });
      } else
        me = c.value;
      return me.map((fe) => {
        var Oe, Ie;
        return {
          ...fe,
          ui_disabled: P.value !== null && ((Oe = P.value) == null ? void 0 : Oe.uid) != fe.uid,
          ui_selected: ((Ie = P.value) == null ? void 0 : Ie.uid) == fe.uid
        };
      });
    }), U = C(() => {
      var Oe;
      const me = {}, fe = Array.isArray(a.errors) ? a.errors : [];
      for (let Ie of fe)
        (Oe = Ie.owner) != null && Oe.product && (me[Ie.owner.product.uid] || (me[Ie.owner.product.uid] = {}), me[Ie.owner.product.uid][Ie.key] = [Ie]);
      return me;
    });
    C(() => {
      const me = {};
      for (let fe in U.value)
        if (U.value.hasOwnProperty(fe)) {
          me[fe] = [];
          for (let Oe in U.value[fe])
            U.value[fe].hasOwnProperty(Oe) && (me[fe] = me[fe].concat(U.value[fe][Oe]));
        }
      return me;
    });
    const G = C(() => {
      var fe, Oe;
      const me = {};
      for (let Ie of c.value)
        if (me[Ie.uid] || (me[Ie.uid] = {}), (fe = Ie.terms) != null && fe.terms_modal && (me[Ie.uid]._generic = Ie.terms.terms_modal), (Oe = Ie.checkboxes) != null && Oe.length)
          for (let ye of Ie.checkboxes)
            for (let Fe of ye.actions)
              Fe.type == hr.TERMS && (me[Ie.uid][Fe.uid] = Fe.modal);
      return me;
    }), F = z(), O = C(() => D.value ? {
      width: "calc(100% - " + N.value.x + "px)",
      top: N.value.y + "px",
      left: N.value.x + "px"
    } : {}), Q = () => {
      n("update:modelValue", P.value ? [P.value.uid] : []);
    }, ae = () => {
      const me = P.value ? [P.value] : [];
      b.setCurrent(me), n("current-products", me);
    }, Te = (me) => {
      var fe;
      P.value = !me || ((fe = P.value) == null ? void 0 : fe.uid) == me.uid ? null : me, Q();
    }, Ae = (me) => {
      if (!E.value)
        return;
      const fe = me.getBoundingClientRect(), Oe = E.value.getBoundingClientRect().top - fe.top;
      D.value = Oe <= 14, D.value && (N.value.y = fe.top, N.value.x = fe.left);
    }, Ye = () => {
      const me = q == null ? void 0 : q.getRootHeader(), fe = q == null ? void 0 : q.getRootFooter();
      let Oe = 0;
      me && (Oe += me.offsetHeight), fe && (Oe += fe.offsetHeight), x.value = `calc(100% - ${Oe}px)`, q && Ae(q.getRootContainer());
    }, Re = (me) => {
      Ae(me.target);
    }, it = (me, fe, Oe) => {
      Y[me] || (Y[me] = {}), Y[me][fe] = Oe;
    }, he = async (me, fe) => {
      var Ie, ye;
      const Oe = await p.getTerms(me, fe);
      Oe ? (ye = (Ie = Y[me.uid]) == null ? void 0 : Ie[(fe == null ? void 0 : fe.uid) ?? "_generic"]) == null || ye.openModal() : o.warnFrom("openTermsModal", "Received invalid terms", Oe);
    }, X = (me) => {
      var fe;
      (fe = V.value[me.uid]) == null || fe.openModal();
    }, re = (me) => {
      b.setTermsAgreed(me, !me.terms_agreed), Q();
    }, Se = (me, fe) => {
      me && (me.checkboxes_values || (me.checkboxes_values = {}), b.setCheckboxValue(me, fe.uid, !(me.checkboxes_values[fe.uid] ?? !1)), Q());
    };
    return Le(R, (me) => {
      var fe;
      Array.isArray(me) && me.length && me[0] != ((fe = P.value) == null ? void 0 : fe.uid) && (P.value = d.value[me[0]]);
    }, {
      immediate: !0
    }), Le(L, () => {
      o.debugFrom("watch:products"), P.value = null, ae(), Q();
    }), Le(P, () => {
      o.debugFrom("watch:selectedProduct"), ae();
    }), Le(h, (me) => {
      var fe;
      me && H.value.length == 1 ? ((fe = P.value) == null ? void 0 : fe.uid) != H.value[0].uid && Te(H.value[0]) : Te(void 0);
    }), St(async () => {
      if (ae(), await Ka(200), F.value = q.getRootContainer(), (R.value === null || R.value === void 0) && Q(), F.value) {
        if (F.value.addEventListener("scroll", Re), P.value && A.value) {
          let me = A.value.querySelector(`[data-uid=${P.value.uid}]`);
          me ? F.value.scrollTop = me.getBoundingClientRect().top - 256 : o.warnFrom("onMounted", "Could not find $product element");
        }
      } else
        o.warnFrom("onMounted", "Could not find scrollWrapper");
    }), jr(() => {
      n("current-products", []), F.value && F.value.removeEventListener("scroll", Re);
    }), Kr(window, "resize", Ye), t({
      ...l.expose,
      openTermsModal: he
    }), (me, fe) => {
      const Oe = oe("acquisit-header"), Ie = oe("acquisit-input"), ye = oe("acquisit-checkbox"), Fe = oe("acquisit-button"), Me = oe("acquisit-string"), He = oe("acquisit-modal");
      return m(), S("div", {
        class: "acquisit-single-product-chooser-list",
        style: we({ minHeight: x.value }),
        ref_key: "$root",
        ref: A
      }, [
        W("div", mL, [
          W("div", hL, [
            K(Oe, {
              class: "header",
              label: g(_)
            }, null, 8, ["label"]),
            M.value ? (m(), S("div", {
              key: 0,
              class: "search-breakpoint",
              ref_key: "$searchBreakpoint",
              ref: E
            }, null, 512)) : B("", !0),
            M.value ? (m(), S("div", {
              key: 1,
              class: pe(["search", { sticky: D.value }]),
              style: we(O.value),
              ref: "$searchWrapper"
            }, [
              K(Ie, {
                modelValue: g(h),
                "onUpdate:modelValue": fe[0] || (fe[0] = (ce) => _a(h) ? h.value = ce : null),
                label: g(w),
                icon: "acq/search",
                class: "search-input",
                role: "search"
              }, null, 8, ["modelValue", "label"])
            ], 6)) : B("", !0),
            M.value ? Kt((m(), S("div", yL, null, 512)), [
              [_r, D.value]
            ]) : B("", !0)
          ])
        ]),
        W("div", bL, [
          W("ul", gL, [
            (m(!0), S(qe, null, We(H.value, (ce) => {
              var mt;
              return m(), J(Xf, {
                key: ce.uid,
                color: ce.color,
                product: ce,
                disabled: ce.ui_disabled,
                selected: ce.ui_selected,
                ref_for: !0,
                ref_key: "$products",
                ref: T,
                "data-uid": ce.uid,
                onClick: (nt) => Te(ce)
              }, Ca({ _: 2 }, [
                (mt = ce.checkboxes) != null && mt.length || ce.terms ? {
                  name: "terms-action",
                  fn: ie(() => {
                    var nt;
                    return [
                      ce.terms ? (m(), J(Sr, {
                        key: 0,
                        name: "list-complete"
                      }, {
                        default: ie(() => {
                          var ot, ft, $e, Qe, te;
                          return [
                            ce.terms.type == "checkbox" && ce.ui_selected ? (m(), J(ye, {
                              label: ce.terms.checkbox_label,
                              modelValue: ce.terms_agreed,
                              onClick: (xe) => re(ce),
                              class: "list-complete-item",
                              key: "checkbox",
                              errors: (ot = U.value[ce.uid]) == null ? void 0 : ot.terms_agreed,
                              "has-current-errors": g(i),
                              color: ce.color
                            }, null, 8, ["label", "modelValue", "onClick", "errors", "has-current-errors", "color"])) : B("", !0),
                            W("div", {
                              class: pe(["buttons", { indented: ce.terms.type == "checkbox" && ce.ui_selected }]),
                              key: "buttons"
                            }, [
                              ce.terms.terms_modal ? (m(), J(Fe, {
                                key: 0,
                                type: ce.terms.terms_modal.button_open_type ?? "text",
                                loading: g(p).loading.storeBoolean[ce.uid],
                                color: "lightgrey",
                                class: pe(["open-terms-btn", "list-complete-item"]),
                                label: ce.terms.terms_modal.button_open_label,
                                errors: (ft = U.value[ce.uid]) == null ? void 0 : ft.terms_agreed,
                                "has-current-errors": g(i),
                                onClick: (xe) => he(ce)
                              }, null, 8, ["type", "loading", "label", "errors", "has-current-errors", "onClick"])) : B("", !0),
                              ce.terms.withdrawal_form_label && ce.terms.withdrawal_form_href ? (m(), J(Fe, {
                                key: 1,
                                href: ce.terms.withdrawal_form_href,
                                target: "_blank",
                                type: (($e = ce.terms.terms_modal) == null ? void 0 : $e.button_open_type) ?? "text",
                                color: "lightgrey",
                                class: pe(["open-withdrawal-form-btn", "list-complete-item"]),
                                label: ce.terms.withdrawal_form_label,
                                errors: (Qe = U.value[ce.uid]) == null ? void 0 : Qe.terms_agreed,
                                "has-current-errors": g(i)
                              }, null, 8, ["href", "type", "label", "errors", "has-current-errors"])) : B("", !0),
                              ce.terms.withdrawal_modal ? (m(), J(Fe, {
                                key: 2,
                                type: ce.terms.withdrawal_modal.button_open_type ?? "text",
                                color: "lightgrey",
                                class: pe(["open-withdrawal-btn", "list-complete-item"]),
                                target: "_blank",
                                label: ce.terms.withdrawal_modal.button_open_label,
                                errors: (te = U.value[ce.uid]) == null ? void 0 : te.terms_agreed,
                                "has-current-errors": g(i),
                                onClick: (xe) => X(ce)
                              }, null, 8, ["type", "label", "errors", "has-current-errors", "onClick"])) : B("", !0),
                              (m(), J(Xt, { to: "body" }, [
                                ce.terms.withdrawal_modal ? (m(), J(He, {
                                  key: "withdrawal_modal",
                                  ref_for: !0,
                                  ref: (xe) => V.value[ce.uid] = xe
                                }, Ca({
                                  default: ie(() => [
                                    K(Me, {
                                      source: ce.terms.withdrawal_modal.body
                                    }, null, 8, ["source"])
                                  ]),
                                  accept: ie(() => [
                                    K(Me, {
                                      source: ce.terms.withdrawal_modal.button_accept_label
                                    }, null, 8, ["source"])
                                  ]),
                                  _: 2
                                }, [
                                  ce.terms.withdrawal_modal.title ? {
                                    name: "header",
                                    fn: ie(() => [
                                      K(Me, {
                                        source: ce.terms.withdrawal_modal.title
                                      }, null, 8, ["source"])
                                    ]),
                                    key: "0"
                                  } : void 0
                                ]), 1536)) : B("", !0)
                              ]))
                            ], 2)
                          ];
                        }),
                        _: 2
                      }, 1024)) : B("", !0),
                      (nt = ce.checkboxes) != null && nt.length ? (m(!0), S(qe, { key: 1 }, We(ce.checkboxes, (ot) => (m(), J(Sr, { name: "list-complete" }, {
                        default: ie(() => {
                          var ft, $e;
                          return [
                            ce.ui_selected ? (m(), J(ye, {
                              uid: ot.uid,
                              label: ot.label,
                              modelValue: ((ft = ce.checkboxes_values) == null ? void 0 : ft[ot.uid]) ?? !1,
                              errors: ($e = U.value[ce.uid]) == null ? void 0 : $e[ot.uid],
                              "has-current-errors": g(i),
                              onClick: (Qe) => Se(ce, ot),
                              color: ce.color,
                              class: "list-complete-item",
                              key: "checkbox-" + ot.uid
                            }, null, 8, ["uid", "label", "modelValue", "errors", "has-current-errors", "onClick", "color"])) : B("", !0),
                            (m(), S("div", {
                              class: pe(["buttons", { indented: ce.ui_selected }]),
                              key: "buttons-" + ot.uid
                            }, [
                              (m(!0), S(qe, null, We(ot.actions, (Qe) => {
                                var te, xe, Ee;
                                return m(), S(qe, null, [
                                  Qe.type == g(hr).MODAL ? (m(), J(Fe, {
                                    key: 0,
                                    label: Qe.label,
                                    modal: Qe.modal,
                                    type: "text",
                                    color: "lightgrey",
                                    errors: (te = U.value[ce.uid]) == null ? void 0 : te[ot.uid],
                                    "has-current-errors": g(i)
                                  }, null, 8, ["label", "modal", "errors", "has-current-errors"])) : Qe.type == g(hr).HREF ? (m(), J(Fe, {
                                    key: 1,
                                    label: Qe.label,
                                    href: Qe.href,
                                    type: "text",
                                    color: "lightgrey",
                                    errors: (xe = U.value[ce.uid]) == null ? void 0 : xe[ot.uid],
                                    "has-current-errors": g(i),
                                    target: "_blank"
                                  }, null, 8, ["label", "href", "errors", "has-current-errors"])) : Qe.type == g(hr).TERMS ? (m(), J(Fe, {
                                    key: 2,
                                    label: Qe.label,
                                    onClick: (Ve) => he(ce, Qe),
                                    type: "text",
                                    color: "lightgrey",
                                    errors: (Ee = U.value[ce.uid]) == null ? void 0 : Ee[ot.uid],
                                    "has-current-errors": g(i)
                                  }, null, 8, ["label", "onClick", "errors", "has-current-errors"])) : B("", !0)
                                ], 64);
                              }), 256))
                            ], 2))
                          ];
                        }),
                        _: 2
                      }, 1024))), 256)) : B("", !0)
                    ];
                  }),
                  key: "0"
                } : void 0
              ]), 1032, ["color", "product", "disabled", "selected", "data-uid", "onClick"]);
            }), 128))
          ]),
          g($) ? (m(), J(Me, {
            key: 0,
            class: "footer",
            source: g($)
          }, null, 8, ["source"])) : B("", !0),
          (m(!0), S(qe, null, We(g(p).store, (ce, mt) => (m(), S(qe, null, [
            (m(!0), S(qe, null, We(ce, (nt, ot) => (m(), J(He, {
              key: "terms-" + mt + "-" + ot,
              ref_for: !0,
              ref: (ft) => it(mt, ot, ft)
            }, {
              header: ie(() => [
                K(Me, null, {
                  default: ie(() => {
                    var ft, $e;
                    return [
                      pt(je(($e = (ft = G.value[mt]) == null ? void 0 : ft[ot]) == null ? void 0 : $e.title), 1)
                    ];
                  }),
                  _: 2
                }, 1024)
              ]),
              accept: ie(() => [
                K(Me, null, {
                  default: ie(() => {
                    var ft, $e;
                    return [
                      pt(je(($e = (ft = G.value[mt]) == null ? void 0 : ft[ot]) == null ? void 0 : $e.button_accept_label), 1)
                    ];
                  }),
                  _: 2
                }, 1024)
              ]),
              default: ie(() => [
                K(Me, null, {
                  default: ie(() => {
                    var ft, $e;
                    return [
                      pt(je((($e = (ft = G.value[mt]) == null ? void 0 : ft[ot]) == null ? void 0 : $e.body) || nt), 1)
                    ];
                  }),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))), 128))
          ], 64))), 256))
        ])
      ], 4);
    };
  }
}), wL = {
  key: 0,
  class: "logo"
}, kL = ["src"], $L = { class: "components" }, CL = /* @__PURE__ */ Pe({
  __name: "SingleProductOfferCard",
  props: {
    ...Ge(),
    product_logo: {
      type: String,
      required: !1,
      default: null
    },
    product_logo_padding: {
      type: Boolean,
      required: !1,
      default: !0
    },
    badge: {
      type: Object,
      required: !1,
      default: null
    },
    footer: {
      type: [String, Object],
      required: !1,
      default: null
    }
  },
  emits: [
    ...Ke()
  ],
  setup(e, { expose: t, emit: r }) {
    const a = e, o = Ze(a, r), { color: l } = o, { color: s } = nr(a), u = z(), i = C(() => ({
      borderColor: l.base.value.cssHSLA
    })), c = () => {
      if (!u.value)
        return;
      const d = u.value;
      let p = d.querySelectorAll(".acquisit-colorize"), h = d.querySelectorAll(".acquisit-text-colorize"), y = (_, $) => {
        for (let w of _)
          w.$el && (w = w.$el), w.style.color = $;
      };
      y(p, l.baseVisuallySafe.value.cssHSLA), y(h, l.textDark.value.cssHSLA);
    };
    return Le(s, () => {
      c();
    }), St(() => {
      c();
    }), t({
      ...o.expose
    }), (d, p) => {
      const h = oe("acquisit-badge"), y = oe("acquisit-string");
      return m(), S("div", {
        class: pe(["acquisit-single-product-offer-card", { "has-color": g(l).hasSpecificColor.value, "has-logo-padding": e.product_logo_padding }]),
        style: we(i.value),
        ref_key: "$root",
        ref: u
      }, [
        e.product_logo ? (m(), S("div", wL, [
          W("img", {
            src: e.product_logo,
            alt: ""
          }, null, 8, kL)
        ])) : B("", !0),
        e.badge ? (m(), J(h, {
          key: 1,
          class: "badge",
          color: e.badge.color,
          label: e.badge.label,
          icon: e.badge.icon
        }, null, 8, ["color", "label", "icon"])) : B("", !0),
        W("div", $L, [
          at(d.$slots, "default")
        ]),
        e.footer ? (m(), S("footer", {
          key: 2,
          style: we({ background: g(l).hasSpecificColor.value ? g(l).base.value.cssHSLA : void 0 }),
          class: "footer"
        }, [
          K(y, {
            style: we({ color: g(l).hasSpecificColor.value ? g(l).textContrast.value.cssHSLA : void 0 }),
            "font-size": "14px",
            "link-color": g(l).textContrast.value
          }, {
            default: ie(() => [
              pt(je(e.footer), 1)
            ]),
            _: 1
          }, 8, ["style", "link-color"])
        ], 4)) : B("", !0)
      ], 6);
    };
  }
}), Dn = {
  core: [
    Th,
    // AddressLabel,
    Lh,
    Nh,
    Uh,
    Qh,
    ey,
    hI,
    yI,
    _I,
    sq,
    kI,
    SI,
    OI,
    EI,
    pI,
    Yf,
    // MathLabel,
    NI,
    XI,
    QI,
    eM,
    aM,
    nM,
    dM,
    vM,
    hM
    // Toast
  ],
  extended: [
    KM,
    GM,
    QM,
    tq,
    rq,
    lq,
    pq,
    Bq,
    Nq,
    zq,
    Sq,
    Wq,
    Qq,
    cE
  ],
  person: [
    hE,
    SE,
    GE,
    pV,
    SV,
    DV
  ],
  product: [
    TV,
    FV,
    UV,
    JV,
    sL,
    _L,
    Xf,
    CL
  ]
}, SL = Dt("plugins/ui-loader", "cyan"), Jf = {};
let Tn = {};
Rt(Dn, (e) => {
  for (let t of e) {
    const r = t.name || t.__name;
    Jf[r] = !0;
  }
});
const KL = (e) => {
  Tn[e] = !0;
}, GL = (e) => {
  delete Tn[e];
}, ZL = {
  /**
   * Get all components sorted by the package they're in
   *
   * @returns {Record<string, Component[]>}
   */
  get allComponentsByPackage() {
    return Dn;
  },
  /**
   * Get all components, regardless of package
   *
   * @returns {Component[]}
   */
  get allComponents() {
    let e = [];
    return Rt(Dn, (t) => {
      e = e.concat(t);
    }), e.sort((t, r) => {
      const a = t.__name || t.name || "", n = r.__name || r.name || "";
      return a.localeCompare(n);
    });
  },
  /**
   * Get all components in a specific package
   *
   * @param {string} pack
   *
   * @returns {Component[]}
   */
  getComponentsInPackage(e) {
    return this.allComponentsByPackage[e] ?? [];
  },
  /**
   * Check whether a given normalized tag exists
   *
   * @param {string | undefined | null} tag
   *
   * @returns {boolean}
   */
  componentExists(e) {
    if (!e)
      return !1;
    const t = um(e), r = cm(dm(t));
    return Jf[r] ? !0 : !!(Tn[e] ?? !1);
  },
  /**
   * Install all UI components as "Acquisit*", e.g. "AcquisitButton"
   */
  install(e, t = {}) {
    e.component("VSvg", Xm), e.component("AcquisitComponentsContainer", jc), e.component("AcquisitComponentError", hs);
    for (let r in Dn)
      for (let a of Dn[r]) {
        const n = a.name || a.__name;
        e.component("Acquisit" + n, a), n === void 0 && SL.warn("Undefined component name", a);
      }
    Tn = Ko(Tn, Ft(t.customComponents ?? [], (r) => r, (r) => !0)), e.provide(Sc, this.componentExists);
  }
};
export {
  UV as $,
  dM as A,
  vM as B,
  hM as C,
  KM as D,
  GM as E,
  QM as F,
  tq as G,
  rq as H,
  lq as I,
  sq as J,
  Bq as K,
  zq as L,
  pq as M,
  Sq as N,
  Wq as O,
  XI as P,
  Qq as Q,
  cE as R,
  hE as S,
  SE as T,
  GE as U,
  pV as V,
  SV as W,
  DV as X,
  TV as Y,
  FV as Z,
  jc as _,
  GL as a,
  iV as a$,
  JV as a0,
  sL as a1,
  _L as a2,
  Xf as a3,
  CL as a4,
  Sh as a5,
  xh as a6,
  Bc as a7,
  UL as a8,
  Na as a9,
  nh as aA,
  oh as aB,
  hl as aC,
  lh as aD,
  dh as aE,
  Di as aF,
  sh as aG,
  yh as aH,
  Kf as aI,
  Gf as aJ,
  ZE as aK,
  XE as aL,
  JE as aM,
  sc as aN,
  QE as aO,
  eV as aP,
  tV as aQ,
  rV as aR,
  aV as aS,
  Zs as aT,
  ic as aU,
  Zf as aV,
  nV as aW,
  uc as aX,
  oV as aY,
  lV as aZ,
  sV as a_,
  zL as aa,
  WL as ab,
  Ai as ac,
  Jm as ad,
  Vc as ae,
  Ch as af,
  Si as ag,
  Oo as ah,
  ms as ai,
  Gr as aj,
  kh as ak,
  yn as al,
  cr as am,
  $h as an,
  Lc as ao,
  FL as ap,
  Fa as aq,
  NL as ar,
  YL as as,
  uo as at,
  th as au,
  rh as av,
  ah as aw,
  yl as ax,
  xi as ay,
  ih as az,
  hs as b,
  uV as b0,
  cV as b1,
  Ym as b2,
  ze as b3,
  Hl as b4,
  Hm as b5,
  Rm as b6,
  Fm as b7,
  LL as b8,
  Ra as b9,
  Ic as ba,
  ps as bb,
  Um as bc,
  zm as bd,
  Mc as be,
  qc as bf,
  BL as bg,
  jL as bh,
  HL as bi,
  RL as bj,
  Lt as bk,
  Xm as c,
  VL as d,
  Th as e,
  Lh as f,
  Nh as g,
  Uh as h,
  Qh as i,
  ey as j,
  hI as k,
  yI as l,
  _I as m,
  kI as n,
  SI as o,
  OI as p,
  EI as q,
  KL as r,
  pI as s,
  Yf as t,
  ZL as u,
  NI as v,
  QI as w,
  eM as x,
  aM as y,
  nM as z
};
//# sourceMappingURL=ui-loader-CD7X6fJt.js.map
